var n6 = Object.defineProperty;
var a6 = (r, a, i) => a in r ? n6(r, a, { enumerable: !0, configurable: !0, writable: !0, value: i }) : r[a] = i;
var qe = (r, a, i) => a6(r, typeof a != "symbol" ? a + "" : a, i);
var pe = /* @__PURE__ */ ((r) => (r.BOOKING_NAME = "booking-name", r.VIEWER_DATE = "viewer-date", r.VIEWER_FULL = "viewer-full", r.VIEWER_FULL_SQUARE = "viewer-full-square", r.VIEWER_NAME = "viewer-name", r.VIEWER_STAGING = "viewer-staging", r))(pe || {}), yn = /* @__PURE__ */ ((r) => (r.CONTAIN = "contain", r.COVER = "cover", r))(yn || {}), tt = /* @__PURE__ */ ((r) => (r.RED = "Red", r.BLUE = "Blue", r.GREEN = "Green", r.YELLOW = "Yellow", r.ORANGE = "Orange", r.PINK = "Pink", r.WHITE = "White", r.BLACK = "Black", r.PURPLE = "Purple", r.RED_FLUO = "Fluored", r.BLUE_FLUO = "Fluoblue", r.GREEN_FLUO = "Fluogreen", r.YELLOW_FLUO = "Fluoyellow", r.PINK_FLUO = "Fluopink", r.WHITE_FLUO = "Fluowhite", r.PURPLE_FLUO = "Fluopurple", r.BLACK_WHITE = "Black-White", r.BLACK_BLUE = "Black-Blue", r.BLACK_YELLOW = "Black-Yellow", r.BLACK_GREY = "Black-Grey", r.BLACK_RED = "Black-Red", r.BLACK_GREEN = "Black-Green", r.BLACK_PURPLE = "Black-Purple", r.GREY = "Grey", r.CYAN = "Cyan", r.BROWN = "Brown", r.LIME = "Lime", r))(tt || {});
tt.RED, tt.BLUE, tt.GREEN, tt.YELLOW, tt.ORANGE, tt.PINK, tt.WHITE, tt.BLACK, tt.PURPLE, tt.RED_FLUO, tt.BLUE_FLUO, tt.GREEN_FLUO, tt.YELLOW_FLUO, tt.PINK_FLUO, tt.WHITE_FLUO, tt.PURPLE_FLUO, tt.BLACK_WHITE, tt.BLACK_BLUE, tt.BLACK_YELLOW, tt.BLACK_GREY, tt.BLACK_RED, tt.BLACK_GREEN, // Color.BLACK_PINK,
tt.BLACK_PURPLE;
tt.RED, tt.BLUE, tt.GREEN, tt.YELLOW, tt.ORANGE, tt.PINK, tt.WHITE, tt.BLACK, tt.PURPLE;
tt.RED, tt.BLUE, tt.GREEN, tt.YELLOW, tt.ORANGE, tt.PINK;
// Color.WHITE,
tt.RED, tt.BLUE, tt.GREEN, tt.YELLOW, tt.ORANGE, tt.PINK;
tt.RED, tt.BLUE, tt.GREEN, tt.YELLOW, tt.ORANGE, tt.PINK, tt.GREY, tt.CYAN, tt.BROWN, tt.LIME;
tt.RED, tt.BLUE, tt.GREEN, tt.YELLOW, tt.ORANGE, tt.PINK, tt.GREY, tt.CYAN, tt.BROWN, tt.LIME, tt.WHITE, tt.BLACK, tt.PURPLE, tt.WHITE_FLUO, tt.RED_FLUO, tt.BLUE_FLUO, tt.GREEN_FLUO, tt.YELLOW_FLUO, tt.PURPLE_FLUO, tt.BLACK_WHITE, tt.BLACK_RED, tt.BLACK_BLUE, tt.BLACK_GREEN, tt.BLACK_YELLOW, tt.BLACK_PURPLE, tt.BLACK_GREY;
var Ce = /* @__PURE__ */ ((r) => (r.BALLOON = "balloon", r.BASKET_FIELD = "basket-field", r.BEACH_VOLLEY = "beach-volley", r.BENCH = "bench", r.CAR = "car", r.CHIRINGUITO = "chiringuito", r.COURT = "court", r.CUSTOM = "custom", r.DESK = "desk", r.FOOTBOARD = "footboard", r.GYM_BARBELL = "gym-barbell", r.GYM_EXERCISE = "gym-exercise", r.GYM_TREADMILL = "gym-treadmill", r.LABEL = "label", r.LIFEBELT = "lifebelt", r.LINE = "line", r.PALM = "palm", r.PLAYGROUND = "playground", r.POOL = "pool", r.POOL_ROUNDED = "pool-rounded", r.RECEPTION = "reception", r.ROWBOAT = "rowboat", r.SHOWER = "shower", r.SOCCER_FIELD = "soccer-field", r.TENT = "tent", r.TENT_BIG = "tent-big", r.TREE = "tree", r.TREE1 = "tree1", r))(Ce || {}), Ar = /* @__PURE__ */ ((r) => (r.UMBRELLA = "umbrella", r.GAZEBO = "gazebo", r.PARKING = "parking", r.BED = "bed", r.BEDS = "beds", r.CABIN = "cabins", r.BOAT = "boat", r.PLAYFIELD = "playfield", r))(Ar || {});
function gr(r, a) {
  throw new Error(
    `Unhandled discriminated union member: ${JSON.stringify(r)}`
  );
}
var Ci = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {}, pa = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
pa.exports;
(function(r, a) {
  (function() {
    var i, s = "4.17.21", h = 200, o = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", l = "Expected a function", u = "Invalid `variable` option passed into `_.template`", g = "__lodash_hash_undefined__", p = 500, b = "__lodash_placeholder__", S = 1, x = 2, v = 4, _ = 1, w = 2, C = 1, F = 2, c = 4, f = 8, m = 16, E = 32, T = 64, D = 128, k = 256, M = 512, O = 30, N = "...", z = 800, y = 16, P = 1, A = 2, G = 3, U = 1 / 0, K = 9007199254740991, $ = 17976931348623157e292, X = NaN, Q = 4294967295, st = Q - 1, Z = Q >>> 1, at = [
      ["ary", D],
      ["bind", C],
      ["bindKey", F],
      ["curry", f],
      ["curryRight", m],
      ["flip", M],
      ["partial", E],
      ["partialRight", T],
      ["rearg", k]
    ], ht = "[object Arguments]", ct = "[object Array]", H = "[object AsyncFunction]", j = "[object Boolean]", et = "[object Date]", ut = "[object DOMException]", gt = "[object Error]", pt = "[object Function]", Mt = "[object GeneratorFunction]", Et = "[object Map]", mt = "[object Number]", re = "[object Null]", Pt = "[object Object]", Ht = "[object Promise]", pr = "[object Proxy]", ie = "[object RegExp]", Zt = "[object Set]", Jt = "[object String]", Ut = "[object Symbol]", ze = "[object Undefined]", ne = "[object WeakMap]", He = "[object WeakSet]", Vt = "[object ArrayBuffer]", ae = "[object DataView]", Oe = "[object Float32Array]", _e = "[object Float64Array]", Ze = "[object Int8Array]", Ia = "[object Int16Array]", We = "[object Int32Array]", Ie = "[object Uint8Array]", Je = "[object Uint8ClampedArray]", oi = "[object Uint16Array]", ka = "[object Uint32Array]", Eg = /\b__p \+= '';/g, Ag = /\b(__p \+=) '' \+/g, Rg = /(__e\(.*?\)|\b__t\)) \+\n'';/g, ol = /&(?:amp|lt|gt|quot|#39);/g, hl = /[&<>"']/g, Tg = RegExp(ol.source), Pg = RegExp(hl.source), Fg = /<%-([\s\S]+?)%>/g, Og = /<%([\s\S]+?)%>/g, ll = /<%=([\s\S]+?)%>/g, Ig = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, kg = /^\w*$/, Mg = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ma = /[\\^$.*+?()[\]{}|]/g, Lg = RegExp(Ma.source), La = /^\s+/, Ng = /\s/, Gg = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Dg = /\{\n\/\* \[wrapped with (.+)\] \*/, Bg = /,? & /, Ug = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, qg = /[()=,{}\[\]\/\s]/, zg = /\\(\\)?/g, Hg = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, ul = /\w*$/, Wg = /^[-+]0x[0-9a-f]+$/i, Vg = /^0b[01]+$/i, jg = /^\[object .+?Constructor\]$/, Kg = /^0o[0-7]+$/i, Yg = /^(?:0|[1-9]\d*)$/, Xg = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, wn = /($^)/, $g = /['\n\r\u2028\u2029\\]/g, Cn = "\\ud800-\\udfff", Zg = "\\u0300-\\u036f", Jg = "\\ufe20-\\ufe2f", Qg = "\\u20d0-\\u20ff", cl = Zg + Jg + Qg, dl = "\\u2700-\\u27bf", fl = "a-z\\xdf-\\xf6\\xf8-\\xff", t1 = "\\xac\\xb1\\xd7\\xf7", e1 = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", r1 = "\\u2000-\\u206f", i1 = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", gl = "A-Z\\xc0-\\xd6\\xd8-\\xde", pl = "\\ufe0e\\ufe0f", _l = t1 + e1 + r1 + i1, Na = "['’]", n1 = "[" + Cn + "]", vl = "[" + _l + "]", xn = "[" + cl + "]", yl = "\\d+", a1 = "[" + dl + "]", ml = "[" + fl + "]", bl = "[^" + Cn + _l + yl + dl + fl + gl + "]", Ga = "\\ud83c[\\udffb-\\udfff]", s1 = "(?:" + xn + "|" + Ga + ")", Sl = "[^" + Cn + "]", Da = "(?:\\ud83c[\\udde6-\\uddff]){2}", Ba = "[\\ud800-\\udbff][\\udc00-\\udfff]", Ur = "[" + gl + "]", wl = "\\u200d", Cl = "(?:" + ml + "|" + bl + ")", o1 = "(?:" + Ur + "|" + bl + ")", xl = "(?:" + Na + "(?:d|ll|m|re|s|t|ve))?", El = "(?:" + Na + "(?:D|LL|M|RE|S|T|VE))?", Al = s1 + "?", Rl = "[" + pl + "]?", h1 = "(?:" + wl + "(?:" + [Sl, Da, Ba].join("|") + ")" + Rl + Al + ")*", l1 = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", u1 = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Tl = Rl + Al + h1, c1 = "(?:" + [a1, Da, Ba].join("|") + ")" + Tl, d1 = "(?:" + [Sl + xn + "?", xn, Da, Ba, n1].join("|") + ")", f1 = RegExp(Na, "g"), g1 = RegExp(xn, "g"), Ua = RegExp(Ga + "(?=" + Ga + ")|" + d1 + Tl, "g"), p1 = RegExp([
      Ur + "?" + ml + "+" + xl + "(?=" + [vl, Ur, "$"].join("|") + ")",
      o1 + "+" + El + "(?=" + [vl, Ur + Cl, "$"].join("|") + ")",
      Ur + "?" + Cl + "+" + xl,
      Ur + "+" + El,
      u1,
      l1,
      yl,
      c1
    ].join("|"), "g"), _1 = RegExp("[" + wl + Cn + cl + pl + "]"), v1 = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, y1 = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], m1 = -1, qt = {};
    qt[Oe] = qt[_e] = qt[Ze] = qt[Ia] = qt[We] = qt[Ie] = qt[Je] = qt[oi] = qt[ka] = !0, qt[ht] = qt[ct] = qt[Vt] = qt[j] = qt[ae] = qt[et] = qt[gt] = qt[pt] = qt[Et] = qt[mt] = qt[Pt] = qt[ie] = qt[Zt] = qt[Jt] = qt[ne] = !1;
    var Bt = {};
    Bt[ht] = Bt[ct] = Bt[Vt] = Bt[ae] = Bt[j] = Bt[et] = Bt[Oe] = Bt[_e] = Bt[Ze] = Bt[Ia] = Bt[We] = Bt[Et] = Bt[mt] = Bt[Pt] = Bt[ie] = Bt[Zt] = Bt[Jt] = Bt[Ut] = Bt[Ie] = Bt[Je] = Bt[oi] = Bt[ka] = !0, Bt[gt] = Bt[pt] = Bt[ne] = !1;
    var b1 = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, S1 = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, w1 = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, C1 = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, x1 = parseFloat, E1 = parseInt, Pl = typeof Ci == "object" && Ci && Ci.Object === Object && Ci, A1 = typeof self == "object" && self && self.Object === Object && self, he = Pl || A1 || Function("return this")(), qa = a && !a.nodeType && a, Rr = qa && !0 && r && !r.nodeType && r, Fl = Rr && Rr.exports === qa, za = Fl && Pl.process, ke = function() {
      try {
        var W = Rr && Rr.require && Rr.require("util").types;
        return W || za && za.binding && za.binding("util");
      } catch {
      }
    }(), Ol = ke && ke.isArrayBuffer, Il = ke && ke.isDate, kl = ke && ke.isMap, Ml = ke && ke.isRegExp, Ll = ke && ke.isSet, Nl = ke && ke.isTypedArray;
    function Ee(W, J, Y) {
      switch (Y.length) {
        case 0:
          return W.call(J);
        case 1:
          return W.call(J, Y[0]);
        case 2:
          return W.call(J, Y[0], Y[1]);
        case 3:
          return W.call(J, Y[0], Y[1], Y[2]);
      }
      return W.apply(J, Y);
    }
    function R1(W, J, Y, lt) {
      for (var bt = -1, Lt = W == null ? 0 : W.length; ++bt < Lt; ) {
        var Qt = W[bt];
        J(lt, Qt, Y(Qt), W);
      }
      return lt;
    }
    function Me(W, J) {
      for (var Y = -1, lt = W == null ? 0 : W.length; ++Y < lt && J(W[Y], Y, W) !== !1; )
        ;
      return W;
    }
    function T1(W, J) {
      for (var Y = W == null ? 0 : W.length; Y-- && J(W[Y], Y, W) !== !1; )
        ;
      return W;
    }
    function Gl(W, J) {
      for (var Y = -1, lt = W == null ? 0 : W.length; ++Y < lt; )
        if (!J(W[Y], Y, W))
          return !1;
      return !0;
    }
    function _r(W, J) {
      for (var Y = -1, lt = W == null ? 0 : W.length, bt = 0, Lt = []; ++Y < lt; ) {
        var Qt = W[Y];
        J(Qt, Y, W) && (Lt[bt++] = Qt);
      }
      return Lt;
    }
    function En(W, J) {
      var Y = W == null ? 0 : W.length;
      return !!Y && qr(W, J, 0) > -1;
    }
    function Ha(W, J, Y) {
      for (var lt = -1, bt = W == null ? 0 : W.length; ++lt < bt; )
        if (Y(J, W[lt]))
          return !0;
      return !1;
    }
    function zt(W, J) {
      for (var Y = -1, lt = W == null ? 0 : W.length, bt = Array(lt); ++Y < lt; )
        bt[Y] = J(W[Y], Y, W);
      return bt;
    }
    function vr(W, J) {
      for (var Y = -1, lt = J.length, bt = W.length; ++Y < lt; )
        W[bt + Y] = J[Y];
      return W;
    }
    function Wa(W, J, Y, lt) {
      var bt = -1, Lt = W == null ? 0 : W.length;
      for (lt && Lt && (Y = W[++bt]); ++bt < Lt; )
        Y = J(Y, W[bt], bt, W);
      return Y;
    }
    function P1(W, J, Y, lt) {
      var bt = W == null ? 0 : W.length;
      for (lt && bt && (Y = W[--bt]); bt--; )
        Y = J(Y, W[bt], bt, W);
      return Y;
    }
    function Va(W, J) {
      for (var Y = -1, lt = W == null ? 0 : W.length; ++Y < lt; )
        if (J(W[Y], Y, W))
          return !0;
      return !1;
    }
    var F1 = ja("length");
    function O1(W) {
      return W.split("");
    }
    function I1(W) {
      return W.match(Ug) || [];
    }
    function Dl(W, J, Y) {
      var lt;
      return Y(W, function(bt, Lt, Qt) {
        if (J(bt, Lt, Qt))
          return lt = Lt, !1;
      }), lt;
    }
    function An(W, J, Y, lt) {
      for (var bt = W.length, Lt = Y + (lt ? 1 : -1); lt ? Lt-- : ++Lt < bt; )
        if (J(W[Lt], Lt, W))
          return Lt;
      return -1;
    }
    function qr(W, J, Y) {
      return J === J ? W1(W, J, Y) : An(W, Bl, Y);
    }
    function k1(W, J, Y, lt) {
      for (var bt = Y - 1, Lt = W.length; ++bt < Lt; )
        if (lt(W[bt], J))
          return bt;
      return -1;
    }
    function Bl(W) {
      return W !== W;
    }
    function Ul(W, J) {
      var Y = W == null ? 0 : W.length;
      return Y ? Ya(W, J) / Y : X;
    }
    function ja(W) {
      return function(J) {
        return J == null ? i : J[W];
      };
    }
    function Ka(W) {
      return function(J) {
        return W == null ? i : W[J];
      };
    }
    function ql(W, J, Y, lt, bt) {
      return bt(W, function(Lt, Qt, Dt) {
        Y = lt ? (lt = !1, Lt) : J(Y, Lt, Qt, Dt);
      }), Y;
    }
    function M1(W, J) {
      var Y = W.length;
      for (W.sort(J); Y--; )
        W[Y] = W[Y].value;
      return W;
    }
    function Ya(W, J) {
      for (var Y, lt = -1, bt = W.length; ++lt < bt; ) {
        var Lt = J(W[lt]);
        Lt !== i && (Y = Y === i ? Lt : Y + Lt);
      }
      return Y;
    }
    function Xa(W, J) {
      for (var Y = -1, lt = Array(W); ++Y < W; )
        lt[Y] = J(Y);
      return lt;
    }
    function L1(W, J) {
      return zt(J, function(Y) {
        return [Y, W[Y]];
      });
    }
    function zl(W) {
      return W && W.slice(0, jl(W) + 1).replace(La, "");
    }
    function Ae(W) {
      return function(J) {
        return W(J);
      };
    }
    function $a(W, J) {
      return zt(J, function(Y) {
        return W[Y];
      });
    }
    function hi(W, J) {
      return W.has(J);
    }
    function Hl(W, J) {
      for (var Y = -1, lt = W.length; ++Y < lt && qr(J, W[Y], 0) > -1; )
        ;
      return Y;
    }
    function Wl(W, J) {
      for (var Y = W.length; Y-- && qr(J, W[Y], 0) > -1; )
        ;
      return Y;
    }
    function N1(W, J) {
      for (var Y = W.length, lt = 0; Y--; )
        W[Y] === J && ++lt;
      return lt;
    }
    var G1 = Ka(b1), D1 = Ka(S1);
    function B1(W) {
      return "\\" + C1[W];
    }
    function U1(W, J) {
      return W == null ? i : W[J];
    }
    function zr(W) {
      return _1.test(W);
    }
    function q1(W) {
      return v1.test(W);
    }
    function z1(W) {
      for (var J, Y = []; !(J = W.next()).done; )
        Y.push(J.value);
      return Y;
    }
    function Za(W) {
      var J = -1, Y = Array(W.size);
      return W.forEach(function(lt, bt) {
        Y[++J] = [bt, lt];
      }), Y;
    }
    function Vl(W, J) {
      return function(Y) {
        return W(J(Y));
      };
    }
    function yr(W, J) {
      for (var Y = -1, lt = W.length, bt = 0, Lt = []; ++Y < lt; ) {
        var Qt = W[Y];
        (Qt === J || Qt === b) && (W[Y] = b, Lt[bt++] = Y);
      }
      return Lt;
    }
    function Rn(W) {
      var J = -1, Y = Array(W.size);
      return W.forEach(function(lt) {
        Y[++J] = lt;
      }), Y;
    }
    function H1(W) {
      var J = -1, Y = Array(W.size);
      return W.forEach(function(lt) {
        Y[++J] = [lt, lt];
      }), Y;
    }
    function W1(W, J, Y) {
      for (var lt = Y - 1, bt = W.length; ++lt < bt; )
        if (W[lt] === J)
          return lt;
      return -1;
    }
    function V1(W, J, Y) {
      for (var lt = Y + 1; lt--; )
        if (W[lt] === J)
          return lt;
      return lt;
    }
    function Hr(W) {
      return zr(W) ? K1(W) : F1(W);
    }
    function Ve(W) {
      return zr(W) ? Y1(W) : O1(W);
    }
    function jl(W) {
      for (var J = W.length; J-- && Ng.test(W.charAt(J)); )
        ;
      return J;
    }
    var j1 = Ka(w1);
    function K1(W) {
      for (var J = Ua.lastIndex = 0; Ua.test(W); )
        ++J;
      return J;
    }
    function Y1(W) {
      return W.match(Ua) || [];
    }
    function X1(W) {
      return W.match(p1) || [];
    }
    var $1 = function W(J) {
      J = J == null ? he : Wr.defaults(he.Object(), J, Wr.pick(he, y1));
      var Y = J.Array, lt = J.Date, bt = J.Error, Lt = J.Function, Qt = J.Math, Dt = J.Object, Ja = J.RegExp, Z1 = J.String, Le = J.TypeError, Tn = Y.prototype, J1 = Lt.prototype, Vr = Dt.prototype, Pn = J["__core-js_shared__"], Fn = J1.toString, Gt = Vr.hasOwnProperty, Q1 = 0, Kl = function() {
        var t = /[^.]+$/.exec(Pn && Pn.keys && Pn.keys.IE_PROTO || "");
        return t ? "Symbol(src)_1." + t : "";
      }(), On = Vr.toString, t2 = Fn.call(Dt), e2 = he._, r2 = Ja(
        "^" + Fn.call(Gt).replace(Ma, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), In = Fl ? J.Buffer : i, mr = J.Symbol, kn = J.Uint8Array, Yl = In ? In.allocUnsafe : i, Mn = Vl(Dt.getPrototypeOf, Dt), Xl = Dt.create, $l = Vr.propertyIsEnumerable, Ln = Tn.splice, Zl = mr ? mr.isConcatSpreadable : i, li = mr ? mr.iterator : i, Tr = mr ? mr.toStringTag : i, Nn = function() {
        try {
          var t = kr(Dt, "defineProperty");
          return t({}, "", {}), t;
        } catch {
        }
      }(), i2 = J.clearTimeout !== he.clearTimeout && J.clearTimeout, n2 = lt && lt.now !== he.Date.now && lt.now, a2 = J.setTimeout !== he.setTimeout && J.setTimeout, Gn = Qt.ceil, Dn = Qt.floor, Qa = Dt.getOwnPropertySymbols, s2 = In ? In.isBuffer : i, Jl = J.isFinite, o2 = Tn.join, h2 = Vl(Dt.keys, Dt), te = Qt.max, ue = Qt.min, l2 = lt.now, u2 = J.parseInt, Ql = Qt.random, c2 = Tn.reverse, ts = kr(J, "DataView"), ui = kr(J, "Map"), es = kr(J, "Promise"), jr = kr(J, "Set"), ci = kr(J, "WeakMap"), di = kr(Dt, "create"), Bn = ci && new ci(), Kr = {}, d2 = Mr(ts), f2 = Mr(ui), g2 = Mr(es), p2 = Mr(jr), _2 = Mr(ci), Un = mr ? mr.prototype : i, fi = Un ? Un.valueOf : i, tu = Un ? Un.toString : i;
      function I(t) {
        if (jt(t) && !St(t) && !(t instanceof It)) {
          if (t instanceof Ne)
            return t;
          if (Gt.call(t, "__wrapped__"))
            return ec(t);
        }
        return new Ne(t);
      }
      var Yr = /* @__PURE__ */ function() {
        function t() {
        }
        return function(e) {
          if (!Wt(e))
            return {};
          if (Xl)
            return Xl(e);
          t.prototype = e;
          var n = new t();
          return t.prototype = i, n;
        };
      }();
      function qn() {
      }
      function Ne(t, e) {
        this.__wrapped__ = t, this.__actions__ = [], this.__chain__ = !!e, this.__index__ = 0, this.__values__ = i;
      }
      I.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Fg,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Og,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: ll,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: I
        }
      }, I.prototype = qn.prototype, I.prototype.constructor = I, Ne.prototype = Yr(qn.prototype), Ne.prototype.constructor = Ne;
      function It(t) {
        this.__wrapped__ = t, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Q, this.__views__ = [];
      }
      function v2() {
        var t = new It(this.__wrapped__);
        return t.__actions__ = ve(this.__actions__), t.__dir__ = this.__dir__, t.__filtered__ = this.__filtered__, t.__iteratees__ = ve(this.__iteratees__), t.__takeCount__ = this.__takeCount__, t.__views__ = ve(this.__views__), t;
      }
      function y2() {
        if (this.__filtered__) {
          var t = new It(this);
          t.__dir__ = -1, t.__filtered__ = !0;
        } else
          t = this.clone(), t.__dir__ *= -1;
        return t;
      }
      function m2() {
        var t = this.__wrapped__.value(), e = this.__dir__, n = St(t), d = e < 0, R = n ? t.length : 0, L = Op(0, R, this.__views__), B = L.start, q = L.end, V = q - B, rt = d ? q : B - 1, it = this.__iteratees__, nt = it.length, ot = 0, dt = ue(V, this.__takeCount__);
        if (!n || !d && R == V && dt == V)
          return xu(t, this.__actions__);
        var vt = [];
        t:
          for (; V-- && ot < dt; ) {
            rt += e;
            for (var xt = -1, yt = t[rt]; ++xt < nt; ) {
              var Ft = it[xt], kt = Ft.iteratee, Pe = Ft.type, ge = kt(yt);
              if (Pe == A)
                yt = ge;
              else if (!ge) {
                if (Pe == P)
                  continue t;
                break t;
              }
            }
            vt[ot++] = yt;
          }
        return vt;
      }
      It.prototype = Yr(qn.prototype), It.prototype.constructor = It;
      function Pr(t) {
        var e = -1, n = t == null ? 0 : t.length;
        for (this.clear(); ++e < n; ) {
          var d = t[e];
          this.set(d[0], d[1]);
        }
      }
      function b2() {
        this.__data__ = di ? di(null) : {}, this.size = 0;
      }
      function S2(t) {
        var e = this.has(t) && delete this.__data__[t];
        return this.size -= e ? 1 : 0, e;
      }
      function w2(t) {
        var e = this.__data__;
        if (di) {
          var n = e[t];
          return n === g ? i : n;
        }
        return Gt.call(e, t) ? e[t] : i;
      }
      function C2(t) {
        var e = this.__data__;
        return di ? e[t] !== i : Gt.call(e, t);
      }
      function x2(t, e) {
        var n = this.__data__;
        return this.size += this.has(t) ? 0 : 1, n[t] = di && e === i ? g : e, this;
      }
      Pr.prototype.clear = b2, Pr.prototype.delete = S2, Pr.prototype.get = w2, Pr.prototype.has = C2, Pr.prototype.set = x2;
      function rr(t) {
        var e = -1, n = t == null ? 0 : t.length;
        for (this.clear(); ++e < n; ) {
          var d = t[e];
          this.set(d[0], d[1]);
        }
      }
      function E2() {
        this.__data__ = [], this.size = 0;
      }
      function A2(t) {
        var e = this.__data__, n = zn(e, t);
        if (n < 0)
          return !1;
        var d = e.length - 1;
        return n == d ? e.pop() : Ln.call(e, n, 1), --this.size, !0;
      }
      function R2(t) {
        var e = this.__data__, n = zn(e, t);
        return n < 0 ? i : e[n][1];
      }
      function T2(t) {
        return zn(this.__data__, t) > -1;
      }
      function P2(t, e) {
        var n = this.__data__, d = zn(n, t);
        return d < 0 ? (++this.size, n.push([t, e])) : n[d][1] = e, this;
      }
      rr.prototype.clear = E2, rr.prototype.delete = A2, rr.prototype.get = R2, rr.prototype.has = T2, rr.prototype.set = P2;
      function ir(t) {
        var e = -1, n = t == null ? 0 : t.length;
        for (this.clear(); ++e < n; ) {
          var d = t[e];
          this.set(d[0], d[1]);
        }
      }
      function F2() {
        this.size = 0, this.__data__ = {
          hash: new Pr(),
          map: new (ui || rr)(),
          string: new Pr()
        };
      }
      function O2(t) {
        var e = ta(this, t).delete(t);
        return this.size -= e ? 1 : 0, e;
      }
      function I2(t) {
        return ta(this, t).get(t);
      }
      function k2(t) {
        return ta(this, t).has(t);
      }
      function M2(t, e) {
        var n = ta(this, t), d = n.size;
        return n.set(t, e), this.size += n.size == d ? 0 : 1, this;
      }
      ir.prototype.clear = F2, ir.prototype.delete = O2, ir.prototype.get = I2, ir.prototype.has = k2, ir.prototype.set = M2;
      function Fr(t) {
        var e = -1, n = t == null ? 0 : t.length;
        for (this.__data__ = new ir(); ++e < n; )
          this.add(t[e]);
      }
      function L2(t) {
        return this.__data__.set(t, g), this;
      }
      function N2(t) {
        return this.__data__.has(t);
      }
      Fr.prototype.add = Fr.prototype.push = L2, Fr.prototype.has = N2;
      function je(t) {
        var e = this.__data__ = new rr(t);
        this.size = e.size;
      }
      function G2() {
        this.__data__ = new rr(), this.size = 0;
      }
      function D2(t) {
        var e = this.__data__, n = e.delete(t);
        return this.size = e.size, n;
      }
      function B2(t) {
        return this.__data__.get(t);
      }
      function U2(t) {
        return this.__data__.has(t);
      }
      function q2(t, e) {
        var n = this.__data__;
        if (n instanceof rr) {
          var d = n.__data__;
          if (!ui || d.length < h - 1)
            return d.push([t, e]), this.size = ++n.size, this;
          n = this.__data__ = new ir(d);
        }
        return n.set(t, e), this.size = n.size, this;
      }
      je.prototype.clear = G2, je.prototype.delete = D2, je.prototype.get = B2, je.prototype.has = U2, je.prototype.set = q2;
      function eu(t, e) {
        var n = St(t), d = !n && Lr(t), R = !n && !d && xr(t), L = !n && !d && !R && Jr(t), B = n || d || R || L, q = B ? Xa(t.length, Z1) : [], V = q.length;
        for (var rt in t)
          (e || Gt.call(t, rt)) && !(B && // Safari 9 has enumerable `arguments.length` in strict mode.
          (rt == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          R && (rt == "offset" || rt == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          L && (rt == "buffer" || rt == "byteLength" || rt == "byteOffset") || // Skip index properties.
          or(rt, V))) && q.push(rt);
        return q;
      }
      function ru(t) {
        var e = t.length;
        return e ? t[ds(0, e - 1)] : i;
      }
      function z2(t, e) {
        return ea(ve(t), Or(e, 0, t.length));
      }
      function H2(t) {
        return ea(ve(t));
      }
      function rs(t, e, n) {
        (n !== i && !Ke(t[e], n) || n === i && !(e in t)) && nr(t, e, n);
      }
      function gi(t, e, n) {
        var d = t[e];
        (!(Gt.call(t, e) && Ke(d, n)) || n === i && !(e in t)) && nr(t, e, n);
      }
      function zn(t, e) {
        for (var n = t.length; n--; )
          if (Ke(t[n][0], e))
            return n;
        return -1;
      }
      function W2(t, e, n, d) {
        return br(t, function(R, L, B) {
          e(d, R, n(R), B);
        }), d;
      }
      function iu(t, e) {
        return t && tr(e, se(e), t);
      }
      function V2(t, e) {
        return t && tr(e, me(e), t);
      }
      function nr(t, e, n) {
        e == "__proto__" && Nn ? Nn(t, e, {
          configurable: !0,
          enumerable: !0,
          value: n,
          writable: !0
        }) : t[e] = n;
      }
      function is(t, e) {
        for (var n = -1, d = e.length, R = Y(d), L = t == null; ++n < d; )
          R[n] = L ? i : Gs(t, e[n]);
        return R;
      }
      function Or(t, e, n) {
        return t === t && (n !== i && (t = t <= n ? t : n), e !== i && (t = t >= e ? t : e)), t;
      }
      function Ge(t, e, n, d, R, L) {
        var B, q = e & S, V = e & x, rt = e & v;
        if (n && (B = R ? n(t, d, R, L) : n(t)), B !== i)
          return B;
        if (!Wt(t))
          return t;
        var it = St(t);
        if (it) {
          if (B = kp(t), !q)
            return ve(t, B);
        } else {
          var nt = ce(t), ot = nt == pt || nt == Mt;
          if (xr(t))
            return Ru(t, q);
          if (nt == Pt || nt == ht || ot && !R) {
            if (B = V || ot ? {} : ju(t), !q)
              return V ? wp(t, V2(B, t)) : Sp(t, iu(B, t));
          } else {
            if (!Bt[nt])
              return R ? t : {};
            B = Mp(t, nt, q);
          }
        }
        L || (L = new je());
        var dt = L.get(t);
        if (dt)
          return dt;
        L.set(t, B), Sc(t) ? t.forEach(function(yt) {
          B.add(Ge(yt, e, n, yt, t, L));
        }) : mc(t) && t.forEach(function(yt, Ft) {
          B.set(Ft, Ge(yt, e, n, Ft, t, L));
        });
        var vt = rt ? V ? Cs : ws : V ? me : se, xt = it ? i : vt(t);
        return Me(xt || t, function(yt, Ft) {
          xt && (Ft = yt, yt = t[Ft]), gi(B, Ft, Ge(yt, e, n, Ft, t, L));
        }), B;
      }
      function j2(t) {
        var e = se(t);
        return function(n) {
          return nu(n, t, e);
        };
      }
      function nu(t, e, n) {
        var d = n.length;
        if (t == null)
          return !d;
        for (t = Dt(t); d--; ) {
          var R = n[d], L = e[R], B = t[R];
          if (B === i && !(R in t) || !L(B))
            return !1;
        }
        return !0;
      }
      function au(t, e, n) {
        if (typeof t != "function")
          throw new Le(l);
        return Si(function() {
          t.apply(i, n);
        }, e);
      }
      function pi(t, e, n, d) {
        var R = -1, L = En, B = !0, q = t.length, V = [], rt = e.length;
        if (!q)
          return V;
        n && (e = zt(e, Ae(n))), d ? (L = Ha, B = !1) : e.length >= h && (L = hi, B = !1, e = new Fr(e));
        t:
          for (; ++R < q; ) {
            var it = t[R], nt = n == null ? it : n(it);
            if (it = d || it !== 0 ? it : 0, B && nt === nt) {
              for (var ot = rt; ot--; )
                if (e[ot] === nt)
                  continue t;
              V.push(it);
            } else
              L(e, nt, d) || V.push(it);
          }
        return V;
      }
      var br = Iu(Qe), su = Iu(as, !0);
      function K2(t, e) {
        var n = !0;
        return br(t, function(d, R, L) {
          return n = !!e(d, R, L), n;
        }), n;
      }
      function Hn(t, e, n) {
        for (var d = -1, R = t.length; ++d < R; ) {
          var L = t[d], B = e(L);
          if (B != null && (q === i ? B === B && !Te(B) : n(B, q)))
            var q = B, V = L;
        }
        return V;
      }
      function Y2(t, e, n, d) {
        var R = t.length;
        for (n = Ct(n), n < 0 && (n = -n > R ? 0 : R + n), d = d === i || d > R ? R : Ct(d), d < 0 && (d += R), d = n > d ? 0 : Cc(d); n < d; )
          t[n++] = e;
        return t;
      }
      function ou(t, e) {
        var n = [];
        return br(t, function(d, R, L) {
          e(d, R, L) && n.push(d);
        }), n;
      }
      function le(t, e, n, d, R) {
        var L = -1, B = t.length;
        for (n || (n = Np), R || (R = []); ++L < B; ) {
          var q = t[L];
          e > 0 && n(q) ? e > 1 ? le(q, e - 1, n, d, R) : vr(R, q) : d || (R[R.length] = q);
        }
        return R;
      }
      var ns = ku(), hu = ku(!0);
      function Qe(t, e) {
        return t && ns(t, e, se);
      }
      function as(t, e) {
        return t && hu(t, e, se);
      }
      function Wn(t, e) {
        return _r(e, function(n) {
          return hr(t[n]);
        });
      }
      function Ir(t, e) {
        e = wr(e, t);
        for (var n = 0, d = e.length; t != null && n < d; )
          t = t[er(e[n++])];
        return n && n == d ? t : i;
      }
      function lu(t, e, n) {
        var d = e(t);
        return St(t) ? d : vr(d, n(t));
      }
      function de(t) {
        return t == null ? t === i ? ze : re : Tr && Tr in Dt(t) ? Fp(t) : Hp(t);
      }
      function ss(t, e) {
        return t > e;
      }
      function X2(t, e) {
        return t != null && Gt.call(t, e);
      }
      function $2(t, e) {
        return t != null && e in Dt(t);
      }
      function Z2(t, e, n) {
        return t >= ue(e, n) && t < te(e, n);
      }
      function os(t, e, n) {
        for (var d = n ? Ha : En, R = t[0].length, L = t.length, B = L, q = Y(L), V = 1 / 0, rt = []; B--; ) {
          var it = t[B];
          B && e && (it = zt(it, Ae(e))), V = ue(it.length, V), q[B] = !n && (e || R >= 120 && it.length >= 120) ? new Fr(B && it) : i;
        }
        it = t[0];
        var nt = -1, ot = q[0];
        t:
          for (; ++nt < R && rt.length < V; ) {
            var dt = it[nt], vt = e ? e(dt) : dt;
            if (dt = n || dt !== 0 ? dt : 0, !(ot ? hi(ot, vt) : d(rt, vt, n))) {
              for (B = L; --B; ) {
                var xt = q[B];
                if (!(xt ? hi(xt, vt) : d(t[B], vt, n)))
                  continue t;
              }
              ot && ot.push(vt), rt.push(dt);
            }
          }
        return rt;
      }
      function J2(t, e, n, d) {
        return Qe(t, function(R, L, B) {
          e(d, n(R), L, B);
        }), d;
      }
      function _i(t, e, n) {
        e = wr(e, t), t = $u(t, e);
        var d = t == null ? t : t[er(Be(e))];
        return d == null ? i : Ee(d, t, n);
      }
      function uu(t) {
        return jt(t) && de(t) == ht;
      }
      function Q2(t) {
        return jt(t) && de(t) == Vt;
      }
      function tp(t) {
        return jt(t) && de(t) == et;
      }
      function vi(t, e, n, d, R) {
        return t === e ? !0 : t == null || e == null || !jt(t) && !jt(e) ? t !== t && e !== e : ep(t, e, n, d, vi, R);
      }
      function ep(t, e, n, d, R, L) {
        var B = St(t), q = St(e), V = B ? ct : ce(t), rt = q ? ct : ce(e);
        V = V == ht ? Pt : V, rt = rt == ht ? Pt : rt;
        var it = V == Pt, nt = rt == Pt, ot = V == rt;
        if (ot && xr(t)) {
          if (!xr(e))
            return !1;
          B = !0, it = !1;
        }
        if (ot && !it)
          return L || (L = new je()), B || Jr(t) ? Hu(t, e, n, d, R, L) : Tp(t, e, V, n, d, R, L);
        if (!(n & _)) {
          var dt = it && Gt.call(t, "__wrapped__"), vt = nt && Gt.call(e, "__wrapped__");
          if (dt || vt) {
            var xt = dt ? t.value() : t, yt = vt ? e.value() : e;
            return L || (L = new je()), R(xt, yt, n, d, L);
          }
        }
        return ot ? (L || (L = new je()), Pp(t, e, n, d, R, L)) : !1;
      }
      function rp(t) {
        return jt(t) && ce(t) == Et;
      }
      function hs(t, e, n, d) {
        var R = n.length, L = R, B = !d;
        if (t == null)
          return !L;
        for (t = Dt(t); R--; ) {
          var q = n[R];
          if (B && q[2] ? q[1] !== t[q[0]] : !(q[0] in t))
            return !1;
        }
        for (; ++R < L; ) {
          q = n[R];
          var V = q[0], rt = t[V], it = q[1];
          if (B && q[2]) {
            if (rt === i && !(V in t))
              return !1;
          } else {
            var nt = new je();
            if (d)
              var ot = d(rt, it, V, t, e, nt);
            if (!(ot === i ? vi(it, rt, _ | w, d, nt) : ot))
              return !1;
          }
        }
        return !0;
      }
      function cu(t) {
        if (!Wt(t) || Dp(t))
          return !1;
        var e = hr(t) ? r2 : jg;
        return e.test(Mr(t));
      }
      function ip(t) {
        return jt(t) && de(t) == ie;
      }
      function np(t) {
        return jt(t) && ce(t) == Zt;
      }
      function ap(t) {
        return jt(t) && oa(t.length) && !!qt[de(t)];
      }
      function du(t) {
        return typeof t == "function" ? t : t == null ? be : typeof t == "object" ? St(t) ? pu(t[0], t[1]) : gu(t) : Mc(t);
      }
      function ls(t) {
        if (!bi(t))
          return h2(t);
        var e = [];
        for (var n in Dt(t))
          Gt.call(t, n) && n != "constructor" && e.push(n);
        return e;
      }
      function sp(t) {
        if (!Wt(t))
          return zp(t);
        var e = bi(t), n = [];
        for (var d in t)
          d == "constructor" && (e || !Gt.call(t, d)) || n.push(d);
        return n;
      }
      function us(t, e) {
        return t < e;
      }
      function fu(t, e) {
        var n = -1, d = ye(t) ? Y(t.length) : [];
        return br(t, function(R, L, B) {
          d[++n] = e(R, L, B);
        }), d;
      }
      function gu(t) {
        var e = Es(t);
        return e.length == 1 && e[0][2] ? Yu(e[0][0], e[0][1]) : function(n) {
          return n === t || hs(n, t, e);
        };
      }
      function pu(t, e) {
        return Rs(t) && Ku(e) ? Yu(er(t), e) : function(n) {
          var d = Gs(n, t);
          return d === i && d === e ? Ds(n, t) : vi(e, d, _ | w);
        };
      }
      function Vn(t, e, n, d, R) {
        t !== e && ns(e, function(L, B) {
          if (R || (R = new je()), Wt(L))
            op(t, e, B, n, Vn, d, R);
          else {
            var q = d ? d(Ps(t, B), L, B + "", t, e, R) : i;
            q === i && (q = L), rs(t, B, q);
          }
        }, me);
      }
      function op(t, e, n, d, R, L, B) {
        var q = Ps(t, n), V = Ps(e, n), rt = B.get(V);
        if (rt) {
          rs(t, n, rt);
          return;
        }
        var it = L ? L(q, V, n + "", t, e, B) : i, nt = it === i;
        if (nt) {
          var ot = St(V), dt = !ot && xr(V), vt = !ot && !dt && Jr(V);
          it = V, ot || dt || vt ? St(q) ? it = q : Yt(q) ? it = ve(q) : dt ? (nt = !1, it = Ru(V, !0)) : vt ? (nt = !1, it = Tu(V, !0)) : it = [] : wi(V) || Lr(V) ? (it = q, Lr(q) ? it = xc(q) : (!Wt(q) || hr(q)) && (it = ju(V))) : nt = !1;
        }
        nt && (B.set(V, it), R(it, V, d, L, B), B.delete(V)), rs(t, n, it);
      }
      function _u(t, e) {
        var n = t.length;
        if (n)
          return e += e < 0 ? n : 0, or(e, n) ? t[e] : i;
      }
      function vu(t, e, n) {
        e.length ? e = zt(e, function(L) {
          return St(L) ? function(B) {
            return Ir(B, L.length === 1 ? L[0] : L);
          } : L;
        }) : e = [be];
        var d = -1;
        e = zt(e, Ae(_t()));
        var R = fu(t, function(L, B, q) {
          var V = zt(e, function(rt) {
            return rt(L);
          });
          return { criteria: V, index: ++d, value: L };
        });
        return M1(R, function(L, B) {
          return bp(L, B, n);
        });
      }
      function hp(t, e) {
        return yu(t, e, function(n, d) {
          return Ds(t, d);
        });
      }
      function yu(t, e, n) {
        for (var d = -1, R = e.length, L = {}; ++d < R; ) {
          var B = e[d], q = Ir(t, B);
          n(q, B) && yi(L, wr(B, t), q);
        }
        return L;
      }
      function lp(t) {
        return function(e) {
          return Ir(e, t);
        };
      }
      function cs(t, e, n, d) {
        var R = d ? k1 : qr, L = -1, B = e.length, q = t;
        for (t === e && (e = ve(e)), n && (q = zt(t, Ae(n))); ++L < B; )
          for (var V = 0, rt = e[L], it = n ? n(rt) : rt; (V = R(q, it, V, d)) > -1; )
            q !== t && Ln.call(q, V, 1), Ln.call(t, V, 1);
        return t;
      }
      function mu(t, e) {
        for (var n = t ? e.length : 0, d = n - 1; n--; ) {
          var R = e[n];
          if (n == d || R !== L) {
            var L = R;
            or(R) ? Ln.call(t, R, 1) : ps(t, R);
          }
        }
        return t;
      }
      function ds(t, e) {
        return t + Dn(Ql() * (e - t + 1));
      }
      function up(t, e, n, d) {
        for (var R = -1, L = te(Gn((e - t) / (n || 1)), 0), B = Y(L); L--; )
          B[d ? L : ++R] = t, t += n;
        return B;
      }
      function fs(t, e) {
        var n = "";
        if (!t || e < 1 || e > K)
          return n;
        do
          e % 2 && (n += t), e = Dn(e / 2), e && (t += t);
        while (e);
        return n;
      }
      function At(t, e) {
        return Fs(Xu(t, e, be), t + "");
      }
      function cp(t) {
        return ru(Qr(t));
      }
      function dp(t, e) {
        var n = Qr(t);
        return ea(n, Or(e, 0, n.length));
      }
      function yi(t, e, n, d) {
        if (!Wt(t))
          return t;
        e = wr(e, t);
        for (var R = -1, L = e.length, B = L - 1, q = t; q != null && ++R < L; ) {
          var V = er(e[R]), rt = n;
          if (V === "__proto__" || V === "constructor" || V === "prototype")
            return t;
          if (R != B) {
            var it = q[V];
            rt = d ? d(it, V, q) : i, rt === i && (rt = Wt(it) ? it : or(e[R + 1]) ? [] : {});
          }
          gi(q, V, rt), q = q[V];
        }
        return t;
      }
      var bu = Bn ? function(t, e) {
        return Bn.set(t, e), t;
      } : be, fp = Nn ? function(t, e) {
        return Nn(t, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Us(e),
          writable: !0
        });
      } : be;
      function gp(t) {
        return ea(Qr(t));
      }
      function De(t, e, n) {
        var d = -1, R = t.length;
        e < 0 && (e = -e > R ? 0 : R + e), n = n > R ? R : n, n < 0 && (n += R), R = e > n ? 0 : n - e >>> 0, e >>>= 0;
        for (var L = Y(R); ++d < R; )
          L[d] = t[d + e];
        return L;
      }
      function pp(t, e) {
        var n;
        return br(t, function(d, R, L) {
          return n = e(d, R, L), !n;
        }), !!n;
      }
      function jn(t, e, n) {
        var d = 0, R = t == null ? d : t.length;
        if (typeof e == "number" && e === e && R <= Z) {
          for (; d < R; ) {
            var L = d + R >>> 1, B = t[L];
            B !== null && !Te(B) && (n ? B <= e : B < e) ? d = L + 1 : R = L;
          }
          return R;
        }
        return gs(t, e, be, n);
      }
      function gs(t, e, n, d) {
        var R = 0, L = t == null ? 0 : t.length;
        if (L === 0)
          return 0;
        e = n(e);
        for (var B = e !== e, q = e === null, V = Te(e), rt = e === i; R < L; ) {
          var it = Dn((R + L) / 2), nt = n(t[it]), ot = nt !== i, dt = nt === null, vt = nt === nt, xt = Te(nt);
          if (B)
            var yt = d || vt;
          else
            rt ? yt = vt && (d || ot) : q ? yt = vt && ot && (d || !dt) : V ? yt = vt && ot && !dt && (d || !xt) : dt || xt ? yt = !1 : yt = d ? nt <= e : nt < e;
          yt ? R = it + 1 : L = it;
        }
        return ue(L, st);
      }
      function Su(t, e) {
        for (var n = -1, d = t.length, R = 0, L = []; ++n < d; ) {
          var B = t[n], q = e ? e(B) : B;
          if (!n || !Ke(q, V)) {
            var V = q;
            L[R++] = B === 0 ? 0 : B;
          }
        }
        return L;
      }
      function wu(t) {
        return typeof t == "number" ? t : Te(t) ? X : +t;
      }
      function Re(t) {
        if (typeof t == "string")
          return t;
        if (St(t))
          return zt(t, Re) + "";
        if (Te(t))
          return tu ? tu.call(t) : "";
        var e = t + "";
        return e == "0" && 1 / t == -1 / 0 ? "-0" : e;
      }
      function Sr(t, e, n) {
        var d = -1, R = En, L = t.length, B = !0, q = [], V = q;
        if (n)
          B = !1, R = Ha;
        else if (L >= h) {
          var rt = e ? null : Ap(t);
          if (rt)
            return Rn(rt);
          B = !1, R = hi, V = new Fr();
        } else
          V = e ? [] : q;
        t:
          for (; ++d < L; ) {
            var it = t[d], nt = e ? e(it) : it;
            if (it = n || it !== 0 ? it : 0, B && nt === nt) {
              for (var ot = V.length; ot--; )
                if (V[ot] === nt)
                  continue t;
              e && V.push(nt), q.push(it);
            } else
              R(V, nt, n) || (V !== q && V.push(nt), q.push(it));
          }
        return q;
      }
      function ps(t, e) {
        return e = wr(e, t), t = $u(t, e), t == null || delete t[er(Be(e))];
      }
      function Cu(t, e, n, d) {
        return yi(t, e, n(Ir(t, e)), d);
      }
      function Kn(t, e, n, d) {
        for (var R = t.length, L = d ? R : -1; (d ? L-- : ++L < R) && e(t[L], L, t); )
          ;
        return n ? De(t, d ? 0 : L, d ? L + 1 : R) : De(t, d ? L + 1 : 0, d ? R : L);
      }
      function xu(t, e) {
        var n = t;
        return n instanceof It && (n = n.value()), Wa(e, function(d, R) {
          return R.func.apply(R.thisArg, vr([d], R.args));
        }, n);
      }
      function _s(t, e, n) {
        var d = t.length;
        if (d < 2)
          return d ? Sr(t[0]) : [];
        for (var R = -1, L = Y(d); ++R < d; )
          for (var B = t[R], q = -1; ++q < d; )
            q != R && (L[R] = pi(L[R] || B, t[q], e, n));
        return Sr(le(L, 1), e, n);
      }
      function Eu(t, e, n) {
        for (var d = -1, R = t.length, L = e.length, B = {}; ++d < R; ) {
          var q = d < L ? e[d] : i;
          n(B, t[d], q);
        }
        return B;
      }
      function vs(t) {
        return Yt(t) ? t : [];
      }
      function ys(t) {
        return typeof t == "function" ? t : be;
      }
      function wr(t, e) {
        return St(t) ? t : Rs(t, e) ? [t] : tc(Nt(t));
      }
      var _p = At;
      function Cr(t, e, n) {
        var d = t.length;
        return n = n === i ? d : n, !e && n >= d ? t : De(t, e, n);
      }
      var Au = i2 || function(t) {
        return he.clearTimeout(t);
      };
      function Ru(t, e) {
        if (e)
          return t.slice();
        var n = t.length, d = Yl ? Yl(n) : new t.constructor(n);
        return t.copy(d), d;
      }
      function ms(t) {
        var e = new t.constructor(t.byteLength);
        return new kn(e).set(new kn(t)), e;
      }
      function vp(t, e) {
        var n = e ? ms(t.buffer) : t.buffer;
        return new t.constructor(n, t.byteOffset, t.byteLength);
      }
      function yp(t) {
        var e = new t.constructor(t.source, ul.exec(t));
        return e.lastIndex = t.lastIndex, e;
      }
      function mp(t) {
        return fi ? Dt(fi.call(t)) : {};
      }
      function Tu(t, e) {
        var n = e ? ms(t.buffer) : t.buffer;
        return new t.constructor(n, t.byteOffset, t.length);
      }
      function Pu(t, e) {
        if (t !== e) {
          var n = t !== i, d = t === null, R = t === t, L = Te(t), B = e !== i, q = e === null, V = e === e, rt = Te(e);
          if (!q && !rt && !L && t > e || L && B && V && !q && !rt || d && B && V || !n && V || !R)
            return 1;
          if (!d && !L && !rt && t < e || rt && n && R && !d && !L || q && n && R || !B && R || !V)
            return -1;
        }
        return 0;
      }
      function bp(t, e, n) {
        for (var d = -1, R = t.criteria, L = e.criteria, B = R.length, q = n.length; ++d < B; ) {
          var V = Pu(R[d], L[d]);
          if (V) {
            if (d >= q)
              return V;
            var rt = n[d];
            return V * (rt == "desc" ? -1 : 1);
          }
        }
        return t.index - e.index;
      }
      function Fu(t, e, n, d) {
        for (var R = -1, L = t.length, B = n.length, q = -1, V = e.length, rt = te(L - B, 0), it = Y(V + rt), nt = !d; ++q < V; )
          it[q] = e[q];
        for (; ++R < B; )
          (nt || R < L) && (it[n[R]] = t[R]);
        for (; rt--; )
          it[q++] = t[R++];
        return it;
      }
      function Ou(t, e, n, d) {
        for (var R = -1, L = t.length, B = -1, q = n.length, V = -1, rt = e.length, it = te(L - q, 0), nt = Y(it + rt), ot = !d; ++R < it; )
          nt[R] = t[R];
        for (var dt = R; ++V < rt; )
          nt[dt + V] = e[V];
        for (; ++B < q; )
          (ot || R < L) && (nt[dt + n[B]] = t[R++]);
        return nt;
      }
      function ve(t, e) {
        var n = -1, d = t.length;
        for (e || (e = Y(d)); ++n < d; )
          e[n] = t[n];
        return e;
      }
      function tr(t, e, n, d) {
        var R = !n;
        n || (n = {});
        for (var L = -1, B = e.length; ++L < B; ) {
          var q = e[L], V = d ? d(n[q], t[q], q, n, t) : i;
          V === i && (V = t[q]), R ? nr(n, q, V) : gi(n, q, V);
        }
        return n;
      }
      function Sp(t, e) {
        return tr(t, As(t), e);
      }
      function wp(t, e) {
        return tr(t, Wu(t), e);
      }
      function Yn(t, e) {
        return function(n, d) {
          var R = St(n) ? R1 : W2, L = e ? e() : {};
          return R(n, t, _t(d, 2), L);
        };
      }
      function Xr(t) {
        return At(function(e, n) {
          var d = -1, R = n.length, L = R > 1 ? n[R - 1] : i, B = R > 2 ? n[2] : i;
          for (L = t.length > 3 && typeof L == "function" ? (R--, L) : i, B && fe(n[0], n[1], B) && (L = R < 3 ? i : L, R = 1), e = Dt(e); ++d < R; ) {
            var q = n[d];
            q && t(e, q, d, L);
          }
          return e;
        });
      }
      function Iu(t, e) {
        return function(n, d) {
          if (n == null)
            return n;
          if (!ye(n))
            return t(n, d);
          for (var R = n.length, L = e ? R : -1, B = Dt(n); (e ? L-- : ++L < R) && d(B[L], L, B) !== !1; )
            ;
          return n;
        };
      }
      function ku(t) {
        return function(e, n, d) {
          for (var R = -1, L = Dt(e), B = d(e), q = B.length; q--; ) {
            var V = B[t ? q : ++R];
            if (n(L[V], V, L) === !1)
              break;
          }
          return e;
        };
      }
      function Cp(t, e, n) {
        var d = e & C, R = mi(t);
        function L() {
          var B = this && this !== he && this instanceof L ? R : t;
          return B.apply(d ? n : this, arguments);
        }
        return L;
      }
      function Mu(t) {
        return function(e) {
          e = Nt(e);
          var n = zr(e) ? Ve(e) : i, d = n ? n[0] : e.charAt(0), R = n ? Cr(n, 1).join("") : e.slice(1);
          return d[t]() + R;
        };
      }
      function $r(t) {
        return function(e) {
          return Wa(Ic(Oc(e).replace(f1, "")), t, "");
        };
      }
      function mi(t) {
        return function() {
          var e = arguments;
          switch (e.length) {
            case 0:
              return new t();
            case 1:
              return new t(e[0]);
            case 2:
              return new t(e[0], e[1]);
            case 3:
              return new t(e[0], e[1], e[2]);
            case 4:
              return new t(e[0], e[1], e[2], e[3]);
            case 5:
              return new t(e[0], e[1], e[2], e[3], e[4]);
            case 6:
              return new t(e[0], e[1], e[2], e[3], e[4], e[5]);
            case 7:
              return new t(e[0], e[1], e[2], e[3], e[4], e[5], e[6]);
          }
          var n = Yr(t.prototype), d = t.apply(n, e);
          return Wt(d) ? d : n;
        };
      }
      function xp(t, e, n) {
        var d = mi(t);
        function R() {
          for (var L = arguments.length, B = Y(L), q = L, V = Zr(R); q--; )
            B[q] = arguments[q];
          var rt = L < 3 && B[0] !== V && B[L - 1] !== V ? [] : yr(B, V);
          if (L -= rt.length, L < n)
            return Bu(
              t,
              e,
              Xn,
              R.placeholder,
              i,
              B,
              rt,
              i,
              i,
              n - L
            );
          var it = this && this !== he && this instanceof R ? d : t;
          return Ee(it, this, B);
        }
        return R;
      }
      function Lu(t) {
        return function(e, n, d) {
          var R = Dt(e);
          if (!ye(e)) {
            var L = _t(n, 3);
            e = se(e), n = function(q) {
              return L(R[q], q, R);
            };
          }
          var B = t(e, n, d);
          return B > -1 ? R[L ? e[B] : B] : i;
        };
      }
      function Nu(t) {
        return sr(function(e) {
          var n = e.length, d = n, R = Ne.prototype.thru;
          for (t && e.reverse(); d--; ) {
            var L = e[d];
            if (typeof L != "function")
              throw new Le(l);
            if (R && !B && Qn(L) == "wrapper")
              var B = new Ne([], !0);
          }
          for (d = B ? d : n; ++d < n; ) {
            L = e[d];
            var q = Qn(L), V = q == "wrapper" ? xs(L) : i;
            V && Ts(V[0]) && V[1] == (D | f | E | k) && !V[4].length && V[9] == 1 ? B = B[Qn(V[0])].apply(B, V[3]) : B = L.length == 1 && Ts(L) ? B[q]() : B.thru(L);
          }
          return function() {
            var rt = arguments, it = rt[0];
            if (B && rt.length == 1 && St(it))
              return B.plant(it).value();
            for (var nt = 0, ot = n ? e[nt].apply(this, rt) : it; ++nt < n; )
              ot = e[nt].call(this, ot);
            return ot;
          };
        });
      }
      function Xn(t, e, n, d, R, L, B, q, V, rt) {
        var it = e & D, nt = e & C, ot = e & F, dt = e & (f | m), vt = e & M, xt = ot ? i : mi(t);
        function yt() {
          for (var Ft = arguments.length, kt = Y(Ft), Pe = Ft; Pe--; )
            kt[Pe] = arguments[Pe];
          if (dt)
            var ge = Zr(yt), Fe = N1(kt, ge);
          if (d && (kt = Fu(kt, d, R, dt)), L && (kt = Ou(kt, L, B, dt)), Ft -= Fe, dt && Ft < rt) {
            var Xt = yr(kt, ge);
            return Bu(
              t,
              e,
              Xn,
              yt.placeholder,
              n,
              kt,
              Xt,
              q,
              V,
              rt - Ft
            );
          }
          var Ye = nt ? n : this, ur = ot ? Ye[t] : t;
          return Ft = kt.length, q ? kt = Wp(kt, q) : vt && Ft > 1 && kt.reverse(), it && V < Ft && (kt.length = V), this && this !== he && this instanceof yt && (ur = xt || mi(ur)), ur.apply(Ye, kt);
        }
        return yt;
      }
      function Gu(t, e) {
        return function(n, d) {
          return J2(n, t, e(d), {});
        };
      }
      function $n(t, e) {
        return function(n, d) {
          var R;
          if (n === i && d === i)
            return e;
          if (n !== i && (R = n), d !== i) {
            if (R === i)
              return d;
            typeof n == "string" || typeof d == "string" ? (n = Re(n), d = Re(d)) : (n = wu(n), d = wu(d)), R = t(n, d);
          }
          return R;
        };
      }
      function bs(t) {
        return sr(function(e) {
          return e = zt(e, Ae(_t())), At(function(n) {
            var d = this;
            return t(e, function(R) {
              return Ee(R, d, n);
            });
          });
        });
      }
      function Zn(t, e) {
        e = e === i ? " " : Re(e);
        var n = e.length;
        if (n < 2)
          return n ? fs(e, t) : e;
        var d = fs(e, Gn(t / Hr(e)));
        return zr(e) ? Cr(Ve(d), 0, t).join("") : d.slice(0, t);
      }
      function Ep(t, e, n, d) {
        var R = e & C, L = mi(t);
        function B() {
          for (var q = -1, V = arguments.length, rt = -1, it = d.length, nt = Y(it + V), ot = this && this !== he && this instanceof B ? L : t; ++rt < it; )
            nt[rt] = d[rt];
          for (; V--; )
            nt[rt++] = arguments[++q];
          return Ee(ot, R ? n : this, nt);
        }
        return B;
      }
      function Du(t) {
        return function(e, n, d) {
          return d && typeof d != "number" && fe(e, n, d) && (n = d = i), e = lr(e), n === i ? (n = e, e = 0) : n = lr(n), d = d === i ? e < n ? 1 : -1 : lr(d), up(e, n, d, t);
        };
      }
      function Jn(t) {
        return function(e, n) {
          return typeof e == "string" && typeof n == "string" || (e = Ue(e), n = Ue(n)), t(e, n);
        };
      }
      function Bu(t, e, n, d, R, L, B, q, V, rt) {
        var it = e & f, nt = it ? B : i, ot = it ? i : B, dt = it ? L : i, vt = it ? i : L;
        e |= it ? E : T, e &= ~(it ? T : E), e & c || (e &= -4);
        var xt = [
          t,
          e,
          R,
          dt,
          nt,
          vt,
          ot,
          q,
          V,
          rt
        ], yt = n.apply(i, xt);
        return Ts(t) && Zu(yt, xt), yt.placeholder = d, Ju(yt, t, e);
      }
      function Ss(t) {
        var e = Qt[t];
        return function(n, d) {
          if (n = Ue(n), d = d == null ? 0 : ue(Ct(d), 292), d && Jl(n)) {
            var R = (Nt(n) + "e").split("e"), L = e(R[0] + "e" + (+R[1] + d));
            return R = (Nt(L) + "e").split("e"), +(R[0] + "e" + (+R[1] - d));
          }
          return e(n);
        };
      }
      var Ap = jr && 1 / Rn(new jr([, -0]))[1] == U ? function(t) {
        return new jr(t);
      } : Hs;
      function Uu(t) {
        return function(e) {
          var n = ce(e);
          return n == Et ? Za(e) : n == Zt ? H1(e) : L1(e, t(e));
        };
      }
      function ar(t, e, n, d, R, L, B, q) {
        var V = e & F;
        if (!V && typeof t != "function")
          throw new Le(l);
        var rt = d ? d.length : 0;
        if (rt || (e &= -97, d = R = i), B = B === i ? B : te(Ct(B), 0), q = q === i ? q : Ct(q), rt -= R ? R.length : 0, e & T) {
          var it = d, nt = R;
          d = R = i;
        }
        var ot = V ? i : xs(t), dt = [
          t,
          e,
          n,
          d,
          R,
          it,
          nt,
          L,
          B,
          q
        ];
        if (ot && qp(dt, ot), t = dt[0], e = dt[1], n = dt[2], d = dt[3], R = dt[4], q = dt[9] = dt[9] === i ? V ? 0 : t.length : te(dt[9] - rt, 0), !q && e & (f | m) && (e &= -25), !e || e == C)
          var vt = Cp(t, e, n);
        else
          e == f || e == m ? vt = xp(t, e, q) : (e == E || e == (C | E)) && !R.length ? vt = Ep(t, e, n, d) : vt = Xn.apply(i, dt);
        var xt = ot ? bu : Zu;
        return Ju(xt(vt, dt), t, e);
      }
      function qu(t, e, n, d) {
        return t === i || Ke(t, Vr[n]) && !Gt.call(d, n) ? e : t;
      }
      function zu(t, e, n, d, R, L) {
        return Wt(t) && Wt(e) && (L.set(e, t), Vn(t, e, i, zu, L), L.delete(e)), t;
      }
      function Rp(t) {
        return wi(t) ? i : t;
      }
      function Hu(t, e, n, d, R, L) {
        var B = n & _, q = t.length, V = e.length;
        if (q != V && !(B && V > q))
          return !1;
        var rt = L.get(t), it = L.get(e);
        if (rt && it)
          return rt == e && it == t;
        var nt = -1, ot = !0, dt = n & w ? new Fr() : i;
        for (L.set(t, e), L.set(e, t); ++nt < q; ) {
          var vt = t[nt], xt = e[nt];
          if (d)
            var yt = B ? d(xt, vt, nt, e, t, L) : d(vt, xt, nt, t, e, L);
          if (yt !== i) {
            if (yt)
              continue;
            ot = !1;
            break;
          }
          if (dt) {
            if (!Va(e, function(Ft, kt) {
              if (!hi(dt, kt) && (vt === Ft || R(vt, Ft, n, d, L)))
                return dt.push(kt);
            })) {
              ot = !1;
              break;
            }
          } else if (!(vt === xt || R(vt, xt, n, d, L))) {
            ot = !1;
            break;
          }
        }
        return L.delete(t), L.delete(e), ot;
      }
      function Tp(t, e, n, d, R, L, B) {
        switch (n) {
          case ae:
            if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
              return !1;
            t = t.buffer, e = e.buffer;
          case Vt:
            return !(t.byteLength != e.byteLength || !L(new kn(t), new kn(e)));
          case j:
          case et:
          case mt:
            return Ke(+t, +e);
          case gt:
            return t.name == e.name && t.message == e.message;
          case ie:
          case Jt:
            return t == e + "";
          case Et:
            var q = Za;
          case Zt:
            var V = d & _;
            if (q || (q = Rn), t.size != e.size && !V)
              return !1;
            var rt = B.get(t);
            if (rt)
              return rt == e;
            d |= w, B.set(t, e);
            var it = Hu(q(t), q(e), d, R, L, B);
            return B.delete(t), it;
          case Ut:
            if (fi)
              return fi.call(t) == fi.call(e);
        }
        return !1;
      }
      function Pp(t, e, n, d, R, L) {
        var B = n & _, q = ws(t), V = q.length, rt = ws(e), it = rt.length;
        if (V != it && !B)
          return !1;
        for (var nt = V; nt--; ) {
          var ot = q[nt];
          if (!(B ? ot in e : Gt.call(e, ot)))
            return !1;
        }
        var dt = L.get(t), vt = L.get(e);
        if (dt && vt)
          return dt == e && vt == t;
        var xt = !0;
        L.set(t, e), L.set(e, t);
        for (var yt = B; ++nt < V; ) {
          ot = q[nt];
          var Ft = t[ot], kt = e[ot];
          if (d)
            var Pe = B ? d(kt, Ft, ot, e, t, L) : d(Ft, kt, ot, t, e, L);
          if (!(Pe === i ? Ft === kt || R(Ft, kt, n, d, L) : Pe)) {
            xt = !1;
            break;
          }
          yt || (yt = ot == "constructor");
        }
        if (xt && !yt) {
          var ge = t.constructor, Fe = e.constructor;
          ge != Fe && "constructor" in t && "constructor" in e && !(typeof ge == "function" && ge instanceof ge && typeof Fe == "function" && Fe instanceof Fe) && (xt = !1);
        }
        return L.delete(t), L.delete(e), xt;
      }
      function sr(t) {
        return Fs(Xu(t, i, nc), t + "");
      }
      function ws(t) {
        return lu(t, se, As);
      }
      function Cs(t) {
        return lu(t, me, Wu);
      }
      var xs = Bn ? function(t) {
        return Bn.get(t);
      } : Hs;
      function Qn(t) {
        for (var e = t.name + "", n = Kr[e], d = Gt.call(Kr, e) ? n.length : 0; d--; ) {
          var R = n[d], L = R.func;
          if (L == null || L == t)
            return R.name;
        }
        return e;
      }
      function Zr(t) {
        var e = Gt.call(I, "placeholder") ? I : t;
        return e.placeholder;
      }
      function _t() {
        var t = I.iteratee || qs;
        return t = t === qs ? du : t, arguments.length ? t(arguments[0], arguments[1]) : t;
      }
      function ta(t, e) {
        var n = t.__data__;
        return Gp(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
      }
      function Es(t) {
        for (var e = se(t), n = e.length; n--; ) {
          var d = e[n], R = t[d];
          e[n] = [d, R, Ku(R)];
        }
        return e;
      }
      function kr(t, e) {
        var n = U1(t, e);
        return cu(n) ? n : i;
      }
      function Fp(t) {
        var e = Gt.call(t, Tr), n = t[Tr];
        try {
          t[Tr] = i;
          var d = !0;
        } catch {
        }
        var R = On.call(t);
        return d && (e ? t[Tr] = n : delete t[Tr]), R;
      }
      var As = Qa ? function(t) {
        return t == null ? [] : (t = Dt(t), _r(Qa(t), function(e) {
          return $l.call(t, e);
        }));
      } : Ws, Wu = Qa ? function(t) {
        for (var e = []; t; )
          vr(e, As(t)), t = Mn(t);
        return e;
      } : Ws, ce = de;
      (ts && ce(new ts(new ArrayBuffer(1))) != ae || ui && ce(new ui()) != Et || es && ce(es.resolve()) != Ht || jr && ce(new jr()) != Zt || ci && ce(new ci()) != ne) && (ce = function(t) {
        var e = de(t), n = e == Pt ? t.constructor : i, d = n ? Mr(n) : "";
        if (d)
          switch (d) {
            case d2:
              return ae;
            case f2:
              return Et;
            case g2:
              return Ht;
            case p2:
              return Zt;
            case _2:
              return ne;
          }
        return e;
      });
      function Op(t, e, n) {
        for (var d = -1, R = n.length; ++d < R; ) {
          var L = n[d], B = L.size;
          switch (L.type) {
            case "drop":
              t += B;
              break;
            case "dropRight":
              e -= B;
              break;
            case "take":
              e = ue(e, t + B);
              break;
            case "takeRight":
              t = te(t, e - B);
              break;
          }
        }
        return { start: t, end: e };
      }
      function Ip(t) {
        var e = t.match(Dg);
        return e ? e[1].split(Bg) : [];
      }
      function Vu(t, e, n) {
        e = wr(e, t);
        for (var d = -1, R = e.length, L = !1; ++d < R; ) {
          var B = er(e[d]);
          if (!(L = t != null && n(t, B)))
            break;
          t = t[B];
        }
        return L || ++d != R ? L : (R = t == null ? 0 : t.length, !!R && oa(R) && or(B, R) && (St(t) || Lr(t)));
      }
      function kp(t) {
        var e = t.length, n = new t.constructor(e);
        return e && typeof t[0] == "string" && Gt.call(t, "index") && (n.index = t.index, n.input = t.input), n;
      }
      function ju(t) {
        return typeof t.constructor == "function" && !bi(t) ? Yr(Mn(t)) : {};
      }
      function Mp(t, e, n) {
        var d = t.constructor;
        switch (e) {
          case Vt:
            return ms(t);
          case j:
          case et:
            return new d(+t);
          case ae:
            return vp(t, n);
          case Oe:
          case _e:
          case Ze:
          case Ia:
          case We:
          case Ie:
          case Je:
          case oi:
          case ka:
            return Tu(t, n);
          case Et:
            return new d();
          case mt:
          case Jt:
            return new d(t);
          case ie:
            return yp(t);
          case Zt:
            return new d();
          case Ut:
            return mp(t);
        }
      }
      function Lp(t, e) {
        var n = e.length;
        if (!n)
          return t;
        var d = n - 1;
        return e[d] = (n > 1 ? "& " : "") + e[d], e = e.join(n > 2 ? ", " : " "), t.replace(Gg, `{
/* [wrapped with ` + e + `] */
`);
      }
      function Np(t) {
        return St(t) || Lr(t) || !!(Zl && t && t[Zl]);
      }
      function or(t, e) {
        var n = typeof t;
        return e = e == null ? K : e, !!e && (n == "number" || n != "symbol" && Yg.test(t)) && t > -1 && t % 1 == 0 && t < e;
      }
      function fe(t, e, n) {
        if (!Wt(n))
          return !1;
        var d = typeof e;
        return (d == "number" ? ye(n) && or(e, n.length) : d == "string" && e in n) ? Ke(n[e], t) : !1;
      }
      function Rs(t, e) {
        if (St(t))
          return !1;
        var n = typeof t;
        return n == "number" || n == "symbol" || n == "boolean" || t == null || Te(t) ? !0 : kg.test(t) || !Ig.test(t) || e != null && t in Dt(e);
      }
      function Gp(t) {
        var e = typeof t;
        return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
      }
      function Ts(t) {
        var e = Qn(t), n = I[e];
        if (typeof n != "function" || !(e in It.prototype))
          return !1;
        if (t === n)
          return !0;
        var d = xs(n);
        return !!d && t === d[0];
      }
      function Dp(t) {
        return !!Kl && Kl in t;
      }
      var Bp = Pn ? hr : Vs;
      function bi(t) {
        var e = t && t.constructor, n = typeof e == "function" && e.prototype || Vr;
        return t === n;
      }
      function Ku(t) {
        return t === t && !Wt(t);
      }
      function Yu(t, e) {
        return function(n) {
          return n == null ? !1 : n[t] === e && (e !== i || t in Dt(n));
        };
      }
      function Up(t) {
        var e = aa(t, function(d) {
          return n.size === p && n.clear(), d;
        }), n = e.cache;
        return e;
      }
      function qp(t, e) {
        var n = t[1], d = e[1], R = n | d, L = R < (C | F | D), B = d == D && n == f || d == D && n == k && t[7].length <= e[8] || d == (D | k) && e[7].length <= e[8] && n == f;
        if (!(L || B))
          return t;
        d & C && (t[2] = e[2], R |= n & C ? 0 : c);
        var q = e[3];
        if (q) {
          var V = t[3];
          t[3] = V ? Fu(V, q, e[4]) : q, t[4] = V ? yr(t[3], b) : e[4];
        }
        return q = e[5], q && (V = t[5], t[5] = V ? Ou(V, q, e[6]) : q, t[6] = V ? yr(t[5], b) : e[6]), q = e[7], q && (t[7] = q), d & D && (t[8] = t[8] == null ? e[8] : ue(t[8], e[8])), t[9] == null && (t[9] = e[9]), t[0] = e[0], t[1] = R, t;
      }
      function zp(t) {
        var e = [];
        if (t != null)
          for (var n in Dt(t))
            e.push(n);
        return e;
      }
      function Hp(t) {
        return On.call(t);
      }
      function Xu(t, e, n) {
        return e = te(e === i ? t.length - 1 : e, 0), function() {
          for (var d = arguments, R = -1, L = te(d.length - e, 0), B = Y(L); ++R < L; )
            B[R] = d[e + R];
          R = -1;
          for (var q = Y(e + 1); ++R < e; )
            q[R] = d[R];
          return q[e] = n(B), Ee(t, this, q);
        };
      }
      function $u(t, e) {
        return e.length < 2 ? t : Ir(t, De(e, 0, -1));
      }
      function Wp(t, e) {
        for (var n = t.length, d = ue(e.length, n), R = ve(t); d--; ) {
          var L = e[d];
          t[d] = or(L, n) ? R[L] : i;
        }
        return t;
      }
      function Ps(t, e) {
        if (!(e === "constructor" && typeof t[e] == "function") && e != "__proto__")
          return t[e];
      }
      var Zu = Qu(bu), Si = a2 || function(t, e) {
        return he.setTimeout(t, e);
      }, Fs = Qu(fp);
      function Ju(t, e, n) {
        var d = e + "";
        return Fs(t, Lp(d, Vp(Ip(d), n)));
      }
      function Qu(t) {
        var e = 0, n = 0;
        return function() {
          var d = l2(), R = y - (d - n);
          if (n = d, R > 0) {
            if (++e >= z)
              return arguments[0];
          } else
            e = 0;
          return t.apply(i, arguments);
        };
      }
      function ea(t, e) {
        var n = -1, d = t.length, R = d - 1;
        for (e = e === i ? d : e; ++n < e; ) {
          var L = ds(n, R), B = t[L];
          t[L] = t[n], t[n] = B;
        }
        return t.length = e, t;
      }
      var tc = Up(function(t) {
        var e = [];
        return t.charCodeAt(0) === 46 && e.push(""), t.replace(Mg, function(n, d, R, L) {
          e.push(R ? L.replace(zg, "$1") : d || n);
        }), e;
      });
      function er(t) {
        if (typeof t == "string" || Te(t))
          return t;
        var e = t + "";
        return e == "0" && 1 / t == -1 / 0 ? "-0" : e;
      }
      function Mr(t) {
        if (t != null) {
          try {
            return Fn.call(t);
          } catch {
          }
          try {
            return t + "";
          } catch {
          }
        }
        return "";
      }
      function Vp(t, e) {
        return Me(at, function(n) {
          var d = "_." + n[0];
          e & n[1] && !En(t, d) && t.push(d);
        }), t.sort();
      }
      function ec(t) {
        if (t instanceof It)
          return t.clone();
        var e = new Ne(t.__wrapped__, t.__chain__);
        return e.__actions__ = ve(t.__actions__), e.__index__ = t.__index__, e.__values__ = t.__values__, e;
      }
      function jp(t, e, n) {
        (n ? fe(t, e, n) : e === i) ? e = 1 : e = te(Ct(e), 0);
        var d = t == null ? 0 : t.length;
        if (!d || e < 1)
          return [];
        for (var R = 0, L = 0, B = Y(Gn(d / e)); R < d; )
          B[L++] = De(t, R, R += e);
        return B;
      }
      function Kp(t) {
        for (var e = -1, n = t == null ? 0 : t.length, d = 0, R = []; ++e < n; ) {
          var L = t[e];
          L && (R[d++] = L);
        }
        return R;
      }
      function Yp() {
        var t = arguments.length;
        if (!t)
          return [];
        for (var e = Y(t - 1), n = arguments[0], d = t; d--; )
          e[d - 1] = arguments[d];
        return vr(St(n) ? ve(n) : [n], le(e, 1));
      }
      var Xp = At(function(t, e) {
        return Yt(t) ? pi(t, le(e, 1, Yt, !0)) : [];
      }), $p = At(function(t, e) {
        var n = Be(e);
        return Yt(n) && (n = i), Yt(t) ? pi(t, le(e, 1, Yt, !0), _t(n, 2)) : [];
      }), Zp = At(function(t, e) {
        var n = Be(e);
        return Yt(n) && (n = i), Yt(t) ? pi(t, le(e, 1, Yt, !0), i, n) : [];
      });
      function Jp(t, e, n) {
        var d = t == null ? 0 : t.length;
        return d ? (e = n || e === i ? 1 : Ct(e), De(t, e < 0 ? 0 : e, d)) : [];
      }
      function Qp(t, e, n) {
        var d = t == null ? 0 : t.length;
        return d ? (e = n || e === i ? 1 : Ct(e), e = d - e, De(t, 0, e < 0 ? 0 : e)) : [];
      }
      function t_(t, e) {
        return t && t.length ? Kn(t, _t(e, 3), !0, !0) : [];
      }
      function e_(t, e) {
        return t && t.length ? Kn(t, _t(e, 3), !0) : [];
      }
      function r_(t, e, n, d) {
        var R = t == null ? 0 : t.length;
        return R ? (n && typeof n != "number" && fe(t, e, n) && (n = 0, d = R), Y2(t, e, n, d)) : [];
      }
      function rc(t, e, n) {
        var d = t == null ? 0 : t.length;
        if (!d)
          return -1;
        var R = n == null ? 0 : Ct(n);
        return R < 0 && (R = te(d + R, 0)), An(t, _t(e, 3), R);
      }
      function ic(t, e, n) {
        var d = t == null ? 0 : t.length;
        if (!d)
          return -1;
        var R = d - 1;
        return n !== i && (R = Ct(n), R = n < 0 ? te(d + R, 0) : ue(R, d - 1)), An(t, _t(e, 3), R, !0);
      }
      function nc(t) {
        var e = t == null ? 0 : t.length;
        return e ? le(t, 1) : [];
      }
      function i_(t) {
        var e = t == null ? 0 : t.length;
        return e ? le(t, U) : [];
      }
      function n_(t, e) {
        var n = t == null ? 0 : t.length;
        return n ? (e = e === i ? 1 : Ct(e), le(t, e)) : [];
      }
      function a_(t) {
        for (var e = -1, n = t == null ? 0 : t.length, d = {}; ++e < n; ) {
          var R = t[e];
          d[R[0]] = R[1];
        }
        return d;
      }
      function ac(t) {
        return t && t.length ? t[0] : i;
      }
      function s_(t, e, n) {
        var d = t == null ? 0 : t.length;
        if (!d)
          return -1;
        var R = n == null ? 0 : Ct(n);
        return R < 0 && (R = te(d + R, 0)), qr(t, e, R);
      }
      function o_(t) {
        var e = t == null ? 0 : t.length;
        return e ? De(t, 0, -1) : [];
      }
      var h_ = At(function(t) {
        var e = zt(t, vs);
        return e.length && e[0] === t[0] ? os(e) : [];
      }), l_ = At(function(t) {
        var e = Be(t), n = zt(t, vs);
        return e === Be(n) ? e = i : n.pop(), n.length && n[0] === t[0] ? os(n, _t(e, 2)) : [];
      }), u_ = At(function(t) {
        var e = Be(t), n = zt(t, vs);
        return e = typeof e == "function" ? e : i, e && n.pop(), n.length && n[0] === t[0] ? os(n, i, e) : [];
      });
      function c_(t, e) {
        return t == null ? "" : o2.call(t, e);
      }
      function Be(t) {
        var e = t == null ? 0 : t.length;
        return e ? t[e - 1] : i;
      }
      function d_(t, e, n) {
        var d = t == null ? 0 : t.length;
        if (!d)
          return -1;
        var R = d;
        return n !== i && (R = Ct(n), R = R < 0 ? te(d + R, 0) : ue(R, d - 1)), e === e ? V1(t, e, R) : An(t, Bl, R, !0);
      }
      function f_(t, e) {
        return t && t.length ? _u(t, Ct(e)) : i;
      }
      var g_ = At(sc);
      function sc(t, e) {
        return t && t.length && e && e.length ? cs(t, e) : t;
      }
      function p_(t, e, n) {
        return t && t.length && e && e.length ? cs(t, e, _t(n, 2)) : t;
      }
      function __(t, e, n) {
        return t && t.length && e && e.length ? cs(t, e, i, n) : t;
      }
      var v_ = sr(function(t, e) {
        var n = t == null ? 0 : t.length, d = is(t, e);
        return mu(t, zt(e, function(R) {
          return or(R, n) ? +R : R;
        }).sort(Pu)), d;
      });
      function y_(t, e) {
        var n = [];
        if (!(t && t.length))
          return n;
        var d = -1, R = [], L = t.length;
        for (e = _t(e, 3); ++d < L; ) {
          var B = t[d];
          e(B, d, t) && (n.push(B), R.push(d));
        }
        return mu(t, R), n;
      }
      function Os(t) {
        return t == null ? t : c2.call(t);
      }
      function m_(t, e, n) {
        var d = t == null ? 0 : t.length;
        return d ? (n && typeof n != "number" && fe(t, e, n) ? (e = 0, n = d) : (e = e == null ? 0 : Ct(e), n = n === i ? d : Ct(n)), De(t, e, n)) : [];
      }
      function b_(t, e) {
        return jn(t, e);
      }
      function S_(t, e, n) {
        return gs(t, e, _t(n, 2));
      }
      function w_(t, e) {
        var n = t == null ? 0 : t.length;
        if (n) {
          var d = jn(t, e);
          if (d < n && Ke(t[d], e))
            return d;
        }
        return -1;
      }
      function C_(t, e) {
        return jn(t, e, !0);
      }
      function x_(t, e, n) {
        return gs(t, e, _t(n, 2), !0);
      }
      function E_(t, e) {
        var n = t == null ? 0 : t.length;
        if (n) {
          var d = jn(t, e, !0) - 1;
          if (Ke(t[d], e))
            return d;
        }
        return -1;
      }
      function A_(t) {
        return t && t.length ? Su(t) : [];
      }
      function R_(t, e) {
        return t && t.length ? Su(t, _t(e, 2)) : [];
      }
      function T_(t) {
        var e = t == null ? 0 : t.length;
        return e ? De(t, 1, e) : [];
      }
      function P_(t, e, n) {
        return t && t.length ? (e = n || e === i ? 1 : Ct(e), De(t, 0, e < 0 ? 0 : e)) : [];
      }
      function F_(t, e, n) {
        var d = t == null ? 0 : t.length;
        return d ? (e = n || e === i ? 1 : Ct(e), e = d - e, De(t, e < 0 ? 0 : e, d)) : [];
      }
      function O_(t, e) {
        return t && t.length ? Kn(t, _t(e, 3), !1, !0) : [];
      }
      function I_(t, e) {
        return t && t.length ? Kn(t, _t(e, 3)) : [];
      }
      var k_ = At(function(t) {
        return Sr(le(t, 1, Yt, !0));
      }), M_ = At(function(t) {
        var e = Be(t);
        return Yt(e) && (e = i), Sr(le(t, 1, Yt, !0), _t(e, 2));
      }), L_ = At(function(t) {
        var e = Be(t);
        return e = typeof e == "function" ? e : i, Sr(le(t, 1, Yt, !0), i, e);
      });
      function N_(t) {
        return t && t.length ? Sr(t) : [];
      }
      function G_(t, e) {
        return t && t.length ? Sr(t, _t(e, 2)) : [];
      }
      function D_(t, e) {
        return e = typeof e == "function" ? e : i, t && t.length ? Sr(t, i, e) : [];
      }
      function Is(t) {
        if (!(t && t.length))
          return [];
        var e = 0;
        return t = _r(t, function(n) {
          if (Yt(n))
            return e = te(n.length, e), !0;
        }), Xa(e, function(n) {
          return zt(t, ja(n));
        });
      }
      function oc(t, e) {
        if (!(t && t.length))
          return [];
        var n = Is(t);
        return e == null ? n : zt(n, function(d) {
          return Ee(e, i, d);
        });
      }
      var B_ = At(function(t, e) {
        return Yt(t) ? pi(t, e) : [];
      }), U_ = At(function(t) {
        return _s(_r(t, Yt));
      }), q_ = At(function(t) {
        var e = Be(t);
        return Yt(e) && (e = i), _s(_r(t, Yt), _t(e, 2));
      }), z_ = At(function(t) {
        var e = Be(t);
        return e = typeof e == "function" ? e : i, _s(_r(t, Yt), i, e);
      }), H_ = At(Is);
      function W_(t, e) {
        return Eu(t || [], e || [], gi);
      }
      function V_(t, e) {
        return Eu(t || [], e || [], yi);
      }
      var j_ = At(function(t) {
        var e = t.length, n = e > 1 ? t[e - 1] : i;
        return n = typeof n == "function" ? (t.pop(), n) : i, oc(t, n);
      });
      function hc(t) {
        var e = I(t);
        return e.__chain__ = !0, e;
      }
      function K_(t, e) {
        return e(t), t;
      }
      function ra(t, e) {
        return e(t);
      }
      var Y_ = sr(function(t) {
        var e = t.length, n = e ? t[0] : 0, d = this.__wrapped__, R = function(L) {
          return is(L, t);
        };
        return e > 1 || this.__actions__.length || !(d instanceof It) || !or(n) ? this.thru(R) : (d = d.slice(n, +n + (e ? 1 : 0)), d.__actions__.push({
          func: ra,
          args: [R],
          thisArg: i
        }), new Ne(d, this.__chain__).thru(function(L) {
          return e && !L.length && L.push(i), L;
        }));
      });
      function X_() {
        return hc(this);
      }
      function $_() {
        return new Ne(this.value(), this.__chain__);
      }
      function Z_() {
        this.__values__ === i && (this.__values__ = wc(this.value()));
        var t = this.__index__ >= this.__values__.length, e = t ? i : this.__values__[this.__index__++];
        return { done: t, value: e };
      }
      function J_() {
        return this;
      }
      function Q_(t) {
        for (var e, n = this; n instanceof qn; ) {
          var d = ec(n);
          d.__index__ = 0, d.__values__ = i, e ? R.__wrapped__ = d : e = d;
          var R = d;
          n = n.__wrapped__;
        }
        return R.__wrapped__ = t, e;
      }
      function t5() {
        var t = this.__wrapped__;
        if (t instanceof It) {
          var e = t;
          return this.__actions__.length && (e = new It(this)), e = e.reverse(), e.__actions__.push({
            func: ra,
            args: [Os],
            thisArg: i
          }), new Ne(e, this.__chain__);
        }
        return this.thru(Os);
      }
      function e5() {
        return xu(this.__wrapped__, this.__actions__);
      }
      var r5 = Yn(function(t, e, n) {
        Gt.call(t, n) ? ++t[n] : nr(t, n, 1);
      });
      function i5(t, e, n) {
        var d = St(t) ? Gl : K2;
        return n && fe(t, e, n) && (e = i), d(t, _t(e, 3));
      }
      function n5(t, e) {
        var n = St(t) ? _r : ou;
        return n(t, _t(e, 3));
      }
      var a5 = Lu(rc), s5 = Lu(ic);
      function o5(t, e) {
        return le(ia(t, e), 1);
      }
      function h5(t, e) {
        return le(ia(t, e), U);
      }
      function l5(t, e, n) {
        return n = n === i ? 1 : Ct(n), le(ia(t, e), n);
      }
      function lc(t, e) {
        var n = St(t) ? Me : br;
        return n(t, _t(e, 3));
      }
      function uc(t, e) {
        var n = St(t) ? T1 : su;
        return n(t, _t(e, 3));
      }
      var u5 = Yn(function(t, e, n) {
        Gt.call(t, n) ? t[n].push(e) : nr(t, n, [e]);
      });
      function c5(t, e, n, d) {
        t = ye(t) ? t : Qr(t), n = n && !d ? Ct(n) : 0;
        var R = t.length;
        return n < 0 && (n = te(R + n, 0)), ha(t) ? n <= R && t.indexOf(e, n) > -1 : !!R && qr(t, e, n) > -1;
      }
      var d5 = At(function(t, e, n) {
        var d = -1, R = typeof e == "function", L = ye(t) ? Y(t.length) : [];
        return br(t, function(B) {
          L[++d] = R ? Ee(e, B, n) : _i(B, e, n);
        }), L;
      }), f5 = Yn(function(t, e, n) {
        nr(t, n, e);
      });
      function ia(t, e) {
        var n = St(t) ? zt : fu;
        return n(t, _t(e, 3));
      }
      function g5(t, e, n, d) {
        return t == null ? [] : (St(e) || (e = e == null ? [] : [e]), n = d ? i : n, St(n) || (n = n == null ? [] : [n]), vu(t, e, n));
      }
      var p5 = Yn(function(t, e, n) {
        t[n ? 0 : 1].push(e);
      }, function() {
        return [[], []];
      });
      function _5(t, e, n) {
        var d = St(t) ? Wa : ql, R = arguments.length < 3;
        return d(t, _t(e, 4), n, R, br);
      }
      function v5(t, e, n) {
        var d = St(t) ? P1 : ql, R = arguments.length < 3;
        return d(t, _t(e, 4), n, R, su);
      }
      function y5(t, e) {
        var n = St(t) ? _r : ou;
        return n(t, sa(_t(e, 3)));
      }
      function m5(t) {
        var e = St(t) ? ru : cp;
        return e(t);
      }
      function b5(t, e, n) {
        (n ? fe(t, e, n) : e === i) ? e = 1 : e = Ct(e);
        var d = St(t) ? z2 : dp;
        return d(t, e);
      }
      function S5(t) {
        var e = St(t) ? H2 : gp;
        return e(t);
      }
      function w5(t) {
        if (t == null)
          return 0;
        if (ye(t))
          return ha(t) ? Hr(t) : t.length;
        var e = ce(t);
        return e == Et || e == Zt ? t.size : ls(t).length;
      }
      function C5(t, e, n) {
        var d = St(t) ? Va : pp;
        return n && fe(t, e, n) && (e = i), d(t, _t(e, 3));
      }
      var x5 = At(function(t, e) {
        if (t == null)
          return [];
        var n = e.length;
        return n > 1 && fe(t, e[0], e[1]) ? e = [] : n > 2 && fe(e[0], e[1], e[2]) && (e = [e[0]]), vu(t, le(e, 1), []);
      }), na = n2 || function() {
        return he.Date.now();
      };
      function E5(t, e) {
        if (typeof e != "function")
          throw new Le(l);
        return t = Ct(t), function() {
          if (--t < 1)
            return e.apply(this, arguments);
        };
      }
      function cc(t, e, n) {
        return e = n ? i : e, e = t && e == null ? t.length : e, ar(t, D, i, i, i, i, e);
      }
      function dc(t, e) {
        var n;
        if (typeof e != "function")
          throw new Le(l);
        return t = Ct(t), function() {
          return --t > 0 && (n = e.apply(this, arguments)), t <= 1 && (e = i), n;
        };
      }
      var ks = At(function(t, e, n) {
        var d = C;
        if (n.length) {
          var R = yr(n, Zr(ks));
          d |= E;
        }
        return ar(t, d, e, n, R);
      }), fc = At(function(t, e, n) {
        var d = C | F;
        if (n.length) {
          var R = yr(n, Zr(fc));
          d |= E;
        }
        return ar(e, d, t, n, R);
      });
      function gc(t, e, n) {
        e = n ? i : e;
        var d = ar(t, f, i, i, i, i, i, e);
        return d.placeholder = gc.placeholder, d;
      }
      function pc(t, e, n) {
        e = n ? i : e;
        var d = ar(t, m, i, i, i, i, i, e);
        return d.placeholder = pc.placeholder, d;
      }
      function _c(t, e, n) {
        var d, R, L, B, q, V, rt = 0, it = !1, nt = !1, ot = !0;
        if (typeof t != "function")
          throw new Le(l);
        e = Ue(e) || 0, Wt(n) && (it = !!n.leading, nt = "maxWait" in n, L = nt ? te(Ue(n.maxWait) || 0, e) : L, ot = "trailing" in n ? !!n.trailing : ot);
        function dt(Xt) {
          var Ye = d, ur = R;
          return d = R = i, rt = Xt, B = t.apply(ur, Ye), B;
        }
        function vt(Xt) {
          return rt = Xt, q = Si(Ft, e), it ? dt(Xt) : B;
        }
        function xt(Xt) {
          var Ye = Xt - V, ur = Xt - rt, Lc = e - Ye;
          return nt ? ue(Lc, L - ur) : Lc;
        }
        function yt(Xt) {
          var Ye = Xt - V, ur = Xt - rt;
          return V === i || Ye >= e || Ye < 0 || nt && ur >= L;
        }
        function Ft() {
          var Xt = na();
          if (yt(Xt))
            return kt(Xt);
          q = Si(Ft, xt(Xt));
        }
        function kt(Xt) {
          return q = i, ot && d ? dt(Xt) : (d = R = i, B);
        }
        function Pe() {
          q !== i && Au(q), rt = 0, d = V = R = q = i;
        }
        function ge() {
          return q === i ? B : kt(na());
        }
        function Fe() {
          var Xt = na(), Ye = yt(Xt);
          if (d = arguments, R = this, V = Xt, Ye) {
            if (q === i)
              return vt(V);
            if (nt)
              return Au(q), q = Si(Ft, e), dt(V);
          }
          return q === i && (q = Si(Ft, e)), B;
        }
        return Fe.cancel = Pe, Fe.flush = ge, Fe;
      }
      var A5 = At(function(t, e) {
        return au(t, 1, e);
      }), R5 = At(function(t, e, n) {
        return au(t, Ue(e) || 0, n);
      });
      function T5(t) {
        return ar(t, M);
      }
      function aa(t, e) {
        if (typeof t != "function" || e != null && typeof e != "function")
          throw new Le(l);
        var n = function() {
          var d = arguments, R = e ? e.apply(this, d) : d[0], L = n.cache;
          if (L.has(R))
            return L.get(R);
          var B = t.apply(this, d);
          return n.cache = L.set(R, B) || L, B;
        };
        return n.cache = new (aa.Cache || ir)(), n;
      }
      aa.Cache = ir;
      function sa(t) {
        if (typeof t != "function")
          throw new Le(l);
        return function() {
          var e = arguments;
          switch (e.length) {
            case 0:
              return !t.call(this);
            case 1:
              return !t.call(this, e[0]);
            case 2:
              return !t.call(this, e[0], e[1]);
            case 3:
              return !t.call(this, e[0], e[1], e[2]);
          }
          return !t.apply(this, e);
        };
      }
      function P5(t) {
        return dc(2, t);
      }
      var F5 = _p(function(t, e) {
        e = e.length == 1 && St(e[0]) ? zt(e[0], Ae(_t())) : zt(le(e, 1), Ae(_t()));
        var n = e.length;
        return At(function(d) {
          for (var R = -1, L = ue(d.length, n); ++R < L; )
            d[R] = e[R].call(this, d[R]);
          return Ee(t, this, d);
        });
      }), Ms = At(function(t, e) {
        var n = yr(e, Zr(Ms));
        return ar(t, E, i, e, n);
      }), vc = At(function(t, e) {
        var n = yr(e, Zr(vc));
        return ar(t, T, i, e, n);
      }), O5 = sr(function(t, e) {
        return ar(t, k, i, i, i, e);
      });
      function I5(t, e) {
        if (typeof t != "function")
          throw new Le(l);
        return e = e === i ? e : Ct(e), At(t, e);
      }
      function k5(t, e) {
        if (typeof t != "function")
          throw new Le(l);
        return e = e == null ? 0 : te(Ct(e), 0), At(function(n) {
          var d = n[e], R = Cr(n, 0, e);
          return d && vr(R, d), Ee(t, this, R);
        });
      }
      function M5(t, e, n) {
        var d = !0, R = !0;
        if (typeof t != "function")
          throw new Le(l);
        return Wt(n) && (d = "leading" in n ? !!n.leading : d, R = "trailing" in n ? !!n.trailing : R), _c(t, e, {
          leading: d,
          maxWait: e,
          trailing: R
        });
      }
      function L5(t) {
        return cc(t, 1);
      }
      function N5(t, e) {
        return Ms(ys(e), t);
      }
      function G5() {
        if (!arguments.length)
          return [];
        var t = arguments[0];
        return St(t) ? t : [t];
      }
      function D5(t) {
        return Ge(t, v);
      }
      function B5(t, e) {
        return e = typeof e == "function" ? e : i, Ge(t, v, e);
      }
      function U5(t) {
        return Ge(t, S | v);
      }
      function q5(t, e) {
        return e = typeof e == "function" ? e : i, Ge(t, S | v, e);
      }
      function z5(t, e) {
        return e == null || nu(t, e, se(e));
      }
      function Ke(t, e) {
        return t === e || t !== t && e !== e;
      }
      var H5 = Jn(ss), W5 = Jn(function(t, e) {
        return t >= e;
      }), Lr = uu(/* @__PURE__ */ function() {
        return arguments;
      }()) ? uu : function(t) {
        return jt(t) && Gt.call(t, "callee") && !$l.call(t, "callee");
      }, St = Y.isArray, V5 = Ol ? Ae(Ol) : Q2;
      function ye(t) {
        return t != null && oa(t.length) && !hr(t);
      }
      function Yt(t) {
        return jt(t) && ye(t);
      }
      function j5(t) {
        return t === !0 || t === !1 || jt(t) && de(t) == j;
      }
      var xr = s2 || Vs, K5 = Il ? Ae(Il) : tp;
      function Y5(t) {
        return jt(t) && t.nodeType === 1 && !wi(t);
      }
      function X5(t) {
        if (t == null)
          return !0;
        if (ye(t) && (St(t) || typeof t == "string" || typeof t.splice == "function" || xr(t) || Jr(t) || Lr(t)))
          return !t.length;
        var e = ce(t);
        if (e == Et || e == Zt)
          return !t.size;
        if (bi(t))
          return !ls(t).length;
        for (var n in t)
          if (Gt.call(t, n))
            return !1;
        return !0;
      }
      function $5(t, e) {
        return vi(t, e);
      }
      function Z5(t, e, n) {
        n = typeof n == "function" ? n : i;
        var d = n ? n(t, e) : i;
        return d === i ? vi(t, e, i, n) : !!d;
      }
      function Ls(t) {
        if (!jt(t))
          return !1;
        var e = de(t);
        return e == gt || e == ut || typeof t.message == "string" && typeof t.name == "string" && !wi(t);
      }
      function J5(t) {
        return typeof t == "number" && Jl(t);
      }
      function hr(t) {
        if (!Wt(t))
          return !1;
        var e = de(t);
        return e == pt || e == Mt || e == H || e == pr;
      }
      function yc(t) {
        return typeof t == "number" && t == Ct(t);
      }
      function oa(t) {
        return typeof t == "number" && t > -1 && t % 1 == 0 && t <= K;
      }
      function Wt(t) {
        var e = typeof t;
        return t != null && (e == "object" || e == "function");
      }
      function jt(t) {
        return t != null && typeof t == "object";
      }
      var mc = kl ? Ae(kl) : rp;
      function Q5(t, e) {
        return t === e || hs(t, e, Es(e));
      }
      function t3(t, e, n) {
        return n = typeof n == "function" ? n : i, hs(t, e, Es(e), n);
      }
      function e3(t) {
        return bc(t) && t != +t;
      }
      function r3(t) {
        if (Bp(t))
          throw new bt(o);
        return cu(t);
      }
      function i3(t) {
        return t === null;
      }
      function n3(t) {
        return t == null;
      }
      function bc(t) {
        return typeof t == "number" || jt(t) && de(t) == mt;
      }
      function wi(t) {
        if (!jt(t) || de(t) != Pt)
          return !1;
        var e = Mn(t);
        if (e === null)
          return !0;
        var n = Gt.call(e, "constructor") && e.constructor;
        return typeof n == "function" && n instanceof n && Fn.call(n) == t2;
      }
      var Ns = Ml ? Ae(Ml) : ip;
      function a3(t) {
        return yc(t) && t >= -9007199254740991 && t <= K;
      }
      var Sc = Ll ? Ae(Ll) : np;
      function ha(t) {
        return typeof t == "string" || !St(t) && jt(t) && de(t) == Jt;
      }
      function Te(t) {
        return typeof t == "symbol" || jt(t) && de(t) == Ut;
      }
      var Jr = Nl ? Ae(Nl) : ap;
      function s3(t) {
        return t === i;
      }
      function o3(t) {
        return jt(t) && ce(t) == ne;
      }
      function h3(t) {
        return jt(t) && de(t) == He;
      }
      var l3 = Jn(us), u3 = Jn(function(t, e) {
        return t <= e;
      });
      function wc(t) {
        if (!t)
          return [];
        if (ye(t))
          return ha(t) ? Ve(t) : ve(t);
        if (li && t[li])
          return z1(t[li]());
        var e = ce(t), n = e == Et ? Za : e == Zt ? Rn : Qr;
        return n(t);
      }
      function lr(t) {
        if (!t)
          return t === 0 ? t : 0;
        if (t = Ue(t), t === U || t === -1 / 0) {
          var e = t < 0 ? -1 : 1;
          return e * $;
        }
        return t === t ? t : 0;
      }
      function Ct(t) {
        var e = lr(t), n = e % 1;
        return e === e ? n ? e - n : e : 0;
      }
      function Cc(t) {
        return t ? Or(Ct(t), 0, Q) : 0;
      }
      function Ue(t) {
        if (typeof t == "number")
          return t;
        if (Te(t))
          return X;
        if (Wt(t)) {
          var e = typeof t.valueOf == "function" ? t.valueOf() : t;
          t = Wt(e) ? e + "" : e;
        }
        if (typeof t != "string")
          return t === 0 ? t : +t;
        t = zl(t);
        var n = Vg.test(t);
        return n || Kg.test(t) ? E1(t.slice(2), n ? 2 : 8) : Wg.test(t) ? X : +t;
      }
      function xc(t) {
        return tr(t, me(t));
      }
      function c3(t) {
        return t ? Or(Ct(t), -9007199254740991, K) : t === 0 ? t : 0;
      }
      function Nt(t) {
        return t == null ? "" : Re(t);
      }
      var d3 = Xr(function(t, e) {
        if (bi(e) || ye(e)) {
          tr(e, se(e), t);
          return;
        }
        for (var n in e)
          Gt.call(e, n) && gi(t, n, e[n]);
      }), Ec = Xr(function(t, e) {
        tr(e, me(e), t);
      }), la = Xr(function(t, e, n, d) {
        tr(e, me(e), t, d);
      }), f3 = Xr(function(t, e, n, d) {
        tr(e, se(e), t, d);
      }), g3 = sr(is);
      function p3(t, e) {
        var n = Yr(t);
        return e == null ? n : iu(n, e);
      }
      var _3 = At(function(t, e) {
        t = Dt(t);
        var n = -1, d = e.length, R = d > 2 ? e[2] : i;
        for (R && fe(e[0], e[1], R) && (d = 1); ++n < d; )
          for (var L = e[n], B = me(L), q = -1, V = B.length; ++q < V; ) {
            var rt = B[q], it = t[rt];
            (it === i || Ke(it, Vr[rt]) && !Gt.call(t, rt)) && (t[rt] = L[rt]);
          }
        return t;
      }), v3 = At(function(t) {
        return t.push(i, zu), Ee(Ac, i, t);
      });
      function y3(t, e) {
        return Dl(t, _t(e, 3), Qe);
      }
      function m3(t, e) {
        return Dl(t, _t(e, 3), as);
      }
      function b3(t, e) {
        return t == null ? t : ns(t, _t(e, 3), me);
      }
      function S3(t, e) {
        return t == null ? t : hu(t, _t(e, 3), me);
      }
      function w3(t, e) {
        return t && Qe(t, _t(e, 3));
      }
      function C3(t, e) {
        return t && as(t, _t(e, 3));
      }
      function x3(t) {
        return t == null ? [] : Wn(t, se(t));
      }
      function E3(t) {
        return t == null ? [] : Wn(t, me(t));
      }
      function Gs(t, e, n) {
        var d = t == null ? i : Ir(t, e);
        return d === i ? n : d;
      }
      function A3(t, e) {
        return t != null && Vu(t, e, X2);
      }
      function Ds(t, e) {
        return t != null && Vu(t, e, $2);
      }
      var R3 = Gu(function(t, e, n) {
        e != null && typeof e.toString != "function" && (e = On.call(e)), t[e] = n;
      }, Us(be)), T3 = Gu(function(t, e, n) {
        e != null && typeof e.toString != "function" && (e = On.call(e)), Gt.call(t, e) ? t[e].push(n) : t[e] = [n];
      }, _t), P3 = At(_i);
      function se(t) {
        return ye(t) ? eu(t) : ls(t);
      }
      function me(t) {
        return ye(t) ? eu(t, !0) : sp(t);
      }
      function F3(t, e) {
        var n = {};
        return e = _t(e, 3), Qe(t, function(d, R, L) {
          nr(n, e(d, R, L), d);
        }), n;
      }
      function O3(t, e) {
        var n = {};
        return e = _t(e, 3), Qe(t, function(d, R, L) {
          nr(n, R, e(d, R, L));
        }), n;
      }
      var I3 = Xr(function(t, e, n) {
        Vn(t, e, n);
      }), Ac = Xr(function(t, e, n, d) {
        Vn(t, e, n, d);
      }), k3 = sr(function(t, e) {
        var n = {};
        if (t == null)
          return n;
        var d = !1;
        e = zt(e, function(L) {
          return L = wr(L, t), d || (d = L.length > 1), L;
        }), tr(t, Cs(t), n), d && (n = Ge(n, S | x | v, Rp));
        for (var R = e.length; R--; )
          ps(n, e[R]);
        return n;
      });
      function M3(t, e) {
        return Rc(t, sa(_t(e)));
      }
      var L3 = sr(function(t, e) {
        return t == null ? {} : hp(t, e);
      });
      function Rc(t, e) {
        if (t == null)
          return {};
        var n = zt(Cs(t), function(d) {
          return [d];
        });
        return e = _t(e), yu(t, n, function(d, R) {
          return e(d, R[0]);
        });
      }
      function N3(t, e, n) {
        e = wr(e, t);
        var d = -1, R = e.length;
        for (R || (R = 1, t = i); ++d < R; ) {
          var L = t == null ? i : t[er(e[d])];
          L === i && (d = R, L = n), t = hr(L) ? L.call(t) : L;
        }
        return t;
      }
      function G3(t, e, n) {
        return t == null ? t : yi(t, e, n);
      }
      function D3(t, e, n, d) {
        return d = typeof d == "function" ? d : i, t == null ? t : yi(t, e, n, d);
      }
      var Tc = Uu(se), Pc = Uu(me);
      function B3(t, e, n) {
        var d = St(t), R = d || xr(t) || Jr(t);
        if (e = _t(e, 4), n == null) {
          var L = t && t.constructor;
          R ? n = d ? new L() : [] : Wt(t) ? n = hr(L) ? Yr(Mn(t)) : {} : n = {};
        }
        return (R ? Me : Qe)(t, function(B, q, V) {
          return e(n, B, q, V);
        }), n;
      }
      function U3(t, e) {
        return t == null ? !0 : ps(t, e);
      }
      function q3(t, e, n) {
        return t == null ? t : Cu(t, e, ys(n));
      }
      function z3(t, e, n, d) {
        return d = typeof d == "function" ? d : i, t == null ? t : Cu(t, e, ys(n), d);
      }
      function Qr(t) {
        return t == null ? [] : $a(t, se(t));
      }
      function H3(t) {
        return t == null ? [] : $a(t, me(t));
      }
      function W3(t, e, n) {
        return n === i && (n = e, e = i), n !== i && (n = Ue(n), n = n === n ? n : 0), e !== i && (e = Ue(e), e = e === e ? e : 0), Or(Ue(t), e, n);
      }
      function V3(t, e, n) {
        return e = lr(e), n === i ? (n = e, e = 0) : n = lr(n), t = Ue(t), Z2(t, e, n);
      }
      function j3(t, e, n) {
        if (n && typeof n != "boolean" && fe(t, e, n) && (e = n = i), n === i && (typeof e == "boolean" ? (n = e, e = i) : typeof t == "boolean" && (n = t, t = i)), t === i && e === i ? (t = 0, e = 1) : (t = lr(t), e === i ? (e = t, t = 0) : e = lr(e)), t > e) {
          var d = t;
          t = e, e = d;
        }
        if (n || t % 1 || e % 1) {
          var R = Ql();
          return ue(t + R * (e - t + x1("1e-" + ((R + "").length - 1))), e);
        }
        return ds(t, e);
      }
      var K3 = $r(function(t, e, n) {
        return e = e.toLowerCase(), t + (n ? Fc(e) : e);
      });
      function Fc(t) {
        return Bs(Nt(t).toLowerCase());
      }
      function Oc(t) {
        return t = Nt(t), t && t.replace(Xg, G1).replace(g1, "");
      }
      function Y3(t, e, n) {
        t = Nt(t), e = Re(e);
        var d = t.length;
        n = n === i ? d : Or(Ct(n), 0, d);
        var R = n;
        return n -= e.length, n >= 0 && t.slice(n, R) == e;
      }
      function X3(t) {
        return t = Nt(t), t && Pg.test(t) ? t.replace(hl, D1) : t;
      }
      function $3(t) {
        return t = Nt(t), t && Lg.test(t) ? t.replace(Ma, "\\$&") : t;
      }
      var Z3 = $r(function(t, e, n) {
        return t + (n ? "-" : "") + e.toLowerCase();
      }), J3 = $r(function(t, e, n) {
        return t + (n ? " " : "") + e.toLowerCase();
      }), Q3 = Mu("toLowerCase");
      function t4(t, e, n) {
        t = Nt(t), e = Ct(e);
        var d = e ? Hr(t) : 0;
        if (!e || d >= e)
          return t;
        var R = (e - d) / 2;
        return Zn(Dn(R), n) + t + Zn(Gn(R), n);
      }
      function e4(t, e, n) {
        t = Nt(t), e = Ct(e);
        var d = e ? Hr(t) : 0;
        return e && d < e ? t + Zn(e - d, n) : t;
      }
      function r4(t, e, n) {
        t = Nt(t), e = Ct(e);
        var d = e ? Hr(t) : 0;
        return e && d < e ? Zn(e - d, n) + t : t;
      }
      function i4(t, e, n) {
        return n || e == null ? e = 0 : e && (e = +e), u2(Nt(t).replace(La, ""), e || 0);
      }
      function n4(t, e, n) {
        return (n ? fe(t, e, n) : e === i) ? e = 1 : e = Ct(e), fs(Nt(t), e);
      }
      function a4() {
        var t = arguments, e = Nt(t[0]);
        return t.length < 3 ? e : e.replace(t[1], t[2]);
      }
      var s4 = $r(function(t, e, n) {
        return t + (n ? "_" : "") + e.toLowerCase();
      });
      function o4(t, e, n) {
        return n && typeof n != "number" && fe(t, e, n) && (e = n = i), n = n === i ? Q : n >>> 0, n ? (t = Nt(t), t && (typeof e == "string" || e != null && !Ns(e)) && (e = Re(e), !e && zr(t)) ? Cr(Ve(t), 0, n) : t.split(e, n)) : [];
      }
      var h4 = $r(function(t, e, n) {
        return t + (n ? " " : "") + Bs(e);
      });
      function l4(t, e, n) {
        return t = Nt(t), n = n == null ? 0 : Or(Ct(n), 0, t.length), e = Re(e), t.slice(n, n + e.length) == e;
      }
      function u4(t, e, n) {
        var d = I.templateSettings;
        n && fe(t, e, n) && (e = i), t = Nt(t), e = la({}, e, d, qu);
        var R = la({}, e.imports, d.imports, qu), L = se(R), B = $a(R, L), q, V, rt = 0, it = e.interpolate || wn, nt = "__p += '", ot = Ja(
          (e.escape || wn).source + "|" + it.source + "|" + (it === ll ? Hg : wn).source + "|" + (e.evaluate || wn).source + "|$",
          "g"
        ), dt = "//# sourceURL=" + (Gt.call(e, "sourceURL") ? (e.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++m1 + "]") + `
`;
        t.replace(ot, function(yt, Ft, kt, Pe, ge, Fe) {
          return kt || (kt = Pe), nt += t.slice(rt, Fe).replace($g, B1), Ft && (q = !0, nt += `' +
__e(` + Ft + `) +
'`), ge && (V = !0, nt += `';
` + ge + `;
__p += '`), kt && (nt += `' +
((__t = (` + kt + `)) == null ? '' : __t) +
'`), rt = Fe + yt.length, yt;
        }), nt += `';
`;
        var vt = Gt.call(e, "variable") && e.variable;
        if (!vt)
          nt = `with (obj) {
` + nt + `
}
`;
        else if (qg.test(vt))
          throw new bt(u);
        nt = (V ? nt.replace(Eg, "") : nt).replace(Ag, "$1").replace(Rg, "$1;"), nt = "function(" + (vt || "obj") + `) {
` + (vt ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (q ? ", __e = _.escape" : "") + (V ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + nt + `return __p
}`;
        var xt = kc(function() {
          return Lt(L, dt + "return " + nt).apply(i, B);
        });
        if (xt.source = nt, Ls(xt))
          throw xt;
        return xt;
      }
      function c4(t) {
        return Nt(t).toLowerCase();
      }
      function d4(t) {
        return Nt(t).toUpperCase();
      }
      function f4(t, e, n) {
        if (t = Nt(t), t && (n || e === i))
          return zl(t);
        if (!t || !(e = Re(e)))
          return t;
        var d = Ve(t), R = Ve(e), L = Hl(d, R), B = Wl(d, R) + 1;
        return Cr(d, L, B).join("");
      }
      function g4(t, e, n) {
        if (t = Nt(t), t && (n || e === i))
          return t.slice(0, jl(t) + 1);
        if (!t || !(e = Re(e)))
          return t;
        var d = Ve(t), R = Wl(d, Ve(e)) + 1;
        return Cr(d, 0, R).join("");
      }
      function p4(t, e, n) {
        if (t = Nt(t), t && (n || e === i))
          return t.replace(La, "");
        if (!t || !(e = Re(e)))
          return t;
        var d = Ve(t), R = Hl(d, Ve(e));
        return Cr(d, R).join("");
      }
      function _4(t, e) {
        var n = O, d = N;
        if (Wt(e)) {
          var R = "separator" in e ? e.separator : R;
          n = "length" in e ? Ct(e.length) : n, d = "omission" in e ? Re(e.omission) : d;
        }
        t = Nt(t);
        var L = t.length;
        if (zr(t)) {
          var B = Ve(t);
          L = B.length;
        }
        if (n >= L)
          return t;
        var q = n - Hr(d);
        if (q < 1)
          return d;
        var V = B ? Cr(B, 0, q).join("") : t.slice(0, q);
        if (R === i)
          return V + d;
        if (B && (q += V.length - q), Ns(R)) {
          if (t.slice(q).search(R)) {
            var rt, it = V;
            for (R.global || (R = Ja(R.source, Nt(ul.exec(R)) + "g")), R.lastIndex = 0; rt = R.exec(it); )
              var nt = rt.index;
            V = V.slice(0, nt === i ? q : nt);
          }
        } else if (t.indexOf(Re(R), q) != q) {
          var ot = V.lastIndexOf(R);
          ot > -1 && (V = V.slice(0, ot));
        }
        return V + d;
      }
      function v4(t) {
        return t = Nt(t), t && Tg.test(t) ? t.replace(ol, j1) : t;
      }
      var y4 = $r(function(t, e, n) {
        return t + (n ? " " : "") + e.toUpperCase();
      }), Bs = Mu("toUpperCase");
      function Ic(t, e, n) {
        return t = Nt(t), e = n ? i : e, e === i ? q1(t) ? X1(t) : I1(t) : t.match(e) || [];
      }
      var kc = At(function(t, e) {
        try {
          return Ee(t, i, e);
        } catch (n) {
          return Ls(n) ? n : new bt(n);
        }
      }), m4 = sr(function(t, e) {
        return Me(e, function(n) {
          n = er(n), nr(t, n, ks(t[n], t));
        }), t;
      });
      function b4(t) {
        var e = t == null ? 0 : t.length, n = _t();
        return t = e ? zt(t, function(d) {
          if (typeof d[1] != "function")
            throw new Le(l);
          return [n(d[0]), d[1]];
        }) : [], At(function(d) {
          for (var R = -1; ++R < e; ) {
            var L = t[R];
            if (Ee(L[0], this, d))
              return Ee(L[1], this, d);
          }
        });
      }
      function S4(t) {
        return j2(Ge(t, S));
      }
      function Us(t) {
        return function() {
          return t;
        };
      }
      function w4(t, e) {
        return t == null || t !== t ? e : t;
      }
      var C4 = Nu(), x4 = Nu(!0);
      function be(t) {
        return t;
      }
      function qs(t) {
        return du(typeof t == "function" ? t : Ge(t, S));
      }
      function E4(t) {
        return gu(Ge(t, S));
      }
      function A4(t, e) {
        return pu(t, Ge(e, S));
      }
      var R4 = At(function(t, e) {
        return function(n) {
          return _i(n, t, e);
        };
      }), T4 = At(function(t, e) {
        return function(n) {
          return _i(t, n, e);
        };
      });
      function zs(t, e, n) {
        var d = se(e), R = Wn(e, d);
        n == null && !(Wt(e) && (R.length || !d.length)) && (n = e, e = t, t = this, R = Wn(e, se(e)));
        var L = !(Wt(n) && "chain" in n) || !!n.chain, B = hr(t);
        return Me(R, function(q) {
          var V = e[q];
          t[q] = V, B && (t.prototype[q] = function() {
            var rt = this.__chain__;
            if (L || rt) {
              var it = t(this.__wrapped__), nt = it.__actions__ = ve(this.__actions__);
              return nt.push({ func: V, args: arguments, thisArg: t }), it.__chain__ = rt, it;
            }
            return V.apply(t, vr([this.value()], arguments));
          });
        }), t;
      }
      function P4() {
        return he._ === this && (he._ = e2), this;
      }
      function Hs() {
      }
      function F4(t) {
        return t = Ct(t), At(function(e) {
          return _u(e, t);
        });
      }
      var O4 = bs(zt), I4 = bs(Gl), k4 = bs(Va);
      function Mc(t) {
        return Rs(t) ? ja(er(t)) : lp(t);
      }
      function M4(t) {
        return function(e) {
          return t == null ? i : Ir(t, e);
        };
      }
      var L4 = Du(), N4 = Du(!0);
      function Ws() {
        return [];
      }
      function Vs() {
        return !1;
      }
      function G4() {
        return {};
      }
      function D4() {
        return "";
      }
      function B4() {
        return !0;
      }
      function U4(t, e) {
        if (t = Ct(t), t < 1 || t > K)
          return [];
        var n = Q, d = ue(t, Q);
        e = _t(e), t -= Q;
        for (var R = Xa(d, e); ++n < t; )
          e(n);
        return R;
      }
      function q4(t) {
        return St(t) ? zt(t, er) : Te(t) ? [t] : ve(tc(Nt(t)));
      }
      function z4(t) {
        var e = ++Q1;
        return Nt(t) + e;
      }
      var H4 = $n(function(t, e) {
        return t + e;
      }, 0), W4 = Ss("ceil"), V4 = $n(function(t, e) {
        return t / e;
      }, 1), j4 = Ss("floor");
      function K4(t) {
        return t && t.length ? Hn(t, be, ss) : i;
      }
      function Y4(t, e) {
        return t && t.length ? Hn(t, _t(e, 2), ss) : i;
      }
      function X4(t) {
        return Ul(t, be);
      }
      function $4(t, e) {
        return Ul(t, _t(e, 2));
      }
      function Z4(t) {
        return t && t.length ? Hn(t, be, us) : i;
      }
      function J4(t, e) {
        return t && t.length ? Hn(t, _t(e, 2), us) : i;
      }
      var Q4 = $n(function(t, e) {
        return t * e;
      }, 1), t6 = Ss("round"), e6 = $n(function(t, e) {
        return t - e;
      }, 0);
      function r6(t) {
        return t && t.length ? Ya(t, be) : 0;
      }
      function i6(t, e) {
        return t && t.length ? Ya(t, _t(e, 2)) : 0;
      }
      return I.after = E5, I.ary = cc, I.assign = d3, I.assignIn = Ec, I.assignInWith = la, I.assignWith = f3, I.at = g3, I.before = dc, I.bind = ks, I.bindAll = m4, I.bindKey = fc, I.castArray = G5, I.chain = hc, I.chunk = jp, I.compact = Kp, I.concat = Yp, I.cond = b4, I.conforms = S4, I.constant = Us, I.countBy = r5, I.create = p3, I.curry = gc, I.curryRight = pc, I.debounce = _c, I.defaults = _3, I.defaultsDeep = v3, I.defer = A5, I.delay = R5, I.difference = Xp, I.differenceBy = $p, I.differenceWith = Zp, I.drop = Jp, I.dropRight = Qp, I.dropRightWhile = t_, I.dropWhile = e_, I.fill = r_, I.filter = n5, I.flatMap = o5, I.flatMapDeep = h5, I.flatMapDepth = l5, I.flatten = nc, I.flattenDeep = i_, I.flattenDepth = n_, I.flip = T5, I.flow = C4, I.flowRight = x4, I.fromPairs = a_, I.functions = x3, I.functionsIn = E3, I.groupBy = u5, I.initial = o_, I.intersection = h_, I.intersectionBy = l_, I.intersectionWith = u_, I.invert = R3, I.invertBy = T3, I.invokeMap = d5, I.iteratee = qs, I.keyBy = f5, I.keys = se, I.keysIn = me, I.map = ia, I.mapKeys = F3, I.mapValues = O3, I.matches = E4, I.matchesProperty = A4, I.memoize = aa, I.merge = I3, I.mergeWith = Ac, I.method = R4, I.methodOf = T4, I.mixin = zs, I.negate = sa, I.nthArg = F4, I.omit = k3, I.omitBy = M3, I.once = P5, I.orderBy = g5, I.over = O4, I.overArgs = F5, I.overEvery = I4, I.overSome = k4, I.partial = Ms, I.partialRight = vc, I.partition = p5, I.pick = L3, I.pickBy = Rc, I.property = Mc, I.propertyOf = M4, I.pull = g_, I.pullAll = sc, I.pullAllBy = p_, I.pullAllWith = __, I.pullAt = v_, I.range = L4, I.rangeRight = N4, I.rearg = O5, I.reject = y5, I.remove = y_, I.rest = I5, I.reverse = Os, I.sampleSize = b5, I.set = G3, I.setWith = D3, I.shuffle = S5, I.slice = m_, I.sortBy = x5, I.sortedUniq = A_, I.sortedUniqBy = R_, I.split = o4, I.spread = k5, I.tail = T_, I.take = P_, I.takeRight = F_, I.takeRightWhile = O_, I.takeWhile = I_, I.tap = K_, I.throttle = M5, I.thru = ra, I.toArray = wc, I.toPairs = Tc, I.toPairsIn = Pc, I.toPath = q4, I.toPlainObject = xc, I.transform = B3, I.unary = L5, I.union = k_, I.unionBy = M_, I.unionWith = L_, I.uniq = N_, I.uniqBy = G_, I.uniqWith = D_, I.unset = U3, I.unzip = Is, I.unzipWith = oc, I.update = q3, I.updateWith = z3, I.values = Qr, I.valuesIn = H3, I.without = B_, I.words = Ic, I.wrap = N5, I.xor = U_, I.xorBy = q_, I.xorWith = z_, I.zip = H_, I.zipObject = W_, I.zipObjectDeep = V_, I.zipWith = j_, I.entries = Tc, I.entriesIn = Pc, I.extend = Ec, I.extendWith = la, zs(I, I), I.add = H4, I.attempt = kc, I.camelCase = K3, I.capitalize = Fc, I.ceil = W4, I.clamp = W3, I.clone = D5, I.cloneDeep = U5, I.cloneDeepWith = q5, I.cloneWith = B5, I.conformsTo = z5, I.deburr = Oc, I.defaultTo = w4, I.divide = V4, I.endsWith = Y3, I.eq = Ke, I.escape = X3, I.escapeRegExp = $3, I.every = i5, I.find = a5, I.findIndex = rc, I.findKey = y3, I.findLast = s5, I.findLastIndex = ic, I.findLastKey = m3, I.floor = j4, I.forEach = lc, I.forEachRight = uc, I.forIn = b3, I.forInRight = S3, I.forOwn = w3, I.forOwnRight = C3, I.get = Gs, I.gt = H5, I.gte = W5, I.has = A3, I.hasIn = Ds, I.head = ac, I.identity = be, I.includes = c5, I.indexOf = s_, I.inRange = V3, I.invoke = P3, I.isArguments = Lr, I.isArray = St, I.isArrayBuffer = V5, I.isArrayLike = ye, I.isArrayLikeObject = Yt, I.isBoolean = j5, I.isBuffer = xr, I.isDate = K5, I.isElement = Y5, I.isEmpty = X5, I.isEqual = $5, I.isEqualWith = Z5, I.isError = Ls, I.isFinite = J5, I.isFunction = hr, I.isInteger = yc, I.isLength = oa, I.isMap = mc, I.isMatch = Q5, I.isMatchWith = t3, I.isNaN = e3, I.isNative = r3, I.isNil = n3, I.isNull = i3, I.isNumber = bc, I.isObject = Wt, I.isObjectLike = jt, I.isPlainObject = wi, I.isRegExp = Ns, I.isSafeInteger = a3, I.isSet = Sc, I.isString = ha, I.isSymbol = Te, I.isTypedArray = Jr, I.isUndefined = s3, I.isWeakMap = o3, I.isWeakSet = h3, I.join = c_, I.kebabCase = Z3, I.last = Be, I.lastIndexOf = d_, I.lowerCase = J3, I.lowerFirst = Q3, I.lt = l3, I.lte = u3, I.max = K4, I.maxBy = Y4, I.mean = X4, I.meanBy = $4, I.min = Z4, I.minBy = J4, I.stubArray = Ws, I.stubFalse = Vs, I.stubObject = G4, I.stubString = D4, I.stubTrue = B4, I.multiply = Q4, I.nth = f_, I.noConflict = P4, I.noop = Hs, I.now = na, I.pad = t4, I.padEnd = e4, I.padStart = r4, I.parseInt = i4, I.random = j3, I.reduce = _5, I.reduceRight = v5, I.repeat = n4, I.replace = a4, I.result = N3, I.round = t6, I.runInContext = W, I.sample = m5, I.size = w5, I.snakeCase = s4, I.some = C5, I.sortedIndex = b_, I.sortedIndexBy = S_, I.sortedIndexOf = w_, I.sortedLastIndex = C_, I.sortedLastIndexBy = x_, I.sortedLastIndexOf = E_, I.startCase = h4, I.startsWith = l4, I.subtract = e6, I.sum = r6, I.sumBy = i6, I.template = u4, I.times = U4, I.toFinite = lr, I.toInteger = Ct, I.toLength = Cc, I.toLower = c4, I.toNumber = Ue, I.toSafeInteger = c3, I.toString = Nt, I.toUpper = d4, I.trim = f4, I.trimEnd = g4, I.trimStart = p4, I.truncate = _4, I.unescape = v4, I.uniqueId = z4, I.upperCase = y4, I.upperFirst = Bs, I.each = lc, I.eachRight = uc, I.first = ac, zs(I, function() {
        var t = {};
        return Qe(I, function(e, n) {
          Gt.call(I.prototype, n) || (t[n] = e);
        }), t;
      }(), { chain: !1 }), I.VERSION = s, Me(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(t) {
        I[t].placeholder = I;
      }), Me(["drop", "take"], function(t, e) {
        It.prototype[t] = function(n) {
          n = n === i ? 1 : te(Ct(n), 0);
          var d = this.__filtered__ && !e ? new It(this) : this.clone();
          return d.__filtered__ ? d.__takeCount__ = ue(n, d.__takeCount__) : d.__views__.push({
            size: ue(n, Q),
            type: t + (d.__dir__ < 0 ? "Right" : "")
          }), d;
        }, It.prototype[t + "Right"] = function(n) {
          return this.reverse()[t](n).reverse();
        };
      }), Me(["filter", "map", "takeWhile"], function(t, e) {
        var n = e + 1, d = n == P || n == G;
        It.prototype[t] = function(R) {
          var L = this.clone();
          return L.__iteratees__.push({
            iteratee: _t(R, 3),
            type: n
          }), L.__filtered__ = L.__filtered__ || d, L;
        };
      }), Me(["head", "last"], function(t, e) {
        var n = "take" + (e ? "Right" : "");
        It.prototype[t] = function() {
          return this[n](1).value()[0];
        };
      }), Me(["initial", "tail"], function(t, e) {
        var n = "drop" + (e ? "" : "Right");
        It.prototype[t] = function() {
          return this.__filtered__ ? new It(this) : this[n](1);
        };
      }), It.prototype.compact = function() {
        return this.filter(be);
      }, It.prototype.find = function(t) {
        return this.filter(t).head();
      }, It.prototype.findLast = function(t) {
        return this.reverse().find(t);
      }, It.prototype.invokeMap = At(function(t, e) {
        return typeof t == "function" ? new It(this) : this.map(function(n) {
          return _i(n, t, e);
        });
      }), It.prototype.reject = function(t) {
        return this.filter(sa(_t(t)));
      }, It.prototype.slice = function(t, e) {
        t = Ct(t);
        var n = this;
        return n.__filtered__ && (t > 0 || e < 0) ? new It(n) : (t < 0 ? n = n.takeRight(-t) : t && (n = n.drop(t)), e !== i && (e = Ct(e), n = e < 0 ? n.dropRight(-e) : n.take(e - t)), n);
      }, It.prototype.takeRightWhile = function(t) {
        return this.reverse().takeWhile(t).reverse();
      }, It.prototype.toArray = function() {
        return this.take(Q);
      }, Qe(It.prototype, function(t, e) {
        var n = /^(?:filter|find|map|reject)|While$/.test(e), d = /^(?:head|last)$/.test(e), R = I[d ? "take" + (e == "last" ? "Right" : "") : e], L = d || /^find/.test(e);
        R && (I.prototype[e] = function() {
          var B = this.__wrapped__, q = d ? [1] : arguments, V = B instanceof It, rt = q[0], it = V || St(B), nt = function(Ft) {
            var kt = R.apply(I, vr([Ft], q));
            return d && ot ? kt[0] : kt;
          };
          it && n && typeof rt == "function" && rt.length != 1 && (V = it = !1);
          var ot = this.__chain__, dt = !!this.__actions__.length, vt = L && !ot, xt = V && !dt;
          if (!L && it) {
            B = xt ? B : new It(this);
            var yt = t.apply(B, q);
            return yt.__actions__.push({ func: ra, args: [nt], thisArg: i }), new Ne(yt, ot);
          }
          return vt && xt ? t.apply(this, q) : (yt = this.thru(nt), vt ? d ? yt.value()[0] : yt.value() : yt);
        });
      }), Me(["pop", "push", "shift", "sort", "splice", "unshift"], function(t) {
        var e = Tn[t], n = /^(?:push|sort|unshift)$/.test(t) ? "tap" : "thru", d = /^(?:pop|shift)$/.test(t);
        I.prototype[t] = function() {
          var R = arguments;
          if (d && !this.__chain__) {
            var L = this.value();
            return e.apply(St(L) ? L : [], R);
          }
          return this[n](function(B) {
            return e.apply(St(B) ? B : [], R);
          });
        };
      }), Qe(It.prototype, function(t, e) {
        var n = I[e];
        if (n) {
          var d = n.name + "";
          Gt.call(Kr, d) || (Kr[d] = []), Kr[d].push({ name: e, func: n });
        }
      }), Kr[Xn(i, F).name] = [{
        name: "wrapper",
        func: i
      }], It.prototype.clone = v2, It.prototype.reverse = y2, It.prototype.value = m2, I.prototype.at = Y_, I.prototype.chain = X_, I.prototype.commit = $_, I.prototype.next = Z_, I.prototype.plant = Q_, I.prototype.reverse = t5, I.prototype.toJSON = I.prototype.valueOf = I.prototype.value = e5, I.prototype.first = I.prototype.head, li && (I.prototype[li] = J_), I;
    }, Wr = $1();
    Rr ? ((Rr.exports = Wr)._ = Wr, qa._ = Wr) : he._ = Wr;
  }).call(Ci);
})(pa, pa.exports);
pa.exports;
Object.values(Ce);
const s6 = Object.values(Ar), o6 = (r) => s6.includes(r);
var fr = /* @__PURE__ */ ((r) => (r.SPOT = "spot", r.DECORATION = "decoration", r))(fr || {});
function h6(r) {
  return !r || typeof r != "object" ? !1 : "type" in r && "subType" in r ? r.type === "spot" && o6(r.subType) : !1;
}
var ii = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function ai(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var ga = { exports: {} }, xi = {}, js = {}, Ks = {}, Nc;
function Rt() {
  return Nc || (Nc = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r._registerNode = r.Konva = r.glob = void 0;
    const a = Math.PI / 180;
    function i() {
      return typeof window != "undefined" && ({}.toString.call(window) === "[object Window]" || {}.toString.call(window) === "[object global]");
    }
    r.glob = typeof ii != "undefined" ? ii : typeof window != "undefined" ? window : typeof WorkerGlobalScope != "undefined" ? self : {}, r.Konva = {
      _global: r.glob,
      version: "9.3.16",
      isBrowser: i(),
      isUnminified: /param/.test(function(h) {
      }.toString()),
      dblClickWindow: 400,
      getAngle(h) {
        return r.Konva.angleDeg ? h * a : h;
      },
      enableTrace: !1,
      pointerEventsEnabled: !0,
      autoDrawEnabled: !0,
      hitOnDragEnabled: !1,
      capturePointerEventsEnabled: !1,
      _mouseListenClick: !1,
      _touchListenClick: !1,
      _pointerListenClick: !1,
      _mouseInDblClickWindow: !1,
      _touchInDblClickWindow: !1,
      _pointerInDblClickWindow: !1,
      _mouseDblClickPointerId: null,
      _touchDblClickPointerId: null,
      _pointerDblClickPointerId: null,
      _fixTextRendering: !1,
      pixelRatio: typeof window != "undefined" && window.devicePixelRatio || 1,
      dragDistance: 3,
      angleDeg: !0,
      showWarnings: !0,
      dragButtons: [0, 1],
      isDragging() {
        return r.Konva.DD.isDragging;
      },
      isTransforming() {
        var h;
        return (h = r.Konva.Transformer) === null || h === void 0 ? void 0 : h.isTransforming();
      },
      isDragReady() {
        return !!r.Konva.DD.node;
      },
      releaseCanvasOnDestroy: !0,
      document: r.glob.document,
      _injectGlobal(h) {
        r.glob.Konva = h;
      }
    };
    const s = (h) => {
      r.Konva[h.prototype.getClassName()] = h;
    };
    r._registerNode = s, r.Konva._injectGlobal(r.Konva);
  }(Ks)), Ks;
}
var Ys = {}, Gc;
function Kt() {
  return Gc || (Gc = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Util = r.Transform = void 0;
    const a = Rt();
    class i {
      constructor(m = [1, 0, 0, 1, 0, 0]) {
        this.dirty = !1, this.m = m && m.slice() || [1, 0, 0, 1, 0, 0];
      }
      reset() {
        this.m[0] = 1, this.m[1] = 0, this.m[2] = 0, this.m[3] = 1, this.m[4] = 0, this.m[5] = 0;
      }
      copy() {
        return new i(this.m);
      }
      copyInto(m) {
        m.m[0] = this.m[0], m.m[1] = this.m[1], m.m[2] = this.m[2], m.m[3] = this.m[3], m.m[4] = this.m[4], m.m[5] = this.m[5];
      }
      point(m) {
        const E = this.m;
        return {
          x: E[0] * m.x + E[2] * m.y + E[4],
          y: E[1] * m.x + E[3] * m.y + E[5]
        };
      }
      translate(m, E) {
        return this.m[4] += this.m[0] * m + this.m[2] * E, this.m[5] += this.m[1] * m + this.m[3] * E, this;
      }
      scale(m, E) {
        return this.m[0] *= m, this.m[1] *= m, this.m[2] *= E, this.m[3] *= E, this;
      }
      rotate(m) {
        const E = Math.cos(m), T = Math.sin(m), D = this.m[0] * E + this.m[2] * T, k = this.m[1] * E + this.m[3] * T, M = this.m[0] * -T + this.m[2] * E, O = this.m[1] * -T + this.m[3] * E;
        return this.m[0] = D, this.m[1] = k, this.m[2] = M, this.m[3] = O, this;
      }
      getTranslation() {
        return {
          x: this.m[4],
          y: this.m[5]
        };
      }
      skew(m, E) {
        const T = this.m[0] + this.m[2] * E, D = this.m[1] + this.m[3] * E, k = this.m[2] + this.m[0] * m, M = this.m[3] + this.m[1] * m;
        return this.m[0] = T, this.m[1] = D, this.m[2] = k, this.m[3] = M, this;
      }
      multiply(m) {
        const E = this.m[0] * m.m[0] + this.m[2] * m.m[1], T = this.m[1] * m.m[0] + this.m[3] * m.m[1], D = this.m[0] * m.m[2] + this.m[2] * m.m[3], k = this.m[1] * m.m[2] + this.m[3] * m.m[3], M = this.m[0] * m.m[4] + this.m[2] * m.m[5] + this.m[4], O = this.m[1] * m.m[4] + this.m[3] * m.m[5] + this.m[5];
        return this.m[0] = E, this.m[1] = T, this.m[2] = D, this.m[3] = k, this.m[4] = M, this.m[5] = O, this;
      }
      invert() {
        const m = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]), E = this.m[3] * m, T = -this.m[1] * m, D = -this.m[2] * m, k = this.m[0] * m, M = m * (this.m[2] * this.m[5] - this.m[3] * this.m[4]), O = m * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
        return this.m[0] = E, this.m[1] = T, this.m[2] = D, this.m[3] = k, this.m[4] = M, this.m[5] = O, this;
      }
      getMatrix() {
        return this.m;
      }
      decompose() {
        const m = this.m[0], E = this.m[1], T = this.m[2], D = this.m[3], k = this.m[4], M = this.m[5], O = m * D - E * T, N = {
          x: k,
          y: M,
          rotation: 0,
          scaleX: 0,
          scaleY: 0,
          skewX: 0,
          skewY: 0
        };
        if (m != 0 || E != 0) {
          const z = Math.sqrt(m * m + E * E);
          N.rotation = E > 0 ? Math.acos(m / z) : -Math.acos(m / z), N.scaleX = z, N.scaleY = O / z, N.skewX = (m * T + E * D) / O, N.skewY = 0;
        } else if (T != 0 || D != 0) {
          const z = Math.sqrt(T * T + D * D);
          N.rotation = Math.PI / 2 - (D > 0 ? Math.acos(-T / z) : -Math.acos(T / z)), N.scaleX = O / z, N.scaleY = z, N.skewX = 0, N.skewY = (m * T + E * D) / O;
        }
        return N.rotation = r.Util._getRotation(N.rotation), N;
      }
    }
    r.Transform = i;
    let s = "[object Array]", h = "[object Number]", o = "[object String]", l = "[object Boolean]", u = Math.PI / 180, g = 180 / Math.PI, p = "#", b = "", S = "0", x = "Konva warning: ", v = "Konva error: ", _ = "rgb(", w = {
      aliceblue: [240, 248, 255],
      antiquewhite: [250, 235, 215],
      aqua: [0, 255, 255],
      aquamarine: [127, 255, 212],
      azure: [240, 255, 255],
      beige: [245, 245, 220],
      bisque: [255, 228, 196],
      black: [0, 0, 0],
      blanchedalmond: [255, 235, 205],
      blue: [0, 0, 255],
      blueviolet: [138, 43, 226],
      brown: [165, 42, 42],
      burlywood: [222, 184, 135],
      cadetblue: [95, 158, 160],
      chartreuse: [127, 255, 0],
      chocolate: [210, 105, 30],
      coral: [255, 127, 80],
      cornflowerblue: [100, 149, 237],
      cornsilk: [255, 248, 220],
      crimson: [220, 20, 60],
      cyan: [0, 255, 255],
      darkblue: [0, 0, 139],
      darkcyan: [0, 139, 139],
      darkgoldenrod: [184, 132, 11],
      darkgray: [169, 169, 169],
      darkgreen: [0, 100, 0],
      darkgrey: [169, 169, 169],
      darkkhaki: [189, 183, 107],
      darkmagenta: [139, 0, 139],
      darkolivegreen: [85, 107, 47],
      darkorange: [255, 140, 0],
      darkorchid: [153, 50, 204],
      darkred: [139, 0, 0],
      darksalmon: [233, 150, 122],
      darkseagreen: [143, 188, 143],
      darkslateblue: [72, 61, 139],
      darkslategray: [47, 79, 79],
      darkslategrey: [47, 79, 79],
      darkturquoise: [0, 206, 209],
      darkviolet: [148, 0, 211],
      deeppink: [255, 20, 147],
      deepskyblue: [0, 191, 255],
      dimgray: [105, 105, 105],
      dimgrey: [105, 105, 105],
      dodgerblue: [30, 144, 255],
      firebrick: [178, 34, 34],
      floralwhite: [255, 255, 240],
      forestgreen: [34, 139, 34],
      fuchsia: [255, 0, 255],
      gainsboro: [220, 220, 220],
      ghostwhite: [248, 248, 255],
      gold: [255, 215, 0],
      goldenrod: [218, 165, 32],
      gray: [128, 128, 128],
      green: [0, 128, 0],
      greenyellow: [173, 255, 47],
      grey: [128, 128, 128],
      honeydew: [240, 255, 240],
      hotpink: [255, 105, 180],
      indianred: [205, 92, 92],
      indigo: [75, 0, 130],
      ivory: [255, 255, 240],
      khaki: [240, 230, 140],
      lavender: [230, 230, 250],
      lavenderblush: [255, 240, 245],
      lawngreen: [124, 252, 0],
      lemonchiffon: [255, 250, 205],
      lightblue: [173, 216, 230],
      lightcoral: [240, 128, 128],
      lightcyan: [224, 255, 255],
      lightgoldenrodyellow: [250, 250, 210],
      lightgray: [211, 211, 211],
      lightgreen: [144, 238, 144],
      lightgrey: [211, 211, 211],
      lightpink: [255, 182, 193],
      lightsalmon: [255, 160, 122],
      lightseagreen: [32, 178, 170],
      lightskyblue: [135, 206, 250],
      lightslategray: [119, 136, 153],
      lightslategrey: [119, 136, 153],
      lightsteelblue: [176, 196, 222],
      lightyellow: [255, 255, 224],
      lime: [0, 255, 0],
      limegreen: [50, 205, 50],
      linen: [250, 240, 230],
      magenta: [255, 0, 255],
      maroon: [128, 0, 0],
      mediumaquamarine: [102, 205, 170],
      mediumblue: [0, 0, 205],
      mediumorchid: [186, 85, 211],
      mediumpurple: [147, 112, 219],
      mediumseagreen: [60, 179, 113],
      mediumslateblue: [123, 104, 238],
      mediumspringgreen: [0, 250, 154],
      mediumturquoise: [72, 209, 204],
      mediumvioletred: [199, 21, 133],
      midnightblue: [25, 25, 112],
      mintcream: [245, 255, 250],
      mistyrose: [255, 228, 225],
      moccasin: [255, 228, 181],
      navajowhite: [255, 222, 173],
      navy: [0, 0, 128],
      oldlace: [253, 245, 230],
      olive: [128, 128, 0],
      olivedrab: [107, 142, 35],
      orange: [255, 165, 0],
      orangered: [255, 69, 0],
      orchid: [218, 112, 214],
      palegoldenrod: [238, 232, 170],
      palegreen: [152, 251, 152],
      paleturquoise: [175, 238, 238],
      palevioletred: [219, 112, 147],
      papayawhip: [255, 239, 213],
      peachpuff: [255, 218, 185],
      peru: [205, 133, 63],
      pink: [255, 192, 203],
      plum: [221, 160, 203],
      powderblue: [176, 224, 230],
      purple: [128, 0, 128],
      rebeccapurple: [102, 51, 153],
      red: [255, 0, 0],
      rosybrown: [188, 143, 143],
      royalblue: [65, 105, 225],
      saddlebrown: [139, 69, 19],
      salmon: [250, 128, 114],
      sandybrown: [244, 164, 96],
      seagreen: [46, 139, 87],
      seashell: [255, 245, 238],
      sienna: [160, 82, 45],
      silver: [192, 192, 192],
      skyblue: [135, 206, 235],
      slateblue: [106, 90, 205],
      slategray: [119, 128, 144],
      slategrey: [119, 128, 144],
      snow: [255, 255, 250],
      springgreen: [0, 255, 127],
      steelblue: [70, 130, 180],
      tan: [210, 180, 140],
      teal: [0, 128, 128],
      thistle: [216, 191, 216],
      transparent: [255, 255, 255, 0],
      tomato: [255, 99, 71],
      turquoise: [64, 224, 208],
      violet: [238, 130, 238],
      wheat: [245, 222, 179],
      white: [255, 255, 255],
      whitesmoke: [245, 245, 245],
      yellow: [255, 255, 0],
      yellowgreen: [154, 205, 5]
    }, C = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/, F = [];
    const c = typeof requestAnimationFrame != "undefined" && requestAnimationFrame || function(f) {
      setTimeout(f, 60);
    };
    r.Util = {
      _isElement(f) {
        return !!(f && f.nodeType == 1);
      },
      _isFunction(f) {
        return !!(f && f.constructor && f.call && f.apply);
      },
      _isPlainObject(f) {
        return !!f && f.constructor === Object;
      },
      _isArray(f) {
        return Object.prototype.toString.call(f) === s;
      },
      _isNumber(f) {
        return Object.prototype.toString.call(f) === h && !isNaN(f) && isFinite(f);
      },
      _isString(f) {
        return Object.prototype.toString.call(f) === o;
      },
      _isBoolean(f) {
        return Object.prototype.toString.call(f) === l;
      },
      isObject(f) {
        return f instanceof Object;
      },
      isValidSelector(f) {
        if (typeof f != "string")
          return !1;
        const m = f[0];
        return m === "#" || m === "." || m === m.toUpperCase();
      },
      _sign(f) {
        return f === 0 || f > 0 ? 1 : -1;
      },
      requestAnimFrame(f) {
        F.push(f), F.length === 1 && c(function() {
          const m = F;
          F = [], m.forEach(function(E) {
            E();
          });
        });
      },
      createCanvasElement() {
        const f = document.createElement("canvas");
        try {
          f.style = f.style || {};
        } catch {
        }
        return f;
      },
      createImageElement() {
        return document.createElement("img");
      },
      _isInDocument(f) {
        for (; f = f.parentNode; )
          if (f == document)
            return !0;
        return !1;
      },
      _urlToImage(f, m) {
        const E = r.Util.createImageElement();
        E.onload = function() {
          m(E);
        }, E.src = f;
      },
      _rgbToHex(f, m, E) {
        return ((1 << 24) + (f << 16) + (m << 8) + E).toString(16).slice(1);
      },
      _hexToRgb(f) {
        f = f.replace(p, b);
        const m = parseInt(f, 16);
        return {
          r: m >> 16 & 255,
          g: m >> 8 & 255,
          b: m & 255
        };
      },
      getRandomColor() {
        let f = (Math.random() * 16777215 << 0).toString(16);
        for (; f.length < 6; )
          f = S + f;
        return p + f;
      },
      getRGB(f) {
        let m;
        return f in w ? (m = w[f], {
          r: m[0],
          g: m[1],
          b: m[2]
        }) : f[0] === p ? this._hexToRgb(f.substring(1)) : f.substr(0, 4) === _ ? (m = C.exec(f.replace(/ /g, "")), {
          r: parseInt(m[1], 10),
          g: parseInt(m[2], 10),
          b: parseInt(m[3], 10)
        }) : {
          r: 0,
          g: 0,
          b: 0
        };
      },
      colorToRGBA(f) {
        return f = f || "black", r.Util._namedColorToRBA(f) || r.Util._hex3ColorToRGBA(f) || r.Util._hex4ColorToRGBA(f) || r.Util._hex6ColorToRGBA(f) || r.Util._hex8ColorToRGBA(f) || r.Util._rgbColorToRGBA(f) || r.Util._rgbaColorToRGBA(f) || r.Util._hslColorToRGBA(f);
      },
      _namedColorToRBA(f) {
        const m = w[f.toLowerCase()];
        return m ? {
          r: m[0],
          g: m[1],
          b: m[2],
          a: 1
        } : null;
      },
      _rgbColorToRGBA(f) {
        if (f.indexOf("rgb(") === 0) {
          f = f.match(/rgb\(([^)]+)\)/)[1];
          const m = f.split(/ *, */).map(Number);
          return {
            r: m[0],
            g: m[1],
            b: m[2],
            a: 1
          };
        }
      },
      _rgbaColorToRGBA(f) {
        if (f.indexOf("rgba(") === 0) {
          f = f.match(/rgba\(([^)]+)\)/)[1];
          const m = f.split(/ *, */).map((E, T) => E.slice(-1) === "%" ? T === 3 ? parseInt(E) / 100 : parseInt(E) / 100 * 255 : Number(E));
          return {
            r: m[0],
            g: m[1],
            b: m[2],
            a: m[3]
          };
        }
      },
      _hex8ColorToRGBA(f) {
        if (f[0] === "#" && f.length === 9)
          return {
            r: parseInt(f.slice(1, 3), 16),
            g: parseInt(f.slice(3, 5), 16),
            b: parseInt(f.slice(5, 7), 16),
            a: parseInt(f.slice(7, 9), 16) / 255
          };
      },
      _hex6ColorToRGBA(f) {
        if (f[0] === "#" && f.length === 7)
          return {
            r: parseInt(f.slice(1, 3), 16),
            g: parseInt(f.slice(3, 5), 16),
            b: parseInt(f.slice(5, 7), 16),
            a: 1
          };
      },
      _hex4ColorToRGBA(f) {
        if (f[0] === "#" && f.length === 5)
          return {
            r: parseInt(f[1] + f[1], 16),
            g: parseInt(f[2] + f[2], 16),
            b: parseInt(f[3] + f[3], 16),
            a: parseInt(f[4] + f[4], 16) / 255
          };
      },
      _hex3ColorToRGBA(f) {
        if (f[0] === "#" && f.length === 4)
          return {
            r: parseInt(f[1] + f[1], 16),
            g: parseInt(f[2] + f[2], 16),
            b: parseInt(f[3] + f[3], 16),
            a: 1
          };
      },
      _hslColorToRGBA(f) {
        if (/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.test(f)) {
          const [m, ...E] = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(f), T = Number(E[0]) / 360, D = Number(E[1]) / 100, k = Number(E[2]) / 100;
          let M, O, N;
          if (D === 0)
            return N = k * 255, {
              r: Math.round(N),
              g: Math.round(N),
              b: Math.round(N),
              a: 1
            };
          k < 0.5 ? M = k * (1 + D) : M = k + D - k * D;
          const z = 2 * k - M, y = [0, 0, 0];
          for (let P = 0; P < 3; P++)
            O = T + 1 / 3 * -(P - 1), O < 0 && O++, O > 1 && O--, 6 * O < 1 ? N = z + (M - z) * 6 * O : 2 * O < 1 ? N = M : 3 * O < 2 ? N = z + (M - z) * (2 / 3 - O) * 6 : N = z, y[P] = N * 255;
          return {
            r: Math.round(y[0]),
            g: Math.round(y[1]),
            b: Math.round(y[2]),
            a: 1
          };
        }
      },
      haveIntersection(f, m) {
        return !(m.x > f.x + f.width || m.x + m.width < f.x || m.y > f.y + f.height || m.y + m.height < f.y);
      },
      cloneObject(f) {
        const m = {};
        for (const E in f)
          this._isPlainObject(f[E]) ? m[E] = this.cloneObject(f[E]) : this._isArray(f[E]) ? m[E] = this.cloneArray(f[E]) : m[E] = f[E];
        return m;
      },
      cloneArray(f) {
        return f.slice(0);
      },
      degToRad(f) {
        return f * u;
      },
      radToDeg(f) {
        return f * g;
      },
      _degToRad(f) {
        return r.Util.warn("Util._degToRad is removed. Please use public Util.degToRad instead."), r.Util.degToRad(f);
      },
      _radToDeg(f) {
        return r.Util.warn("Util._radToDeg is removed. Please use public Util.radToDeg instead."), r.Util.radToDeg(f);
      },
      _getRotation(f) {
        return a.Konva.angleDeg ? r.Util.radToDeg(f) : f;
      },
      _capitalize(f) {
        return f.charAt(0).toUpperCase() + f.slice(1);
      },
      throw(f) {
        throw new Error(v + f);
      },
      error(f) {
        console.error(v + f);
      },
      warn(f) {
        a.Konva.showWarnings && console.warn(x + f);
      },
      each(f, m) {
        for (const E in f)
          m(E, f[E]);
      },
      _inRange(f, m, E) {
        return m <= f && f < E;
      },
      _getProjectionToSegment(f, m, E, T, D, k) {
        let M, O, N;
        const z = (f - E) * (f - E) + (m - T) * (m - T);
        if (z == 0)
          M = f, O = m, N = (D - E) * (D - E) + (k - T) * (k - T);
        else {
          const y = ((D - f) * (E - f) + (k - m) * (T - m)) / z;
          y < 0 ? (M = f, O = m, N = (f - D) * (f - D) + (m - k) * (m - k)) : y > 1 ? (M = E, O = T, N = (E - D) * (E - D) + (T - k) * (T - k)) : (M = f + y * (E - f), O = m + y * (T - m), N = (M - D) * (M - D) + (O - k) * (O - k));
        }
        return [M, O, N];
      },
      _getProjectionToLine(f, m, E) {
        const T = r.Util.cloneObject(f);
        let D = Number.MAX_VALUE;
        return m.forEach(function(k, M) {
          if (!E && M === m.length - 1)
            return;
          const O = m[(M + 1) % m.length], N = r.Util._getProjectionToSegment(k.x, k.y, O.x, O.y, f.x, f.y), z = N[0], y = N[1], P = N[2];
          P < D && (T.x = z, T.y = y, D = P);
        }), T;
      },
      _prepareArrayForTween(f, m, E) {
        let T, D = [], k = [];
        if (f.length > m.length) {
          const O = m;
          m = f, f = O;
        }
        for (T = 0; T < f.length; T += 2)
          D.push({
            x: f[T],
            y: f[T + 1]
          });
        for (T = 0; T < m.length; T += 2)
          k.push({
            x: m[T],
            y: m[T + 1]
          });
        const M = [];
        return k.forEach(function(O) {
          const N = r.Util._getProjectionToLine(O, D, E);
          M.push(N.x), M.push(N.y);
        }), M;
      },
      _prepareToStringify(f) {
        let m;
        f.visitedByCircularReferenceRemoval = !0;
        for (const E in f)
          if (f.hasOwnProperty(E) && f[E] && typeof f[E] == "object") {
            if (m = Object.getOwnPropertyDescriptor(f, E), f[E].visitedByCircularReferenceRemoval || r.Util._isElement(f[E]))
              if (m.configurable)
                delete f[E];
              else
                return null;
            else if (r.Util._prepareToStringify(f[E]) === null)
              if (m.configurable)
                delete f[E];
              else
                return null;
          }
        return delete f.visitedByCircularReferenceRemoval, f;
      },
      _assign(f, m) {
        for (const E in m)
          f[E] = m[E];
        return f;
      },
      _getFirstPointerId(f) {
        return f.touches ? f.changedTouches[0].identifier : f.pointerId || 999;
      },
      releaseCanvas(...f) {
        a.Konva.releaseCanvasOnDestroy && f.forEach((m) => {
          m.width = 0, m.height = 0;
        });
      },
      drawRoundedRectPath(f, m, E, T) {
        let D = 0, k = 0, M = 0, O = 0;
        typeof T == "number" ? D = k = M = O = Math.min(T, m / 2, E / 2) : (D = Math.min(T[0] || 0, m / 2, E / 2), k = Math.min(T[1] || 0, m / 2, E / 2), O = Math.min(T[2] || 0, m / 2, E / 2), M = Math.min(T[3] || 0, m / 2, E / 2)), f.moveTo(D, 0), f.lineTo(m - k, 0), f.arc(m - k, k, k, Math.PI * 3 / 2, 0, !1), f.lineTo(m, E - O), f.arc(m - O, E - O, O, 0, Math.PI / 2, !1), f.lineTo(M, E), f.arc(M, E - M, M, Math.PI / 2, Math.PI, !1), f.lineTo(0, D), f.arc(D, D, D, Math.PI, Math.PI * 3 / 2, !1);
      }
    };
  }(Ys)), Ys;
}
var Ei = {}, Xs = {}, Se = {}, Dc;
function Ot() {
  if (Dc) return Se;
  Dc = 1, Object.defineProperty(Se, "__esModule", { value: !0 }), Se.RGBComponent = s, Se.alphaComponent = h, Se.getNumberValidator = o, Se.getNumberOrArrayOfNumbersValidator = l, Se.getNumberOrAutoValidator = u, Se.getStringValidator = g, Se.getStringOrGradientValidator = p, Se.getFunctionValidator = b, Se.getNumberArrayValidator = S, Se.getBooleanValidator = x, Se.getComponentValidator = v;
  const r = Rt(), a = Kt();
  function i(_) {
    return a.Util._isString(_) ? '"' + _ + '"' : Object.prototype.toString.call(_) === "[object Number]" || a.Util._isBoolean(_) ? _ : Object.prototype.toString.call(_);
  }
  function s(_) {
    return _ > 255 ? 255 : _ < 0 ? 0 : Math.round(_);
  }
  function h(_) {
    return _ > 1 ? 1 : _ < 1e-4 ? 1e-4 : _;
  }
  function o() {
    if (r.Konva.isUnminified)
      return function(_, w) {
        return a.Util._isNumber(_) || a.Util.warn(i(_) + ' is a not valid value for "' + w + '" attribute. The value should be a number.'), _;
      };
  }
  function l(_) {
    if (r.Konva.isUnminified)
      return function(w, C) {
        const F = a.Util._isNumber(w), c = a.Util._isArray(w) && w.length == _;
        return !F && !c && a.Util.warn(i(w) + ' is a not valid value for "' + C + '" attribute. The value should be a number or Array<number>(' + _ + ")"), w;
      };
  }
  function u() {
    if (r.Konva.isUnminified)
      return function(_, w) {
        return a.Util._isNumber(_) || _ === "auto" || a.Util.warn(i(_) + ' is a not valid value for "' + w + '" attribute. The value should be a number or "auto".'), _;
      };
  }
  function g() {
    if (r.Konva.isUnminified)
      return function(_, w) {
        return a.Util._isString(_) || a.Util.warn(i(_) + ' is a not valid value for "' + w + '" attribute. The value should be a string.'), _;
      };
  }
  function p() {
    if (r.Konva.isUnminified)
      return function(_, w) {
        const C = a.Util._isString(_), F = Object.prototype.toString.call(_) === "[object CanvasGradient]" || _ && _.addColorStop;
        return C || F || a.Util.warn(i(_) + ' is a not valid value for "' + w + '" attribute. The value should be a string or a native gradient.'), _;
      };
  }
  function b() {
    if (r.Konva.isUnminified)
      return function(_, w) {
        return a.Util._isFunction(_) || a.Util.warn(i(_) + ' is a not valid value for "' + w + '" attribute. The value should be a function.'), _;
      };
  }
  function S() {
    if (r.Konva.isUnminified)
      return function(_, w) {
        const C = Int8Array ? Object.getPrototypeOf(Int8Array) : null;
        return C && _ instanceof C || (a.Util._isArray(_) ? _.forEach(function(F) {
          a.Util._isNumber(F) || a.Util.warn('"' + w + '" attribute has non numeric element ' + F + ". Make sure that all elements are numbers.");
        }) : a.Util.warn(i(_) + ' is a not valid value for "' + w + '" attribute. The value should be a array of numbers.')), _;
      };
  }
  function x() {
    if (r.Konva.isUnminified)
      return function(_, w) {
        return _ === !0 || _ === !1 || a.Util.warn(i(_) + ' is a not valid value for "' + w + '" attribute. The value should be a boolean.'), _;
      };
  }
  function v(_) {
    if (r.Konva.isUnminified)
      return function(w, C) {
        return w == null || a.Util.isObject(w) || a.Util.warn(i(w) + ' is a not valid value for "' + C + '" attribute. The value should be an object with properties ' + _), w;
      };
  }
  return Se;
}
var Bc;
function Tt() {
  return Bc || (Bc = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Factory = void 0;
    const a = Kt(), i = Ot(), s = "get", h = "set";
    r.Factory = {
      addGetterSetter(o, l, u, g, p) {
        r.Factory.addGetter(o, l, u), r.Factory.addSetter(o, l, g, p), r.Factory.addOverloadedGetterSetter(o, l);
      },
      addGetter(o, l, u) {
        const g = s + a.Util._capitalize(l);
        o.prototype[g] = o.prototype[g] || function() {
          const p = this.attrs[l];
          return p === void 0 ? u : p;
        };
      },
      addSetter(o, l, u, g) {
        const p = h + a.Util._capitalize(l);
        o.prototype[p] || r.Factory.overWriteSetter(o, l, u, g);
      },
      overWriteSetter(o, l, u, g) {
        const p = h + a.Util._capitalize(l);
        o.prototype[p] = function(b) {
          return u && b !== void 0 && b !== null && (b = u.call(this, b, l)), this._setAttr(l, b), g && g.call(this), this;
        };
      },
      addComponentsGetterSetter(o, l, u, g, p) {
        let b = u.length, S = a.Util._capitalize, x = s + S(l), v = h + S(l), _, w;
        o.prototype[x] = function() {
          const F = {};
          for (_ = 0; _ < b; _++)
            w = u[_], F[w] = this.getAttr(l + S(w));
          return F;
        };
        const C = (0, i.getComponentValidator)(u);
        o.prototype[v] = function(F) {
          let c = this.attrs[l], f;
          g && (F = g.call(this, F)), C && C.call(this, F, l);
          for (f in F)
            F.hasOwnProperty(f) && this._setAttr(l + S(f), F[f]);
          return F || u.forEach((m) => {
            this._setAttr(l + S(m), void 0);
          }), this._fireChangeEvent(l, c, F), p && p.call(this), this;
        }, r.Factory.addOverloadedGetterSetter(o, l);
      },
      addOverloadedGetterSetter(o, l) {
        const u = a.Util._capitalize(l), g = h + u, p = s + u;
        o.prototype[l] = function() {
          return arguments.length ? (this[g](arguments[0]), this) : this[p]();
        };
      },
      addDeprecatedGetterSetter(o, l, u, g) {
        a.Util.error("Adding deprecated " + l);
        const p = s + a.Util._capitalize(l), b = l + " property is deprecated and will be removed soon. Look at Konva change log for more information.";
        o.prototype[p] = function() {
          a.Util.error(b);
          const S = this.attrs[l];
          return S === void 0 ? u : S;
        }, r.Factory.addSetter(o, l, g, function() {
          a.Util.error(b);
        }), r.Factory.addOverloadedGetterSetter(o, l);
      },
      backCompat(o, l) {
        a.Util.each(l, function(u, g) {
          const p = o.prototype[g], b = s + a.Util._capitalize(u), S = h + a.Util._capitalize(u);
          function x() {
            p.apply(this, arguments), a.Util.error('"' + u + '" method is deprecated and will be removed soon. Use ""' + g + '" instead.');
          }
          o.prototype[u] = x, o.prototype[b] = x, o.prototype[S] = x;
        });
      },
      afterSetFilter() {
        this._filterUpToDate = !1;
      }
    };
  }(Xs)), Xs;
}
var cr = {}, dr = {}, Uc;
function eg() {
  if (Uc) return dr;
  Uc = 1, Object.defineProperty(dr, "__esModule", { value: !0 }), dr.HitContext = dr.SceneContext = dr.Context = void 0;
  const r = Kt(), a = Rt();
  function i(F) {
    let c = [], f = F.length, m = r.Util, E, T;
    for (E = 0; E < f; E++)
      T = F[E], m._isNumber(T) ? T = Math.round(T * 1e3) / 1e3 : m._isString(T) || (T = T + ""), c.push(T);
    return c;
  }
  const s = ",", h = "(", o = ")", l = "([", u = "])", g = ";", p = "()", b = "=", S = [
    "arc",
    "arcTo",
    "beginPath",
    "bezierCurveTo",
    "clearRect",
    "clip",
    "closePath",
    "createLinearGradient",
    "createPattern",
    "createRadialGradient",
    "drawImage",
    "ellipse",
    "fill",
    "fillText",
    "getImageData",
    "createImageData",
    "lineTo",
    "moveTo",
    "putImageData",
    "quadraticCurveTo",
    "rect",
    "roundRect",
    "restore",
    "rotate",
    "save",
    "scale",
    "setLineDash",
    "setTransform",
    "stroke",
    "strokeText",
    "transform",
    "translate"
  ], x = [
    "fillStyle",
    "strokeStyle",
    "shadowColor",
    "shadowBlur",
    "shadowOffsetX",
    "shadowOffsetY",
    "letterSpacing",
    "lineCap",
    "lineDashOffset",
    "lineJoin",
    "lineWidth",
    "miterLimit",
    "direction",
    "font",
    "textAlign",
    "textBaseline",
    "globalAlpha",
    "globalCompositeOperation",
    "imageSmoothingEnabled"
  ], v = 100;
  let _ = class {
    constructor(c) {
      this.canvas = c, a.Konva.enableTrace && (this.traceArr = [], this._enableTrace());
    }
    fillShape(c) {
      c.fillEnabled() && this._fill(c);
    }
    _fill(c) {
    }
    strokeShape(c) {
      c.hasStroke() && this._stroke(c);
    }
    _stroke(c) {
    }
    fillStrokeShape(c) {
      c.attrs.fillAfterStrokeEnabled ? (this.strokeShape(c), this.fillShape(c)) : (this.fillShape(c), this.strokeShape(c));
    }
    getTrace(c, f) {
      let m = this.traceArr, E = m.length, T = "", D, k, M, O;
      for (D = 0; D < E; D++)
        k = m[D], M = k.method, M ? (O = k.args, T += M, c ? T += p : r.Util._isArray(O[0]) ? T += l + O.join(s) + u : (f && (O = O.map((N) => typeof N == "number" ? Math.floor(N) : N)), T += h + O.join(s) + o)) : (T += k.property, c || (T += b + k.val)), T += g;
      return T;
    }
    clearTrace() {
      this.traceArr = [];
    }
    _trace(c) {
      let f = this.traceArr, m;
      f.push(c), m = f.length, m >= v && f.shift();
    }
    reset() {
      const c = this.getCanvas().getPixelRatio();
      this.setTransform(1 * c, 0, 0, 1 * c, 0, 0);
    }
    getCanvas() {
      return this.canvas;
    }
    clear(c) {
      const f = this.getCanvas();
      c ? this.clearRect(c.x || 0, c.y || 0, c.width || 0, c.height || 0) : this.clearRect(0, 0, f.getWidth() / f.pixelRatio, f.getHeight() / f.pixelRatio);
    }
    _applyLineCap(c) {
      const f = c.attrs.lineCap;
      f && this.setAttr("lineCap", f);
    }
    _applyOpacity(c) {
      const f = c.getAbsoluteOpacity();
      f !== 1 && this.setAttr("globalAlpha", f);
    }
    _applyLineJoin(c) {
      const f = c.attrs.lineJoin;
      f && this.setAttr("lineJoin", f);
    }
    setAttr(c, f) {
      this._context[c] = f;
    }
    arc(c, f, m, E, T, D) {
      this._context.arc(c, f, m, E, T, D);
    }
    arcTo(c, f, m, E, T) {
      this._context.arcTo(c, f, m, E, T);
    }
    beginPath() {
      this._context.beginPath();
    }
    bezierCurveTo(c, f, m, E, T, D) {
      this._context.bezierCurveTo(c, f, m, E, T, D);
    }
    clearRect(c, f, m, E) {
      this._context.clearRect(c, f, m, E);
    }
    clip(...c) {
      this._context.clip.apply(this._context, c);
    }
    closePath() {
      this._context.closePath();
    }
    createImageData(c, f) {
      const m = arguments;
      if (m.length === 2)
        return this._context.createImageData(c, f);
      if (m.length === 1)
        return this._context.createImageData(c);
    }
    createLinearGradient(c, f, m, E) {
      return this._context.createLinearGradient(c, f, m, E);
    }
    createPattern(c, f) {
      return this._context.createPattern(c, f);
    }
    createRadialGradient(c, f, m, E, T, D) {
      return this._context.createRadialGradient(c, f, m, E, T, D);
    }
    drawImage(c, f, m, E, T, D, k, M, O) {
      const N = arguments, z = this._context;
      N.length === 3 ? z.drawImage(c, f, m) : N.length === 5 ? z.drawImage(c, f, m, E, T) : N.length === 9 && z.drawImage(c, f, m, E, T, D, k, M, O);
    }
    ellipse(c, f, m, E, T, D, k, M) {
      this._context.ellipse(c, f, m, E, T, D, k, M);
    }
    isPointInPath(c, f, m, E) {
      return m ? this._context.isPointInPath(m, c, f, E) : this._context.isPointInPath(c, f, E);
    }
    fill(...c) {
      this._context.fill.apply(this._context, c);
    }
    fillRect(c, f, m, E) {
      this._context.fillRect(c, f, m, E);
    }
    strokeRect(c, f, m, E) {
      this._context.strokeRect(c, f, m, E);
    }
    fillText(c, f, m, E) {
      E ? this._context.fillText(c, f, m, E) : this._context.fillText(c, f, m);
    }
    measureText(c) {
      return this._context.measureText(c);
    }
    getImageData(c, f, m, E) {
      return this._context.getImageData(c, f, m, E);
    }
    lineTo(c, f) {
      this._context.lineTo(c, f);
    }
    moveTo(c, f) {
      this._context.moveTo(c, f);
    }
    rect(c, f, m, E) {
      this._context.rect(c, f, m, E);
    }
    roundRect(c, f, m, E, T) {
      this._context.roundRect(c, f, m, E, T);
    }
    putImageData(c, f, m) {
      this._context.putImageData(c, f, m);
    }
    quadraticCurveTo(c, f, m, E) {
      this._context.quadraticCurveTo(c, f, m, E);
    }
    restore() {
      this._context.restore();
    }
    rotate(c) {
      this._context.rotate(c);
    }
    save() {
      this._context.save();
    }
    scale(c, f) {
      this._context.scale(c, f);
    }
    setLineDash(c) {
      this._context.setLineDash ? this._context.setLineDash(c) : "mozDash" in this._context ? this._context.mozDash = c : "webkitLineDash" in this._context && (this._context.webkitLineDash = c);
    }
    getLineDash() {
      return this._context.getLineDash();
    }
    setTransform(c, f, m, E, T, D) {
      this._context.setTransform(c, f, m, E, T, D);
    }
    stroke(c) {
      c ? this._context.stroke(c) : this._context.stroke();
    }
    strokeText(c, f, m, E) {
      this._context.strokeText(c, f, m, E);
    }
    transform(c, f, m, E, T, D) {
      this._context.transform(c, f, m, E, T, D);
    }
    translate(c, f) {
      this._context.translate(c, f);
    }
    _enableTrace() {
      let c = this, f = S.length, m = this.setAttr, E, T;
      const D = function(k) {
        let M = c[k], O;
        c[k] = function() {
          return T = i(Array.prototype.slice.call(arguments, 0)), O = M.apply(c, arguments), c._trace({
            method: k,
            args: T
          }), O;
        };
      };
      for (E = 0; E < f; E++)
        D(S[E]);
      c.setAttr = function() {
        m.apply(c, arguments);
        const k = arguments[0];
        let M = arguments[1];
        (k === "shadowOffsetX" || k === "shadowOffsetY" || k === "shadowBlur") && (M = M / this.canvas.getPixelRatio()), c._trace({
          property: k,
          val: M
        });
      };
    }
    _applyGlobalCompositeOperation(c) {
      const f = c.attrs.globalCompositeOperation;
      !f || f === "source-over" || this.setAttr("globalCompositeOperation", f);
    }
  };
  dr.Context = _, x.forEach(function(F) {
    Object.defineProperty(_.prototype, F, {
      get() {
        return this._context[F];
      },
      set(c) {
        this._context[F] = c;
      }
    });
  });
  class w extends _ {
    constructor(c, { willReadFrequently: f = !1 } = {}) {
      super(c), this._context = c._canvas.getContext("2d", {
        willReadFrequently: f
      });
    }
    _fillColor(c) {
      const f = c.fill();
      this.setAttr("fillStyle", f), c._fillFunc(this);
    }
    _fillPattern(c) {
      this.setAttr("fillStyle", c._getFillPattern()), c._fillFunc(this);
    }
    _fillLinearGradient(c) {
      const f = c._getLinearGradient();
      f && (this.setAttr("fillStyle", f), c._fillFunc(this));
    }
    _fillRadialGradient(c) {
      const f = c._getRadialGradient();
      f && (this.setAttr("fillStyle", f), c._fillFunc(this));
    }
    _fill(c) {
      const f = c.fill(), m = c.getFillPriority();
      if (f && m === "color") {
        this._fillColor(c);
        return;
      }
      const E = c.getFillPatternImage();
      if (E && m === "pattern") {
        this._fillPattern(c);
        return;
      }
      const T = c.getFillLinearGradientColorStops();
      if (T && m === "linear-gradient") {
        this._fillLinearGradient(c);
        return;
      }
      const D = c.getFillRadialGradientColorStops();
      if (D && m === "radial-gradient") {
        this._fillRadialGradient(c);
        return;
      }
      f ? this._fillColor(c) : E ? this._fillPattern(c) : T ? this._fillLinearGradient(c) : D && this._fillRadialGradient(c);
    }
    _strokeLinearGradient(c) {
      const f = c.getStrokeLinearGradientStartPoint(), m = c.getStrokeLinearGradientEndPoint(), E = c.getStrokeLinearGradientColorStops(), T = this.createLinearGradient(f.x, f.y, m.x, m.y);
      if (E) {
        for (let D = 0; D < E.length; D += 2)
          T.addColorStop(E[D], E[D + 1]);
        this.setAttr("strokeStyle", T);
      }
    }
    _stroke(c) {
      const f = c.dash(), m = c.getStrokeScaleEnabled();
      if (c.hasStroke()) {
        if (!m) {
          this.save();
          const T = this.getCanvas().getPixelRatio();
          this.setTransform(T, 0, 0, T, 0, 0);
        }
        this._applyLineCap(c), f && c.dashEnabled() && (this.setLineDash(f), this.setAttr("lineDashOffset", c.dashOffset())), this.setAttr("lineWidth", c.strokeWidth()), c.getShadowForStrokeEnabled() || this.setAttr("shadowColor", "rgba(0,0,0,0)"), c.getStrokeLinearGradientColorStops() ? this._strokeLinearGradient(c) : this.setAttr("strokeStyle", c.stroke()), c._strokeFunc(this), m || this.restore();
      }
    }
    _applyShadow(c) {
      var f, m, E;
      const T = (f = c.getShadowRGBA()) !== null && f !== void 0 ? f : "black", D = (m = c.getShadowBlur()) !== null && m !== void 0 ? m : 5, k = (E = c.getShadowOffset()) !== null && E !== void 0 ? E : {
        x: 0,
        y: 0
      }, M = c.getAbsoluteScale(), O = this.canvas.getPixelRatio(), N = M.x * O, z = M.y * O;
      this.setAttr("shadowColor", T), this.setAttr("shadowBlur", D * Math.min(Math.abs(N), Math.abs(z))), this.setAttr("shadowOffsetX", k.x * N), this.setAttr("shadowOffsetY", k.y * z);
    }
  }
  dr.SceneContext = w;
  class C extends _ {
    constructor(c) {
      super(c), this._context = c._canvas.getContext("2d", {
        willReadFrequently: !0
      });
    }
    _fill(c) {
      this.save(), this.setAttr("fillStyle", c.colorKey), c._fillFuncHit(this), this.restore();
    }
    strokeShape(c) {
      c.hasHitStroke() && this._stroke(c);
    }
    _stroke(c) {
      if (c.hasHitStroke()) {
        const f = c.getStrokeScaleEnabled();
        if (!f) {
          this.save();
          const T = this.getCanvas().getPixelRatio();
          this.setTransform(T, 0, 0, T, 0, 0);
        }
        this._applyLineCap(c);
        const m = c.hitStrokeWidth(), E = m === "auto" ? c.strokeWidth() : m;
        this.setAttr("lineWidth", E), this.setAttr("strokeStyle", c.colorKey), c._strokeFuncHit(this), f || this.restore();
      }
    }
  }
  return dr.HitContext = C, dr;
}
var qc;
function ba() {
  if (qc) return cr;
  qc = 1, Object.defineProperty(cr, "__esModule", { value: !0 }), cr.HitCanvas = cr.SceneCanvas = cr.Canvas = void 0;
  const r = Kt(), a = eg(), i = Rt(), s = Tt(), h = Ot();
  let o;
  function l() {
    if (o)
      return o;
    const b = r.Util.createCanvasElement(), S = b.getContext("2d");
    return o = function() {
      const x = i.Konva._global.devicePixelRatio || 1, v = S.webkitBackingStorePixelRatio || S.mozBackingStorePixelRatio || S.msBackingStorePixelRatio || S.oBackingStorePixelRatio || S.backingStorePixelRatio || 1;
      return x / v;
    }(), r.Util.releaseCanvas(b), o;
  }
  let u = class {
    constructor(S) {
      this.pixelRatio = 1, this.width = 0, this.height = 0, this.isCache = !1;
      const v = (S || {}).pixelRatio || i.Konva.pixelRatio || l();
      this.pixelRatio = v, this._canvas = r.Util.createCanvasElement(), this._canvas.style.padding = "0", this._canvas.style.margin = "0", this._canvas.style.border = "0", this._canvas.style.background = "transparent", this._canvas.style.position = "absolute", this._canvas.style.top = "0", this._canvas.style.left = "0";
    }
    getContext() {
      return this.context;
    }
    getPixelRatio() {
      return this.pixelRatio;
    }
    setPixelRatio(S) {
      const x = this.pixelRatio;
      this.pixelRatio = S, this.setSize(this.getWidth() / x, this.getHeight() / x);
    }
    setWidth(S) {
      this.width = this._canvas.width = S * this.pixelRatio, this._canvas.style.width = S + "px";
      const x = this.pixelRatio;
      this.getContext()._context.scale(x, x);
    }
    setHeight(S) {
      this.height = this._canvas.height = S * this.pixelRatio, this._canvas.style.height = S + "px";
      const x = this.pixelRatio;
      this.getContext()._context.scale(x, x);
    }
    getWidth() {
      return this.width;
    }
    getHeight() {
      return this.height;
    }
    setSize(S, x) {
      this.setWidth(S || 0), this.setHeight(x || 0);
    }
    toDataURL(S, x) {
      try {
        return this._canvas.toDataURL(S, x);
      } catch {
        try {
          return this._canvas.toDataURL();
        } catch (_) {
          return r.Util.error("Unable to get data URL. " + _.message + " For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html."), "";
        }
      }
    }
  };
  cr.Canvas = u, s.Factory.addGetterSetter(u, "pixelRatio", void 0, (0, h.getNumberValidator)());
  class g extends u {
    constructor(S = { width: 0, height: 0, willReadFrequently: !1 }) {
      super(S), this.context = new a.SceneContext(this, {
        willReadFrequently: S.willReadFrequently
      }), this.setSize(S.width, S.height);
    }
  }
  cr.SceneCanvas = g;
  class p extends u {
    constructor(S = { width: 0, height: 0 }) {
      super(S), this.hitCanvas = !0, this.context = new a.HitContext(this), this.setSize(S.width, S.height);
    }
  }
  return cr.HitCanvas = p, cr;
}
var $s = {}, zc;
function tl() {
  return zc || (zc = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.DD = void 0;
    const a = Rt(), i = Kt();
    r.DD = {
      get isDragging() {
        let s = !1;
        return r.DD._dragElements.forEach((h) => {
          h.dragStatus === "dragging" && (s = !0);
        }), s;
      },
      justDragged: !1,
      get node() {
        let s;
        return r.DD._dragElements.forEach((h) => {
          s = h.node;
        }), s;
      },
      _dragElements: /* @__PURE__ */ new Map(),
      _drag(s) {
        const h = [];
        r.DD._dragElements.forEach((o, l) => {
          const { node: u } = o, g = u.getStage();
          g.setPointersPositions(s), o.pointerId === void 0 && (o.pointerId = i.Util._getFirstPointerId(s));
          const p = g._changedPointerPositions.find((b) => b.id === o.pointerId);
          if (p) {
            if (o.dragStatus !== "dragging") {
              const b = u.dragDistance();
              if (Math.max(Math.abs(p.x - o.startPointerPos.x), Math.abs(p.y - o.startPointerPos.y)) < b || (u.startDrag({ evt: s }), !u.isDragging()))
                return;
            }
            u._setDragPosition(s, o), h.push(u);
          }
        }), h.forEach((o) => {
          o.fire("dragmove", {
            type: "dragmove",
            target: o,
            evt: s
          }, !0);
        });
      },
      _endDragBefore(s) {
        const h = [];
        r.DD._dragElements.forEach((o) => {
          const { node: l } = o, u = l.getStage();
          if (s && u.setPointersPositions(s), !u._changedPointerPositions.find((b) => b.id === o.pointerId))
            return;
          (o.dragStatus === "dragging" || o.dragStatus === "stopped") && (r.DD.justDragged = !0, a.Konva._mouseListenClick = !1, a.Konva._touchListenClick = !1, a.Konva._pointerListenClick = !1, o.dragStatus = "stopped");
          const p = o.node.getLayer() || o.node instanceof a.Konva.Stage && o.node;
          p && h.indexOf(p) === -1 && h.push(p);
        }), h.forEach((o) => {
          o.draw();
        });
      },
      _endDragAfter(s) {
        r.DD._dragElements.forEach((h, o) => {
          h.dragStatus === "stopped" && h.node.fire("dragend", {
            type: "dragend",
            target: h.node,
            evt: s
          }, !0), h.dragStatus !== "dragging" && r.DD._dragElements.delete(o);
        });
      }
    }, a.Konva.isBrowser && (window.addEventListener("mouseup", r.DD._endDragBefore, !0), window.addEventListener("touchend", r.DD._endDragBefore, !0), window.addEventListener("touchcancel", r.DD._endDragBefore, !0), window.addEventListener("mousemove", r.DD._drag), window.addEventListener("touchmove", r.DD._drag), window.addEventListener("mouseup", r.DD._endDragAfter, !1), window.addEventListener("touchend", r.DD._endDragAfter, !1), window.addEventListener("touchcancel", r.DD._endDragAfter, !1));
  }($s)), $s;
}
var Hc;
function $t() {
  if (Hc) return Ei;
  Hc = 1, Object.defineProperty(Ei, "__esModule", { value: !0 }), Ei.Node = void 0;
  const r = Kt(), a = Tt(), i = ba(), s = Rt(), h = tl(), o = Ot(), l = "absoluteOpacity", u = "allEventListeners", g = "absoluteTransform", p = "absoluteScale", b = "canvas", S = "Change", x = "children", v = "konva", _ = "listening", w = "mouseenter", C = "mouseleave", F = "set", c = "Shape", f = " ", m = "stage", E = "transform", T = "Stage", D = "visible", k = [
    "xChange.konva",
    "yChange.konva",
    "scaleXChange.konva",
    "scaleYChange.konva",
    "skewXChange.konva",
    "skewYChange.konva",
    "rotationChange.konva",
    "offsetXChange.konva",
    "offsetYChange.konva",
    "transformsEnabledChange.konva"
  ].join(f);
  let M = 1, O = class Jh {
    constructor(y) {
      this._id = M++, this.eventListeners = {}, this.attrs = {}, this.index = 0, this._allEventListeners = null, this.parent = null, this._cache = /* @__PURE__ */ new Map(), this._attachedDepsListeners = /* @__PURE__ */ new Map(), this._lastPos = null, this._batchingTransformChange = !1, this._needClearTransformCache = !1, this._filterUpToDate = !1, this._isUnderCache = !1, this._dragEventId = null, this._shouldFireChangeEvents = !1, this.setAttrs(y), this._shouldFireChangeEvents = !0;
    }
    hasChildren() {
      return !1;
    }
    _clearCache(y) {
      (y === E || y === g) && this._cache.get(y) ? this._cache.get(y).dirty = !0 : y ? this._cache.delete(y) : this._cache.clear();
    }
    _getCache(y, P) {
      let A = this._cache.get(y);
      return (A === void 0 || (y === E || y === g) && A.dirty === !0) && (A = P.call(this), this._cache.set(y, A)), A;
    }
    _calculate(y, P, A) {
      if (!this._attachedDepsListeners.get(y)) {
        const G = P.map((U) => U + "Change.konva").join(f);
        this.on(G, () => {
          this._clearCache(y);
        }), this._attachedDepsListeners.set(y, !0);
      }
      return this._getCache(y, A);
    }
    _getCanvasCache() {
      return this._cache.get(b);
    }
    _clearSelfAndDescendantCache(y) {
      this._clearCache(y), y === g && this.fire("absoluteTransformChange");
    }
    clearCache() {
      if (this._cache.has(b)) {
        const { scene: y, filter: P, hit: A } = this._cache.get(b);
        r.Util.releaseCanvas(y, P, A), this._cache.delete(b);
      }
      return this._clearSelfAndDescendantCache(), this._requestDraw(), this;
    }
    cache(y) {
      const P = y || {};
      let A = {};
      (P.x === void 0 || P.y === void 0 || P.width === void 0 || P.height === void 0) && (A = this.getClientRect({
        skipTransform: !0,
        relativeTo: this.getParent() || void 0
      }));
      let G = Math.ceil(P.width || A.width), U = Math.ceil(P.height || A.height), K = P.pixelRatio, $ = P.x === void 0 ? Math.floor(A.x) : P.x, X = P.y === void 0 ? Math.floor(A.y) : P.y, Q = P.offset || 0, st = P.drawBorder || !1, Z = P.hitCanvasPixelRatio || 1;
      if (!G || !U) {
        r.Util.error("Can not cache the node. Width or height of the node equals 0. Caching is skipped.");
        return;
      }
      const at = Math.abs(Math.round(A.x) - $) > 0.5 ? 1 : 0, ht = Math.abs(Math.round(A.y) - X) > 0.5 ? 1 : 0;
      G += Q * 2 + at, U += Q * 2 + ht, $ -= Q, X -= Q;
      const ct = new i.SceneCanvas({
        pixelRatio: K,
        width: G,
        height: U
      }), H = new i.SceneCanvas({
        pixelRatio: K,
        width: 0,
        height: 0,
        willReadFrequently: !0
      }), j = new i.HitCanvas({
        pixelRatio: Z,
        width: G,
        height: U
      }), et = ct.getContext(), ut = j.getContext();
      return j.isCache = !0, ct.isCache = !0, this._cache.delete(b), this._filterUpToDate = !1, P.imageSmoothingEnabled === !1 && (ct.getContext()._context.imageSmoothingEnabled = !1, H.getContext()._context.imageSmoothingEnabled = !1), et.save(), ut.save(), et.translate(-$, -X), ut.translate(-$, -X), this._isUnderCache = !0, this._clearSelfAndDescendantCache(l), this._clearSelfAndDescendantCache(p), this.drawScene(ct, this), this.drawHit(j, this), this._isUnderCache = !1, et.restore(), ut.restore(), st && (et.save(), et.beginPath(), et.rect(0, 0, G, U), et.closePath(), et.setAttr("strokeStyle", "red"), et.setAttr("lineWidth", 5), et.stroke(), et.restore()), this._cache.set(b, {
        scene: ct,
        filter: H,
        hit: j,
        x: $,
        y: X
      }), this._requestDraw(), this;
    }
    isCached() {
      return this._cache.has(b);
    }
    getClientRect(y) {
      throw new Error('abstract "getClientRect" method call');
    }
    _transformedRect(y, P) {
      const A = [
        { x: y.x, y: y.y },
        { x: y.x + y.width, y: y.y },
        { x: y.x + y.width, y: y.y + y.height },
        { x: y.x, y: y.y + y.height }
      ];
      let G = 1 / 0, U = 1 / 0, K = -1 / 0, $ = -1 / 0;
      const X = this.getAbsoluteTransform(P);
      return A.forEach(function(Q) {
        const st = X.point(Q);
        G === void 0 && (G = K = st.x, U = $ = st.y), G = Math.min(G, st.x), U = Math.min(U, st.y), K = Math.max(K, st.x), $ = Math.max($, st.y);
      }), {
        x: G,
        y: U,
        width: K - G,
        height: $ - U
      };
    }
    _drawCachedSceneCanvas(y) {
      y.save(), y._applyOpacity(this), y._applyGlobalCompositeOperation(this);
      const P = this._getCanvasCache();
      y.translate(P.x, P.y);
      const A = this._getCachedSceneCanvas(), G = A.pixelRatio;
      y.drawImage(A._canvas, 0, 0, A.width / G, A.height / G), y.restore();
    }
    _drawCachedHitCanvas(y) {
      const P = this._getCanvasCache(), A = P.hit;
      y.save(), y.translate(P.x, P.y), y.drawImage(A._canvas, 0, 0, A.width / A.pixelRatio, A.height / A.pixelRatio), y.restore();
    }
    _getCachedSceneCanvas() {
      let y = this.filters(), P = this._getCanvasCache(), A = P.scene, G = P.filter, U = G.getContext(), K, $, X, Q;
      if (y) {
        if (!this._filterUpToDate) {
          const st = A.pixelRatio;
          G.setSize(A.width / A.pixelRatio, A.height / A.pixelRatio);
          try {
            for (K = y.length, U.clear(), U.drawImage(A._canvas, 0, 0, A.getWidth() / st, A.getHeight() / st), $ = U.getImageData(0, 0, G.getWidth(), G.getHeight()), X = 0; X < K; X++) {
              if (Q = y[X], typeof Q != "function") {
                r.Util.error("Filter should be type of function, but got " + typeof Q + " instead. Please check correct filters");
                continue;
              }
              Q.call(this, $), U.putImageData($, 0, 0);
            }
          } catch (Z) {
            r.Util.error("Unable to apply filter. " + Z.message + " This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.");
          }
          this._filterUpToDate = !0;
        }
        return G;
      }
      return A;
    }
    on(y, P) {
      if (this._cache && this._cache.delete(u), arguments.length === 3)
        return this._delegate.apply(this, arguments);
      let A = y.split(f), G = A.length, U, K, $, X, Q;
      for (U = 0; U < G; U++)
        K = A[U], $ = K.split("."), X = $[0], Q = $[1] || "", this.eventListeners[X] || (this.eventListeners[X] = []), this.eventListeners[X].push({
          name: Q,
          handler: P
        });
      return this;
    }
    off(y, P) {
      let A = (y || "").split(f), G = A.length, U, K, $, X, Q, st;
      if (this._cache && this._cache.delete(u), !y)
        for (K in this.eventListeners)
          this._off(K);
      for (U = 0; U < G; U++)
        if ($ = A[U], X = $.split("."), Q = X[0], st = X[1], Q)
          this.eventListeners[Q] && this._off(Q, st, P);
        else
          for (K in this.eventListeners)
            this._off(K, st, P);
      return this;
    }
    dispatchEvent(y) {
      const P = {
        target: this,
        type: y.type,
        evt: y
      };
      return this.fire(y.type, P), this;
    }
    addEventListener(y, P) {
      return this.on(y, function(A) {
        P.call(this, A.evt);
      }), this;
    }
    removeEventListener(y) {
      return this.off(y), this;
    }
    _delegate(y, P, A) {
      const G = this;
      this.on(y, function(U) {
        const K = U.target.findAncestors(P, !0, G);
        for (let $ = 0; $ < K.length; $++)
          U = r.Util.cloneObject(U), U.currentTarget = K[$], A.call(K[$], U);
      });
    }
    remove() {
      return this.isDragging() && this.stopDrag(), h.DD._dragElements.delete(this._id), this._remove(), this;
    }
    _clearCaches() {
      this._clearSelfAndDescendantCache(g), this._clearSelfAndDescendantCache(l), this._clearSelfAndDescendantCache(p), this._clearSelfAndDescendantCache(m), this._clearSelfAndDescendantCache(D), this._clearSelfAndDescendantCache(_);
    }
    _remove() {
      this._clearCaches();
      const y = this.getParent();
      y && y.children && (y.children.splice(this.index, 1), y._setChildrenIndices(), this.parent = null);
    }
    destroy() {
      return this.remove(), this.clearCache(), this;
    }
    getAttr(y) {
      const P = "get" + r.Util._capitalize(y);
      return r.Util._isFunction(this[P]) ? this[P]() : this.attrs[y];
    }
    getAncestors() {
      let y = this.getParent(), P = [];
      for (; y; )
        P.push(y), y = y.getParent();
      return P;
    }
    getAttrs() {
      return this.attrs || {};
    }
    setAttrs(y) {
      return this._batchTransformChanges(() => {
        let P, A;
        if (!y)
          return this;
        for (P in y)
          P !== x && (A = F + r.Util._capitalize(P), r.Util._isFunction(this[A]) ? this[A](y[P]) : this._setAttr(P, y[P]));
      }), this;
    }
    isListening() {
      return this._getCache(_, this._isListening);
    }
    _isListening(y) {
      if (!this.listening())
        return !1;
      const A = this.getParent();
      return A && A !== y && this !== y ? A._isListening(y) : !0;
    }
    isVisible() {
      return this._getCache(D, this._isVisible);
    }
    _isVisible(y) {
      if (!this.visible())
        return !1;
      const A = this.getParent();
      return A && A !== y && this !== y ? A._isVisible(y) : !0;
    }
    shouldDrawHit(y, P = !1) {
      if (y)
        return this._isVisible(y) && this._isListening(y);
      const A = this.getLayer();
      let G = !1;
      h.DD._dragElements.forEach((K) => {
        K.dragStatus === "dragging" && (K.node.nodeType === "Stage" || K.node.getLayer() === A) && (G = !0);
      });
      const U = !P && !s.Konva.hitOnDragEnabled && (G || s.Konva.isTransforming());
      return this.isListening() && this.isVisible() && !U;
    }
    show() {
      return this.visible(!0), this;
    }
    hide() {
      return this.visible(!1), this;
    }
    getZIndex() {
      return this.index || 0;
    }
    getAbsoluteZIndex() {
      let y = this.getDepth(), P = this, A = 0, G, U, K, $;
      function X(st) {
        for (G = [], U = st.length, K = 0; K < U; K++)
          $ = st[K], A++, $.nodeType !== c && (G = G.concat($.getChildren().slice())), $._id === P._id && (K = U);
        G.length > 0 && G[0].getDepth() <= y && X(G);
      }
      const Q = this.getStage();
      return P.nodeType !== T && Q && X(Q.getChildren()), A;
    }
    getDepth() {
      let y = 0, P = this.parent;
      for (; P; )
        y++, P = P.parent;
      return y;
    }
    _batchTransformChanges(y) {
      this._batchingTransformChange = !0, y(), this._batchingTransformChange = !1, this._needClearTransformCache && (this._clearCache(E), this._clearSelfAndDescendantCache(g)), this._needClearTransformCache = !1;
    }
    setPosition(y) {
      return this._batchTransformChanges(() => {
        this.x(y.x), this.y(y.y);
      }), this;
    }
    getPosition() {
      return {
        x: this.x(),
        y: this.y()
      };
    }
    getRelativePointerPosition() {
      const y = this.getStage();
      if (!y)
        return null;
      const P = y.getPointerPosition();
      if (!P)
        return null;
      const A = this.getAbsoluteTransform().copy();
      return A.invert(), A.point(P);
    }
    getAbsolutePosition(y) {
      let P = !1, A = this.parent;
      for (; A; ) {
        if (A.isCached()) {
          P = !0;
          break;
        }
        A = A.parent;
      }
      P && !y && (y = !0);
      const G = this.getAbsoluteTransform(y).getMatrix(), U = new r.Transform(), K = this.offset();
      return U.m = G.slice(), U.translate(K.x, K.y), U.getTranslation();
    }
    setAbsolutePosition(y) {
      const { x: P, y: A, ...G } = this._clearTransform();
      this.attrs.x = P, this.attrs.y = A, this._clearCache(E);
      const U = this._getAbsoluteTransform().copy();
      return U.invert(), U.translate(y.x, y.y), y = {
        x: this.attrs.x + U.getTranslation().x,
        y: this.attrs.y + U.getTranslation().y
      }, this._setTransform(G), this.setPosition({ x: y.x, y: y.y }), this._clearCache(E), this._clearSelfAndDescendantCache(g), this;
    }
    _setTransform(y) {
      let P;
      for (P in y)
        this.attrs[P] = y[P];
    }
    _clearTransform() {
      const y = {
        x: this.x(),
        y: this.y(),
        rotation: this.rotation(),
        scaleX: this.scaleX(),
        scaleY: this.scaleY(),
        offsetX: this.offsetX(),
        offsetY: this.offsetY(),
        skewX: this.skewX(),
        skewY: this.skewY()
      };
      return this.attrs.x = 0, this.attrs.y = 0, this.attrs.rotation = 0, this.attrs.scaleX = 1, this.attrs.scaleY = 1, this.attrs.offsetX = 0, this.attrs.offsetY = 0, this.attrs.skewX = 0, this.attrs.skewY = 0, y;
    }
    move(y) {
      let P = y.x, A = y.y, G = this.x(), U = this.y();
      return P !== void 0 && (G += P), A !== void 0 && (U += A), this.setPosition({ x: G, y: U }), this;
    }
    _eachAncestorReverse(y, P) {
      let A = [], G = this.getParent(), U, K;
      if (!(P && P._id === this._id)) {
        for (A.unshift(this); G && (!P || G._id !== P._id); )
          A.unshift(G), G = G.parent;
        for (U = A.length, K = 0; K < U; K++)
          y(A[K]);
      }
    }
    rotate(y) {
      return this.rotation(this.rotation() + y), this;
    }
    moveToTop() {
      if (!this.parent)
        return r.Util.warn("Node has no parent. moveToTop function is ignored."), !1;
      const y = this.index, P = this.parent.getChildren().length;
      return y < P - 1 ? (this.parent.children.splice(y, 1), this.parent.children.push(this), this.parent._setChildrenIndices(), !0) : !1;
    }
    moveUp() {
      if (!this.parent)
        return r.Util.warn("Node has no parent. moveUp function is ignored."), !1;
      const y = this.index, P = this.parent.getChildren().length;
      return y < P - 1 ? (this.parent.children.splice(y, 1), this.parent.children.splice(y + 1, 0, this), this.parent._setChildrenIndices(), !0) : !1;
    }
    moveDown() {
      if (!this.parent)
        return r.Util.warn("Node has no parent. moveDown function is ignored."), !1;
      const y = this.index;
      return y > 0 ? (this.parent.children.splice(y, 1), this.parent.children.splice(y - 1, 0, this), this.parent._setChildrenIndices(), !0) : !1;
    }
    moveToBottom() {
      if (!this.parent)
        return r.Util.warn("Node has no parent. moveToBottom function is ignored."), !1;
      const y = this.index;
      return y > 0 ? (this.parent.children.splice(y, 1), this.parent.children.unshift(this), this.parent._setChildrenIndices(), !0) : !1;
    }
    setZIndex(y) {
      if (!this.parent)
        return r.Util.warn("Node has no parent. zIndex parameter is ignored."), this;
      (y < 0 || y >= this.parent.children.length) && r.Util.warn("Unexpected value " + y + " for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to " + (this.parent.children.length - 1) + ".");
      const P = this.index;
      return this.parent.children.splice(P, 1), this.parent.children.splice(y, 0, this), this.parent._setChildrenIndices(), this;
    }
    getAbsoluteOpacity() {
      return this._getCache(l, this._getAbsoluteOpacity);
    }
    _getAbsoluteOpacity() {
      let y = this.opacity();
      const P = this.getParent();
      return P && !P._isUnderCache && (y *= P.getAbsoluteOpacity()), y;
    }
    moveTo(y) {
      return this.getParent() !== y && (this._remove(), y.add(this)), this;
    }
    toObject() {
      let y = this.getAttrs(), P, A, G, U, K;
      const $ = {
        attrs: {},
        className: this.getClassName()
      };
      for (P in y)
        A = y[P], K = r.Util.isObject(A) && !r.Util._isPlainObject(A) && !r.Util._isArray(A), !K && (G = typeof this[P] == "function" && this[P], delete y[P], U = G ? G.call(this) : null, y[P] = A, U !== A && ($.attrs[P] = A));
      return r.Util._prepareToStringify($);
    }
    toJSON() {
      return JSON.stringify(this.toObject());
    }
    getParent() {
      return this.parent;
    }
    findAncestors(y, P, A) {
      const G = [];
      P && this._isMatch(y) && G.push(this);
      let U = this.parent;
      for (; U; ) {
        if (U === A)
          return G;
        U._isMatch(y) && G.push(U), U = U.parent;
      }
      return G;
    }
    isAncestorOf(y) {
      return !1;
    }
    findAncestor(y, P, A) {
      return this.findAncestors(y, P, A)[0];
    }
    _isMatch(y) {
      if (!y)
        return !1;
      if (typeof y == "function")
        return y(this);
      let P = y.replace(/ /g, "").split(","), A = P.length, G, U;
      for (G = 0; G < A; G++)
        if (U = P[G], r.Util.isValidSelector(U) || (r.Util.warn('Selector "' + U + '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".'), r.Util.warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".'), r.Util.warn("Konva is awesome, right?")), U.charAt(0) === "#") {
          if (this.id() === U.slice(1))
            return !0;
        } else if (U.charAt(0) === ".") {
          if (this.hasName(U.slice(1)))
            return !0;
        } else if (this.className === U || this.nodeType === U)
          return !0;
      return !1;
    }
    getLayer() {
      const y = this.getParent();
      return y ? y.getLayer() : null;
    }
    getStage() {
      return this._getCache(m, this._getStage);
    }
    _getStage() {
      const y = this.getParent();
      return y ? y.getStage() : null;
    }
    fire(y, P = {}, A) {
      return P.target = P.target || this, A ? this._fireAndBubble(y, P) : this._fire(y, P), this;
    }
    getAbsoluteTransform(y) {
      return y ? this._getAbsoluteTransform(y) : this._getCache(g, this._getAbsoluteTransform);
    }
    _getAbsoluteTransform(y) {
      let P;
      if (y)
        return P = new r.Transform(), this._eachAncestorReverse(function(A) {
          const G = A.transformsEnabled();
          G === "all" ? P.multiply(A.getTransform()) : G === "position" && P.translate(A.x() - A.offsetX(), A.y() - A.offsetY());
        }, y), P;
      {
        P = this._cache.get(g) || new r.Transform(), this.parent ? this.parent.getAbsoluteTransform().copyInto(P) : P.reset();
        const A = this.transformsEnabled();
        if (A === "all")
          P.multiply(this.getTransform());
        else if (A === "position") {
          const G = this.attrs.x || 0, U = this.attrs.y || 0, K = this.attrs.offsetX || 0, $ = this.attrs.offsetY || 0;
          P.translate(G - K, U - $);
        }
        return P.dirty = !1, P;
      }
    }
    getAbsoluteScale(y) {
      let P = this;
      for (; P; )
        P._isUnderCache && (y = P), P = P.getParent();
      const G = this.getAbsoluteTransform(y).decompose();
      return {
        x: G.scaleX,
        y: G.scaleY
      };
    }
    getAbsoluteRotation() {
      return this.getAbsoluteTransform().decompose().rotation;
    }
    getTransform() {
      return this._getCache(E, this._getTransform);
    }
    _getTransform() {
      var y, P;
      const A = this._cache.get(E) || new r.Transform();
      A.reset();
      const G = this.x(), U = this.y(), K = s.Konva.getAngle(this.rotation()), $ = (y = this.attrs.scaleX) !== null && y !== void 0 ? y : 1, X = (P = this.attrs.scaleY) !== null && P !== void 0 ? P : 1, Q = this.attrs.skewX || 0, st = this.attrs.skewY || 0, Z = this.attrs.offsetX || 0, at = this.attrs.offsetY || 0;
      return (G !== 0 || U !== 0) && A.translate(G, U), K !== 0 && A.rotate(K), (Q !== 0 || st !== 0) && A.skew(Q, st), ($ !== 1 || X !== 1) && A.scale($, X), (Z !== 0 || at !== 0) && A.translate(-1 * Z, -1 * at), A.dirty = !1, A;
    }
    clone(y) {
      let P = r.Util.cloneObject(this.attrs), A, G, U, K, $;
      for (A in y)
        P[A] = y[A];
      const X = new this.constructor(P);
      for (A in this.eventListeners)
        for (G = this.eventListeners[A], U = G.length, K = 0; K < U; K++)
          $ = G[K], $.name.indexOf(v) < 0 && (X.eventListeners[A] || (X.eventListeners[A] = []), X.eventListeners[A].push($));
      return X;
    }
    _toKonvaCanvas(y) {
      y = y || {};
      const P = this.getClientRect(), A = this.getStage(), G = y.x !== void 0 ? y.x : Math.floor(P.x), U = y.y !== void 0 ? y.y : Math.floor(P.y), K = y.pixelRatio || 1, $ = new i.SceneCanvas({
        width: y.width || Math.ceil(P.width) || (A ? A.width() : 0),
        height: y.height || Math.ceil(P.height) || (A ? A.height() : 0),
        pixelRatio: K
      }), X = $.getContext(), Q = new i.SceneCanvas({
        width: $.width / $.pixelRatio + Math.abs(G),
        height: $.height / $.pixelRatio + Math.abs(U),
        pixelRatio: $.pixelRatio
      });
      return y.imageSmoothingEnabled === !1 && (X._context.imageSmoothingEnabled = !1), X.save(), (G || U) && X.translate(-1 * G, -1 * U), this.drawScene($, void 0, Q), X.restore(), $;
    }
    toCanvas(y) {
      return this._toKonvaCanvas(y)._canvas;
    }
    toDataURL(y) {
      y = y || {};
      const P = y.mimeType || null, A = y.quality || null, G = this._toKonvaCanvas(y).toDataURL(P, A);
      return y.callback && y.callback(G), G;
    }
    toImage(y) {
      return new Promise((P, A) => {
        try {
          const G = y == null ? void 0 : y.callback;
          G && delete y.callback, r.Util._urlToImage(this.toDataURL(y), function(U) {
            P(U), G == null || G(U);
          });
        } catch (G) {
          A(G);
        }
      });
    }
    toBlob(y) {
      return new Promise((P, A) => {
        try {
          const G = y == null ? void 0 : y.callback;
          G && delete y.callback, this.toCanvas(y).toBlob((U) => {
            P(U), G == null || G(U);
          }, y == null ? void 0 : y.mimeType, y == null ? void 0 : y.quality);
        } catch (G) {
          A(G);
        }
      });
    }
    setSize(y) {
      return this.width(y.width), this.height(y.height), this;
    }
    getSize() {
      return {
        width: this.width(),
        height: this.height()
      };
    }
    getClassName() {
      return this.className || this.nodeType;
    }
    getType() {
      return this.nodeType;
    }
    getDragDistance() {
      return this.attrs.dragDistance !== void 0 ? this.attrs.dragDistance : this.parent ? this.parent.getDragDistance() : s.Konva.dragDistance;
    }
    _off(y, P, A) {
      let G = this.eventListeners[y], U, K, $;
      for (U = 0; U < G.length; U++)
        if (K = G[U].name, $ = G[U].handler, (K !== "konva" || P === "konva") && (!P || K === P) && (!A || A === $)) {
          if (G.splice(U, 1), G.length === 0) {
            delete this.eventListeners[y];
            break;
          }
          U--;
        }
    }
    _fireChangeEvent(y, P, A) {
      this._fire(y + S, {
        oldVal: P,
        newVal: A
      });
    }
    addName(y) {
      if (!this.hasName(y)) {
        const P = this.name(), A = P ? P + " " + y : y;
        this.name(A);
      }
      return this;
    }
    hasName(y) {
      if (!y)
        return !1;
      const P = this.name();
      return P ? (P || "").split(/\s/g).indexOf(y) !== -1 : !1;
    }
    removeName(y) {
      const P = (this.name() || "").split(/\s/g), A = P.indexOf(y);
      return A !== -1 && (P.splice(A, 1), this.name(P.join(" "))), this;
    }
    setAttr(y, P) {
      const A = this[F + r.Util._capitalize(y)];
      return r.Util._isFunction(A) ? A.call(this, P) : this._setAttr(y, P), this;
    }
    _requestDraw() {
      if (s.Konva.autoDrawEnabled) {
        const y = this.getLayer() || this.getStage();
        y == null || y.batchDraw();
      }
    }
    _setAttr(y, P) {
      const A = this.attrs[y];
      A === P && !r.Util.isObject(P) || (P == null ? delete this.attrs[y] : this.attrs[y] = P, this._shouldFireChangeEvents && this._fireChangeEvent(y, A, P), this._requestDraw());
    }
    _setComponentAttr(y, P, A) {
      let G;
      A !== void 0 && (G = this.attrs[y], G || (this.attrs[y] = this.getAttr(y)), this.attrs[y][P] = A, this._fireChangeEvent(y, G, A));
    }
    _fireAndBubble(y, P, A) {
      if (P && this.nodeType === c && (P.target = this), !((y === w || y === C) && (A && (this === A || this.isAncestorOf && this.isAncestorOf(A)) || this.nodeType === "Stage" && !A))) {
        this._fire(y, P);
        const U = (y === w || y === C) && A && A.isAncestorOf && A.isAncestorOf(this) && !A.isAncestorOf(this.parent);
        (P && !P.cancelBubble || !P) && this.parent && this.parent.isListening() && !U && (A && A.parent ? this._fireAndBubble.call(this.parent, y, P, A) : this._fireAndBubble.call(this.parent, y, P));
      }
    }
    _getProtoListeners(y) {
      var P, A, G;
      const U = (P = this._cache.get(u)) !== null && P !== void 0 ? P : {};
      let K = U == null ? void 0 : U[y];
      if (K === void 0) {
        K = [];
        let $ = Object.getPrototypeOf(this);
        for (; $; ) {
          const X = (G = (A = $.eventListeners) === null || A === void 0 ? void 0 : A[y]) !== null && G !== void 0 ? G : [];
          K.push(...X), $ = Object.getPrototypeOf($);
        }
        U[y] = K, this._cache.set(u, U);
      }
      return K;
    }
    _fire(y, P) {
      P = P || {}, P.currentTarget = this, P.type = y;
      const A = this._getProtoListeners(y);
      if (A)
        for (var G = 0; G < A.length; G++)
          A[G].handler.call(this, P);
      const U = this.eventListeners[y];
      if (U)
        for (var G = 0; G < U.length; G++)
          U[G].handler.call(this, P);
    }
    draw() {
      return this.drawScene(), this.drawHit(), this;
    }
    _createDragElement(y) {
      const P = y ? y.pointerId : void 0, A = this.getStage(), G = this.getAbsolutePosition();
      if (!A)
        return;
      const U = A._getPointerById(P) || A._changedPointerPositions[0] || G;
      h.DD._dragElements.set(this._id, {
        node: this,
        startPointerPos: U,
        offset: {
          x: U.x - G.x,
          y: U.y - G.y
        },
        dragStatus: "ready",
        pointerId: P
      });
    }
    startDrag(y, P = !0) {
      h.DD._dragElements.has(this._id) || this._createDragElement(y);
      const A = h.DD._dragElements.get(this._id);
      A.dragStatus = "dragging", this.fire("dragstart", {
        type: "dragstart",
        target: this,
        evt: y && y.evt
      }, P);
    }
    _setDragPosition(y, P) {
      const A = this.getStage()._getPointerById(P.pointerId);
      if (!A)
        return;
      let G = {
        x: A.x - P.offset.x,
        y: A.y - P.offset.y
      };
      const U = this.dragBoundFunc();
      if (U !== void 0) {
        const K = U.call(this, G, y);
        K ? G = K : r.Util.warn("dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.");
      }
      (!this._lastPos || this._lastPos.x !== G.x || this._lastPos.y !== G.y) && (this.setAbsolutePosition(G), this._requestDraw()), this._lastPos = G;
    }
    stopDrag(y) {
      const P = h.DD._dragElements.get(this._id);
      P && (P.dragStatus = "stopped"), h.DD._endDragBefore(y), h.DD._endDragAfter(y);
    }
    setDraggable(y) {
      this._setAttr("draggable", y), this._dragChange();
    }
    isDragging() {
      const y = h.DD._dragElements.get(this._id);
      return y ? y.dragStatus === "dragging" : !1;
    }
    _listenDrag() {
      this._dragCleanup(), this.on("mousedown.konva touchstart.konva", function(y) {
        if (!(!(y.evt.button !== void 0) || s.Konva.dragButtons.indexOf(y.evt.button) >= 0) || this.isDragging())
          return;
        let G = !1;
        h.DD._dragElements.forEach((U) => {
          this.isAncestorOf(U.node) && (G = !0);
        }), G || this._createDragElement(y);
      });
    }
    _dragChange() {
      if (this.attrs.draggable)
        this._listenDrag();
      else {
        if (this._dragCleanup(), !this.getStage())
          return;
        const P = h.DD._dragElements.get(this._id), A = P && P.dragStatus === "dragging", G = P && P.dragStatus === "ready";
        A ? this.stopDrag() : G && h.DD._dragElements.delete(this._id);
      }
    }
    _dragCleanup() {
      this.off("mousedown.konva"), this.off("touchstart.konva");
    }
    isClientRectOnScreen(y = { x: 0, y: 0 }) {
      const P = this.getStage();
      if (!P)
        return !1;
      const A = {
        x: -y.x,
        y: -y.y,
        width: P.width() + 2 * y.x,
        height: P.height() + 2 * y.y
      };
      return r.Util.haveIntersection(A, this.getClientRect());
    }
    static create(y, P) {
      return r.Util._isString(y) && (y = JSON.parse(y)), this._createNode(y, P);
    }
    static _createNode(y, P) {
      let A = Jh.prototype.getClassName.call(y), G = y.children, U, K, $;
      P && (y.attrs.container = P), s.Konva[A] || (r.Util.warn('Can not find a node with class name "' + A + '". Fallback to "Shape".'), A = "Shape");
      const X = s.Konva[A];
      if (U = new X(y.attrs), G)
        for (K = G.length, $ = 0; $ < K; $++)
          U.add(Jh._createNode(G[$]));
      return U;
    }
  };
  Ei.Node = O, O.prototype.nodeType = "Node", O.prototype._attrsAffectingSize = [], O.prototype.eventListeners = {}, O.prototype.on.call(O.prototype, k, function() {
    if (this._batchingTransformChange) {
      this._needClearTransformCache = !0;
      return;
    }
    this._clearCache(E), this._clearSelfAndDescendantCache(g);
  }), O.prototype.on.call(O.prototype, "visibleChange.konva", function() {
    this._clearSelfAndDescendantCache(D);
  }), O.prototype.on.call(O.prototype, "listeningChange.konva", function() {
    this._clearSelfAndDescendantCache(_);
  }), O.prototype.on.call(O.prototype, "opacityChange.konva", function() {
    this._clearSelfAndDescendantCache(l);
  });
  const N = a.Factory.addGetterSetter;
  return N(O, "zIndex"), N(O, "absolutePosition"), N(O, "position"), N(O, "x", 0, (0, o.getNumberValidator)()), N(O, "y", 0, (0, o.getNumberValidator)()), N(O, "globalCompositeOperation", "source-over", (0, o.getStringValidator)()), N(O, "opacity", 1, (0, o.getNumberValidator)()), N(O, "name", "", (0, o.getStringValidator)()), N(O, "id", "", (0, o.getStringValidator)()), N(O, "rotation", 0, (0, o.getNumberValidator)()), a.Factory.addComponentsGetterSetter(O, "scale", ["x", "y"]), N(O, "scaleX", 1, (0, o.getNumberValidator)()), N(O, "scaleY", 1, (0, o.getNumberValidator)()), a.Factory.addComponentsGetterSetter(O, "skew", ["x", "y"]), N(O, "skewX", 0, (0, o.getNumberValidator)()), N(O, "skewY", 0, (0, o.getNumberValidator)()), a.Factory.addComponentsGetterSetter(O, "offset", ["x", "y"]), N(O, "offsetX", 0, (0, o.getNumberValidator)()), N(O, "offsetY", 0, (0, o.getNumberValidator)()), N(O, "dragDistance", null, (0, o.getNumberValidator)()), N(O, "width", 0, (0, o.getNumberValidator)()), N(O, "height", 0, (0, o.getNumberValidator)()), N(O, "listening", !0, (0, o.getBooleanValidator)()), N(O, "preventDefault", !0, (0, o.getBooleanValidator)()), N(O, "filters", null, function(z) {
    return this._filterUpToDate = !1, z;
  }), N(O, "visible", !0, (0, o.getBooleanValidator)()), N(O, "transformsEnabled", "all", (0, o.getStringValidator)()), N(O, "size"), N(O, "dragBoundFunc"), N(O, "draggable", !1, (0, o.getBooleanValidator)()), a.Factory.backCompat(O, {
    rotateDeg: "rotate",
    setRotationDeg: "setRotation",
    getRotationDeg: "getRotation"
  }), Ei;
}
var Ai = {}, Wc;
function Sa() {
  if (Wc) return Ai;
  Wc = 1, Object.defineProperty(Ai, "__esModule", { value: !0 }), Ai.Container = void 0;
  const r = Tt(), a = $t(), i = Ot();
  let s = class extends a.Node {
    constructor() {
      super(...arguments), this.children = [];
    }
    getChildren(o) {
      if (!o)
        return this.children || [];
      const l = this.children || [], u = [];
      return l.forEach(function(g) {
        o(g) && u.push(g);
      }), u;
    }
    hasChildren() {
      return this.getChildren().length > 0;
    }
    removeChildren() {
      return this.getChildren().forEach((o) => {
        o.parent = null, o.index = 0, o.remove();
      }), this.children = [], this._requestDraw(), this;
    }
    destroyChildren() {
      return this.getChildren().forEach((o) => {
        o.parent = null, o.index = 0, o.destroy();
      }), this.children = [], this._requestDraw(), this;
    }
    add(...o) {
      if (o.length === 0)
        return this;
      if (o.length > 1) {
        for (let u = 0; u < o.length; u++)
          this.add(o[u]);
        return this;
      }
      const l = o[0];
      return l.getParent() ? (l.moveTo(this), this) : (this._validateAdd(l), l.index = this.getChildren().length, l.parent = this, l._clearCaches(), this.getChildren().push(l), this._fire("add", {
        child: l
      }), this._requestDraw(), this);
    }
    destroy() {
      return this.hasChildren() && this.destroyChildren(), super.destroy(), this;
    }
    find(o) {
      return this._generalFind(o, !1);
    }
    findOne(o) {
      const l = this._generalFind(o, !0);
      return l.length > 0 ? l[0] : void 0;
    }
    _generalFind(o, l) {
      const u = [];
      return this._descendants((g) => {
        const p = g._isMatch(o);
        return p && u.push(g), !!(p && l);
      }), u;
    }
    _descendants(o) {
      let l = !1;
      const u = this.getChildren();
      for (const g of u) {
        if (l = o(g), l)
          return !0;
        if (g.hasChildren() && (l = g._descendants(o), l))
          return !0;
      }
      return !1;
    }
    toObject() {
      const o = a.Node.prototype.toObject.call(this);
      return o.children = [], this.getChildren().forEach((l) => {
        o.children.push(l.toObject());
      }), o;
    }
    isAncestorOf(o) {
      let l = o.getParent();
      for (; l; ) {
        if (l._id === this._id)
          return !0;
        l = l.getParent();
      }
      return !1;
    }
    clone(o) {
      const l = a.Node.prototype.clone.call(this, o);
      return this.getChildren().forEach(function(u) {
        l.add(u.clone());
      }), l;
    }
    getAllIntersections(o) {
      const l = [];
      return this.find("Shape").forEach((u) => {
        u.isVisible() && u.intersects(o) && l.push(u);
      }), l;
    }
    _clearSelfAndDescendantCache(o) {
      var l;
      super._clearSelfAndDescendantCache(o), !this.isCached() && ((l = this.children) === null || l === void 0 || l.forEach(function(u) {
        u._clearSelfAndDescendantCache(o);
      }));
    }
    _setChildrenIndices() {
      var o;
      (o = this.children) === null || o === void 0 || o.forEach(function(l, u) {
        l.index = u;
      }), this._requestDraw();
    }
    drawScene(o, l, u) {
      const g = this.getLayer(), p = o || g && g.getCanvas(), b = p && p.getContext(), S = this._getCanvasCache(), x = S && S.scene, v = p && p.isCache;
      if (!this.isVisible() && !v)
        return this;
      if (x) {
        b.save();
        const _ = this.getAbsoluteTransform(l).getMatrix();
        b.transform(_[0], _[1], _[2], _[3], _[4], _[5]), this._drawCachedSceneCanvas(b), b.restore();
      } else
        this._drawChildren("drawScene", p, l, u);
      return this;
    }
    drawHit(o, l) {
      if (!this.shouldDrawHit(l))
        return this;
      const u = this.getLayer(), g = o || u && u.hitCanvas, p = g && g.getContext(), b = this._getCanvasCache();
      if (b && b.hit) {
        p.save();
        const x = this.getAbsoluteTransform(l).getMatrix();
        p.transform(x[0], x[1], x[2], x[3], x[4], x[5]), this._drawCachedHitCanvas(p), p.restore();
      } else
        this._drawChildren("drawHit", g, l);
      return this;
    }
    _drawChildren(o, l, u, g) {
      var p;
      const b = l && l.getContext(), S = this.clipWidth(), x = this.clipHeight(), v = this.clipFunc(), _ = typeof S == "number" && typeof x == "number" || v, w = u === this;
      if (_) {
        b.save();
        const F = this.getAbsoluteTransform(u);
        let c = F.getMatrix();
        b.transform(c[0], c[1], c[2], c[3], c[4], c[5]), b.beginPath();
        let f;
        if (v)
          f = v.call(this, b, this);
        else {
          const m = this.clipX(), E = this.clipY();
          b.rect(m || 0, E || 0, S, x);
        }
        b.clip.apply(b, f), c = F.copy().invert().getMatrix(), b.transform(c[0], c[1], c[2], c[3], c[4], c[5]);
      }
      const C = !w && this.globalCompositeOperation() !== "source-over" && o === "drawScene";
      C && (b.save(), b._applyGlobalCompositeOperation(this)), (p = this.children) === null || p === void 0 || p.forEach(function(F) {
        F[o](l, u, g);
      }), C && b.restore(), _ && b.restore();
    }
    getClientRect(o = {}) {
      var l;
      const u = o.skipTransform, g = o.relativeTo;
      let p, b, S, x, v = {
        x: 1 / 0,
        y: 1 / 0,
        width: 0,
        height: 0
      };
      const _ = this;
      (l = this.children) === null || l === void 0 || l.forEach(function(F) {
        if (!F.visible())
          return;
        const c = F.getClientRect({
          relativeTo: _,
          skipShadow: o.skipShadow,
          skipStroke: o.skipStroke
        });
        c.width === 0 && c.height === 0 || (p === void 0 ? (p = c.x, b = c.y, S = c.x + c.width, x = c.y + c.height) : (p = Math.min(p, c.x), b = Math.min(b, c.y), S = Math.max(S, c.x + c.width), x = Math.max(x, c.y + c.height)));
      });
      const w = this.find("Shape");
      let C = !1;
      for (let F = 0; F < w.length; F++)
        if (w[F]._isVisible(this)) {
          C = !0;
          break;
        }
      return C && p !== void 0 ? v = {
        x: p,
        y: b,
        width: S - p,
        height: x - b
      } : v = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      }, u ? v : this._transformedRect(v, g);
    }
  };
  return Ai.Container = s, r.Factory.addComponentsGetterSetter(s, "clip", [
    "x",
    "y",
    "width",
    "height"
  ]), r.Factory.addGetterSetter(s, "clipX", void 0, (0, i.getNumberValidator)()), r.Factory.addGetterSetter(s, "clipY", void 0, (0, i.getNumberValidator)()), r.Factory.addGetterSetter(s, "clipWidth", void 0, (0, i.getNumberValidator)()), r.Factory.addGetterSetter(s, "clipHeight", void 0, (0, i.getNumberValidator)()), r.Factory.addGetterSetter(s, "clipFunc"), Ai;
}
var Zs = {}, Er = {}, Vc;
function rg() {
  if (Vc) return Er;
  Vc = 1, Object.defineProperty(Er, "__esModule", { value: !0 }), Er.getCapturedShape = s, Er.createEvent = h, Er.hasPointerCapture = o, Er.setPointerCapture = l, Er.releaseCapture = u;
  const r = Rt(), a = /* @__PURE__ */ new Map(), i = r.Konva._global.PointerEvent !== void 0;
  function s(g) {
    return a.get(g);
  }
  function h(g) {
    return {
      evt: g,
      pointerId: g.pointerId
    };
  }
  function o(g, p) {
    return a.get(g) === p;
  }
  function l(g, p) {
    u(g), p.getStage() && (a.set(g, p), i && p._fire("gotpointercapture", h(new PointerEvent("gotpointercapture"))));
  }
  function u(g, p) {
    const b = a.get(g);
    if (!b)
      return;
    const S = b.getStage();
    S && S.content, a.delete(g), i && b._fire("lostpointercapture", h(new PointerEvent("lostpointercapture")));
  }
  return Er;
}
var jc;
function l6() {
  return jc || (jc = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Stage = r.stages = void 0;
    const a = Kt(), i = Tt(), s = Sa(), h = Rt(), o = ba(), l = tl(), u = Rt(), g = rg(), p = "Stage", b = "string", S = "px", x = "mouseout", v = "mouseleave", _ = "mouseover", w = "mouseenter", C = "mousemove", F = "mousedown", c = "mouseup", f = "pointermove", m = "pointerdown", E = "pointerup", T = "pointercancel", D = "lostpointercapture", k = "pointerout", M = "pointerleave", O = "pointerover", N = "pointerenter", z = "contextmenu", y = "touchstart", P = "touchend", A = "touchmove", G = "touchcancel", U = "wheel", K = 5, $ = [
      [w, "_pointerenter"],
      [F, "_pointerdown"],
      [C, "_pointermove"],
      [c, "_pointerup"],
      [v, "_pointerleave"],
      [y, "_pointerdown"],
      [A, "_pointermove"],
      [P, "_pointerup"],
      [G, "_pointercancel"],
      [_, "_pointerover"],
      [U, "_wheel"],
      [z, "_contextmenu"],
      [m, "_pointerdown"],
      [f, "_pointermove"],
      [E, "_pointerup"],
      [T, "_pointercancel"],
      [D, "_lostpointercapture"]
    ], X = {
      mouse: {
        [k]: x,
        [M]: v,
        [O]: _,
        [N]: w,
        [f]: C,
        [m]: F,
        [E]: c,
        [T]: "mousecancel",
        pointerclick: "click",
        pointerdblclick: "dblclick"
      },
      touch: {
        [k]: "touchout",
        [M]: "touchleave",
        [O]: "touchover",
        [N]: "touchenter",
        [f]: A,
        [m]: y,
        [E]: P,
        [T]: G,
        pointerclick: "tap",
        pointerdblclick: "dbltap"
      },
      pointer: {
        [k]: k,
        [M]: M,
        [O]: O,
        [N]: N,
        [f]: f,
        [m]: m,
        [E]: E,
        [T]: T,
        pointerclick: "pointerclick",
        pointerdblclick: "pointerdblclick"
      }
    }, Q = (ct) => ct.indexOf("pointer") >= 0 ? "pointer" : ct.indexOf("touch") >= 0 ? "touch" : "mouse", st = (ct) => {
      const H = Q(ct);
      if (H === "pointer")
        return h.Konva.pointerEventsEnabled && X.pointer;
      if (H === "touch")
        return X.touch;
      if (H === "mouse")
        return X.mouse;
    };
    function Z(ct = {}) {
      return (ct.clipFunc || ct.clipWidth || ct.clipHeight) && a.Util.warn("Stage does not support clipping. Please use clip for Layers or Groups."), ct;
    }
    const at = "Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);";
    r.stages = [];
    class ht extends s.Container {
      constructor(H) {
        super(Z(H)), this._pointerPositions = [], this._changedPointerPositions = [], this._buildDOM(), this._bindContentEvents(), r.stages.push(this), this.on("widthChange.konva heightChange.konva", this._resizeDOM), this.on("visibleChange.konva", this._checkVisibility), this.on("clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva", () => {
          Z(this.attrs);
        }), this._checkVisibility();
      }
      _validateAdd(H) {
        const j = H.getType() === "Layer", et = H.getType() === "FastLayer";
        j || et || a.Util.throw("You may only add layers to the stage.");
      }
      _checkVisibility() {
        if (!this.content)
          return;
        const H = this.visible() ? "" : "none";
        this.content.style.display = H;
      }
      setContainer(H) {
        if (typeof H === b) {
          if (H.charAt(0) === ".") {
            const et = H.slice(1);
            H = document.getElementsByClassName(et)[0];
          } else {
            var j;
            H.charAt(0) !== "#" ? j = H : j = H.slice(1), H = document.getElementById(j);
          }
          if (!H)
            throw "Can not find container in document with id " + j;
        }
        return this._setAttr("container", H), this.content && (this.content.parentElement && this.content.parentElement.removeChild(this.content), H.appendChild(this.content)), this;
      }
      shouldDrawHit() {
        return !0;
      }
      clear() {
        let H = this.children, j = H.length, et;
        for (et = 0; et < j; et++)
          H[et].clear();
        return this;
      }
      clone(H) {
        return H || (H = {}), H.container = typeof document != "undefined" && document.createElement("div"), s.Container.prototype.clone.call(this, H);
      }
      destroy() {
        super.destroy();
        const H = this.content;
        H && a.Util._isInDocument(H) && this.container().removeChild(H);
        const j = r.stages.indexOf(this);
        return j > -1 && r.stages.splice(j, 1), a.Util.releaseCanvas(this.bufferCanvas._canvas, this.bufferHitCanvas._canvas), this;
      }
      getPointerPosition() {
        const H = this._pointerPositions[0] || this._changedPointerPositions[0];
        return H ? {
          x: H.x,
          y: H.y
        } : (a.Util.warn(at), null);
      }
      _getPointerById(H) {
        return this._pointerPositions.find((j) => j.id === H);
      }
      getPointersPositions() {
        return this._pointerPositions;
      }
      getStage() {
        return this;
      }
      getContent() {
        return this.content;
      }
      _toKonvaCanvas(H) {
        H = H || {}, H.x = H.x || 0, H.y = H.y || 0, H.width = H.width || this.width(), H.height = H.height || this.height();
        const j = new o.SceneCanvas({
          width: H.width,
          height: H.height,
          pixelRatio: H.pixelRatio || 1
        }), et = j.getContext()._context, ut = this.children;
        return (H.x || H.y) && et.translate(-1 * H.x, -1 * H.y), ut.forEach(function(gt) {
          if (!gt.isVisible())
            return;
          const pt = gt._toKonvaCanvas(H);
          et.drawImage(pt._canvas, H.x, H.y, pt.getWidth() / pt.getPixelRatio(), pt.getHeight() / pt.getPixelRatio());
        }), j;
      }
      getIntersection(H) {
        if (!H)
          return null;
        let j = this.children, et = j.length, ut = et - 1, gt;
        for (gt = ut; gt >= 0; gt--) {
          const pt = j[gt].getIntersection(H);
          if (pt)
            return pt;
        }
        return null;
      }
      _resizeDOM() {
        const H = this.width(), j = this.height();
        this.content && (this.content.style.width = H + S, this.content.style.height = j + S), this.bufferCanvas.setSize(H, j), this.bufferHitCanvas.setSize(H, j), this.children.forEach((et) => {
          et.setSize({ width: H, height: j }), et.draw();
        });
      }
      add(H, ...j) {
        if (arguments.length > 1) {
          for (let ut = 0; ut < arguments.length; ut++)
            this.add(arguments[ut]);
          return this;
        }
        super.add(H);
        const et = this.children.length;
        return et > K && a.Util.warn("The stage has " + et + " layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group."), H.setSize({ width: this.width(), height: this.height() }), H.draw(), h.Konva.isBrowser && this.content.appendChild(H.canvas._canvas), this;
      }
      getParent() {
        return null;
      }
      getLayer() {
        return null;
      }
      hasPointerCapture(H) {
        return g.hasPointerCapture(H, this);
      }
      setPointerCapture(H) {
        g.setPointerCapture(H, this);
      }
      releaseCapture(H) {
        g.releaseCapture(H, this);
      }
      getLayers() {
        return this.children;
      }
      _bindContentEvents() {
        h.Konva.isBrowser && $.forEach(([H, j]) => {
          this.content.addEventListener(H, (et) => {
            this[j](et);
          }, { passive: !1 });
        });
      }
      _pointerenter(H) {
        this.setPointersPositions(H);
        const j = st(H.type);
        j && this._fire(j.pointerenter, {
          evt: H,
          target: this,
          currentTarget: this
        });
      }
      _pointerover(H) {
        this.setPointersPositions(H);
        const j = st(H.type);
        j && this._fire(j.pointerover, {
          evt: H,
          target: this,
          currentTarget: this
        });
      }
      _getTargetShape(H) {
        let j = this[H + "targetShape"];
        return j && !j.getStage() && (j = null), j;
      }
      _pointerleave(H) {
        const j = st(H.type), et = Q(H.type);
        if (!j)
          return;
        this.setPointersPositions(H);
        const ut = this._getTargetShape(et), gt = !(h.Konva.isDragging() || h.Konva.isTransforming()) || h.Konva.hitOnDragEnabled;
        ut && gt ? (ut._fireAndBubble(j.pointerout, { evt: H }), ut._fireAndBubble(j.pointerleave, { evt: H }), this._fire(j.pointerleave, {
          evt: H,
          target: this,
          currentTarget: this
        }), this[et + "targetShape"] = null) : gt && (this._fire(j.pointerleave, {
          evt: H,
          target: this,
          currentTarget: this
        }), this._fire(j.pointerout, {
          evt: H,
          target: this,
          currentTarget: this
        })), this.pointerPos = null, this._pointerPositions = [];
      }
      _pointerdown(H) {
        const j = st(H.type), et = Q(H.type);
        if (!j)
          return;
        this.setPointersPositions(H);
        let ut = !1;
        this._changedPointerPositions.forEach((gt) => {
          const pt = this.getIntersection(gt);
          if (l.DD.justDragged = !1, h.Konva["_" + et + "ListenClick"] = !0, !pt || !pt.isListening()) {
            this[et + "ClickStartShape"] = void 0;
            return;
          }
          h.Konva.capturePointerEventsEnabled && pt.setPointerCapture(gt.id), this[et + "ClickStartShape"] = pt, pt._fireAndBubble(j.pointerdown, {
            evt: H,
            pointerId: gt.id
          }), ut = !0;
          const Mt = H.type.indexOf("touch") >= 0;
          pt.preventDefault() && H.cancelable && Mt && H.preventDefault();
        }), ut || this._fire(j.pointerdown, {
          evt: H,
          target: this,
          currentTarget: this,
          pointerId: this._pointerPositions[0].id
        });
      }
      _pointermove(H) {
        const j = st(H.type), et = Q(H.type);
        if (!j || (h.Konva.isDragging() && l.DD.node.preventDefault() && H.cancelable && H.preventDefault(), this.setPointersPositions(H), !(!(h.Konva.isDragging() || h.Konva.isTransforming()) || h.Konva.hitOnDragEnabled)))
          return;
        const gt = {};
        let pt = !1;
        const Mt = this._getTargetShape(et);
        this._changedPointerPositions.forEach((Et) => {
          const mt = g.getCapturedShape(Et.id) || this.getIntersection(Et), re = Et.id, Pt = { evt: H, pointerId: re }, Ht = Mt !== mt;
          if (Ht && Mt && (Mt._fireAndBubble(j.pointerout, { ...Pt }, mt), Mt._fireAndBubble(j.pointerleave, { ...Pt }, mt)), mt) {
            if (gt[mt._id])
              return;
            gt[mt._id] = !0;
          }
          mt && mt.isListening() ? (pt = !0, Ht && (mt._fireAndBubble(j.pointerover, { ...Pt }, Mt), mt._fireAndBubble(j.pointerenter, { ...Pt }, Mt), this[et + "targetShape"] = mt), mt._fireAndBubble(j.pointermove, { ...Pt })) : Mt && (this._fire(j.pointerover, {
            evt: H,
            target: this,
            currentTarget: this,
            pointerId: re
          }), this[et + "targetShape"] = null);
        }), pt || this._fire(j.pointermove, {
          evt: H,
          target: this,
          currentTarget: this,
          pointerId: this._changedPointerPositions[0].id
        });
      }
      _pointerup(H) {
        const j = st(H.type), et = Q(H.type);
        if (!j)
          return;
        this.setPointersPositions(H);
        const ut = this[et + "ClickStartShape"], gt = this[et + "ClickEndShape"], pt = {};
        let Mt = !1;
        this._changedPointerPositions.forEach((Et) => {
          const mt = g.getCapturedShape(Et.id) || this.getIntersection(Et);
          if (mt) {
            if (mt.releaseCapture(Et.id), pt[mt._id])
              return;
            pt[mt._id] = !0;
          }
          const re = Et.id, Pt = { evt: H, pointerId: re };
          let Ht = !1;
          h.Konva["_" + et + "InDblClickWindow"] ? (Ht = !0, clearTimeout(this[et + "DblTimeout"])) : l.DD.justDragged || (h.Konva["_" + et + "InDblClickWindow"] = !0, clearTimeout(this[et + "DblTimeout"])), this[et + "DblTimeout"] = setTimeout(function() {
            h.Konva["_" + et + "InDblClickWindow"] = !1;
          }, h.Konva.dblClickWindow), mt && mt.isListening() ? (Mt = !0, this[et + "ClickEndShape"] = mt, mt._fireAndBubble(j.pointerup, { ...Pt }), h.Konva["_" + et + "ListenClick"] && ut && ut === mt && (mt._fireAndBubble(j.pointerclick, { ...Pt }), Ht && gt && gt === mt && mt._fireAndBubble(j.pointerdblclick, { ...Pt }))) : (this[et + "ClickEndShape"] = null, h.Konva["_" + et + "ListenClick"] && this._fire(j.pointerclick, {
            evt: H,
            target: this,
            currentTarget: this,
            pointerId: re
          }), Ht && this._fire(j.pointerdblclick, {
            evt: H,
            target: this,
            currentTarget: this,
            pointerId: re
          }));
        }), Mt || this._fire(j.pointerup, {
          evt: H,
          target: this,
          currentTarget: this,
          pointerId: this._changedPointerPositions[0].id
        }), h.Konva["_" + et + "ListenClick"] = !1, H.cancelable && et !== "touch" && H.preventDefault();
      }
      _contextmenu(H) {
        this.setPointersPositions(H);
        const j = this.getIntersection(this.getPointerPosition());
        j && j.isListening() ? j._fireAndBubble(z, { evt: H }) : this._fire(z, {
          evt: H,
          target: this,
          currentTarget: this
        });
      }
      _wheel(H) {
        this.setPointersPositions(H);
        const j = this.getIntersection(this.getPointerPosition());
        j && j.isListening() ? j._fireAndBubble(U, { evt: H }) : this._fire(U, {
          evt: H,
          target: this,
          currentTarget: this
        });
      }
      _pointercancel(H) {
        this.setPointersPositions(H);
        const j = g.getCapturedShape(H.pointerId) || this.getIntersection(this.getPointerPosition());
        j && j._fireAndBubble(E, g.createEvent(H)), g.releaseCapture(H.pointerId);
      }
      _lostpointercapture(H) {
        g.releaseCapture(H.pointerId);
      }
      setPointersPositions(H) {
        let j = this._getContentPosition(), et = null, ut = null;
        H = H || window.event, H.touches !== void 0 ? (this._pointerPositions = [], this._changedPointerPositions = [], Array.prototype.forEach.call(H.touches, (gt) => {
          this._pointerPositions.push({
            id: gt.identifier,
            x: (gt.clientX - j.left) / j.scaleX,
            y: (gt.clientY - j.top) / j.scaleY
          });
        }), Array.prototype.forEach.call(H.changedTouches || H.touches, (gt) => {
          this._changedPointerPositions.push({
            id: gt.identifier,
            x: (gt.clientX - j.left) / j.scaleX,
            y: (gt.clientY - j.top) / j.scaleY
          });
        })) : (et = (H.clientX - j.left) / j.scaleX, ut = (H.clientY - j.top) / j.scaleY, this.pointerPos = {
          x: et,
          y: ut
        }, this._pointerPositions = [{ x: et, y: ut, id: a.Util._getFirstPointerId(H) }], this._changedPointerPositions = [
          { x: et, y: ut, id: a.Util._getFirstPointerId(H) }
        ]);
      }
      _setPointerPosition(H) {
        a.Util.warn('Method _setPointerPosition is deprecated. Use "stage.setPointersPositions(event)" instead.'), this.setPointersPositions(H);
      }
      _getContentPosition() {
        if (!this.content || !this.content.getBoundingClientRect)
          return {
            top: 0,
            left: 0,
            scaleX: 1,
            scaleY: 1
          };
        const H = this.content.getBoundingClientRect();
        return {
          top: H.top,
          left: H.left,
          scaleX: H.width / this.content.clientWidth || 1,
          scaleY: H.height / this.content.clientHeight || 1
        };
      }
      _buildDOM() {
        if (this.bufferCanvas = new o.SceneCanvas({
          width: this.width(),
          height: this.height()
        }), this.bufferHitCanvas = new o.HitCanvas({
          pixelRatio: 1,
          width: this.width(),
          height: this.height()
        }), !h.Konva.isBrowser)
          return;
        const H = this.container();
        if (!H)
          throw "Stage has no container. A container is required.";
        H.innerHTML = "", this.content = document.createElement("div"), this.content.style.position = "relative", this.content.style.userSelect = "none", this.content.className = "konvajs-content", this.content.setAttribute("role", "presentation"), H.appendChild(this.content), this._resizeDOM();
      }
      cache() {
        return a.Util.warn("Cache function is not allowed for stage. You may use cache only for layers, groups and shapes."), this;
      }
      clearCache() {
        return this;
      }
      batchDraw() {
        return this.getChildren().forEach(function(H) {
          H.batchDraw();
        }), this;
      }
    }
    r.Stage = ht, ht.prototype.nodeType = p, (0, u._registerNode)(ht), i.Factory.addGetterSetter(ht, "container"), h.Konva.isBrowser && document.addEventListener("visibilitychange", () => {
      r.stages.forEach((ct) => {
        ct.batchDraw();
      });
    });
  }(Zs)), Zs;
}
var Ri = {}, Js = {}, Kc;
function oe() {
  return Kc || (Kc = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Shape = r.shapes = void 0;
    const a = Rt(), i = Kt(), s = Tt(), h = $t(), o = Ot(), l = Rt(), u = rg(), g = "hasShadow", p = "shadowRGBA", b = "patternImage", S = "linearGradient", x = "radialGradient";
    let v;
    function _() {
      return v || (v = i.Util.createCanvasElement().getContext("2d"), v);
    }
    r.shapes = {};
    function w(M) {
      const O = this.attrs.fillRule;
      O ? M.fill(O) : M.fill();
    }
    function C(M) {
      M.stroke();
    }
    function F(M) {
      const O = this.attrs.fillRule;
      O ? M.fill(O) : M.fill();
    }
    function c(M) {
      M.stroke();
    }
    function f() {
      this._clearCache(g);
    }
    function m() {
      this._clearCache(p);
    }
    function E() {
      this._clearCache(b);
    }
    function T() {
      this._clearCache(S);
    }
    function D() {
      this._clearCache(x);
    }
    class k extends h.Node {
      constructor(O) {
        super(O);
        let N;
        for (; N = i.Util.getRandomColor(), !(N && !(N in r.shapes)); )
          ;
        this.colorKey = N, r.shapes[N] = this;
      }
      getContext() {
        return i.Util.warn("shape.getContext() method is deprecated. Please do not use it."), this.getLayer().getContext();
      }
      getCanvas() {
        return i.Util.warn("shape.getCanvas() method is deprecated. Please do not use it."), this.getLayer().getCanvas();
      }
      getSceneFunc() {
        return this.attrs.sceneFunc || this._sceneFunc;
      }
      getHitFunc() {
        return this.attrs.hitFunc || this._hitFunc;
      }
      hasShadow() {
        return this._getCache(g, this._hasShadow);
      }
      _hasShadow() {
        return this.shadowEnabled() && this.shadowOpacity() !== 0 && !!(this.shadowColor() || this.shadowBlur() || this.shadowOffsetX() || this.shadowOffsetY());
      }
      _getFillPattern() {
        return this._getCache(b, this.__getFillPattern);
      }
      __getFillPattern() {
        if (this.fillPatternImage()) {
          const N = _().createPattern(this.fillPatternImage(), this.fillPatternRepeat() || "repeat");
          if (N && N.setTransform) {
            const z = new i.Transform();
            z.translate(this.fillPatternX(), this.fillPatternY()), z.rotate(a.Konva.getAngle(this.fillPatternRotation())), z.scale(this.fillPatternScaleX(), this.fillPatternScaleY()), z.translate(-1 * this.fillPatternOffsetX(), -1 * this.fillPatternOffsetY());
            const y = z.getMatrix(), P = typeof DOMMatrix == "undefined" ? {
              a: y[0],
              b: y[1],
              c: y[2],
              d: y[3],
              e: y[4],
              f: y[5]
            } : new DOMMatrix(y);
            N.setTransform(P);
          }
          return N;
        }
      }
      _getLinearGradient() {
        return this._getCache(S, this.__getLinearGradient);
      }
      __getLinearGradient() {
        const O = this.fillLinearGradientColorStops();
        if (O) {
          const N = _(), z = this.fillLinearGradientStartPoint(), y = this.fillLinearGradientEndPoint(), P = N.createLinearGradient(z.x, z.y, y.x, y.y);
          for (let A = 0; A < O.length; A += 2)
            P.addColorStop(O[A], O[A + 1]);
          return P;
        }
      }
      _getRadialGradient() {
        return this._getCache(x, this.__getRadialGradient);
      }
      __getRadialGradient() {
        const O = this.fillRadialGradientColorStops();
        if (O) {
          const N = _(), z = this.fillRadialGradientStartPoint(), y = this.fillRadialGradientEndPoint(), P = N.createRadialGradient(z.x, z.y, this.fillRadialGradientStartRadius(), y.x, y.y, this.fillRadialGradientEndRadius());
          for (let A = 0; A < O.length; A += 2)
            P.addColorStop(O[A], O[A + 1]);
          return P;
        }
      }
      getShadowRGBA() {
        return this._getCache(p, this._getShadowRGBA);
      }
      _getShadowRGBA() {
        if (!this.hasShadow())
          return;
        const O = i.Util.colorToRGBA(this.shadowColor());
        if (O)
          return "rgba(" + O.r + "," + O.g + "," + O.b + "," + O.a * (this.shadowOpacity() || 1) + ")";
      }
      hasFill() {
        return this._calculate("hasFill", [
          "fillEnabled",
          "fill",
          "fillPatternImage",
          "fillLinearGradientColorStops",
          "fillRadialGradientColorStops"
        ], () => this.fillEnabled() && !!(this.fill() || this.fillPatternImage() || this.fillLinearGradientColorStops() || this.fillRadialGradientColorStops()));
      }
      hasStroke() {
        return this._calculate("hasStroke", [
          "strokeEnabled",
          "strokeWidth",
          "stroke",
          "strokeLinearGradientColorStops"
        ], () => this.strokeEnabled() && this.strokeWidth() && !!(this.stroke() || this.strokeLinearGradientColorStops()));
      }
      hasHitStroke() {
        const O = this.hitStrokeWidth();
        return O === "auto" ? this.hasStroke() : this.strokeEnabled() && !!O;
      }
      intersects(O) {
        const N = this.getStage();
        if (!N)
          return !1;
        const z = N.bufferHitCanvas;
        return z.getContext().clear(), this.drawHit(z, void 0, !0), z.context.getImageData(Math.round(O.x), Math.round(O.y), 1, 1).data[3] > 0;
      }
      destroy() {
        return h.Node.prototype.destroy.call(this), delete r.shapes[this.colorKey], delete this.colorKey, this;
      }
      _useBufferCanvas(O) {
        var N;
        if (!((N = this.attrs.perfectDrawEnabled) !== null && N !== void 0 ? N : !0))
          return !1;
        const y = O || this.hasFill(), P = this.hasStroke(), A = this.getAbsoluteOpacity() !== 1;
        if (y && P && A)
          return !0;
        const G = this.hasShadow(), U = this.shadowForStrokeEnabled();
        return !!(y && P && G && U);
      }
      setStrokeHitEnabled(O) {
        i.Util.warn("strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead."), O ? this.hitStrokeWidth("auto") : this.hitStrokeWidth(0);
      }
      getStrokeHitEnabled() {
        return this.hitStrokeWidth() !== 0;
      }
      getSelfRect() {
        const O = this.size();
        return {
          x: this._centroid ? -O.width / 2 : 0,
          y: this._centroid ? -O.height / 2 : 0,
          width: O.width,
          height: O.height
        };
      }
      getClientRect(O = {}) {
        let N = !1, z = this.getParent();
        for (; z; ) {
          if (z.isCached()) {
            N = !0;
            break;
          }
          z = z.getParent();
        }
        const y = O.skipTransform, P = O.relativeTo || N && this.getStage() || void 0, A = this.getSelfRect(), U = !O.skipStroke && this.hasStroke() && this.strokeWidth() || 0, K = A.width + U, $ = A.height + U, X = !O.skipShadow && this.hasShadow(), Q = X ? this.shadowOffsetX() : 0, st = X ? this.shadowOffsetY() : 0, Z = K + Math.abs(Q), at = $ + Math.abs(st), ht = X && this.shadowBlur() || 0, ct = Z + ht * 2, H = at + ht * 2, j = {
          width: ct,
          height: H,
          x: -(U / 2 + ht) + Math.min(Q, 0) + A.x,
          y: -(U / 2 + ht) + Math.min(st, 0) + A.y
        };
        return y ? j : this._transformedRect(j, P);
      }
      drawScene(O, N, z) {
        const y = this.getLayer();
        let P = O || y.getCanvas(), A = P.getContext(), G = this._getCanvasCache(), U = this.getSceneFunc(), K = this.hasShadow(), $, X;
        const Q = P.isCache, st = N === this;
        if (!this.isVisible() && !st)
          return this;
        if (G) {
          A.save();
          const at = this.getAbsoluteTransform(N).getMatrix();
          return A.transform(at[0], at[1], at[2], at[3], at[4], at[5]), this._drawCachedSceneCanvas(A), A.restore(), this;
        }
        if (!U)
          return this;
        if (A.save(), this._useBufferCanvas() && !Q) {
          $ = this.getStage();
          const at = z || $.bufferCanvas;
          X = at.getContext(), X.clear(), X.save(), X._applyLineJoin(this);
          var Z = this.getAbsoluteTransform(N).getMatrix();
          X.transform(Z[0], Z[1], Z[2], Z[3], Z[4], Z[5]), U.call(this, X, this), X.restore();
          const ht = at.pixelRatio;
          K && A._applyShadow(this), A._applyOpacity(this), A._applyGlobalCompositeOperation(this), A.drawImage(at._canvas, 0, 0, at.width / ht, at.height / ht);
        } else {
          if (A._applyLineJoin(this), !st) {
            var Z = this.getAbsoluteTransform(N).getMatrix();
            A.transform(Z[0], Z[1], Z[2], Z[3], Z[4], Z[5]), A._applyOpacity(this), A._applyGlobalCompositeOperation(this);
          }
          K && A._applyShadow(this), U.call(this, A, this);
        }
        return A.restore(), this;
      }
      drawHit(O, N, z = !1) {
        if (!this.shouldDrawHit(N, z))
          return this;
        const y = this.getLayer(), P = O || y.hitCanvas, A = P && P.getContext(), G = this.hitFunc() || this.sceneFunc(), U = this._getCanvasCache(), K = U && U.hit;
        if (this.colorKey || i.Util.warn("Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. If you want to reuse shape you should call remove() instead of destroy()"), K) {
          A.save();
          const X = this.getAbsoluteTransform(N).getMatrix();
          return A.transform(X[0], X[1], X[2], X[3], X[4], X[5]), this._drawCachedHitCanvas(A), A.restore(), this;
        }
        if (!G)
          return this;
        if (A.save(), A._applyLineJoin(this), !(this === N)) {
          const X = this.getAbsoluteTransform(N).getMatrix();
          A.transform(X[0], X[1], X[2], X[3], X[4], X[5]);
        }
        return G.call(this, A, this), A.restore(), this;
      }
      drawHitFromCache(O = 0) {
        let N = this._getCanvasCache(), z = this._getCachedSceneCanvas(), y = N.hit, P = y.getContext(), A = y.getWidth(), G = y.getHeight(), U, K, $, X, Q, st;
        P.clear(), P.drawImage(z._canvas, 0, 0, A, G);
        try {
          for (U = P.getImageData(0, 0, A, G), K = U.data, $ = K.length, X = i.Util._hexToRgb(this.colorKey), Q = 0; Q < $; Q += 4)
            st = K[Q + 3], st > O ? (K[Q] = X.r, K[Q + 1] = X.g, K[Q + 2] = X.b, K[Q + 3] = 255) : K[Q + 3] = 0;
          P.putImageData(U, 0, 0);
        } catch (Z) {
          i.Util.error("Unable to draw hit graph from cached scene canvas. " + Z.message);
        }
        return this;
      }
      hasPointerCapture(O) {
        return u.hasPointerCapture(O, this);
      }
      setPointerCapture(O) {
        u.setPointerCapture(O, this);
      }
      releaseCapture(O) {
        u.releaseCapture(O, this);
      }
    }
    r.Shape = k, k.prototype._fillFunc = w, k.prototype._strokeFunc = C, k.prototype._fillFuncHit = F, k.prototype._strokeFuncHit = c, k.prototype._centroid = !1, k.prototype.nodeType = "Shape", (0, l._registerNode)(k), k.prototype.eventListeners = {}, k.prototype.on.call(k.prototype, "shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", f), k.prototype.on.call(k.prototype, "shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", m), k.prototype.on.call(k.prototype, "fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva fillPatternOffsetXChange.konva fillPatternOffsetYChange.konva fillPatternXChange.konva fillPatternYChange.konva fillPatternRotationChange.konva", E), k.prototype.on.call(k.prototype, "fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva", T), k.prototype.on.call(k.prototype, "fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva", D), s.Factory.addGetterSetter(k, "stroke", void 0, (0, o.getStringOrGradientValidator)()), s.Factory.addGetterSetter(k, "strokeWidth", 2, (0, o.getNumberValidator)()), s.Factory.addGetterSetter(k, "fillAfterStrokeEnabled", !1), s.Factory.addGetterSetter(k, "hitStrokeWidth", "auto", (0, o.getNumberOrAutoValidator)()), s.Factory.addGetterSetter(k, "strokeHitEnabled", !0, (0, o.getBooleanValidator)()), s.Factory.addGetterSetter(k, "perfectDrawEnabled", !0, (0, o.getBooleanValidator)()), s.Factory.addGetterSetter(k, "shadowForStrokeEnabled", !0, (0, o.getBooleanValidator)()), s.Factory.addGetterSetter(k, "lineJoin"), s.Factory.addGetterSetter(k, "lineCap"), s.Factory.addGetterSetter(k, "sceneFunc"), s.Factory.addGetterSetter(k, "hitFunc"), s.Factory.addGetterSetter(k, "dash"), s.Factory.addGetterSetter(k, "dashOffset", 0, (0, o.getNumberValidator)()), s.Factory.addGetterSetter(k, "shadowColor", void 0, (0, o.getStringValidator)()), s.Factory.addGetterSetter(k, "shadowBlur", 0, (0, o.getNumberValidator)()), s.Factory.addGetterSetter(k, "shadowOpacity", 1, (0, o.getNumberValidator)()), s.Factory.addComponentsGetterSetter(k, "shadowOffset", ["x", "y"]), s.Factory.addGetterSetter(k, "shadowOffsetX", 0, (0, o.getNumberValidator)()), s.Factory.addGetterSetter(k, "shadowOffsetY", 0, (0, o.getNumberValidator)()), s.Factory.addGetterSetter(k, "fillPatternImage"), s.Factory.addGetterSetter(k, "fill", void 0, (0, o.getStringOrGradientValidator)()), s.Factory.addGetterSetter(k, "fillPatternX", 0, (0, o.getNumberValidator)()), s.Factory.addGetterSetter(k, "fillPatternY", 0, (0, o.getNumberValidator)()), s.Factory.addGetterSetter(k, "fillLinearGradientColorStops"), s.Factory.addGetterSetter(k, "strokeLinearGradientColorStops"), s.Factory.addGetterSetter(k, "fillRadialGradientStartRadius", 0), s.Factory.addGetterSetter(k, "fillRadialGradientEndRadius", 0), s.Factory.addGetterSetter(k, "fillRadialGradientColorStops"), s.Factory.addGetterSetter(k, "fillPatternRepeat", "repeat"), s.Factory.addGetterSetter(k, "fillEnabled", !0), s.Factory.addGetterSetter(k, "strokeEnabled", !0), s.Factory.addGetterSetter(k, "shadowEnabled", !0), s.Factory.addGetterSetter(k, "dashEnabled", !0), s.Factory.addGetterSetter(k, "strokeScaleEnabled", !0), s.Factory.addGetterSetter(k, "fillPriority", "color"), s.Factory.addComponentsGetterSetter(k, "fillPatternOffset", ["x", "y"]), s.Factory.addGetterSetter(k, "fillPatternOffsetX", 0, (0, o.getNumberValidator)()), s.Factory.addGetterSetter(k, "fillPatternOffsetY", 0, (0, o.getNumberValidator)()), s.Factory.addComponentsGetterSetter(k, "fillPatternScale", ["x", "y"]), s.Factory.addGetterSetter(k, "fillPatternScaleX", 1, (0, o.getNumberValidator)()), s.Factory.addGetterSetter(k, "fillPatternScaleY", 1, (0, o.getNumberValidator)()), s.Factory.addComponentsGetterSetter(k, "fillLinearGradientStartPoint", [
      "x",
      "y"
    ]), s.Factory.addComponentsGetterSetter(k, "strokeLinearGradientStartPoint", [
      "x",
      "y"
    ]), s.Factory.addGetterSetter(k, "fillLinearGradientStartPointX", 0), s.Factory.addGetterSetter(k, "strokeLinearGradientStartPointX", 0), s.Factory.addGetterSetter(k, "fillLinearGradientStartPointY", 0), s.Factory.addGetterSetter(k, "strokeLinearGradientStartPointY", 0), s.Factory.addComponentsGetterSetter(k, "fillLinearGradientEndPoint", [
      "x",
      "y"
    ]), s.Factory.addComponentsGetterSetter(k, "strokeLinearGradientEndPoint", [
      "x",
      "y"
    ]), s.Factory.addGetterSetter(k, "fillLinearGradientEndPointX", 0), s.Factory.addGetterSetter(k, "strokeLinearGradientEndPointX", 0), s.Factory.addGetterSetter(k, "fillLinearGradientEndPointY", 0), s.Factory.addGetterSetter(k, "strokeLinearGradientEndPointY", 0), s.Factory.addComponentsGetterSetter(k, "fillRadialGradientStartPoint", [
      "x",
      "y"
    ]), s.Factory.addGetterSetter(k, "fillRadialGradientStartPointX", 0), s.Factory.addGetterSetter(k, "fillRadialGradientStartPointY", 0), s.Factory.addComponentsGetterSetter(k, "fillRadialGradientEndPoint", [
      "x",
      "y"
    ]), s.Factory.addGetterSetter(k, "fillRadialGradientEndPointX", 0), s.Factory.addGetterSetter(k, "fillRadialGradientEndPointY", 0), s.Factory.addGetterSetter(k, "fillPatternRotation", 0), s.Factory.addGetterSetter(k, "fillRule", void 0, (0, o.getStringValidator)()), s.Factory.backCompat(k, {
      dashArray: "dash",
      getDashArray: "getDash",
      setDashArray: "getDash",
      drawFunc: "sceneFunc",
      getDrawFunc: "getSceneFunc",
      setDrawFunc: "setSceneFunc",
      drawHitFunc: "hitFunc",
      getDrawHitFunc: "getHitFunc",
      setDrawHitFunc: "setHitFunc"
    });
  }(Js)), Js;
}
var Yc;
function ig() {
  if (Yc) return Ri;
  Yc = 1, Object.defineProperty(Ri, "__esModule", { value: !0 }), Ri.Layer = void 0;
  const r = Kt(), a = Sa(), i = $t(), s = Tt(), h = ba(), o = Ot(), l = oe(), u = Rt(), g = "#", p = "beforeDraw", b = "draw", S = [
    { x: 0, y: 0 },
    { x: -1, y: -1 },
    { x: 1, y: -1 },
    { x: 1, y: 1 },
    { x: -1, y: 1 }
  ], x = S.length;
  let v = class extends a.Container {
    constructor(w) {
      super(w), this.canvas = new h.SceneCanvas(), this.hitCanvas = new h.HitCanvas({
        pixelRatio: 1
      }), this._waitingForDraw = !1, this.on("visibleChange.konva", this._checkVisibility), this._checkVisibility(), this.on("imageSmoothingEnabledChange.konva", this._setSmoothEnabled), this._setSmoothEnabled();
    }
    createPNGStream() {
      return this.canvas._canvas.createPNGStream();
    }
    getCanvas() {
      return this.canvas;
    }
    getNativeCanvasElement() {
      return this.canvas._canvas;
    }
    getHitCanvas() {
      return this.hitCanvas;
    }
    getContext() {
      return this.getCanvas().getContext();
    }
    clear(w) {
      return this.getContext().clear(w), this.getHitCanvas().getContext().clear(w), this;
    }
    setZIndex(w) {
      super.setZIndex(w);
      const C = this.getStage();
      return C && C.content && (C.content.removeChild(this.getNativeCanvasElement()), w < C.children.length - 1 ? C.content.insertBefore(this.getNativeCanvasElement(), C.children[w + 1].getCanvas()._canvas) : C.content.appendChild(this.getNativeCanvasElement())), this;
    }
    moveToTop() {
      i.Node.prototype.moveToTop.call(this);
      const w = this.getStage();
      return w && w.content && (w.content.removeChild(this.getNativeCanvasElement()), w.content.appendChild(this.getNativeCanvasElement())), !0;
    }
    moveUp() {
      if (!i.Node.prototype.moveUp.call(this))
        return !1;
      const C = this.getStage();
      return !C || !C.content ? !1 : (C.content.removeChild(this.getNativeCanvasElement()), this.index < C.children.length - 1 ? C.content.insertBefore(this.getNativeCanvasElement(), C.children[this.index + 1].getCanvas()._canvas) : C.content.appendChild(this.getNativeCanvasElement()), !0);
    }
    moveDown() {
      if (i.Node.prototype.moveDown.call(this)) {
        const w = this.getStage();
        if (w) {
          const C = w.children;
          w.content && (w.content.removeChild(this.getNativeCanvasElement()), w.content.insertBefore(this.getNativeCanvasElement(), C[this.index + 1].getCanvas()._canvas));
        }
        return !0;
      }
      return !1;
    }
    moveToBottom() {
      if (i.Node.prototype.moveToBottom.call(this)) {
        const w = this.getStage();
        if (w) {
          const C = w.children;
          w.content && (w.content.removeChild(this.getNativeCanvasElement()), w.content.insertBefore(this.getNativeCanvasElement(), C[1].getCanvas()._canvas));
        }
        return !0;
      }
      return !1;
    }
    getLayer() {
      return this;
    }
    remove() {
      const w = this.getNativeCanvasElement();
      return i.Node.prototype.remove.call(this), w && w.parentNode && r.Util._isInDocument(w) && w.parentNode.removeChild(w), this;
    }
    getStage() {
      return this.parent;
    }
    setSize({ width: w, height: C }) {
      return this.canvas.setSize(w, C), this.hitCanvas.setSize(w, C), this._setSmoothEnabled(), this;
    }
    _validateAdd(w) {
      const C = w.getType();
      C !== "Group" && C !== "Shape" && r.Util.throw("You may only add groups and shapes to a layer.");
    }
    _toKonvaCanvas(w) {
      return w = w || {}, w.width = w.width || this.getWidth(), w.height = w.height || this.getHeight(), w.x = w.x !== void 0 ? w.x : this.x(), w.y = w.y !== void 0 ? w.y : this.y(), i.Node.prototype._toKonvaCanvas.call(this, w);
    }
    _checkVisibility() {
      this.visible() ? this.canvas._canvas.style.display = "block" : this.canvas._canvas.style.display = "none";
    }
    _setSmoothEnabled() {
      this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled();
    }
    getWidth() {
      if (this.parent)
        return this.parent.width();
    }
    setWidth() {
      r.Util.warn('Can not change width of layer. Use "stage.width(value)" function instead.');
    }
    getHeight() {
      if (this.parent)
        return this.parent.height();
    }
    setHeight() {
      r.Util.warn('Can not change height of layer. Use "stage.height(value)" function instead.');
    }
    batchDraw() {
      return this._waitingForDraw || (this._waitingForDraw = !0, r.Util.requestAnimFrame(() => {
        this.draw(), this._waitingForDraw = !1;
      })), this;
    }
    getIntersection(w) {
      if (!this.isListening() || !this.isVisible())
        return null;
      let C = 1, F = !1;
      for (; ; ) {
        for (let c = 0; c < x; c++) {
          const f = S[c], m = this._getIntersection({
            x: w.x + f.x * C,
            y: w.y + f.y * C
          }), E = m.shape;
          if (E)
            return E;
          if (F = !!m.antialiased, !m.antialiased)
            break;
        }
        if (F)
          C += 1;
        else
          return null;
      }
    }
    _getIntersection(w) {
      const C = this.hitCanvas.pixelRatio, F = this.hitCanvas.context.getImageData(Math.round(w.x * C), Math.round(w.y * C), 1, 1).data, c = F[3];
      if (c === 255) {
        const f = r.Util._rgbToHex(F[0], F[1], F[2]), m = l.shapes[g + f];
        return m ? {
          shape: m
        } : {
          antialiased: !0
        };
      } else if (c > 0)
        return {
          antialiased: !0
        };
      return {};
    }
    drawScene(w, C) {
      const F = this.getLayer(), c = w || F && F.getCanvas();
      return this._fire(p, {
        node: this
      }), this.clearBeforeDraw() && c.getContext().clear(), a.Container.prototype.drawScene.call(this, c, C), this._fire(b, {
        node: this
      }), this;
    }
    drawHit(w, C) {
      const F = this.getLayer(), c = w || F && F.hitCanvas;
      return F && F.clearBeforeDraw() && F.getHitCanvas().getContext().clear(), a.Container.prototype.drawHit.call(this, c, C), this;
    }
    enableHitGraph() {
      return this.hitGraphEnabled(!0), this;
    }
    disableHitGraph() {
      return this.hitGraphEnabled(!1), this;
    }
    setHitGraphEnabled(w) {
      r.Util.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead."), this.listening(w);
    }
    getHitGraphEnabled(w) {
      return r.Util.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead."), this.listening();
    }
    toggleHitCanvas() {
      if (!this.parent || !this.parent.content)
        return;
      const w = this.parent;
      !!this.hitCanvas._canvas.parentNode ? w.content.removeChild(this.hitCanvas._canvas) : w.content.appendChild(this.hitCanvas._canvas);
    }
    destroy() {
      return r.Util.releaseCanvas(this.getNativeCanvasElement(), this.getHitCanvas()._canvas), super.destroy();
    }
  };
  return Ri.Layer = v, v.prototype.nodeType = "Layer", (0, u._registerNode)(v), s.Factory.addGetterSetter(v, "imageSmoothingEnabled", !0), s.Factory.addGetterSetter(v, "clearBeforeDraw", !0), s.Factory.addGetterSetter(v, "hitGraphEnabled", !0, (0, o.getBooleanValidator)()), Ri;
}
var Ti = {}, Xc;
function u6() {
  if (Xc) return Ti;
  Xc = 1, Object.defineProperty(Ti, "__esModule", { value: !0 }), Ti.FastLayer = void 0;
  const r = Kt(), a = ig(), i = Rt();
  let s = class extends a.Layer {
    constructor(o) {
      super(o), this.listening(!1), r.Util.warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
    }
  };
  return Ti.FastLayer = s, s.prototype.nodeType = "FastLayer", (0, i._registerNode)(s), Ti;
}
var Pi = {}, $c;
function el() {
  if ($c) return Pi;
  $c = 1, Object.defineProperty(Pi, "__esModule", { value: !0 }), Pi.Group = void 0;
  const r = Kt(), a = Sa(), i = Rt();
  let s = class extends a.Container {
    _validateAdd(o) {
      const l = o.getType();
      l !== "Group" && l !== "Shape" && r.Util.throw("You may only add groups and shapes to groups.");
    }
  };
  return Pi.Group = s, s.prototype.nodeType = "Group", (0, i._registerNode)(s), Pi;
}
var Fi = {}, Zc;
function rl() {
  if (Zc) return Fi;
  Zc = 1, Object.defineProperty(Fi, "__esModule", { value: !0 }), Fi.Animation = void 0;
  const r = Rt(), a = Kt(), i = function() {
    return r.glob.performance && r.glob.performance.now ? function() {
      return r.glob.performance.now();
    } : function() {
      return (/* @__PURE__ */ new Date()).getTime();
    };
  }();
  let s = class ri {
    constructor(o, l) {
      this.id = ri.animIdCounter++, this.frame = {
        time: 0,
        timeDiff: 0,
        lastTime: i(),
        frameRate: 0
      }, this.func = o, this.setLayers(l);
    }
    setLayers(o) {
      let l = [];
      return o && (l = Array.isArray(o) ? o : [o]), this.layers = l, this;
    }
    getLayers() {
      return this.layers;
    }
    addLayer(o) {
      const l = this.layers, u = l.length;
      for (let g = 0; g < u; g++)
        if (l[g]._id === o._id)
          return !1;
      return this.layers.push(o), !0;
    }
    isRunning() {
      const l = ri.animations, u = l.length;
      for (let g = 0; g < u; g++)
        if (l[g].id === this.id)
          return !0;
      return !1;
    }
    start() {
      return this.stop(), this.frame.timeDiff = 0, this.frame.lastTime = i(), ri._addAnimation(this), this;
    }
    stop() {
      return ri._removeAnimation(this), this;
    }
    _updateFrameObject(o) {
      this.frame.timeDiff = o - this.frame.lastTime, this.frame.lastTime = o, this.frame.time += this.frame.timeDiff, this.frame.frameRate = 1e3 / this.frame.timeDiff;
    }
    static _addAnimation(o) {
      this.animations.push(o), this._handleAnimation();
    }
    static _removeAnimation(o) {
      const l = o.id, u = this.animations, g = u.length;
      for (let p = 0; p < g; p++)
        if (u[p].id === l) {
          this.animations.splice(p, 1);
          break;
        }
    }
    static _runFrames() {
      const o = {}, l = this.animations;
      for (let u = 0; u < l.length; u++) {
        const g = l[u], p = g.layers, b = g.func;
        g._updateFrameObject(i());
        const S = p.length;
        let x;
        if (b ? x = b.call(g, g.frame) !== !1 : x = !0, !!x)
          for (let v = 0; v < S; v++) {
            const _ = p[v];
            _._id !== void 0 && (o[_._id] = _);
          }
      }
      for (const u in o)
        o.hasOwnProperty(u) && o[u].batchDraw();
    }
    static _animationLoop() {
      const o = ri;
      o.animations.length ? (o._runFrames(), a.Util.requestAnimFrame(o._animationLoop)) : o.animRunning = !1;
    }
    static _handleAnimation() {
      this.animRunning || (this.animRunning = !0, a.Util.requestAnimFrame(this._animationLoop));
    }
  };
  return Fi.Animation = s, s.animations = [], s.animIdCounter = 0, s.animRunning = !1, Fi;
}
var Qs = {}, Jc;
function c6() {
  return Jc || (Jc = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Easings = r.Tween = void 0;
    const a = Kt(), i = rl(), s = $t(), h = Rt();
    let o = {
      node: 1,
      duration: 1,
      easing: 1,
      onFinish: 1,
      yoyo: 1
    }, l = 1, u = 2, g = 3, p = 0, b = ["fill", "stroke", "shadowColor"];
    class S {
      constructor(_, w, C, F, c, f, m) {
        this.prop = _, this.propFunc = w, this.begin = F, this._pos = F, this.duration = f, this._change = 0, this.prevPos = 0, this.yoyo = m, this._time = 0, this._position = 0, this._startTime = 0, this._finish = 0, this.func = C, this._change = c - this.begin, this.pause();
      }
      fire(_) {
        const w = this[_];
        w && w();
      }
      setTime(_) {
        _ > this.duration ? this.yoyo ? (this._time = this.duration, this.reverse()) : this.finish() : _ < 0 ? this.yoyo ? (this._time = 0, this.play()) : this.reset() : (this._time = _, this.update());
      }
      getTime() {
        return this._time;
      }
      setPosition(_) {
        this.prevPos = this._pos, this.propFunc(_), this._pos = _;
      }
      getPosition(_) {
        return _ === void 0 && (_ = this._time), this.func(_, this.begin, this._change, this.duration);
      }
      play() {
        this.state = u, this._startTime = this.getTimer() - this._time, this.onEnterFrame(), this.fire("onPlay");
      }
      reverse() {
        this.state = g, this._time = this.duration - this._time, this._startTime = this.getTimer() - this._time, this.onEnterFrame(), this.fire("onReverse");
      }
      seek(_) {
        this.pause(), this._time = _, this.update(), this.fire("onSeek");
      }
      reset() {
        this.pause(), this._time = 0, this.update(), this.fire("onReset");
      }
      finish() {
        this.pause(), this._time = this.duration, this.update(), this.fire("onFinish");
      }
      update() {
        this.setPosition(this.getPosition(this._time)), this.fire("onUpdate");
      }
      onEnterFrame() {
        const _ = this.getTimer() - this._startTime;
        this.state === u ? this.setTime(_) : this.state === g && this.setTime(this.duration - _);
      }
      pause() {
        this.state = l, this.fire("onPause");
      }
      getTimer() {
        return (/* @__PURE__ */ new Date()).getTime();
      }
    }
    class x {
      constructor(_) {
        let w = this, C = _.node, F = C._id, c, f = _.easing || r.Easings.Linear, m = !!_.yoyo, E;
        typeof _.duration == "undefined" ? c = 0.3 : _.duration === 0 ? c = 1e-3 : c = _.duration, this.node = C, this._id = p++;
        const T = C.getLayer() || (C instanceof h.Konva.Stage ? C.getLayers() : null);
        T || a.Util.error("Tween constructor have `node` that is not in a layer. Please add node into layer first."), this.anim = new i.Animation(function() {
          w.tween.onEnterFrame();
        }, T), this.tween = new S(E, function(D) {
          w._tweenFunc(D);
        }, f, 0, 1, c * 1e3, m), this._addListeners(), x.attrs[F] || (x.attrs[F] = {}), x.attrs[F][this._id] || (x.attrs[F][this._id] = {}), x.tweens[F] || (x.tweens[F] = {});
        for (E in _)
          o[E] === void 0 && this._addAttr(E, _[E]);
        this.reset(), this.onFinish = _.onFinish, this.onReset = _.onReset, this.onUpdate = _.onUpdate;
      }
      _addAttr(_, w) {
        let C = this.node, F = C._id, c, f, m, E, T, D, k, M;
        if (m = x.tweens[F][_], m && delete x.attrs[F][m][_], c = C.getAttr(_), a.Util._isArray(w))
          if (f = [], T = Math.max(w.length, c.length), _ === "points" && w.length !== c.length && (w.length > c.length ? (k = c, c = a.Util._prepareArrayForTween(c, w, C.closed())) : (D = w, w = a.Util._prepareArrayForTween(w, c, C.closed()))), _.indexOf("fill") === 0)
            for (E = 0; E < T; E++)
              if (E % 2 === 0)
                f.push(w[E] - c[E]);
              else {
                const O = a.Util.colorToRGBA(c[E]);
                M = a.Util.colorToRGBA(w[E]), c[E] = O, f.push({
                  r: M.r - O.r,
                  g: M.g - O.g,
                  b: M.b - O.b,
                  a: M.a - O.a
                });
              }
          else
            for (E = 0; E < T; E++)
              f.push(w[E] - c[E]);
        else b.indexOf(_) !== -1 ? (c = a.Util.colorToRGBA(c), M = a.Util.colorToRGBA(w), f = {
          r: M.r - c.r,
          g: M.g - c.g,
          b: M.b - c.b,
          a: M.a - c.a
        }) : f = w - c;
        x.attrs[F][this._id][_] = {
          start: c,
          diff: f,
          end: w,
          trueEnd: D,
          trueStart: k
        }, x.tweens[F][_] = this._id;
      }
      _tweenFunc(_) {
        let w = this.node, C = x.attrs[w._id][this._id], F, c, f, m, E, T, D, k;
        for (F in C) {
          if (c = C[F], f = c.start, m = c.diff, k = c.end, a.Util._isArray(f))
            if (E = [], D = Math.max(f.length, k.length), F.indexOf("fill") === 0)
              for (T = 0; T < D; T++)
                T % 2 === 0 ? E.push((f[T] || 0) + m[T] * _) : E.push("rgba(" + Math.round(f[T].r + m[T].r * _) + "," + Math.round(f[T].g + m[T].g * _) + "," + Math.round(f[T].b + m[T].b * _) + "," + (f[T].a + m[T].a * _) + ")");
            else
              for (T = 0; T < D; T++)
                E.push((f[T] || 0) + m[T] * _);
          else b.indexOf(F) !== -1 ? E = "rgba(" + Math.round(f.r + m.r * _) + "," + Math.round(f.g + m.g * _) + "," + Math.round(f.b + m.b * _) + "," + (f.a + m.a * _) + ")" : E = f + m * _;
          w.setAttr(F, E);
        }
      }
      _addListeners() {
        this.tween.onPlay = () => {
          this.anim.start();
        }, this.tween.onReverse = () => {
          this.anim.start();
        }, this.tween.onPause = () => {
          this.anim.stop();
        }, this.tween.onFinish = () => {
          const _ = this.node, w = x.attrs[_._id][this._id];
          w.points && w.points.trueEnd && _.setAttr("points", w.points.trueEnd), this.onFinish && this.onFinish.call(this);
        }, this.tween.onReset = () => {
          const _ = this.node, w = x.attrs[_._id][this._id];
          w.points && w.points.trueStart && _.points(w.points.trueStart), this.onReset && this.onReset();
        }, this.tween.onUpdate = () => {
          this.onUpdate && this.onUpdate.call(this);
        };
      }
      play() {
        return this.tween.play(), this;
      }
      reverse() {
        return this.tween.reverse(), this;
      }
      reset() {
        return this.tween.reset(), this;
      }
      seek(_) {
        return this.tween.seek(_ * 1e3), this;
      }
      pause() {
        return this.tween.pause(), this;
      }
      finish() {
        return this.tween.finish(), this;
      }
      destroy() {
        let _ = this.node._id, w = this._id, C = x.tweens[_], F;
        this.pause();
        for (F in C)
          delete x.tweens[_][F];
        delete x.attrs[_][w];
      }
    }
    r.Tween = x, x.attrs = {}, x.tweens = {}, s.Node.prototype.to = function(v) {
      const _ = v.onFinish;
      v.node = this, v.onFinish = function() {
        this.destroy(), _ && _();
      }, new x(v).play();
    }, r.Easings = {
      BackEaseIn(v, _, w, C) {
        return w * (v /= C) * v * ((1.70158 + 1) * v - 1.70158) + _;
      },
      BackEaseOut(v, _, w, C) {
        return w * ((v = v / C - 1) * v * ((1.70158 + 1) * v + 1.70158) + 1) + _;
      },
      BackEaseInOut(v, _, w, C) {
        let F = 1.70158;
        return (v /= C / 2) < 1 ? w / 2 * (v * v * (((F *= 1.525) + 1) * v - F)) + _ : w / 2 * ((v -= 2) * v * (((F *= 1.525) + 1) * v + F) + 2) + _;
      },
      ElasticEaseIn(v, _, w, C, F, c) {
        let f = 0;
        return v === 0 ? _ : (v /= C) === 1 ? _ + w : (c || (c = C * 0.3), !F || F < Math.abs(w) ? (F = w, f = c / 4) : f = c / (2 * Math.PI) * Math.asin(w / F), -(F * Math.pow(2, 10 * (v -= 1)) * Math.sin((v * C - f) * (2 * Math.PI) / c)) + _);
      },
      ElasticEaseOut(v, _, w, C, F, c) {
        let f = 0;
        return v === 0 ? _ : (v /= C) === 1 ? _ + w : (c || (c = C * 0.3), !F || F < Math.abs(w) ? (F = w, f = c / 4) : f = c / (2 * Math.PI) * Math.asin(w / F), F * Math.pow(2, -10 * v) * Math.sin((v * C - f) * (2 * Math.PI) / c) + w + _);
      },
      ElasticEaseInOut(v, _, w, C, F, c) {
        let f = 0;
        return v === 0 ? _ : (v /= C / 2) === 2 ? _ + w : (c || (c = C * (0.3 * 1.5)), !F || F < Math.abs(w) ? (F = w, f = c / 4) : f = c / (2 * Math.PI) * Math.asin(w / F), v < 1 ? -0.5 * (F * Math.pow(2, 10 * (v -= 1)) * Math.sin((v * C - f) * (2 * Math.PI) / c)) + _ : F * Math.pow(2, -10 * (v -= 1)) * Math.sin((v * C - f) * (2 * Math.PI) / c) * 0.5 + w + _);
      },
      BounceEaseOut(v, _, w, C) {
        return (v /= C) < 1 / 2.75 ? w * (7.5625 * v * v) + _ : v < 2 / 2.75 ? w * (7.5625 * (v -= 1.5 / 2.75) * v + 0.75) + _ : v < 2.5 / 2.75 ? w * (7.5625 * (v -= 2.25 / 2.75) * v + 0.9375) + _ : w * (7.5625 * (v -= 2.625 / 2.75) * v + 0.984375) + _;
      },
      BounceEaseIn(v, _, w, C) {
        return w - r.Easings.BounceEaseOut(C - v, 0, w, C) + _;
      },
      BounceEaseInOut(v, _, w, C) {
        return v < C / 2 ? r.Easings.BounceEaseIn(v * 2, 0, w, C) * 0.5 + _ : r.Easings.BounceEaseOut(v * 2 - C, 0, w, C) * 0.5 + w * 0.5 + _;
      },
      EaseIn(v, _, w, C) {
        return w * (v /= C) * v + _;
      },
      EaseOut(v, _, w, C) {
        return -w * (v /= C) * (v - 2) + _;
      },
      EaseInOut(v, _, w, C) {
        return (v /= C / 2) < 1 ? w / 2 * v * v + _ : -w / 2 * (--v * (v - 2) - 1) + _;
      },
      StrongEaseIn(v, _, w, C) {
        return w * (v /= C) * v * v * v * v + _;
      },
      StrongEaseOut(v, _, w, C) {
        return w * ((v = v / C - 1) * v * v * v * v + 1) + _;
      },
      StrongEaseInOut(v, _, w, C) {
        return (v /= C / 2) < 1 ? w / 2 * v * v * v * v * v + _ : w / 2 * ((v -= 2) * v * v * v * v + 2) + _;
      },
      Linear(v, _, w, C) {
        return w * v / C + _;
      }
    };
  }(Qs)), Qs;
}
var Qc;
function d6() {
  return Qc || (Qc = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Konva = void 0;
    const a = Rt(), i = Kt(), s = $t(), h = Sa(), o = l6(), l = ig(), u = u6(), g = el(), p = tl(), b = oe(), S = rl(), x = c6(), v = eg(), _ = ba();
    r.Konva = i.Util._assign(a.Konva, {
      Util: i.Util,
      Transform: i.Transform,
      Node: s.Node,
      Container: h.Container,
      Stage: o.Stage,
      stages: o.stages,
      Layer: l.Layer,
      FastLayer: u.FastLayer,
      Group: g.Group,
      DD: p.DD,
      Shape: b.Shape,
      shapes: b.shapes,
      Animation: S.Animation,
      Tween: x.Tween,
      Easings: x.Easings,
      Context: v.Context,
      Canvas: _.Canvas
    }), r.default = r.Konva;
  }(js)), js;
}
var Oi = {}, td;
function f6() {
  if (td) return Oi;
  td = 1, Object.defineProperty(Oi, "__esModule", { value: !0 }), Oi.Arc = void 0;
  const r = Tt(), a = oe(), i = Rt(), s = Ot(), h = Rt();
  let o = class extends a.Shape {
    _sceneFunc(u) {
      const g = i.Konva.getAngle(this.angle()), p = this.clockwise();
      u.beginPath(), u.arc(0, 0, this.outerRadius(), 0, g, p), u.arc(0, 0, this.innerRadius(), g, 0, !p), u.closePath(), u.fillStrokeShape(this);
    }
    getWidth() {
      return this.outerRadius() * 2;
    }
    getHeight() {
      return this.outerRadius() * 2;
    }
    setWidth(u) {
      this.outerRadius(u / 2);
    }
    setHeight(u) {
      this.outerRadius(u / 2);
    }
    getSelfRect() {
      const u = this.innerRadius(), g = this.outerRadius(), p = this.clockwise(), b = i.Konva.getAngle(p ? 360 - this.angle() : this.angle()), S = Math.cos(Math.min(b, Math.PI)), x = 1, v = Math.sin(Math.min(Math.max(Math.PI, b), 3 * Math.PI / 2)), _ = Math.sin(Math.min(b, Math.PI / 2)), w = S * (S > 0 ? u : g), C = x * g, F = v * (v > 0 ? u : g), c = _ * (_ > 0 ? g : u);
      return {
        x: w,
        y: p ? -1 * c : F,
        width: C - w,
        height: c - F
      };
    }
  };
  return Oi.Arc = o, o.prototype._centroid = !0, o.prototype.className = "Arc", o.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"], (0, h._registerNode)(o), r.Factory.addGetterSetter(o, "innerRadius", 0, (0, s.getNumberValidator)()), r.Factory.addGetterSetter(o, "outerRadius", 0, (0, s.getNumberValidator)()), r.Factory.addGetterSetter(o, "angle", 0, (0, s.getNumberValidator)()), r.Factory.addGetterSetter(o, "clockwise", !1, (0, s.getBooleanValidator)()), Oi;
}
var Ii = {}, ki = {}, ed;
function ng() {
  if (ed) return ki;
  ed = 1, Object.defineProperty(ki, "__esModule", { value: !0 }), ki.Line = void 0;
  const r = Tt(), a = Rt(), i = oe(), s = Ot();
  function h(u, g, p, b, S, x, v) {
    const _ = Math.sqrt(Math.pow(p - u, 2) + Math.pow(b - g, 2)), w = Math.sqrt(Math.pow(S - p, 2) + Math.pow(x - b, 2)), C = v * _ / (_ + w), F = v * w / (_ + w), c = p - C * (S - u), f = b - C * (x - g), m = p + F * (S - u), E = b + F * (x - g);
    return [c, f, m, E];
  }
  function o(u, g) {
    const p = u.length, b = [];
    for (let S = 2; S < p - 2; S += 2) {
      const x = h(u[S - 2], u[S - 1], u[S], u[S + 1], u[S + 2], u[S + 3], g);
      isNaN(x[0]) || (b.push(x[0]), b.push(x[1]), b.push(u[S]), b.push(u[S + 1]), b.push(x[2]), b.push(x[3]));
    }
    return b;
  }
  let l = class extends i.Shape {
    constructor(g) {
      super(g), this.on("pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva", function() {
        this._clearCache("tensionPoints");
      });
    }
    _sceneFunc(g) {
      let p = this.points(), b = p.length, S = this.tension(), x = this.closed(), v = this.bezier(), _, w, C;
      if (b) {
        if (g.beginPath(), g.moveTo(p[0], p[1]), S !== 0 && b > 4) {
          for (_ = this.getTensionPoints(), w = _.length, C = x ? 0 : 4, x || g.quadraticCurveTo(_[0], _[1], _[2], _[3]); C < w - 2; )
            g.bezierCurveTo(_[C++], _[C++], _[C++], _[C++], _[C++], _[C++]);
          x || g.quadraticCurveTo(_[w - 2], _[w - 1], p[b - 2], p[b - 1]);
        } else if (v)
          for (C = 2; C < b; )
            g.bezierCurveTo(p[C++], p[C++], p[C++], p[C++], p[C++], p[C++]);
        else
          for (C = 2; C < b; C += 2)
            g.lineTo(p[C], p[C + 1]);
        x ? (g.closePath(), g.fillStrokeShape(this)) : g.strokeShape(this);
      }
    }
    getTensionPoints() {
      return this._getCache("tensionPoints", this._getTensionPoints);
    }
    _getTensionPoints() {
      return this.closed() ? this._getTensionPointsClosed() : o(this.points(), this.tension());
    }
    _getTensionPointsClosed() {
      const g = this.points(), p = g.length, b = this.tension(), S = h(g[p - 2], g[p - 1], g[0], g[1], g[2], g[3], b), x = h(g[p - 4], g[p - 3], g[p - 2], g[p - 1], g[0], g[1], b), v = o(g, b);
      return [S[2], S[3]].concat(v).concat([
        x[0],
        x[1],
        g[p - 2],
        g[p - 1],
        x[2],
        x[3],
        S[0],
        S[1],
        g[0],
        g[1]
      ]);
    }
    getWidth() {
      return this.getSelfRect().width;
    }
    getHeight() {
      return this.getSelfRect().height;
    }
    getSelfRect() {
      let g = this.points();
      if (g.length < 4)
        return {
          x: g[0] || 0,
          y: g[1] || 0,
          width: 0,
          height: 0
        };
      this.tension() !== 0 ? g = [
        g[0],
        g[1],
        ...this._getTensionPoints(),
        g[g.length - 2],
        g[g.length - 1]
      ] : g = this.points();
      let p = g[0], b = g[0], S = g[1], x = g[1], v, _;
      for (let w = 0; w < g.length / 2; w++)
        v = g[w * 2], _ = g[w * 2 + 1], p = Math.min(p, v), b = Math.max(b, v), S = Math.min(S, _), x = Math.max(x, _);
      return {
        x: p,
        y: S,
        width: b - p,
        height: x - S
      };
    }
  };
  return ki.Line = l, l.prototype.className = "Line", l.prototype._attrsAffectingSize = ["points", "bezier", "tension"], (0, a._registerNode)(l), r.Factory.addGetterSetter(l, "closed", !1), r.Factory.addGetterSetter(l, "bezier", !1), r.Factory.addGetterSetter(l, "tension", 0, (0, s.getNumberValidator)()), r.Factory.addGetterSetter(l, "points", [], (0, s.getNumberArrayValidator)()), ki;
}
var Mi = {}, to = {}, rd;
function g6() {
  return rd || (rd = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.t2length = r.getQuadraticArcLength = r.getCubicArcLength = r.binomialCoefficients = r.cValues = r.tValues = void 0, r.tValues = [
      [],
      [],
      [
        -0.5773502691896257,
        0.5773502691896257
      ],
      [
        0,
        -0.7745966692414834,
        0.7745966692414834
      ],
      [
        -0.33998104358485626,
        0.33998104358485626,
        -0.8611363115940526,
        0.8611363115940526
      ],
      [
        0,
        -0.5384693101056831,
        0.5384693101056831,
        -0.906179845938664,
        0.906179845938664
      ],
      [
        0.6612093864662645,
        -0.6612093864662645,
        -0.2386191860831969,
        0.2386191860831969,
        -0.932469514203152,
        0.932469514203152
      ],
      [
        0,
        0.4058451513773972,
        -0.4058451513773972,
        -0.7415311855993945,
        0.7415311855993945,
        -0.9491079123427585,
        0.9491079123427585
      ],
      [
        -0.1834346424956498,
        0.1834346424956498,
        -0.525532409916329,
        0.525532409916329,
        -0.7966664774136267,
        0.7966664774136267,
        -0.9602898564975363,
        0.9602898564975363
      ],
      [
        0,
        -0.8360311073266358,
        0.8360311073266358,
        -0.9681602395076261,
        0.9681602395076261,
        -0.3242534234038089,
        0.3242534234038089,
        -0.6133714327005904,
        0.6133714327005904
      ],
      [
        -0.14887433898163122,
        0.14887433898163122,
        -0.4333953941292472,
        0.4333953941292472,
        -0.6794095682990244,
        0.6794095682990244,
        -0.8650633666889845,
        0.8650633666889845,
        -0.9739065285171717,
        0.9739065285171717
      ],
      [
        0,
        -0.26954315595234496,
        0.26954315595234496,
        -0.5190961292068118,
        0.5190961292068118,
        -0.7301520055740494,
        0.7301520055740494,
        -0.8870625997680953,
        0.8870625997680953,
        -0.978228658146057,
        0.978228658146057
      ],
      [
        -0.1252334085114689,
        0.1252334085114689,
        -0.3678314989981802,
        0.3678314989981802,
        -0.5873179542866175,
        0.5873179542866175,
        -0.7699026741943047,
        0.7699026741943047,
        -0.9041172563704749,
        0.9041172563704749,
        -0.9815606342467192,
        0.9815606342467192
      ],
      [
        0,
        -0.2304583159551348,
        0.2304583159551348,
        -0.44849275103644687,
        0.44849275103644687,
        -0.6423493394403402,
        0.6423493394403402,
        -0.8015780907333099,
        0.8015780907333099,
        -0.9175983992229779,
        0.9175983992229779,
        -0.9841830547185881,
        0.9841830547185881
      ],
      [
        -0.10805494870734367,
        0.10805494870734367,
        -0.31911236892788974,
        0.31911236892788974,
        -0.5152486363581541,
        0.5152486363581541,
        -0.6872929048116855,
        0.6872929048116855,
        -0.827201315069765,
        0.827201315069765,
        -0.9284348836635735,
        0.9284348836635735,
        -0.9862838086968123,
        0.9862838086968123
      ],
      [
        0,
        -0.20119409399743451,
        0.20119409399743451,
        -0.3941513470775634,
        0.3941513470775634,
        -0.5709721726085388,
        0.5709721726085388,
        -0.7244177313601701,
        0.7244177313601701,
        -0.8482065834104272,
        0.8482065834104272,
        -0.937273392400706,
        0.937273392400706,
        -0.9879925180204854,
        0.9879925180204854
      ],
      [
        -0.09501250983763744,
        0.09501250983763744,
        -0.2816035507792589,
        0.2816035507792589,
        -0.45801677765722737,
        0.45801677765722737,
        -0.6178762444026438,
        0.6178762444026438,
        -0.755404408355003,
        0.755404408355003,
        -0.8656312023878318,
        0.8656312023878318,
        -0.9445750230732326,
        0.9445750230732326,
        -0.9894009349916499,
        0.9894009349916499
      ],
      [
        0,
        -0.17848418149584785,
        0.17848418149584785,
        -0.3512317634538763,
        0.3512317634538763,
        -0.5126905370864769,
        0.5126905370864769,
        -0.6576711592166907,
        0.6576711592166907,
        -0.7815140038968014,
        0.7815140038968014,
        -0.8802391537269859,
        0.8802391537269859,
        -0.9506755217687678,
        0.9506755217687678,
        -0.9905754753144174,
        0.9905754753144174
      ],
      [
        -0.0847750130417353,
        0.0847750130417353,
        -0.2518862256915055,
        0.2518862256915055,
        -0.41175116146284263,
        0.41175116146284263,
        -0.5597708310739475,
        0.5597708310739475,
        -0.6916870430603532,
        0.6916870430603532,
        -0.8037049589725231,
        0.8037049589725231,
        -0.8926024664975557,
        0.8926024664975557,
        -0.9558239495713977,
        0.9558239495713977,
        -0.9915651684209309,
        0.9915651684209309
      ],
      [
        0,
        -0.16035864564022537,
        0.16035864564022537,
        -0.31656409996362983,
        0.31656409996362983,
        -0.46457074137596094,
        0.46457074137596094,
        -0.600545304661681,
        0.600545304661681,
        -0.7209661773352294,
        0.7209661773352294,
        -0.8227146565371428,
        0.8227146565371428,
        -0.9031559036148179,
        0.9031559036148179,
        -0.96020815213483,
        0.96020815213483,
        -0.9924068438435844,
        0.9924068438435844
      ],
      [
        -0.07652652113349734,
        0.07652652113349734,
        -0.22778585114164507,
        0.22778585114164507,
        -0.37370608871541955,
        0.37370608871541955,
        -0.5108670019508271,
        0.5108670019508271,
        -0.636053680726515,
        0.636053680726515,
        -0.7463319064601508,
        0.7463319064601508,
        -0.8391169718222188,
        0.8391169718222188,
        -0.912234428251326,
        0.912234428251326,
        -0.9639719272779138,
        0.9639719272779138,
        -0.9931285991850949,
        0.9931285991850949
      ],
      [
        0,
        -0.1455618541608951,
        0.1455618541608951,
        -0.2880213168024011,
        0.2880213168024011,
        -0.4243421202074388,
        0.4243421202074388,
        -0.5516188358872198,
        0.5516188358872198,
        -0.6671388041974123,
        0.6671388041974123,
        -0.7684399634756779,
        0.7684399634756779,
        -0.8533633645833173,
        0.8533633645833173,
        -0.9200993341504008,
        0.9200993341504008,
        -0.9672268385663063,
        0.9672268385663063,
        -0.9937521706203895,
        0.9937521706203895
      ],
      [
        -0.06973927331972223,
        0.06973927331972223,
        -0.20786042668822127,
        0.20786042668822127,
        -0.34193582089208424,
        0.34193582089208424,
        -0.469355837986757,
        0.469355837986757,
        -0.5876404035069116,
        0.5876404035069116,
        -0.6944872631866827,
        0.6944872631866827,
        -0.7878168059792081,
        0.7878168059792081,
        -0.8658125777203002,
        0.8658125777203002,
        -0.926956772187174,
        0.926956772187174,
        -0.9700604978354287,
        0.9700604978354287,
        -0.9942945854823992,
        0.9942945854823992
      ],
      [
        0,
        -0.1332568242984661,
        0.1332568242984661,
        -0.26413568097034495,
        0.26413568097034495,
        -0.3903010380302908,
        0.3903010380302908,
        -0.5095014778460075,
        0.5095014778460075,
        -0.6196098757636461,
        0.6196098757636461,
        -0.7186613631319502,
        0.7186613631319502,
        -0.8048884016188399,
        0.8048884016188399,
        -0.8767523582704416,
        0.8767523582704416,
        -0.9329710868260161,
        0.9329710868260161,
        -0.9725424712181152,
        0.9725424712181152,
        -0.9947693349975522,
        0.9947693349975522
      ],
      [
        -0.06405689286260563,
        0.06405689286260563,
        -0.1911188674736163,
        0.1911188674736163,
        -0.3150426796961634,
        0.3150426796961634,
        -0.4337935076260451,
        0.4337935076260451,
        -0.5454214713888396,
        0.5454214713888396,
        -0.6480936519369755,
        0.6480936519369755,
        -0.7401241915785544,
        0.7401241915785544,
        -0.820001985973903,
        0.820001985973903,
        -0.8864155270044011,
        0.8864155270044011,
        -0.9382745520027328,
        0.9382745520027328,
        -0.9747285559713095,
        0.9747285559713095,
        -0.9951872199970213,
        0.9951872199970213
      ]
    ], r.cValues = [
      [],
      [],
      [1, 1],
      [
        0.8888888888888888,
        0.5555555555555556,
        0.5555555555555556
      ],
      [
        0.6521451548625461,
        0.6521451548625461,
        0.34785484513745385,
        0.34785484513745385
      ],
      [
        0.5688888888888889,
        0.47862867049936647,
        0.47862867049936647,
        0.23692688505618908,
        0.23692688505618908
      ],
      [
        0.3607615730481386,
        0.3607615730481386,
        0.46791393457269104,
        0.46791393457269104,
        0.17132449237917036,
        0.17132449237917036
      ],
      [
        0.4179591836734694,
        0.3818300505051189,
        0.3818300505051189,
        0.27970539148927664,
        0.27970539148927664,
        0.1294849661688697,
        0.1294849661688697
      ],
      [
        0.362683783378362,
        0.362683783378362,
        0.31370664587788727,
        0.31370664587788727,
        0.22238103445337448,
        0.22238103445337448,
        0.10122853629037626,
        0.10122853629037626
      ],
      [
        0.3302393550012598,
        0.1806481606948574,
        0.1806481606948574,
        0.08127438836157441,
        0.08127438836157441,
        0.31234707704000286,
        0.31234707704000286,
        0.26061069640293544,
        0.26061069640293544
      ],
      [
        0.29552422471475287,
        0.29552422471475287,
        0.26926671930999635,
        0.26926671930999635,
        0.21908636251598204,
        0.21908636251598204,
        0.1494513491505806,
        0.1494513491505806,
        0.06667134430868814,
        0.06667134430868814
      ],
      [
        0.2729250867779006,
        0.26280454451024665,
        0.26280454451024665,
        0.23319376459199048,
        0.23319376459199048,
        0.18629021092773426,
        0.18629021092773426,
        0.1255803694649046,
        0.1255803694649046,
        0.05566856711617366,
        0.05566856711617366
      ],
      [
        0.24914704581340277,
        0.24914704581340277,
        0.2334925365383548,
        0.2334925365383548,
        0.20316742672306592,
        0.20316742672306592,
        0.16007832854334622,
        0.16007832854334622,
        0.10693932599531843,
        0.10693932599531843,
        0.04717533638651183,
        0.04717533638651183
      ],
      [
        0.2325515532308739,
        0.22628318026289723,
        0.22628318026289723,
        0.2078160475368885,
        0.2078160475368885,
        0.17814598076194574,
        0.17814598076194574,
        0.13887351021978725,
        0.13887351021978725,
        0.09212149983772845,
        0.09212149983772845,
        0.04048400476531588,
        0.04048400476531588
      ],
      [
        0.2152638534631578,
        0.2152638534631578,
        0.2051984637212956,
        0.2051984637212956,
        0.18553839747793782,
        0.18553839747793782,
        0.15720316715819355,
        0.15720316715819355,
        0.12151857068790319,
        0.12151857068790319,
        0.08015808715976021,
        0.08015808715976021,
        0.03511946033175186,
        0.03511946033175186
      ],
      [
        0.2025782419255613,
        0.19843148532711158,
        0.19843148532711158,
        0.1861610000155622,
        0.1861610000155622,
        0.16626920581699392,
        0.16626920581699392,
        0.13957067792615432,
        0.13957067792615432,
        0.10715922046717194,
        0.10715922046717194,
        0.07036604748810812,
        0.07036604748810812,
        0.03075324199611727,
        0.03075324199611727
      ],
      [
        0.1894506104550685,
        0.1894506104550685,
        0.18260341504492358,
        0.18260341504492358,
        0.16915651939500254,
        0.16915651939500254,
        0.14959598881657674,
        0.14959598881657674,
        0.12462897125553388,
        0.12462897125553388,
        0.09515851168249279,
        0.09515851168249279,
        0.062253523938647894,
        0.062253523938647894,
        0.027152459411754096,
        0.027152459411754096
      ],
      [
        0.17944647035620653,
        0.17656270536699264,
        0.17656270536699264,
        0.16800410215645004,
        0.16800410215645004,
        0.15404576107681028,
        0.15404576107681028,
        0.13513636846852548,
        0.13513636846852548,
        0.11188384719340397,
        0.11188384719340397,
        0.08503614831717918,
        0.08503614831717918,
        0.0554595293739872,
        0.0554595293739872,
        0.02414830286854793,
        0.02414830286854793
      ],
      [
        0.1691423829631436,
        0.1691423829631436,
        0.16427648374583273,
        0.16427648374583273,
        0.15468467512626524,
        0.15468467512626524,
        0.14064291467065065,
        0.14064291467065065,
        0.12255520671147846,
        0.12255520671147846,
        0.10094204410628717,
        0.10094204410628717,
        0.07642573025488905,
        0.07642573025488905,
        0.0497145488949698,
        0.0497145488949698,
        0.02161601352648331,
        0.02161601352648331
      ],
      [
        0.1610544498487837,
        0.15896884339395434,
        0.15896884339395434,
        0.15276604206585967,
        0.15276604206585967,
        0.1426067021736066,
        0.1426067021736066,
        0.12875396253933621,
        0.12875396253933621,
        0.11156664554733399,
        0.11156664554733399,
        0.09149002162245,
        0.09149002162245,
        0.06904454273764123,
        0.06904454273764123,
        0.0448142267656996,
        0.0448142267656996,
        0.019461788229726478,
        0.019461788229726478
      ],
      [
        0.15275338713072584,
        0.15275338713072584,
        0.14917298647260374,
        0.14917298647260374,
        0.14209610931838204,
        0.14209610931838204,
        0.13168863844917664,
        0.13168863844917664,
        0.11819453196151841,
        0.11819453196151841,
        0.10193011981724044,
        0.10193011981724044,
        0.08327674157670475,
        0.08327674157670475,
        0.06267204833410907,
        0.06267204833410907,
        0.04060142980038694,
        0.04060142980038694,
        0.017614007139152118,
        0.017614007139152118
      ],
      [
        0.14608113364969041,
        0.14452440398997005,
        0.14452440398997005,
        0.13988739479107315,
        0.13988739479107315,
        0.13226893863333747,
        0.13226893863333747,
        0.12183141605372853,
        0.12183141605372853,
        0.10879729916714838,
        0.10879729916714838,
        0.09344442345603386,
        0.09344442345603386,
        0.0761001136283793,
        0.0761001136283793,
        0.057134425426857205,
        0.057134425426857205,
        0.036953789770852494,
        0.036953789770852494,
        0.016017228257774335,
        0.016017228257774335
      ],
      [
        0.13925187285563198,
        0.13925187285563198,
        0.13654149834601517,
        0.13654149834601517,
        0.13117350478706238,
        0.13117350478706238,
        0.12325237681051242,
        0.12325237681051242,
        0.11293229608053922,
        0.11293229608053922,
        0.10041414444288096,
        0.10041414444288096,
        0.08594160621706773,
        0.08594160621706773,
        0.06979646842452049,
        0.06979646842452049,
        0.052293335152683286,
        0.052293335152683286,
        0.03377490158481415,
        0.03377490158481415,
        0.0146279952982722,
        0.0146279952982722
      ],
      [
        0.13365457218610619,
        0.1324620394046966,
        0.1324620394046966,
        0.12890572218808216,
        0.12890572218808216,
        0.12304908430672953,
        0.12304908430672953,
        0.11499664022241136,
        0.11499664022241136,
        0.10489209146454141,
        0.10489209146454141,
        0.09291576606003515,
        0.09291576606003515,
        0.07928141177671895,
        0.07928141177671895,
        0.06423242140852585,
        0.06423242140852585,
        0.04803767173108467,
        0.04803767173108467,
        0.030988005856979445,
        0.030988005856979445,
        0.013411859487141771,
        0.013411859487141771
      ],
      [
        0.12793819534675216,
        0.12793819534675216,
        0.1258374563468283,
        0.1258374563468283,
        0.12167047292780339,
        0.12167047292780339,
        0.1155056680537256,
        0.1155056680537256,
        0.10744427011596563,
        0.10744427011596563,
        0.09761865210411388,
        0.09761865210411388,
        0.08619016153195327,
        0.08619016153195327,
        0.0733464814110803,
        0.0733464814110803,
        0.05929858491543678,
        0.05929858491543678,
        0.04427743881741981,
        0.04427743881741981,
        0.028531388628933663,
        0.028531388628933663,
        0.0123412297999872,
        0.0123412297999872
      ]
    ], r.binomialCoefficients = [[1], [1, 1], [1, 2, 1], [1, 3, 3, 1]];
    const a = (l, u, g) => {
      let p, b;
      const x = g / 2;
      p = 0;
      for (let v = 0; v < 20; v++)
        b = x * r.tValues[20][v] + x, p += r.cValues[20][v] * s(l, u, b);
      return x * p;
    };
    r.getCubicArcLength = a;
    const i = (l, u, g) => {
      g === void 0 && (g = 1);
      const p = l[0] - 2 * l[1] + l[2], b = u[0] - 2 * u[1] + u[2], S = 2 * l[1] - 2 * l[0], x = 2 * u[1] - 2 * u[0], v = 4 * (p * p + b * b), _ = 4 * (p * S + b * x), w = S * S + x * x;
      if (v === 0)
        return g * Math.sqrt(Math.pow(l[2] - l[0], 2) + Math.pow(u[2] - u[0], 2));
      const C = _ / (2 * v), F = w / v, c = g + C, f = F - C * C, m = c * c + f > 0 ? Math.sqrt(c * c + f) : 0, E = C * C + f > 0 ? Math.sqrt(C * C + f) : 0, T = C + Math.sqrt(C * C + f) !== 0 ? f * Math.log(Math.abs((c + m) / (C + E))) : 0;
      return Math.sqrt(v) / 2 * (c * m - C * E + T);
    };
    r.getQuadraticArcLength = i;
    function s(l, u, g) {
      const p = h(1, g, l), b = h(1, g, u), S = p * p + b * b;
      return Math.sqrt(S);
    }
    const h = (l, u, g) => {
      const p = g.length - 1;
      let b, S;
      if (p === 0)
        return 0;
      if (l === 0) {
        S = 0;
        for (let x = 0; x <= p; x++)
          S += r.binomialCoefficients[p][x] * Math.pow(1 - u, p - x) * Math.pow(u, x) * g[x];
        return S;
      } else {
        b = new Array(p);
        for (let x = 0; x < p; x++)
          b[x] = p * (g[x + 1] - g[x]);
        return h(l - 1, u, b);
      }
    }, o = (l, u, g) => {
      let p = 1, b = l / u, S = (l - g(b)) / u, x = 0;
      for (; p > 1e-3; ) {
        const v = g(b + S), _ = Math.abs(l - v) / u;
        if (_ < p)
          p = _, b += S;
        else {
          const w = g(b - S), C = Math.abs(l - w) / u;
          C < p ? (p = C, b -= S) : S /= 2;
        }
        if (x++, x > 500)
          break;
      }
      return b;
    };
    r.t2length = o;
  }(to)), to;
}
var id;
function il() {
  if (id) return Mi;
  id = 1, Object.defineProperty(Mi, "__esModule", { value: !0 }), Mi.Path = void 0;
  const r = Tt(), a = oe(), i = Rt(), s = g6();
  let h = class we extends a.Shape {
    constructor(l) {
      super(l), this.dataArray = [], this.pathLength = 0, this._readDataAttribute(), this.on("dataChange.konva", function() {
        this._readDataAttribute();
      });
    }
    _readDataAttribute() {
      this.dataArray = we.parsePathData(this.data()), this.pathLength = we.getPathLength(this.dataArray);
    }
    _sceneFunc(l) {
      const u = this.dataArray;
      l.beginPath();
      let g = !1;
      for (let m = 0; m < u.length; m++) {
        const E = u[m].command, T = u[m].points;
        switch (E) {
          case "L":
            l.lineTo(T[0], T[1]);
            break;
          case "M":
            l.moveTo(T[0], T[1]);
            break;
          case "C":
            l.bezierCurveTo(T[0], T[1], T[2], T[3], T[4], T[5]);
            break;
          case "Q":
            l.quadraticCurveTo(T[0], T[1], T[2], T[3]);
            break;
          case "A":
            var p = T[0], b = T[1], S = T[2], x = T[3], v = T[4], _ = T[5], w = T[6], C = T[7], F = S > x ? S : x, c = S > x ? 1 : S / x, f = S > x ? x / S : 1;
            l.translate(p, b), l.rotate(w), l.scale(c, f), l.arc(0, 0, F, v, v + _, 1 - C), l.scale(1 / c, 1 / f), l.rotate(-w), l.translate(-p, -b);
            break;
          case "z":
            g = !0, l.closePath();
            break;
        }
      }
      !g && !this.hasFill() ? l.strokeShape(this) : l.fillStrokeShape(this);
    }
    getSelfRect() {
      let l = [];
      this.dataArray.forEach(function(v) {
        if (v.command === "A") {
          const _ = v.points[4], w = v.points[5], C = v.points[4] + w;
          let F = Math.PI / 180;
          if (Math.abs(_ - C) < F && (F = Math.abs(_ - C)), w < 0)
            for (let c = _ - F; c > C; c -= F) {
              const f = we.getPointOnEllipticalArc(v.points[0], v.points[1], v.points[2], v.points[3], c, 0);
              l.push(f.x, f.y);
            }
          else
            for (let c = _ + F; c < C; c += F) {
              const f = we.getPointOnEllipticalArc(v.points[0], v.points[1], v.points[2], v.points[3], c, 0);
              l.push(f.x, f.y);
            }
        } else if (v.command === "C")
          for (let _ = 0; _ <= 1; _ += 0.01) {
            const w = we.getPointOnCubicBezier(_, v.start.x, v.start.y, v.points[0], v.points[1], v.points[2], v.points[3], v.points[4], v.points[5]);
            l.push(w.x, w.y);
          }
        else
          l = l.concat(v.points);
      });
      let u = l[0], g = l[0], p = l[1], b = l[1], S, x;
      for (let v = 0; v < l.length / 2; v++)
        S = l[v * 2], x = l[v * 2 + 1], isNaN(S) || (u = Math.min(u, S), g = Math.max(g, S)), isNaN(x) || (p = Math.min(p, x), b = Math.max(b, x));
      return {
        x: u,
        y: p,
        width: g - u,
        height: b - p
      };
    }
    getLength() {
      return this.pathLength;
    }
    getPointAtLength(l) {
      return we.getPointAtLengthOfDataArray(l, this.dataArray);
    }
    static getLineLength(l, u, g, p) {
      return Math.sqrt((g - l) * (g - l) + (p - u) * (p - u));
    }
    static getPathLength(l) {
      let u = 0;
      for (let g = 0; g < l.length; ++g)
        u += l[g].pathLength;
      return u;
    }
    static getPointAtLengthOfDataArray(l, u) {
      let g, p = 0, b = u.length;
      if (!b)
        return null;
      for (; p < b && l > u[p].pathLength; )
        l -= u[p].pathLength, ++p;
      if (p === b)
        return g = u[p - 1].points.slice(-2), {
          x: g[0],
          y: g[1]
        };
      if (l < 0.01)
        return g = u[p].points.slice(0, 2), {
          x: g[0],
          y: g[1]
        };
      const S = u[p], x = S.points;
      switch (S.command) {
        case "L":
          return we.getPointOnLine(l, S.start.x, S.start.y, x[0], x[1]);
        case "C":
          return we.getPointOnCubicBezier((0, s.t2length)(l, we.getPathLength(u), (m) => (0, s.getCubicArcLength)([S.start.x, x[0], x[2], x[4]], [S.start.y, x[1], x[3], x[5]], m)), S.start.x, S.start.y, x[0], x[1], x[2], x[3], x[4], x[5]);
        case "Q":
          return we.getPointOnQuadraticBezier((0, s.t2length)(l, we.getPathLength(u), (m) => (0, s.getQuadraticArcLength)([S.start.x, x[0], x[2]], [S.start.y, x[1], x[3]], m)), S.start.x, S.start.y, x[0], x[1], x[2], x[3]);
        case "A":
          var v = x[0], _ = x[1], w = x[2], C = x[3], F = x[4], c = x[5], f = x[6];
          return F += c * l / S.pathLength, we.getPointOnEllipticalArc(v, _, w, C, F, f);
      }
      return null;
    }
    static getPointOnLine(l, u, g, p, b, S, x) {
      S = S != null ? S : u, x = x != null ? x : g;
      const v = this.getLineLength(u, g, p, b);
      if (v < 1e-10)
        return { x: u, y: g };
      if (p === u)
        return { x: S, y: x + (b > g ? l : -l) };
      const _ = (b - g) / (p - u), w = Math.sqrt(l * l / (1 + _ * _)) * (p < u ? -1 : 1), C = _ * w;
      if (Math.abs(x - g - _ * (S - u)) < 1e-10)
        return { x: S + w, y: x + C };
      const F = ((S - u) * (p - u) + (x - g) * (b - g)) / (v * v), c = u + F * (p - u), f = g + F * (b - g), m = this.getLineLength(S, x, c, f), E = Math.sqrt(l * l - m * m), T = Math.sqrt(E * E / (1 + _ * _)) * (p < u ? -1 : 1), D = _ * T;
      return { x: c + T, y: f + D };
    }
    static getPointOnCubicBezier(l, u, g, p, b, S, x, v, _) {
      function w(E) {
        return E * E * E;
      }
      function C(E) {
        return 3 * E * E * (1 - E);
      }
      function F(E) {
        return 3 * E * (1 - E) * (1 - E);
      }
      function c(E) {
        return (1 - E) * (1 - E) * (1 - E);
      }
      const f = v * w(l) + S * C(l) + p * F(l) + u * c(l), m = _ * w(l) + x * C(l) + b * F(l) + g * c(l);
      return {
        x: f,
        y: m
      };
    }
    static getPointOnQuadraticBezier(l, u, g, p, b, S, x) {
      function v(c) {
        return c * c;
      }
      function _(c) {
        return 2 * c * (1 - c);
      }
      function w(c) {
        return (1 - c) * (1 - c);
      }
      const C = S * v(l) + p * _(l) + u * w(l), F = x * v(l) + b * _(l) + g * w(l);
      return {
        x: C,
        y: F
      };
    }
    static getPointOnEllipticalArc(l, u, g, p, b, S) {
      const x = Math.cos(S), v = Math.sin(S), _ = {
        x: g * Math.cos(b),
        y: p * Math.sin(b)
      };
      return {
        x: l + (_.x * x - _.y * v),
        y: u + (_.x * v + _.y * x)
      };
    }
    static parsePathData(l) {
      if (!l)
        return [];
      let u = l;
      const g = [
        "m",
        "M",
        "l",
        "L",
        "v",
        "V",
        "h",
        "H",
        "z",
        "Z",
        "c",
        "C",
        "q",
        "Q",
        "t",
        "T",
        "s",
        "S",
        "a",
        "A"
      ];
      u = u.replace(new RegExp(" ", "g"), ",");
      for (var p = 0; p < g.length; p++)
        u = u.replace(new RegExp(g[p], "g"), "|" + g[p]);
      const b = u.split("|"), S = [], x = [];
      let v = 0, _ = 0;
      const w = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi;
      let C;
      for (p = 1; p < b.length; p++) {
        let y = b[p], P = y.charAt(0);
        for (y = y.slice(1), x.length = 0; C = w.exec(y); )
          x.push(C[0]);
        const A = [];
        for (let G = 0, U = x.length; G < U; G++) {
          if (x[G] === "00") {
            A.push(0, 0);
            continue;
          }
          const K = parseFloat(x[G]);
          isNaN(K) ? A.push(0) : A.push(K);
        }
        for (; A.length > 0 && !isNaN(A[0]); ) {
          let G = "", U = [];
          const K = v, $ = _;
          var F, c, f, m, E, T, D, k, M, O;
          switch (P) {
            case "l":
              v += A.shift(), _ += A.shift(), G = "L", U.push(v, _);
              break;
            case "L":
              v = A.shift(), _ = A.shift(), U.push(v, _);
              break;
            case "m":
              var N = A.shift(), z = A.shift();
              if (v += N, _ += z, G = "M", S.length > 2 && S[S.length - 1].command === "z") {
                for (let X = S.length - 2; X >= 0; X--)
                  if (S[X].command === "M") {
                    v = S[X].points[0] + N, _ = S[X].points[1] + z;
                    break;
                  }
              }
              U.push(v, _), P = "l";
              break;
            case "M":
              v = A.shift(), _ = A.shift(), G = "M", U.push(v, _), P = "L";
              break;
            case "h":
              v += A.shift(), G = "L", U.push(v, _);
              break;
            case "H":
              v = A.shift(), G = "L", U.push(v, _);
              break;
            case "v":
              _ += A.shift(), G = "L", U.push(v, _);
              break;
            case "V":
              _ = A.shift(), G = "L", U.push(v, _);
              break;
            case "C":
              U.push(A.shift(), A.shift(), A.shift(), A.shift()), v = A.shift(), _ = A.shift(), U.push(v, _);
              break;
            case "c":
              U.push(v + A.shift(), _ + A.shift(), v + A.shift(), _ + A.shift()), v += A.shift(), _ += A.shift(), G = "C", U.push(v, _);
              break;
            case "S":
              c = v, f = _, F = S[S.length - 1], F.command === "C" && (c = v + (v - F.points[2]), f = _ + (_ - F.points[3])), U.push(c, f, A.shift(), A.shift()), v = A.shift(), _ = A.shift(), G = "C", U.push(v, _);
              break;
            case "s":
              c = v, f = _, F = S[S.length - 1], F.command === "C" && (c = v + (v - F.points[2]), f = _ + (_ - F.points[3])), U.push(c, f, v + A.shift(), _ + A.shift()), v += A.shift(), _ += A.shift(), G = "C", U.push(v, _);
              break;
            case "Q":
              U.push(A.shift(), A.shift()), v = A.shift(), _ = A.shift(), U.push(v, _);
              break;
            case "q":
              U.push(v + A.shift(), _ + A.shift()), v += A.shift(), _ += A.shift(), G = "Q", U.push(v, _);
              break;
            case "T":
              c = v, f = _, F = S[S.length - 1], F.command === "Q" && (c = v + (v - F.points[0]), f = _ + (_ - F.points[1])), v = A.shift(), _ = A.shift(), G = "Q", U.push(c, f, v, _);
              break;
            case "t":
              c = v, f = _, F = S[S.length - 1], F.command === "Q" && (c = v + (v - F.points[0]), f = _ + (_ - F.points[1])), v += A.shift(), _ += A.shift(), G = "Q", U.push(c, f, v, _);
              break;
            case "A":
              m = A.shift(), E = A.shift(), T = A.shift(), D = A.shift(), k = A.shift(), M = v, O = _, v = A.shift(), _ = A.shift(), G = "A", U = this.convertEndpointToCenterParameterization(M, O, v, _, D, k, m, E, T);
              break;
            case "a":
              m = A.shift(), E = A.shift(), T = A.shift(), D = A.shift(), k = A.shift(), M = v, O = _, v += A.shift(), _ += A.shift(), G = "A", U = this.convertEndpointToCenterParameterization(M, O, v, _, D, k, m, E, T);
              break;
          }
          S.push({
            command: G || P,
            points: U,
            start: {
              x: K,
              y: $
            },
            pathLength: this.calcLength(K, $, G || P, U)
          });
        }
        (P === "z" || P === "Z") && S.push({
          command: "z",
          points: [],
          start: void 0,
          pathLength: 0
        });
      }
      return S;
    }
    static calcLength(l, u, g, p) {
      let b, S, x, v;
      const _ = we;
      switch (g) {
        case "L":
          return _.getLineLength(l, u, p[0], p[1]);
        case "C":
          return (0, s.getCubicArcLength)([l, p[0], p[2], p[4]], [u, p[1], p[3], p[5]], 1);
        case "Q":
          return (0, s.getQuadraticArcLength)([l, p[0], p[2]], [u, p[1], p[3]], 1);
        case "A":
          b = 0;
          var w = p[4], C = p[5], F = p[4] + C, c = Math.PI / 180;
          if (Math.abs(w - F) < c && (c = Math.abs(w - F)), S = _.getPointOnEllipticalArc(p[0], p[1], p[2], p[3], w, 0), C < 0)
            for (v = w - c; v > F; v -= c)
              x = _.getPointOnEllipticalArc(p[0], p[1], p[2], p[3], v, 0), b += _.getLineLength(S.x, S.y, x.x, x.y), S = x;
          else
            for (v = w + c; v < F; v += c)
              x = _.getPointOnEllipticalArc(p[0], p[1], p[2], p[3], v, 0), b += _.getLineLength(S.x, S.y, x.x, x.y), S = x;
          return x = _.getPointOnEllipticalArc(p[0], p[1], p[2], p[3], F, 0), b += _.getLineLength(S.x, S.y, x.x, x.y), b;
      }
      return 0;
    }
    static convertEndpointToCenterParameterization(l, u, g, p, b, S, x, v, _) {
      const w = _ * (Math.PI / 180), C = Math.cos(w) * (l - g) / 2 + Math.sin(w) * (u - p) / 2, F = -1 * Math.sin(w) * (l - g) / 2 + Math.cos(w) * (u - p) / 2, c = C * C / (x * x) + F * F / (v * v);
      c > 1 && (x *= Math.sqrt(c), v *= Math.sqrt(c));
      let f = Math.sqrt((x * x * (v * v) - x * x * (F * F) - v * v * (C * C)) / (x * x * (F * F) + v * v * (C * C)));
      b === S && (f *= -1), isNaN(f) && (f = 0);
      const m = f * x * F / v, E = f * -v * C / x, T = (l + g) / 2 + Math.cos(w) * m - Math.sin(w) * E, D = (u + p) / 2 + Math.sin(w) * m + Math.cos(w) * E, k = function(A) {
        return Math.sqrt(A[0] * A[0] + A[1] * A[1]);
      }, M = function(A, G) {
        return (A[0] * G[0] + A[1] * G[1]) / (k(A) * k(G));
      }, O = function(A, G) {
        return (A[0] * G[1] < A[1] * G[0] ? -1 : 1) * Math.acos(M(A, G));
      }, N = O([1, 0], [(C - m) / x, (F - E) / v]), z = [(C - m) / x, (F - E) / v], y = [(-1 * C - m) / x, (-1 * F - E) / v];
      let P = O(z, y);
      return M(z, y) <= -1 && (P = Math.PI), M(z, y) >= 1 && (P = 0), S === 0 && P > 0 && (P = P - 2 * Math.PI), S === 1 && P < 0 && (P = P + 2 * Math.PI), [T, D, x, v, N, P, w, S];
    }
  };
  return Mi.Path = h, h.prototype.className = "Path", h.prototype._attrsAffectingSize = ["data"], (0, i._registerNode)(h), r.Factory.addGetterSetter(h, "data"), Mi;
}
var nd;
function p6() {
  if (nd) return Ii;
  nd = 1, Object.defineProperty(Ii, "__esModule", { value: !0 }), Ii.Arrow = void 0;
  const r = Tt(), a = ng(), i = Ot(), s = Rt(), h = il();
  let o = class extends a.Line {
    _sceneFunc(u) {
      super._sceneFunc(u);
      const g = Math.PI * 2, p = this.points();
      let b = p;
      const S = this.tension() !== 0 && p.length > 4;
      S && (b = this.getTensionPoints());
      const x = this.pointerLength(), v = p.length;
      let _, w;
      if (S) {
        const c = [
          b[b.length - 4],
          b[b.length - 3],
          b[b.length - 2],
          b[b.length - 1],
          p[v - 2],
          p[v - 1]
        ], f = h.Path.calcLength(b[b.length - 4], b[b.length - 3], "C", c), m = h.Path.getPointOnQuadraticBezier(Math.min(1, 1 - x / f), c[0], c[1], c[2], c[3], c[4], c[5]);
        _ = p[v - 2] - m.x, w = p[v - 1] - m.y;
      } else
        _ = p[v - 2] - p[v - 4], w = p[v - 1] - p[v - 3];
      const C = (Math.atan2(w, _) + g) % g, F = this.pointerWidth();
      this.pointerAtEnding() && (u.save(), u.beginPath(), u.translate(p[v - 2], p[v - 1]), u.rotate(C), u.moveTo(0, 0), u.lineTo(-x, F / 2), u.lineTo(-x, -F / 2), u.closePath(), u.restore(), this.__fillStroke(u)), this.pointerAtBeginning() && (u.save(), u.beginPath(), u.translate(p[0], p[1]), S ? (_ = (b[0] + b[2]) / 2 - p[0], w = (b[1] + b[3]) / 2 - p[1]) : (_ = p[2] - p[0], w = p[3] - p[1]), u.rotate((Math.atan2(-w, -_) + g) % g), u.moveTo(0, 0), u.lineTo(-x, F / 2), u.lineTo(-x, -F / 2), u.closePath(), u.restore(), this.__fillStroke(u));
    }
    __fillStroke(u) {
      const g = this.dashEnabled();
      g && (this.attrs.dashEnabled = !1, u.setLineDash([])), u.fillStrokeShape(this), g && (this.attrs.dashEnabled = !0);
    }
    getSelfRect() {
      const u = super.getSelfRect(), g = this.pointerWidth() / 2;
      return {
        x: u.x - g,
        y: u.y - g,
        width: u.width + g * 2,
        height: u.height + g * 2
      };
    }
  };
  return Ii.Arrow = o, o.prototype.className = "Arrow", (0, s._registerNode)(o), r.Factory.addGetterSetter(o, "pointerLength", 10, (0, i.getNumberValidator)()), r.Factory.addGetterSetter(o, "pointerWidth", 10, (0, i.getNumberValidator)()), r.Factory.addGetterSetter(o, "pointerAtBeginning", !1), r.Factory.addGetterSetter(o, "pointerAtEnding", !0), Ii;
}
var Li = {}, ad;
function _6() {
  if (ad) return Li;
  ad = 1, Object.defineProperty(Li, "__esModule", { value: !0 }), Li.Circle = void 0;
  const r = Tt(), a = oe(), i = Ot(), s = Rt();
  let h = class extends a.Shape {
    _sceneFunc(l) {
      l.beginPath(), l.arc(0, 0, this.attrs.radius || 0, 0, Math.PI * 2, !1), l.closePath(), l.fillStrokeShape(this);
    }
    getWidth() {
      return this.radius() * 2;
    }
    getHeight() {
      return this.radius() * 2;
    }
    setWidth(l) {
      this.radius() !== l / 2 && this.radius(l / 2);
    }
    setHeight(l) {
      this.radius() !== l / 2 && this.radius(l / 2);
    }
  };
  return Li.Circle = h, h.prototype._centroid = !0, h.prototype.className = "Circle", h.prototype._attrsAffectingSize = ["radius"], (0, s._registerNode)(h), r.Factory.addGetterSetter(h, "radius", 0, (0, i.getNumberValidator)()), Li;
}
var Ni = {}, sd;
function v6() {
  if (sd) return Ni;
  sd = 1, Object.defineProperty(Ni, "__esModule", { value: !0 }), Ni.Ellipse = void 0;
  const r = Tt(), a = oe(), i = Ot(), s = Rt();
  let h = class extends a.Shape {
    _sceneFunc(l) {
      const u = this.radiusX(), g = this.radiusY();
      l.beginPath(), l.save(), u !== g && l.scale(1, g / u), l.arc(0, 0, u, 0, Math.PI * 2, !1), l.restore(), l.closePath(), l.fillStrokeShape(this);
    }
    getWidth() {
      return this.radiusX() * 2;
    }
    getHeight() {
      return this.radiusY() * 2;
    }
    setWidth(l) {
      this.radiusX(l / 2);
    }
    setHeight(l) {
      this.radiusY(l / 2);
    }
  };
  return Ni.Ellipse = h, h.prototype.className = "Ellipse", h.prototype._centroid = !0, h.prototype._attrsAffectingSize = ["radiusX", "radiusY"], (0, s._registerNode)(h), r.Factory.addComponentsGetterSetter(h, "radius", ["x", "y"]), r.Factory.addGetterSetter(h, "radiusX", 0, (0, i.getNumberValidator)()), r.Factory.addGetterSetter(h, "radiusY", 0, (0, i.getNumberValidator)()), Ni;
}
var Gi = {}, od;
function y6() {
  if (od) return Gi;
  od = 1, Object.defineProperty(Gi, "__esModule", { value: !0 }), Gi.Image = void 0;
  const r = Kt(), a = Tt(), i = oe(), s = Rt(), h = Ot();
  let o = class ag extends i.Shape {
    constructor(u) {
      super(u), this.on("imageChange.konva", () => {
        this._setImageLoad();
      }), this._setImageLoad();
    }
    _setImageLoad() {
      const u = this.image();
      u && u.complete || u && u.readyState === 4 || u && u.addEventListener && u.addEventListener("load", () => {
        this._requestDraw();
      });
    }
    _useBufferCanvas() {
      const u = !!this.cornerRadius(), g = this.hasShadow();
      return u && g ? !0 : super._useBufferCanvas(!0);
    }
    _sceneFunc(u) {
      const g = this.getWidth(), p = this.getHeight(), b = this.cornerRadius(), S = this.attrs.image;
      let x;
      if (S) {
        const v = this.attrs.cropWidth, _ = this.attrs.cropHeight;
        v && _ ? x = [
          S,
          this.cropX(),
          this.cropY(),
          v,
          _,
          0,
          0,
          g,
          p
        ] : x = [S, 0, 0, g, p];
      }
      (this.hasFill() || this.hasStroke() || b) && (u.beginPath(), b ? r.Util.drawRoundedRectPath(u, g, p, b) : u.rect(0, 0, g, p), u.closePath(), u.fillStrokeShape(this)), S && (b && u.clip(), u.drawImage.apply(u, x));
    }
    _hitFunc(u) {
      const g = this.width(), p = this.height(), b = this.cornerRadius();
      u.beginPath(), b ? r.Util.drawRoundedRectPath(u, g, p, b) : u.rect(0, 0, g, p), u.closePath(), u.fillStrokeShape(this);
    }
    getWidth() {
      var u, g;
      return (u = this.attrs.width) !== null && u !== void 0 ? u : (g = this.image()) === null || g === void 0 ? void 0 : g.width;
    }
    getHeight() {
      var u, g;
      return (u = this.attrs.height) !== null && u !== void 0 ? u : (g = this.image()) === null || g === void 0 ? void 0 : g.height;
    }
    static fromURL(u, g, p = null) {
      const b = r.Util.createImageElement();
      b.onload = function() {
        const S = new ag({
          image: b
        });
        g(S);
      }, b.onerror = p, b.crossOrigin = "Anonymous", b.src = u;
    }
  };
  return Gi.Image = o, o.prototype.className = "Image", (0, s._registerNode)(o), a.Factory.addGetterSetter(o, "cornerRadius", 0, (0, h.getNumberOrArrayOfNumbersValidator)(4)), a.Factory.addGetterSetter(o, "image"), a.Factory.addComponentsGetterSetter(o, "crop", ["x", "y", "width", "height"]), a.Factory.addGetterSetter(o, "cropX", 0, (0, h.getNumberValidator)()), a.Factory.addGetterSetter(o, "cropY", 0, (0, h.getNumberValidator)()), a.Factory.addGetterSetter(o, "cropWidth", 0, (0, h.getNumberValidator)()), a.Factory.addGetterSetter(o, "cropHeight", 0, (0, h.getNumberValidator)()), Gi;
}
var Nr = {}, hd;
function m6() {
  if (hd) return Nr;
  hd = 1, Object.defineProperty(Nr, "__esModule", { value: !0 }), Nr.Tag = Nr.Label = void 0;
  const r = Tt(), a = oe(), i = el(), s = Ot(), h = Rt(), o = [
    "fontFamily",
    "fontSize",
    "fontStyle",
    "padding",
    "lineHeight",
    "text",
    "width",
    "height",
    "pointerDirection",
    "pointerWidth",
    "pointerHeight"
  ], l = "Change.konva", u = "none", g = "up", p = "right", b = "down", S = "left", x = o.length;
  let v = class extends i.Group {
    constructor(C) {
      super(C), this.on("add.konva", function(F) {
        this._addListeners(F.child), this._sync();
      });
    }
    getText() {
      return this.find("Text")[0];
    }
    getTag() {
      return this.find("Tag")[0];
    }
    _addListeners(C) {
      let F = this, c;
      const f = function() {
        F._sync();
      };
      for (c = 0; c < x; c++)
        C.on(o[c] + l, f);
    }
    getWidth() {
      return this.getText().width();
    }
    getHeight() {
      return this.getText().height();
    }
    _sync() {
      let C = this.getText(), F = this.getTag(), c, f, m, E, T, D, k;
      if (C && F) {
        switch (c = C.width(), f = C.height(), m = F.pointerDirection(), E = F.pointerWidth(), k = F.pointerHeight(), T = 0, D = 0, m) {
          case g:
            T = c / 2, D = -1 * k;
            break;
          case p:
            T = c + E, D = f / 2;
            break;
          case b:
            T = c / 2, D = f + k;
            break;
          case S:
            T = -1 * E, D = f / 2;
            break;
        }
        F.setAttrs({
          x: -1 * T,
          y: -1 * D,
          width: c,
          height: f
        }), C.setAttrs({
          x: -1 * T,
          y: -1 * D
        });
      }
    }
  };
  Nr.Label = v, v.prototype.className = "Label", (0, h._registerNode)(v);
  class _ extends a.Shape {
    _sceneFunc(C) {
      const F = this.width(), c = this.height(), f = this.pointerDirection(), m = this.pointerWidth(), E = this.pointerHeight(), T = this.cornerRadius();
      let D = 0, k = 0, M = 0, O = 0;
      typeof T == "number" ? D = k = M = O = Math.min(T, F / 2, c / 2) : (D = Math.min(T[0] || 0, F / 2, c / 2), k = Math.min(T[1] || 0, F / 2, c / 2), O = Math.min(T[2] || 0, F / 2, c / 2), M = Math.min(T[3] || 0, F / 2, c / 2)), C.beginPath(), C.moveTo(D, 0), f === g && (C.lineTo((F - m) / 2, 0), C.lineTo(F / 2, -1 * E), C.lineTo((F + m) / 2, 0)), C.lineTo(F - k, 0), C.arc(F - k, k, k, Math.PI * 3 / 2, 0, !1), f === p && (C.lineTo(F, (c - E) / 2), C.lineTo(F + m, c / 2), C.lineTo(F, (c + E) / 2)), C.lineTo(F, c - O), C.arc(F - O, c - O, O, 0, Math.PI / 2, !1), f === b && (C.lineTo((F + m) / 2, c), C.lineTo(F / 2, c + E), C.lineTo((F - m) / 2, c)), C.lineTo(M, c), C.arc(M, c - M, M, Math.PI / 2, Math.PI, !1), f === S && (C.lineTo(0, (c + E) / 2), C.lineTo(-1 * m, c / 2), C.lineTo(0, (c - E) / 2)), C.lineTo(0, D), C.arc(D, D, D, Math.PI, Math.PI * 3 / 2, !1), C.closePath(), C.fillStrokeShape(this);
    }
    getSelfRect() {
      let C = 0, F = 0, c = this.pointerWidth(), f = this.pointerHeight(), m = this.pointerDirection(), E = this.width(), T = this.height();
      return m === g ? (F -= f, T += f) : m === b ? T += f : m === S ? (C -= c * 1.5, E += c) : m === p && (E += c * 1.5), {
        x: C,
        y: F,
        width: E,
        height: T
      };
    }
  }
  return Nr.Tag = _, _.prototype.className = "Tag", (0, h._registerNode)(_), r.Factory.addGetterSetter(_, "pointerDirection", u), r.Factory.addGetterSetter(_, "pointerWidth", 0, (0, s.getNumberValidator)()), r.Factory.addGetterSetter(_, "pointerHeight", 0, (0, s.getNumberValidator)()), r.Factory.addGetterSetter(_, "cornerRadius", 0, (0, s.getNumberOrArrayOfNumbersValidator)(4)), Nr;
}
var Di = {}, ld;
function sg() {
  if (ld) return Di;
  ld = 1, Object.defineProperty(Di, "__esModule", { value: !0 }), Di.Rect = void 0;
  const r = Tt(), a = oe(), i = Rt(), s = Kt(), h = Ot();
  let o = class extends a.Shape {
    _sceneFunc(u) {
      const g = this.cornerRadius(), p = this.width(), b = this.height();
      u.beginPath(), g ? s.Util.drawRoundedRectPath(u, p, b, g) : u.rect(0, 0, p, b), u.closePath(), u.fillStrokeShape(this);
    }
  };
  return Di.Rect = o, o.prototype.className = "Rect", (0, i._registerNode)(o), r.Factory.addGetterSetter(o, "cornerRadius", 0, (0, h.getNumberOrArrayOfNumbersValidator)(4)), Di;
}
var Bi = {}, ud;
function b6() {
  if (ud) return Bi;
  ud = 1, Object.defineProperty(Bi, "__esModule", { value: !0 }), Bi.RegularPolygon = void 0;
  const r = Tt(), a = oe(), i = Ot(), s = Rt();
  let h = class extends a.Shape {
    _sceneFunc(l) {
      const u = this._getPoints();
      l.beginPath(), l.moveTo(u[0].x, u[0].y);
      for (let g = 1; g < u.length; g++)
        l.lineTo(u[g].x, u[g].y);
      l.closePath(), l.fillStrokeShape(this);
    }
    _getPoints() {
      const l = this.attrs.sides, u = this.attrs.radius || 0, g = [];
      for (let p = 0; p < l; p++)
        g.push({
          x: u * Math.sin(p * 2 * Math.PI / l),
          y: -1 * u * Math.cos(p * 2 * Math.PI / l)
        });
      return g;
    }
    getSelfRect() {
      const l = this._getPoints();
      let u = l[0].x, g = l[0].y, p = l[0].x, b = l[0].y;
      return l.forEach((S) => {
        u = Math.min(u, S.x), g = Math.max(g, S.x), p = Math.min(p, S.y), b = Math.max(b, S.y);
      }), {
        x: u,
        y: p,
        width: g - u,
        height: b - p
      };
    }
    getWidth() {
      return this.radius() * 2;
    }
    getHeight() {
      return this.radius() * 2;
    }
    setWidth(l) {
      this.radius(l / 2);
    }
    setHeight(l) {
      this.radius(l / 2);
    }
  };
  return Bi.RegularPolygon = h, h.prototype.className = "RegularPolygon", h.prototype._centroid = !0, h.prototype._attrsAffectingSize = ["radius"], (0, s._registerNode)(h), r.Factory.addGetterSetter(h, "radius", 0, (0, i.getNumberValidator)()), r.Factory.addGetterSetter(h, "sides", 0, (0, i.getNumberValidator)()), Bi;
}
var Ui = {}, cd;
function S6() {
  if (cd) return Ui;
  cd = 1, Object.defineProperty(Ui, "__esModule", { value: !0 }), Ui.Ring = void 0;
  const r = Tt(), a = oe(), i = Ot(), s = Rt(), h = Math.PI * 2;
  let o = class extends a.Shape {
    _sceneFunc(u) {
      u.beginPath(), u.arc(0, 0, this.innerRadius(), 0, h, !1), u.moveTo(this.outerRadius(), 0), u.arc(0, 0, this.outerRadius(), h, 0, !0), u.closePath(), u.fillStrokeShape(this);
    }
    getWidth() {
      return this.outerRadius() * 2;
    }
    getHeight() {
      return this.outerRadius() * 2;
    }
    setWidth(u) {
      this.outerRadius(u / 2);
    }
    setHeight(u) {
      this.outerRadius(u / 2);
    }
  };
  return Ui.Ring = o, o.prototype.className = "Ring", o.prototype._centroid = !0, o.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"], (0, s._registerNode)(o), r.Factory.addGetterSetter(o, "innerRadius", 0, (0, i.getNumberValidator)()), r.Factory.addGetterSetter(o, "outerRadius", 0, (0, i.getNumberValidator)()), Ui;
}
var qi = {}, dd;
function w6() {
  if (dd) return qi;
  dd = 1, Object.defineProperty(qi, "__esModule", { value: !0 }), qi.Sprite = void 0;
  const r = Tt(), a = oe(), i = rl(), s = Ot(), h = Rt();
  let o = class extends a.Shape {
    constructor(u) {
      super(u), this._updated = !0, this.anim = new i.Animation(() => {
        const g = this._updated;
        return this._updated = !1, g;
      }), this.on("animationChange.konva", function() {
        this.frameIndex(0);
      }), this.on("frameIndexChange.konva", function() {
        this._updated = !0;
      }), this.on("frameRateChange.konva", function() {
        this.anim.isRunning() && (clearInterval(this.interval), this._setInterval());
      });
    }
    _sceneFunc(u) {
      const g = this.animation(), p = this.frameIndex(), b = p * 4, S = this.animations()[g], x = this.frameOffsets(), v = S[b + 0], _ = S[b + 1], w = S[b + 2], C = S[b + 3], F = this.image();
      if ((this.hasFill() || this.hasStroke()) && (u.beginPath(), u.rect(0, 0, w, C), u.closePath(), u.fillStrokeShape(this)), F)
        if (x) {
          const c = x[g], f = p * 2;
          u.drawImage(F, v, _, w, C, c[f + 0], c[f + 1], w, C);
        } else
          u.drawImage(F, v, _, w, C, 0, 0, w, C);
    }
    _hitFunc(u) {
      const g = this.animation(), p = this.frameIndex(), b = p * 4, S = this.animations()[g], x = this.frameOffsets(), v = S[b + 2], _ = S[b + 3];
      if (u.beginPath(), x) {
        const w = x[g], C = p * 2;
        u.rect(w[C + 0], w[C + 1], v, _);
      } else
        u.rect(0, 0, v, _);
      u.closePath(), u.fillShape(this);
    }
    _useBufferCanvas() {
      return super._useBufferCanvas(!0);
    }
    _setInterval() {
      const u = this;
      this.interval = setInterval(function() {
        u._updateIndex();
      }, 1e3 / this.frameRate());
    }
    start() {
      if (this.isRunning())
        return;
      const u = this.getLayer();
      this.anim.setLayers(u), this._setInterval(), this.anim.start();
    }
    stop() {
      this.anim.stop(), clearInterval(this.interval);
    }
    isRunning() {
      return this.anim.isRunning();
    }
    _updateIndex() {
      const u = this.frameIndex(), g = this.animation(), p = this.animations(), b = p[g], S = b.length / 4;
      u < S - 1 ? this.frameIndex(u + 1) : this.frameIndex(0);
    }
  };
  return qi.Sprite = o, o.prototype.className = "Sprite", (0, h._registerNode)(o), r.Factory.addGetterSetter(o, "animation"), r.Factory.addGetterSetter(o, "animations"), r.Factory.addGetterSetter(o, "frameOffsets"), r.Factory.addGetterSetter(o, "image"), r.Factory.addGetterSetter(o, "frameIndex", 0, (0, s.getNumberValidator)()), r.Factory.addGetterSetter(o, "frameRate", 17, (0, s.getNumberValidator)()), r.Factory.backCompat(o, {
    index: "frameIndex",
    getIndex: "getFrameIndex",
    setIndex: "setFrameIndex"
  }), qi;
}
var zi = {}, fd;
function C6() {
  if (fd) return zi;
  fd = 1, Object.defineProperty(zi, "__esModule", { value: !0 }), zi.Star = void 0;
  const r = Tt(), a = oe(), i = Ot(), s = Rt();
  let h = class extends a.Shape {
    _sceneFunc(l) {
      const u = this.innerRadius(), g = this.outerRadius(), p = this.numPoints();
      l.beginPath(), l.moveTo(0, 0 - g);
      for (let b = 1; b < p * 2; b++) {
        const S = b % 2 === 0 ? g : u, x = S * Math.sin(b * Math.PI / p), v = -1 * S * Math.cos(b * Math.PI / p);
        l.lineTo(x, v);
      }
      l.closePath(), l.fillStrokeShape(this);
    }
    getWidth() {
      return this.outerRadius() * 2;
    }
    getHeight() {
      return this.outerRadius() * 2;
    }
    setWidth(l) {
      this.outerRadius(l / 2);
    }
    setHeight(l) {
      this.outerRadius(l / 2);
    }
  };
  return zi.Star = h, h.prototype.className = "Star", h.prototype._centroid = !0, h.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"], (0, s._registerNode)(h), r.Factory.addGetterSetter(h, "numPoints", 5, (0, i.getNumberValidator)()), r.Factory.addGetterSetter(h, "innerRadius", 0, (0, i.getNumberValidator)()), r.Factory.addGetterSetter(h, "outerRadius", 0, (0, i.getNumberValidator)()), zi;
}
var ti = {}, gd;
function og() {
  if (gd) return ti;
  gd = 1, Object.defineProperty(ti, "__esModule", { value: !0 }), ti.Text = void 0, ti.stringToArray = l;
  const r = Kt(), a = Tt(), i = oe(), s = Rt(), h = Ot(), o = Rt();
  function l(st) {
    return [...st].reduce((Z, at, ht, ct) => (/\p{Emoji_Modifier_Base}\p{Emoji_Modifier}?(?:\u200D\p{Emoji_Presentation})+/u.test(at) ? Z.push(at) : /\p{Regional_Indicator}{2}/u.test(at + (ct[ht + 1] || "")) ? Z.push(at + ct[ht + 1]) : ht > 0 && /\p{Mn}|\p{Me}|\p{Mc}/u.test(at) ? Z[Z.length - 1] += at : Z.push(at), Z), []);
  }
  const u = "auto", g = "center", p = "inherit", b = "justify", S = "Change.konva", x = "2d", v = "-", _ = "left", w = "text", C = "Text", F = "top", c = "bottom", f = "middle", m = "normal", E = "px ", T = " ", D = "right", k = "rtl", M = "word", O = "char", N = "none", z = "…", y = [
    "direction",
    "fontFamily",
    "fontSize",
    "fontStyle",
    "fontVariant",
    "padding",
    "align",
    "verticalAlign",
    "lineHeight",
    "text",
    "width",
    "height",
    "wrap",
    "ellipsis",
    "letterSpacing"
  ], P = y.length;
  function A(st) {
    return st.split(",").map((Z) => {
      Z = Z.trim();
      const at = Z.indexOf(" ") >= 0, ht = Z.indexOf('"') >= 0 || Z.indexOf("'") >= 0;
      return at && !ht && (Z = `"${Z}"`), Z;
    }).join(", ");
  }
  let G;
  function U() {
    return G || (G = r.Util.createCanvasElement().getContext(x), G);
  }
  function K(st) {
    st.fillText(this._partialText, this._partialTextX, this._partialTextY);
  }
  function $(st) {
    st.setAttr("miterLimit", 2), st.strokeText(this._partialText, this._partialTextX, this._partialTextY);
  }
  function X(st) {
    return st = st || {}, !st.fillLinearGradientColorStops && !st.fillRadialGradientColorStops && !st.fillPatternImage && (st.fill = st.fill || "black"), st;
  }
  let Q = class extends i.Shape {
    constructor(Z) {
      super(X(Z)), this._partialTextX = 0, this._partialTextY = 0;
      for (let at = 0; at < P; at++)
        this.on(y[at] + S, this._setTextData);
      this._setTextData();
    }
    _sceneFunc(Z) {
      const at = this.textArr, ht = at.length;
      if (!this.text())
        return;
      let ct = this.padding(), H = this.fontSize(), j = this.lineHeight() * H, et = this.verticalAlign(), ut = this.direction(), gt = 0, pt = this.align(), Mt = this.getWidth(), Et = this.letterSpacing(), mt = this.fill(), re = this.textDecoration(), Pt = re.indexOf("underline") !== -1, Ht = re.indexOf("line-through") !== -1, pr;
      ut = ut === p ? Z.direction : ut;
      let ie = j / 2, Zt = f;
      if (s.Konva._fixTextRendering) {
        const Ze = this.measureSize("M");
        Zt = "alphabetic", ie = (Ze.fontBoundingBoxAscent - Ze.fontBoundingBoxDescent) / 2 + j / 2;
      }
      var Jt = 0, Ut = 0;
      for (ut === k && Z.setAttr("direction", ut), Z.setAttr("font", this._getContextFont()), Z.setAttr("textBaseline", Zt), Z.setAttr("textAlign", _), et === f ? gt = (this.getHeight() - ht * j - ct * 2) / 2 : et === c && (gt = this.getHeight() - ht * j - ct * 2), Z.translate(ct, gt + ct), pr = 0; pr < ht; pr++) {
        var Jt = 0, Ut = 0, ze = at[pr], ne = ze.text, He = ze.width, Vt = ze.lastInParagraph, ae, Oe, _e;
        if (Z.save(), pt === D ? Jt += Mt - He - ct * 2 : pt === g && (Jt += (Mt - He - ct * 2) / 2), Pt) {
          Z.save(), Z.beginPath();
          const We = s.Konva._fixTextRendering ? Math.round(H / 4) : Math.round(H / 2), Ie = Jt, Je = ie + Ut + We;
          Z.moveTo(Ie, Je), ae = ne.split(" ").length - 1, Oe = ae === 0, _e = pt === b && !Vt ? Mt - ct * 2 : He, Z.lineTo(Ie + Math.round(_e), Je), Z.lineWidth = H / 15;
          const oi = this._getLinearGradient();
          Z.strokeStyle = oi || mt, Z.stroke(), Z.restore();
        }
        if (Ht) {
          Z.save(), Z.beginPath();
          const We = s.Konva._fixTextRendering ? -Math.round(H / 4) : 0;
          Z.moveTo(Jt, ie + Ut + We), ae = ne.split(" ").length - 1, Oe = ae === 0, _e = pt === b && Vt && !Oe ? Mt - ct * 2 : He, Z.lineTo(Jt + Math.round(_e), ie + Ut + We), Z.lineWidth = H / 15;
          const Ie = this._getLinearGradient();
          Z.strokeStyle = Ie || mt, Z.stroke(), Z.restore();
        }
        if (ut !== k && (Et !== 0 || pt === b)) {
          ae = ne.split(" ").length - 1;
          const We = l(ne);
          for (let Ie = 0; Ie < We.length; Ie++) {
            const Je = We[Ie];
            Je === " " && !Vt && pt === b && (Jt += (Mt - ct * 2 - He) / ae), this._partialTextX = Jt, this._partialTextY = ie + Ut, this._partialText = Je, Z.fillStrokeShape(this), Jt += this.measureSize(Je).width + Et;
          }
        } else
          Et !== 0 && Z.setAttr("letterSpacing", `${Et}px`), this._partialTextX = Jt, this._partialTextY = ie + Ut, this._partialText = ne, Z.fillStrokeShape(this);
        Z.restore(), ht > 1 && (ie += j);
      }
    }
    _hitFunc(Z) {
      const at = this.getWidth(), ht = this.getHeight();
      Z.beginPath(), Z.rect(0, 0, at, ht), Z.closePath(), Z.fillStrokeShape(this);
    }
    setText(Z) {
      const at = r.Util._isString(Z) ? Z : Z == null ? "" : Z + "";
      return this._setAttr(w, at), this;
    }
    getWidth() {
      return this.attrs.width === u || this.attrs.width === void 0 ? this.getTextWidth() + this.padding() * 2 : this.attrs.width;
    }
    getHeight() {
      return this.attrs.height === u || this.attrs.height === void 0 ? this.fontSize() * this.textArr.length * this.lineHeight() + this.padding() * 2 : this.attrs.height;
    }
    getTextWidth() {
      return this.textWidth;
    }
    getTextHeight() {
      return r.Util.warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height."), this.textHeight;
    }
    measureSize(Z) {
      var at, ht, ct, H, j, et, ut, gt, pt, Mt, Et;
      let mt = U(), re = this.fontSize(), Pt;
      mt.save(), mt.font = this._getContextFont(), Pt = mt.measureText(Z), mt.restore();
      const Ht = re / 100;
      return {
        actualBoundingBoxAscent: (at = Pt.actualBoundingBoxAscent) !== null && at !== void 0 ? at : 71.58203125 * Ht,
        actualBoundingBoxDescent: (ht = Pt.actualBoundingBoxDescent) !== null && ht !== void 0 ? ht : 0,
        actualBoundingBoxLeft: (ct = Pt.actualBoundingBoxLeft) !== null && ct !== void 0 ? ct : -7.421875 * Ht,
        actualBoundingBoxRight: (H = Pt.actualBoundingBoxRight) !== null && H !== void 0 ? H : 75.732421875 * Ht,
        alphabeticBaseline: (j = Pt.alphabeticBaseline) !== null && j !== void 0 ? j : 0,
        emHeightAscent: (et = Pt.emHeightAscent) !== null && et !== void 0 ? et : 100 * Ht,
        emHeightDescent: (ut = Pt.emHeightDescent) !== null && ut !== void 0 ? ut : -20 * Ht,
        fontBoundingBoxAscent: (gt = Pt.fontBoundingBoxAscent) !== null && gt !== void 0 ? gt : 91 * Ht,
        fontBoundingBoxDescent: (pt = Pt.fontBoundingBoxDescent) !== null && pt !== void 0 ? pt : 21 * Ht,
        hangingBaseline: (Mt = Pt.hangingBaseline) !== null && Mt !== void 0 ? Mt : 72.80000305175781 * Ht,
        ideographicBaseline: (Et = Pt.ideographicBaseline) !== null && Et !== void 0 ? Et : -21 * Ht,
        width: Pt.width,
        height: re
      };
    }
    _getContextFont() {
      return this.fontStyle() + T + this.fontVariant() + T + (this.fontSize() + E) + A(this.fontFamily());
    }
    _addTextLine(Z) {
      this.align() === b && (Z = Z.trim());
      const ht = this._getTextWidth(Z);
      return this.textArr.push({
        text: Z,
        width: ht,
        lastInParagraph: !1
      });
    }
    _getTextWidth(Z) {
      const at = this.letterSpacing(), ht = Z.length;
      return U().measureText(Z).width + (ht ? at * (ht - 1) : 0);
    }
    _setTextData() {
      let Z = this.text().split(`
`), at = +this.fontSize(), ht = 0, ct = this.lineHeight() * at, H = this.attrs.width, j = this.attrs.height, et = H !== u && H !== void 0, ut = j !== u && j !== void 0, gt = this.padding(), pt = H - gt * 2, Mt = j - gt * 2, Et = 0, mt = this.wrap(), re = mt !== N, Pt = mt !== O && re, Ht = this.ellipsis();
      this.textArr = [], U().font = this._getContextFont();
      const pr = Ht ? this._getTextWidth(z) : 0;
      for (let Zt = 0, Jt = Z.length; Zt < Jt; ++Zt) {
        let Ut = Z[Zt], ze = this._getTextWidth(Ut);
        if (et && ze > pt)
          for (; Ut.length > 0; ) {
            let ne = 0, He = Ut.length, Vt = "", ae = 0;
            for (; ne < He; ) {
              const Oe = ne + He >>> 1, _e = Ut.slice(0, Oe + 1), Ze = this._getTextWidth(_e) + pr;
              Ze <= pt ? (ne = Oe + 1, Vt = _e, ae = Ze) : He = Oe;
            }
            if (Vt) {
              if (Pt) {
                var ie;
                const _e = Ut[Vt.length];
                (_e === T || _e === v) && ae <= pt ? ie = Vt.length : ie = Math.max(Vt.lastIndexOf(T), Vt.lastIndexOf(v)) + 1, ie > 0 && (ne = ie, Vt = Vt.slice(0, ne), ae = this._getTextWidth(Vt));
              }
              if (Vt = Vt.trimRight(), this._addTextLine(Vt), ht = Math.max(ht, ae), Et += ct, this._shouldHandleEllipsis(Et)) {
                this._tryToAddEllipsisToLastLine();
                break;
              }
              if (Ut = Ut.slice(ne), Ut = Ut.trimLeft(), Ut.length > 0 && (ze = this._getTextWidth(Ut), ze <= pt)) {
                this._addTextLine(Ut), Et += ct, ht = Math.max(ht, ze);
                break;
              }
            } else
              break;
          }
        else
          this._addTextLine(Ut), Et += ct, ht = Math.max(ht, ze), this._shouldHandleEllipsis(Et) && Zt < Jt - 1 && this._tryToAddEllipsisToLastLine();
        if (this.textArr[this.textArr.length - 1] && (this.textArr[this.textArr.length - 1].lastInParagraph = !0), ut && Et + ct > Mt)
          break;
      }
      this.textHeight = at, this.textWidth = ht;
    }
    _shouldHandleEllipsis(Z) {
      const at = +this.fontSize(), ht = this.lineHeight() * at, ct = this.attrs.height, H = ct !== u && ct !== void 0, j = this.padding(), et = ct - j * 2;
      return !(this.wrap() !== N) || H && Z + ht > et;
    }
    _tryToAddEllipsisToLastLine() {
      const Z = this.attrs.width, at = Z !== u && Z !== void 0, ht = this.padding(), ct = Z - ht * 2, H = this.ellipsis(), j = this.textArr[this.textArr.length - 1];
      !j || !H || (at && (this._getTextWidth(j.text + z) < ct || (j.text = j.text.slice(0, j.text.length - 3))), this.textArr.splice(this.textArr.length - 1, 1), this._addTextLine(j.text + z));
    }
    getStrokeScaleEnabled() {
      return !0;
    }
    _useBufferCanvas() {
      const Z = this.textDecoration().indexOf("underline") !== -1 || this.textDecoration().indexOf("line-through") !== -1, at = this.hasShadow();
      return Z && at ? !0 : super._useBufferCanvas();
    }
  };
  return ti.Text = Q, Q.prototype._fillFunc = K, Q.prototype._strokeFunc = $, Q.prototype.className = C, Q.prototype._attrsAffectingSize = [
    "text",
    "fontSize",
    "padding",
    "wrap",
    "lineHeight",
    "letterSpacing"
  ], (0, o._registerNode)(Q), a.Factory.overWriteSetter(Q, "width", (0, h.getNumberOrAutoValidator)()), a.Factory.overWriteSetter(Q, "height", (0, h.getNumberOrAutoValidator)()), a.Factory.addGetterSetter(Q, "direction", p), a.Factory.addGetterSetter(Q, "fontFamily", "Arial"), a.Factory.addGetterSetter(Q, "fontSize", 12, (0, h.getNumberValidator)()), a.Factory.addGetterSetter(Q, "fontStyle", m), a.Factory.addGetterSetter(Q, "fontVariant", m), a.Factory.addGetterSetter(Q, "padding", 0, (0, h.getNumberValidator)()), a.Factory.addGetterSetter(Q, "align", _), a.Factory.addGetterSetter(Q, "verticalAlign", F), a.Factory.addGetterSetter(Q, "lineHeight", 1, (0, h.getNumberValidator)()), a.Factory.addGetterSetter(Q, "wrap", M), a.Factory.addGetterSetter(Q, "ellipsis", !1, (0, h.getBooleanValidator)()), a.Factory.addGetterSetter(Q, "letterSpacing", 0, (0, h.getNumberValidator)()), a.Factory.addGetterSetter(Q, "text", "", (0, h.getStringValidator)()), a.Factory.addGetterSetter(Q, "textDecoration", ""), ti;
}
var Hi = {}, pd;
function x6() {
  if (pd) return Hi;
  pd = 1, Object.defineProperty(Hi, "__esModule", { value: !0 }), Hi.TextPath = void 0;
  const r = Kt(), a = Tt(), i = oe(), s = il(), h = og(), o = Ot(), l = Rt(), u = "", g = "normal";
  function p(x) {
    x.fillText(this.partialText, 0, 0);
  }
  function b(x) {
    x.strokeText(this.partialText, 0, 0);
  }
  let S = class extends i.Shape {
    constructor(v) {
      super(v), this.dummyCanvas = r.Util.createCanvasElement(), this.dataArray = [], this._readDataAttribute(), this.on("dataChange.konva", function() {
        this._readDataAttribute(), this._setTextData();
      }), this.on("textChange.konva alignChange.konva letterSpacingChange.konva kerningFuncChange.konva fontSizeChange.konva fontFamilyChange.konva", this._setTextData), this._setTextData();
    }
    _getTextPathLength() {
      return s.Path.getPathLength(this.dataArray);
    }
    _getPointAtLength(v) {
      if (!this.attrs.data)
        return null;
      const _ = this.pathLength;
      return v - 1 > _ ? null : s.Path.getPointAtLengthOfDataArray(v, this.dataArray);
    }
    _readDataAttribute() {
      this.dataArray = s.Path.parsePathData(this.attrs.data), this.pathLength = this._getTextPathLength();
    }
    _sceneFunc(v) {
      v.setAttr("font", this._getContextFont()), v.setAttr("textBaseline", this.textBaseline()), v.setAttr("textAlign", "left"), v.save();
      const _ = this.textDecoration(), w = this.fill(), C = this.fontSize(), F = this.glyphInfo;
      _ === "underline" && v.beginPath();
      for (let c = 0; c < F.length; c++) {
        v.save();
        const f = F[c].p0;
        v.translate(f.x, f.y), v.rotate(F[c].rotation), this.partialText = F[c].text, v.fillStrokeShape(this), _ === "underline" && (c === 0 && v.moveTo(0, C / 2 + 1), v.lineTo(C, C / 2 + 1)), v.restore();
      }
      _ === "underline" && (v.strokeStyle = w, v.lineWidth = C / 20, v.stroke()), v.restore();
    }
    _hitFunc(v) {
      v.beginPath();
      const _ = this.glyphInfo;
      if (_.length >= 1) {
        const w = _[0].p0;
        v.moveTo(w.x, w.y);
      }
      for (let w = 0; w < _.length; w++) {
        const C = _[w].p1;
        v.lineTo(C.x, C.y);
      }
      v.setAttr("lineWidth", this.fontSize()), v.setAttr("strokeStyle", this.colorKey), v.stroke();
    }
    getTextWidth() {
      return this.textWidth;
    }
    getTextHeight() {
      return r.Util.warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height."), this.textHeight;
    }
    setText(v) {
      return h.Text.prototype.setText.call(this, v);
    }
    _getContextFont() {
      return h.Text.prototype._getContextFont.call(this);
    }
    _getTextSize(v) {
      const w = this.dummyCanvas.getContext("2d");
      w.save(), w.font = this._getContextFont();
      const C = w.measureText(v);
      return w.restore(), {
        width: C.width,
        height: parseInt(`${this.fontSize()}`, 10)
      };
    }
    _setTextData() {
      const { width: v, height: _ } = this._getTextSize(this.attrs.text);
      if (this.textWidth = v, this.textHeight = _, this.glyphInfo = [], !this.attrs.data)
        return null;
      const w = this.letterSpacing(), C = this.align(), F = this.kerningFunc(), c = Math.max(this.textWidth + ((this.attrs.text || "").length - 1) * w, 0);
      let f = 0;
      C === "center" && (f = Math.max(0, this.pathLength / 2 - c / 2)), C === "right" && (f = Math.max(0, this.pathLength - c));
      const m = (0, h.stringToArray)(this.text());
      let E = f;
      for (let T = 0; T < m.length; T++) {
        const D = this._getPointAtLength(E);
        if (!D)
          return;
        let k = this._getTextSize(m[T]).width + w;
        if (m[T] === " " && C === "justify") {
          const P = this.text().split(" ").length - 1;
          k += (this.pathLength - c) / P;
        }
        const M = this._getPointAtLength(E + k);
        if (!M)
          return;
        const O = s.Path.getLineLength(D.x, D.y, M.x, M.y);
        let N = 0;
        if (F)
          try {
            N = F(m[T - 1], m[T]) * this.fontSize();
          } catch {
            N = 0;
          }
        D.x += N, M.x += N, this.textWidth += N;
        const z = s.Path.getPointOnLine(N + O / 2, D.x, D.y, M.x, M.y), y = Math.atan2(M.y - D.y, M.x - D.x);
        this.glyphInfo.push({
          transposeX: z.x,
          transposeY: z.y,
          text: m[T],
          rotation: y,
          p0: D,
          p1: M
        }), E += k;
      }
    }
    getSelfRect() {
      if (!this.glyphInfo.length)
        return {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      const v = [];
      this.glyphInfo.forEach(function(E) {
        v.push(E.p0.x), v.push(E.p0.y), v.push(E.p1.x), v.push(E.p1.y);
      });
      let _ = v[0] || 0, w = v[0] || 0, C = v[1] || 0, F = v[1] || 0, c, f;
      for (let E = 0; E < v.length / 2; E++)
        c = v[E * 2], f = v[E * 2 + 1], _ = Math.min(_, c), w = Math.max(w, c), C = Math.min(C, f), F = Math.max(F, f);
      const m = this.fontSize();
      return {
        x: _ - m / 2,
        y: C - m / 2,
        width: w - _ + m,
        height: F - C + m
      };
    }
    destroy() {
      return r.Util.releaseCanvas(this.dummyCanvas), super.destroy();
    }
  };
  return Hi.TextPath = S, S.prototype._fillFunc = p, S.prototype._strokeFunc = b, S.prototype._fillFuncHit = p, S.prototype._strokeFuncHit = b, S.prototype.className = "TextPath", S.prototype._attrsAffectingSize = ["text", "fontSize", "data"], (0, l._registerNode)(S), a.Factory.addGetterSetter(S, "data"), a.Factory.addGetterSetter(S, "fontFamily", "Arial"), a.Factory.addGetterSetter(S, "fontSize", 12, (0, o.getNumberValidator)()), a.Factory.addGetterSetter(S, "fontStyle", g), a.Factory.addGetterSetter(S, "align", "left"), a.Factory.addGetterSetter(S, "letterSpacing", 0, (0, o.getNumberValidator)()), a.Factory.addGetterSetter(S, "textBaseline", "middle"), a.Factory.addGetterSetter(S, "fontVariant", g), a.Factory.addGetterSetter(S, "text", u), a.Factory.addGetterSetter(S, "textDecoration", null), a.Factory.addGetterSetter(S, "kerningFunc", null), Hi;
}
var Wi = {}, _d;
function E6() {
  if (_d) return Wi;
  _d = 1, Object.defineProperty(Wi, "__esModule", { value: !0 }), Wi.Transformer = void 0;
  const r = Kt(), a = Tt(), i = $t(), s = oe(), h = sg(), o = el(), l = Rt(), u = Ot(), g = Rt(), p = "tr-konva", b = [
    "resizeEnabledChange",
    "rotateAnchorOffsetChange",
    "rotateEnabledChange",
    "enabledAnchorsChange",
    "anchorSizeChange",
    "borderEnabledChange",
    "borderStrokeChange",
    "borderStrokeWidthChange",
    "borderDashChange",
    "anchorStrokeChange",
    "anchorStrokeWidthChange",
    "anchorFillChange",
    "anchorCornerRadiusChange",
    "ignoreStrokeChange",
    "anchorStyleFuncChange"
  ].map((k) => k + `.${p}`).join(" "), S = "nodesRect", x = [
    "widthChange",
    "heightChange",
    "scaleXChange",
    "scaleYChange",
    "skewXChange",
    "skewYChange",
    "rotationChange",
    "offsetXChange",
    "offsetYChange",
    "transformsEnabledChange",
    "strokeWidthChange"
  ], v = {
    "top-left": -45,
    "top-center": 0,
    "top-right": 45,
    "middle-right": -90,
    "middle-left": 90,
    "bottom-left": -135,
    "bottom-center": 180,
    "bottom-right": 135
  }, _ = "ontouchstart" in l.Konva._global;
  function w(k, M, O) {
    if (k === "rotater")
      return O;
    M += r.Util.degToRad(v[k] || 0);
    const N = (r.Util.radToDeg(M) % 360 + 360) % 360;
    return r.Util._inRange(N, 315 + 22.5, 360) || r.Util._inRange(N, 0, 22.5) ? "ns-resize" : r.Util._inRange(N, 45 - 22.5, 45 + 22.5) ? "nesw-resize" : r.Util._inRange(N, 90 - 22.5, 90 + 22.5) ? "ew-resize" : r.Util._inRange(N, 135 - 22.5, 135 + 22.5) ? "nwse-resize" : r.Util._inRange(N, 180 - 22.5, 180 + 22.5) ? "ns-resize" : r.Util._inRange(N, 225 - 22.5, 225 + 22.5) ? "nesw-resize" : r.Util._inRange(N, 270 - 22.5, 270 + 22.5) ? "ew-resize" : r.Util._inRange(N, 315 - 22.5, 315 + 22.5) ? "nwse-resize" : (r.Util.error("Transformer has unknown angle for cursor detection: " + N), "pointer");
  }
  const C = [
    "top-left",
    "top-center",
    "top-right",
    "middle-right",
    "middle-left",
    "bottom-left",
    "bottom-center",
    "bottom-right"
  ];
  function F(k) {
    return {
      x: k.x + k.width / 2 * Math.cos(k.rotation) + k.height / 2 * Math.sin(-k.rotation),
      y: k.y + k.height / 2 * Math.cos(k.rotation) + k.width / 2 * Math.sin(k.rotation)
    };
  }
  function c(k, M, O) {
    const N = O.x + (k.x - O.x) * Math.cos(M) - (k.y - O.y) * Math.sin(M), z = O.y + (k.x - O.x) * Math.sin(M) + (k.y - O.y) * Math.cos(M);
    return {
      ...k,
      rotation: k.rotation + M,
      x: N,
      y: z
    };
  }
  function f(k, M) {
    const O = F(k);
    return c(k, M, O);
  }
  function m(k, M, O) {
    let N = M;
    for (let z = 0; z < k.length; z++) {
      const y = l.Konva.getAngle(k[z]), P = Math.abs(y - M) % (Math.PI * 2);
      Math.min(P, Math.PI * 2 - P) < O && (N = y);
    }
    return N;
  }
  let E = 0, T = class extends o.Group {
    constructor(M) {
      super(M), this._movingAnchorName = null, this._transforming = !1, this._createElements(), this._handleMouseMove = this._handleMouseMove.bind(this), this._handleMouseUp = this._handleMouseUp.bind(this), this.update = this.update.bind(this), this.on(b, this.update), this.getNode() && this.update();
    }
    attachTo(M) {
      return this.setNode(M), this;
    }
    setNode(M) {
      return r.Util.warn("tr.setNode(shape), tr.node(shape) and tr.attachTo(shape) methods are deprecated. Please use tr.nodes(nodesArray) instead."), this.setNodes([M]);
    }
    getNode() {
      return this._nodes && this._nodes[0];
    }
    _getEventNamespace() {
      return p + this._id;
    }
    setNodes(M = []) {
      this._nodes && this._nodes.length && this.detach();
      const O = M.filter((z) => z.isAncestorOf(this) ? (r.Util.error("Konva.Transformer cannot be an a child of the node you are trying to attach"), !1) : !0);
      return this._nodes = M = O, M.length === 1 && this.useSingleNodeRotation() ? this.rotation(M[0].getAbsoluteRotation()) : this.rotation(0), this._nodes.forEach((z) => {
        const y = () => {
          this.nodes().length === 1 && this.useSingleNodeRotation() && this.rotation(this.nodes()[0].getAbsoluteRotation()), this._resetTransformCache(), !this._transforming && !this.isDragging() && this.update();
        }, P = z._attrsAffectingSize.map((A) => A + "Change." + this._getEventNamespace()).join(" ");
        z.on(P, y), z.on(x.map((A) => A + `.${this._getEventNamespace()}`).join(" "), y), z.on(`absoluteTransformChange.${this._getEventNamespace()}`, y), this._proxyDrag(z);
      }), this._resetTransformCache(), !!this.findOne(".top-left") && this.update(), this;
    }
    _proxyDrag(M) {
      let O;
      M.on(`dragstart.${this._getEventNamespace()}`, (N) => {
        O = M.getAbsolutePosition(), !this.isDragging() && M !== this.findOne(".back") && this.startDrag(N, !1);
      }), M.on(`dragmove.${this._getEventNamespace()}`, (N) => {
        if (!O)
          return;
        const z = M.getAbsolutePosition(), y = z.x - O.x, P = z.y - O.y;
        this.nodes().forEach((A) => {
          if (A === M || A.isDragging())
            return;
          const G = A.getAbsolutePosition();
          A.setAbsolutePosition({
            x: G.x + y,
            y: G.y + P
          }), A.startDrag(N);
        }), O = null;
      });
    }
    getNodes() {
      return this._nodes || [];
    }
    getActiveAnchor() {
      return this._movingAnchorName;
    }
    detach() {
      this._nodes && this._nodes.forEach((M) => {
        M.off("." + this._getEventNamespace());
      }), this._nodes = [], this._resetTransformCache();
    }
    _resetTransformCache() {
      this._clearCache(S), this._clearCache("transform"), this._clearSelfAndDescendantCache("absoluteTransform");
    }
    _getNodeRect() {
      return this._getCache(S, this.__getNodeRect);
    }
    __getNodeShape(M, O = this.rotation(), N) {
      const z = M.getClientRect({
        skipTransform: !0,
        skipShadow: !0,
        skipStroke: this.ignoreStroke()
      }), y = M.getAbsoluteScale(N), P = M.getAbsolutePosition(N), A = z.x * y.x - M.offsetX() * y.x, G = z.y * y.y - M.offsetY() * y.y, U = (l.Konva.getAngle(M.getAbsoluteRotation()) + Math.PI * 2) % (Math.PI * 2), K = {
        x: P.x + A * Math.cos(U) + G * Math.sin(-U),
        y: P.y + G * Math.cos(U) + A * Math.sin(U),
        width: z.width * y.x,
        height: z.height * y.y,
        rotation: U
      };
      return c(K, -l.Konva.getAngle(O), {
        x: 0,
        y: 0
      });
    }
    __getNodeRect() {
      if (!this.getNode())
        return {
          x: -1e8,
          y: -1e8,
          width: 0,
          height: 0,
          rotation: 0
        };
      const O = [];
      this.nodes().map((U) => {
        const K = U.getClientRect({
          skipTransform: !0,
          skipShadow: !0,
          skipStroke: this.ignoreStroke()
        }), $ = [
          { x: K.x, y: K.y },
          { x: K.x + K.width, y: K.y },
          { x: K.x + K.width, y: K.y + K.height },
          { x: K.x, y: K.y + K.height }
        ], X = U.getAbsoluteTransform();
        $.forEach(function(Q) {
          const st = X.point(Q);
          O.push(st);
        });
      });
      const N = new r.Transform();
      N.rotate(-l.Konva.getAngle(this.rotation()));
      let z = 1 / 0, y = 1 / 0, P = -1 / 0, A = -1 / 0;
      O.forEach(function(U) {
        const K = N.point(U);
        z === void 0 && (z = P = K.x, y = A = K.y), z = Math.min(z, K.x), y = Math.min(y, K.y), P = Math.max(P, K.x), A = Math.max(A, K.y);
      }), N.invert();
      const G = N.point({ x: z, y });
      return {
        x: G.x,
        y: G.y,
        width: P - z,
        height: A - y,
        rotation: l.Konva.getAngle(this.rotation())
      };
    }
    getX() {
      return this._getNodeRect().x;
    }
    getY() {
      return this._getNodeRect().y;
    }
    getWidth() {
      return this._getNodeRect().width;
    }
    getHeight() {
      return this._getNodeRect().height;
    }
    _createElements() {
      this._createBack(), C.forEach((M) => {
        this._createAnchor(M);
      }), this._createAnchor("rotater");
    }
    _createAnchor(M) {
      const O = new h.Rect({
        stroke: "rgb(0, 161, 255)",
        fill: "white",
        strokeWidth: 1,
        name: M + " _anchor",
        dragDistance: 0,
        draggable: !0,
        hitStrokeWidth: _ ? 10 : "auto"
      }), N = this;
      O.on("mousedown touchstart", function(z) {
        N._handleMouseDown(z);
      }), O.on("dragstart", (z) => {
        O.stopDrag(), z.cancelBubble = !0;
      }), O.on("dragend", (z) => {
        z.cancelBubble = !0;
      }), O.on("mouseenter", () => {
        const z = l.Konva.getAngle(this.rotation()), y = this.rotateAnchorCursor(), P = w(M, z, y);
        O.getStage().content && (O.getStage().content.style.cursor = P), this._cursorChange = !0;
      }), O.on("mouseout", () => {
        O.getStage().content && (O.getStage().content.style.cursor = ""), this._cursorChange = !1;
      }), this.add(O);
    }
    _createBack() {
      const M = new s.Shape({
        name: "back",
        width: 0,
        height: 0,
        draggable: !0,
        sceneFunc(O, N) {
          const z = N.getParent(), y = z.padding();
          O.beginPath(), O.rect(-y, -y, N.width() + y * 2, N.height() + y * 2), O.moveTo(N.width() / 2, -y), z.rotateEnabled() && z.rotateLineVisible() && O.lineTo(N.width() / 2, -z.rotateAnchorOffset() * r.Util._sign(N.height()) - y), O.fillStrokeShape(N);
        },
        hitFunc: (O, N) => {
          if (!this.shouldOverdrawWholeArea())
            return;
          const z = this.padding();
          O.beginPath(), O.rect(-z, -z, N.width() + z * 2, N.height() + z * 2), O.fillStrokeShape(N);
        }
      });
      this.add(M), this._proxyDrag(M), M.on("dragstart", (O) => {
        O.cancelBubble = !0;
      }), M.on("dragmove", (O) => {
        O.cancelBubble = !0;
      }), M.on("dragend", (O) => {
        O.cancelBubble = !0;
      }), this.on("dragmove", (O) => {
        this.update();
      });
    }
    _handleMouseDown(M) {
      if (this._transforming)
        return;
      this._movingAnchorName = M.target.name().split(" ")[0];
      const O = this._getNodeRect(), N = O.width, z = O.height, y = Math.sqrt(Math.pow(N, 2) + Math.pow(z, 2));
      this.sin = Math.abs(z / y), this.cos = Math.abs(N / y), typeof window != "undefined" && (window.addEventListener("mousemove", this._handleMouseMove), window.addEventListener("touchmove", this._handleMouseMove), window.addEventListener("mouseup", this._handleMouseUp, !0), window.addEventListener("touchend", this._handleMouseUp, !0)), this._transforming = !0;
      const P = M.target.getAbsolutePosition(), A = M.target.getStage().getPointerPosition();
      this._anchorDragOffset = {
        x: A.x - P.x,
        y: A.y - P.y
      }, E++, this._fire("transformstart", { evt: M.evt, target: this.getNode() }), this._nodes.forEach((G) => {
        G._fire("transformstart", { evt: M.evt, target: G });
      });
    }
    _handleMouseMove(M) {
      let O, N, z;
      const y = this.findOne("." + this._movingAnchorName), P = y.getStage();
      P.setPointersPositions(M);
      const A = P.getPointerPosition();
      let G = {
        x: A.x - this._anchorDragOffset.x,
        y: A.y - this._anchorDragOffset.y
      };
      const U = y.getAbsolutePosition();
      this.anchorDragBoundFunc() && (G = this.anchorDragBoundFunc()(U, G, M)), y.setAbsolutePosition(G);
      const K = y.getAbsolutePosition();
      if (U.x === K.x && U.y === K.y)
        return;
      if (this._movingAnchorName === "rotater") {
        const et = this._getNodeRect();
        O = y.x() - et.width / 2, N = -y.y() + et.height / 2;
        let ut = Math.atan2(-N, O) + Math.PI / 2;
        et.height < 0 && (ut -= Math.PI);
        const pt = l.Konva.getAngle(this.rotation()) + ut, Mt = l.Konva.getAngle(this.rotationSnapTolerance()), mt = m(this.rotationSnaps(), pt, Mt) - et.rotation, re = f(et, mt);
        this._fitNodesInto(re, M);
        return;
      }
      const $ = this.shiftBehavior();
      let X;
      $ === "inverted" ? X = this.keepRatio() && !M.shiftKey : $ === "none" ? X = this.keepRatio() : X = this.keepRatio() || M.shiftKey;
      var ht = this.centeredScaling() || M.altKey;
      if (this._movingAnchorName === "top-left") {
        if (X) {
          var Q = ht ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".bottom-right").x(),
            y: this.findOne(".bottom-right").y()
          };
          z = Math.sqrt(Math.pow(Q.x - y.x(), 2) + Math.pow(Q.y - y.y(), 2));
          var st = this.findOne(".top-left").x() > Q.x ? -1 : 1, Z = this.findOne(".top-left").y() > Q.y ? -1 : 1;
          O = z * this.cos * st, N = z * this.sin * Z, this.findOne(".top-left").x(Q.x - O), this.findOne(".top-left").y(Q.y - N);
        }
      } else if (this._movingAnchorName === "top-center")
        this.findOne(".top-left").y(y.y());
      else if (this._movingAnchorName === "top-right") {
        if (X) {
          var Q = ht ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".bottom-left").x(),
            y: this.findOne(".bottom-left").y()
          };
          z = Math.sqrt(Math.pow(y.x() - Q.x, 2) + Math.pow(Q.y - y.y(), 2));
          var st = this.findOne(".top-right").x() < Q.x ? -1 : 1, Z = this.findOne(".top-right").y() > Q.y ? -1 : 1;
          O = z * this.cos * st, N = z * this.sin * Z, this.findOne(".top-right").x(Q.x + O), this.findOne(".top-right").y(Q.y - N);
        }
        var at = y.position();
        this.findOne(".top-left").y(at.y), this.findOne(".bottom-right").x(at.x);
      } else if (this._movingAnchorName === "middle-left")
        this.findOne(".top-left").x(y.x());
      else if (this._movingAnchorName === "middle-right")
        this.findOne(".bottom-right").x(y.x());
      else if (this._movingAnchorName === "bottom-left") {
        if (X) {
          var Q = ht ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".top-right").x(),
            y: this.findOne(".top-right").y()
          };
          z = Math.sqrt(Math.pow(Q.x - y.x(), 2) + Math.pow(y.y() - Q.y, 2));
          var st = Q.x < y.x() ? -1 : 1, Z = y.y() < Q.y ? -1 : 1;
          O = z * this.cos * st, N = z * this.sin * Z, y.x(Q.x - O), y.y(Q.y + N);
        }
        at = y.position(), this.findOne(".top-left").x(at.x), this.findOne(".bottom-right").y(at.y);
      } else if (this._movingAnchorName === "bottom-center")
        this.findOne(".bottom-right").y(y.y());
      else if (this._movingAnchorName === "bottom-right") {
        if (X) {
          var Q = ht ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".top-left").x(),
            y: this.findOne(".top-left").y()
          };
          z = Math.sqrt(Math.pow(y.x() - Q.x, 2) + Math.pow(y.y() - Q.y, 2));
          var st = this.findOne(".bottom-right").x() < Q.x ? -1 : 1, Z = this.findOne(".bottom-right").y() < Q.y ? -1 : 1;
          O = z * this.cos * st, N = z * this.sin * Z, this.findOne(".bottom-right").x(Q.x + O), this.findOne(".bottom-right").y(Q.y + N);
        }
      } else
        console.error(new Error("Wrong position argument of selection resizer: " + this._movingAnchorName));
      var ht = this.centeredScaling() || M.altKey;
      if (ht) {
        const et = this.findOne(".top-left"), ut = this.findOne(".bottom-right"), gt = et.x(), pt = et.y(), Mt = this.getWidth() - ut.x(), Et = this.getHeight() - ut.y();
        ut.move({
          x: -gt,
          y: -pt
        }), et.move({
          x: Mt,
          y: Et
        });
      }
      const ct = this.findOne(".top-left").getAbsolutePosition();
      O = ct.x, N = ct.y;
      const H = this.findOne(".bottom-right").x() - this.findOne(".top-left").x(), j = this.findOne(".bottom-right").y() - this.findOne(".top-left").y();
      this._fitNodesInto({
        x: O,
        y: N,
        width: H,
        height: j,
        rotation: l.Konva.getAngle(this.rotation())
      }, M);
    }
    _handleMouseUp(M) {
      this._removeEvents(M);
    }
    getAbsoluteTransform() {
      return this.getTransform();
    }
    _removeEvents(M) {
      var O;
      if (this._transforming) {
        this._transforming = !1, typeof window != "undefined" && (window.removeEventListener("mousemove", this._handleMouseMove), window.removeEventListener("touchmove", this._handleMouseMove), window.removeEventListener("mouseup", this._handleMouseUp, !0), window.removeEventListener("touchend", this._handleMouseUp, !0));
        const N = this.getNode();
        E--, this._fire("transformend", { evt: M, target: N }), (O = this.getLayer()) === null || O === void 0 || O.batchDraw(), N && this._nodes.forEach((z) => {
          var y;
          z._fire("transformend", { evt: M, target: z }), (y = z.getLayer()) === null || y === void 0 || y.batchDraw();
        }), this._movingAnchorName = null;
      }
    }
    _fitNodesInto(M, O) {
      const N = this._getNodeRect(), z = 1;
      if (r.Util._inRange(M.width, -this.padding() * 2 - z, z)) {
        this.update();
        return;
      }
      if (r.Util._inRange(M.height, -this.padding() * 2 - z, z)) {
        this.update();
        return;
      }
      const y = new r.Transform();
      if (y.rotate(l.Konva.getAngle(this.rotation())), this._movingAnchorName && M.width < 0 && this._movingAnchorName.indexOf("left") >= 0) {
        const X = y.point({
          x: -this.padding() * 2,
          y: 0
        });
        M.x += X.x, M.y += X.y, M.width += this.padding() * 2, this._movingAnchorName = this._movingAnchorName.replace("left", "right"), this._anchorDragOffset.x -= X.x, this._anchorDragOffset.y -= X.y;
      } else if (this._movingAnchorName && M.width < 0 && this._movingAnchorName.indexOf("right") >= 0) {
        const X = y.point({
          x: this.padding() * 2,
          y: 0
        });
        this._movingAnchorName = this._movingAnchorName.replace("right", "left"), this._anchorDragOffset.x -= X.x, this._anchorDragOffset.y -= X.y, M.width += this.padding() * 2;
      }
      if (this._movingAnchorName && M.height < 0 && this._movingAnchorName.indexOf("top") >= 0) {
        const X = y.point({
          x: 0,
          y: -this.padding() * 2
        });
        M.x += X.x, M.y += X.y, this._movingAnchorName = this._movingAnchorName.replace("top", "bottom"), this._anchorDragOffset.x -= X.x, this._anchorDragOffset.y -= X.y, M.height += this.padding() * 2;
      } else if (this._movingAnchorName && M.height < 0 && this._movingAnchorName.indexOf("bottom") >= 0) {
        const X = y.point({
          x: 0,
          y: this.padding() * 2
        });
        this._movingAnchorName = this._movingAnchorName.replace("bottom", "top"), this._anchorDragOffset.x -= X.x, this._anchorDragOffset.y -= X.y, M.height += this.padding() * 2;
      }
      if (this.boundBoxFunc()) {
        const X = this.boundBoxFunc()(N, M);
        X ? M = X : r.Util.warn("boundBoxFunc returned falsy. You should return new bound rect from it!");
      }
      const P = 1e7, A = new r.Transform();
      A.translate(N.x, N.y), A.rotate(N.rotation), A.scale(N.width / P, N.height / P);
      const G = new r.Transform(), U = M.width / P, K = M.height / P;
      this.flipEnabled() === !1 ? (G.translate(M.x, M.y), G.rotate(M.rotation), G.translate(M.width < 0 ? M.width : 0, M.height < 0 ? M.height : 0), G.scale(Math.abs(U), Math.abs(K))) : (G.translate(M.x, M.y), G.rotate(M.rotation), G.scale(U, K));
      const $ = G.multiply(A.invert());
      this._nodes.forEach((X) => {
        var Q;
        const st = X.getParent().getAbsoluteTransform(), Z = X.getTransform().copy();
        Z.translate(X.offsetX(), X.offsetY());
        const at = new r.Transform();
        at.multiply(st.copy().invert()).multiply($).multiply(st).multiply(Z);
        const ht = at.decompose();
        X.setAttrs(ht), (Q = X.getLayer()) === null || Q === void 0 || Q.batchDraw();
      }), this.rotation(r.Util._getRotation(M.rotation)), this._nodes.forEach((X) => {
        this._fire("transform", { evt: O, target: X }), X._fire("transform", { evt: O, target: X });
      }), this._resetTransformCache(), this.update(), this.getLayer().batchDraw();
    }
    forceUpdate() {
      this._resetTransformCache(), this.update();
    }
    _batchChangeChild(M, O) {
      this.findOne(M).setAttrs(O);
    }
    update() {
      var M;
      const O = this._getNodeRect();
      this.rotation(r.Util._getRotation(O.rotation));
      const N = O.width, z = O.height, y = this.enabledAnchors(), P = this.resizeEnabled(), A = this.padding(), G = this.anchorSize(), U = this.find("._anchor");
      U.forEach(($) => {
        $.setAttrs({
          width: G,
          height: G,
          offsetX: G / 2,
          offsetY: G / 2,
          stroke: this.anchorStroke(),
          strokeWidth: this.anchorStrokeWidth(),
          fill: this.anchorFill(),
          cornerRadius: this.anchorCornerRadius()
        });
      }), this._batchChangeChild(".top-left", {
        x: 0,
        y: 0,
        offsetX: G / 2 + A,
        offsetY: G / 2 + A,
        visible: P && y.indexOf("top-left") >= 0
      }), this._batchChangeChild(".top-center", {
        x: N / 2,
        y: 0,
        offsetY: G / 2 + A,
        visible: P && y.indexOf("top-center") >= 0
      }), this._batchChangeChild(".top-right", {
        x: N,
        y: 0,
        offsetX: G / 2 - A,
        offsetY: G / 2 + A,
        visible: P && y.indexOf("top-right") >= 0
      }), this._batchChangeChild(".middle-left", {
        x: 0,
        y: z / 2,
        offsetX: G / 2 + A,
        visible: P && y.indexOf("middle-left") >= 0
      }), this._batchChangeChild(".middle-right", {
        x: N,
        y: z / 2,
        offsetX: G / 2 - A,
        visible: P && y.indexOf("middle-right") >= 0
      }), this._batchChangeChild(".bottom-left", {
        x: 0,
        y: z,
        offsetX: G / 2 + A,
        offsetY: G / 2 - A,
        visible: P && y.indexOf("bottom-left") >= 0
      }), this._batchChangeChild(".bottom-center", {
        x: N / 2,
        y: z,
        offsetY: G / 2 - A,
        visible: P && y.indexOf("bottom-center") >= 0
      }), this._batchChangeChild(".bottom-right", {
        x: N,
        y: z,
        offsetX: G / 2 - A,
        offsetY: G / 2 - A,
        visible: P && y.indexOf("bottom-right") >= 0
      }), this._batchChangeChild(".rotater", {
        x: N / 2,
        y: -this.rotateAnchorOffset() * r.Util._sign(z) - A,
        visible: this.rotateEnabled()
      }), this._batchChangeChild(".back", {
        width: N,
        height: z,
        visible: this.borderEnabled(),
        stroke: this.borderStroke(),
        strokeWidth: this.borderStrokeWidth(),
        dash: this.borderDash(),
        x: 0,
        y: 0
      });
      const K = this.anchorStyleFunc();
      K && U.forEach(($) => {
        K($);
      }), (M = this.getLayer()) === null || M === void 0 || M.batchDraw();
    }
    isTransforming() {
      return this._transforming;
    }
    stopTransform() {
      if (this._transforming) {
        this._removeEvents();
        const M = this.findOne("." + this._movingAnchorName);
        M && M.stopDrag();
      }
    }
    destroy() {
      return this.getStage() && this._cursorChange && this.getStage().content && (this.getStage().content.style.cursor = ""), o.Group.prototype.destroy.call(this), this.detach(), this._removeEvents(), this;
    }
    toObject() {
      return i.Node.prototype.toObject.call(this);
    }
    clone(M) {
      return i.Node.prototype.clone.call(this, M);
    }
    getClientRect() {
      return this.nodes().length > 0 ? super.getClientRect() : { x: 0, y: 0, width: 0, height: 0 };
    }
  };
  Wi.Transformer = T, T.isTransforming = () => E > 0;
  function D(k) {
    return k instanceof Array || r.Util.warn("enabledAnchors value should be an array"), k instanceof Array && k.forEach(function(M) {
      C.indexOf(M) === -1 && r.Util.warn("Unknown anchor name: " + M + ". Available names are: " + C.join(", "));
    }), k || [];
  }
  return T.prototype.className = "Transformer", (0, g._registerNode)(T), a.Factory.addGetterSetter(T, "enabledAnchors", C, D), a.Factory.addGetterSetter(T, "flipEnabled", !0, (0, u.getBooleanValidator)()), a.Factory.addGetterSetter(T, "resizeEnabled", !0), a.Factory.addGetterSetter(T, "anchorSize", 10, (0, u.getNumberValidator)()), a.Factory.addGetterSetter(T, "rotateEnabled", !0), a.Factory.addGetterSetter(T, "rotateLineVisible", !0), a.Factory.addGetterSetter(T, "rotationSnaps", []), a.Factory.addGetterSetter(T, "rotateAnchorOffset", 50, (0, u.getNumberValidator)()), a.Factory.addGetterSetter(T, "rotateAnchorCursor", "crosshair"), a.Factory.addGetterSetter(T, "rotationSnapTolerance", 5, (0, u.getNumberValidator)()), a.Factory.addGetterSetter(T, "borderEnabled", !0), a.Factory.addGetterSetter(T, "anchorStroke", "rgb(0, 161, 255)"), a.Factory.addGetterSetter(T, "anchorStrokeWidth", 1, (0, u.getNumberValidator)()), a.Factory.addGetterSetter(T, "anchorFill", "white"), a.Factory.addGetterSetter(T, "anchorCornerRadius", 0, (0, u.getNumberValidator)()), a.Factory.addGetterSetter(T, "borderStroke", "rgb(0, 161, 255)"), a.Factory.addGetterSetter(T, "borderStrokeWidth", 1, (0, u.getNumberValidator)()), a.Factory.addGetterSetter(T, "borderDash"), a.Factory.addGetterSetter(T, "keepRatio", !0), a.Factory.addGetterSetter(T, "shiftBehavior", "default"), a.Factory.addGetterSetter(T, "centeredScaling", !1), a.Factory.addGetterSetter(T, "ignoreStroke", !1), a.Factory.addGetterSetter(T, "padding", 0, (0, u.getNumberValidator)()), a.Factory.addGetterSetter(T, "node"), a.Factory.addGetterSetter(T, "nodes"), a.Factory.addGetterSetter(T, "boundBoxFunc"), a.Factory.addGetterSetter(T, "anchorDragBoundFunc"), a.Factory.addGetterSetter(T, "anchorStyleFunc"), a.Factory.addGetterSetter(T, "shouldOverdrawWholeArea", !1), a.Factory.addGetterSetter(T, "useSingleNodeRotation", !0), a.Factory.backCompat(T, {
    lineEnabled: "borderEnabled",
    rotateHandlerOffset: "rotateAnchorOffset",
    enabledHandlers: "enabledAnchors"
  }), Wi;
}
var Vi = {}, vd;
function A6() {
  if (vd) return Vi;
  vd = 1, Object.defineProperty(Vi, "__esModule", { value: !0 }), Vi.Wedge = void 0;
  const r = Tt(), a = oe(), i = Rt(), s = Ot(), h = Rt();
  let o = class extends a.Shape {
    _sceneFunc(u) {
      u.beginPath(), u.arc(0, 0, this.radius(), 0, i.Konva.getAngle(this.angle()), this.clockwise()), u.lineTo(0, 0), u.closePath(), u.fillStrokeShape(this);
    }
    getWidth() {
      return this.radius() * 2;
    }
    getHeight() {
      return this.radius() * 2;
    }
    setWidth(u) {
      this.radius(u / 2);
    }
    setHeight(u) {
      this.radius(u / 2);
    }
  };
  return Vi.Wedge = o, o.prototype.className = "Wedge", o.prototype._centroid = !0, o.prototype._attrsAffectingSize = ["radius"], (0, h._registerNode)(o), r.Factory.addGetterSetter(o, "radius", 0, (0, s.getNumberValidator)()), r.Factory.addGetterSetter(o, "angle", 0, (0, s.getNumberValidator)()), r.Factory.addGetterSetter(o, "clockwise", !1), r.Factory.backCompat(o, {
    angleDeg: "angle",
    getAngleDeg: "getAngle",
    setAngleDeg: "setAngle"
  }), Vi;
}
var ji = {}, yd;
function R6() {
  if (yd) return ji;
  yd = 1, Object.defineProperty(ji, "__esModule", { value: !0 }), ji.Blur = void 0;
  const r = Tt(), a = $t(), i = Ot();
  function s() {
    this.r = 0, this.g = 0, this.b = 0, this.a = 0, this.next = null;
  }
  const h = [
    512,
    512,
    456,
    512,
    328,
    456,
    335,
    512,
    405,
    328,
    271,
    456,
    388,
    335,
    292,
    512,
    454,
    405,
    364,
    328,
    298,
    271,
    496,
    456,
    420,
    388,
    360,
    335,
    312,
    292,
    273,
    512,
    482,
    454,
    428,
    405,
    383,
    364,
    345,
    328,
    312,
    298,
    284,
    271,
    259,
    496,
    475,
    456,
    437,
    420,
    404,
    388,
    374,
    360,
    347,
    335,
    323,
    312,
    302,
    292,
    282,
    273,
    265,
    512,
    497,
    482,
    468,
    454,
    441,
    428,
    417,
    405,
    394,
    383,
    373,
    364,
    354,
    345,
    337,
    328,
    320,
    312,
    305,
    298,
    291,
    284,
    278,
    271,
    265,
    259,
    507,
    496,
    485,
    475,
    465,
    456,
    446,
    437,
    428,
    420,
    412,
    404,
    396,
    388,
    381,
    374,
    367,
    360,
    354,
    347,
    341,
    335,
    329,
    323,
    318,
    312,
    307,
    302,
    297,
    292,
    287,
    282,
    278,
    273,
    269,
    265,
    261,
    512,
    505,
    497,
    489,
    482,
    475,
    468,
    461,
    454,
    447,
    441,
    435,
    428,
    422,
    417,
    411,
    405,
    399,
    394,
    389,
    383,
    378,
    373,
    368,
    364,
    359,
    354,
    350,
    345,
    341,
    337,
    332,
    328,
    324,
    320,
    316,
    312,
    309,
    305,
    301,
    298,
    294,
    291,
    287,
    284,
    281,
    278,
    274,
    271,
    268,
    265,
    262,
    259,
    257,
    507,
    501,
    496,
    491,
    485,
    480,
    475,
    470,
    465,
    460,
    456,
    451,
    446,
    442,
    437,
    433,
    428,
    424,
    420,
    416,
    412,
    408,
    404,
    400,
    396,
    392,
    388,
    385,
    381,
    377,
    374,
    370,
    367,
    363,
    360,
    357,
    354,
    350,
    347,
    344,
    341,
    338,
    335,
    332,
    329,
    326,
    323,
    320,
    318,
    315,
    312,
    310,
    307,
    304,
    302,
    299,
    297,
    294,
    292,
    289,
    287,
    285,
    282,
    280,
    278,
    275,
    273,
    271,
    269,
    267,
    265,
    263,
    261,
    259
  ], o = [
    9,
    11,
    12,
    13,
    13,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24
  ];
  function l(g, p) {
    const b = g.data, S = g.width, x = g.height;
    let v, _, w, C, F, c, f, m, E, T, D, k, M, O, N, z, y, P, A, G, U, K, $, X, Q = p + p + 1, st = S - 1, Z = x - 1, at = p + 1, ht = at * (at + 1) / 2, ct = new s(), H = null, j = ct, et = null, ut = null, gt = h[p], pt = o[p];
    for (w = 1; w < Q; w++)
      j = j.next = new s(), w === at && (H = j);
    for (j.next = ct, f = c = 0, _ = 0; _ < x; _++) {
      for (z = y = P = A = m = E = T = D = 0, k = at * (G = b[c]), M = at * (U = b[c + 1]), O = at * (K = b[c + 2]), N = at * ($ = b[c + 3]), m += ht * G, E += ht * U, T += ht * K, D += ht * $, j = ct, w = 0; w < at; w++)
        j.r = G, j.g = U, j.b = K, j.a = $, j = j.next;
      for (w = 1; w < at; w++)
        C = c + ((st < w ? st : w) << 2), m += (j.r = G = b[C]) * (X = at - w), E += (j.g = U = b[C + 1]) * X, T += (j.b = K = b[C + 2]) * X, D += (j.a = $ = b[C + 3]) * X, z += G, y += U, P += K, A += $, j = j.next;
      for (et = ct, ut = H, v = 0; v < S; v++)
        b[c + 3] = $ = D * gt >> pt, $ !== 0 ? ($ = 255 / $, b[c] = (m * gt >> pt) * $, b[c + 1] = (E * gt >> pt) * $, b[c + 2] = (T * gt >> pt) * $) : b[c] = b[c + 1] = b[c + 2] = 0, m -= k, E -= M, T -= O, D -= N, k -= et.r, M -= et.g, O -= et.b, N -= et.a, C = f + ((C = v + p + 1) < st ? C : st) << 2, z += et.r = b[C], y += et.g = b[C + 1], P += et.b = b[C + 2], A += et.a = b[C + 3], m += z, E += y, T += P, D += A, et = et.next, k += G = ut.r, M += U = ut.g, O += K = ut.b, N += $ = ut.a, z -= G, y -= U, P -= K, A -= $, ut = ut.next, c += 4;
      f += S;
    }
    for (v = 0; v < S; v++) {
      for (y = P = A = z = E = T = D = m = 0, c = v << 2, k = at * (G = b[c]), M = at * (U = b[c + 1]), O = at * (K = b[c + 2]), N = at * ($ = b[c + 3]), m += ht * G, E += ht * U, T += ht * K, D += ht * $, j = ct, w = 0; w < at; w++)
        j.r = G, j.g = U, j.b = K, j.a = $, j = j.next;
      for (F = S, w = 1; w <= p; w++)
        c = F + v << 2, m += (j.r = G = b[c]) * (X = at - w), E += (j.g = U = b[c + 1]) * X, T += (j.b = K = b[c + 2]) * X, D += (j.a = $ = b[c + 3]) * X, z += G, y += U, P += K, A += $, j = j.next, w < Z && (F += S);
      for (c = v, et = ct, ut = H, _ = 0; _ < x; _++)
        C = c << 2, b[C + 3] = $ = D * gt >> pt, $ > 0 ? ($ = 255 / $, b[C] = (m * gt >> pt) * $, b[C + 1] = (E * gt >> pt) * $, b[C + 2] = (T * gt >> pt) * $) : b[C] = b[C + 1] = b[C + 2] = 0, m -= k, E -= M, T -= O, D -= N, k -= et.r, M -= et.g, O -= et.b, N -= et.a, C = v + ((C = _ + at) < Z ? C : Z) * S << 2, m += z += et.r = b[C], E += y += et.g = b[C + 1], T += P += et.b = b[C + 2], D += A += et.a = b[C + 3], et = et.next, k += G = ut.r, M += U = ut.g, O += K = ut.b, N += $ = ut.a, z -= G, y -= U, P -= K, A -= $, ut = ut.next, c += S;
    }
  }
  const u = function(p) {
    const b = Math.round(this.blurRadius());
    b > 0 && l(p, b);
  };
  return ji.Blur = u, r.Factory.addGetterSetter(a.Node, "blurRadius", 0, (0, i.getNumberValidator)(), r.Factory.afterSetFilter), ji;
}
var Ki = {}, md;
function T6() {
  if (md) return Ki;
  md = 1, Object.defineProperty(Ki, "__esModule", { value: !0 }), Ki.Brighten = void 0;
  const r = Tt(), a = $t(), i = Ot(), s = function(h) {
    let o = this.brightness() * 255, l = h.data, u = l.length, g;
    for (g = 0; g < u; g += 4)
      l[g] += o, l[g + 1] += o, l[g + 2] += o;
  };
  return Ki.Brighten = s, r.Factory.addGetterSetter(a.Node, "brightness", 0, (0, i.getNumberValidator)(), r.Factory.afterSetFilter), Ki;
}
var Yi = {}, bd;
function P6() {
  if (bd) return Yi;
  bd = 1, Object.defineProperty(Yi, "__esModule", { value: !0 }), Yi.Contrast = void 0;
  const r = Tt(), a = $t(), i = Ot(), s = function(h) {
    const o = Math.pow((this.contrast() + 100) / 100, 2);
    let l = h.data, u = l.length, g = 150, p = 150, b = 150, S;
    for (S = 0; S < u; S += 4)
      g = l[S], p = l[S + 1], b = l[S + 2], g /= 255, g -= 0.5, g *= o, g += 0.5, g *= 255, p /= 255, p -= 0.5, p *= o, p += 0.5, p *= 255, b /= 255, b -= 0.5, b *= o, b += 0.5, b *= 255, g = g < 0 ? 0 : g > 255 ? 255 : g, p = p < 0 ? 0 : p > 255 ? 255 : p, b = b < 0 ? 0 : b > 255 ? 255 : b, l[S] = g, l[S + 1] = p, l[S + 2] = b;
  };
  return Yi.Contrast = s, r.Factory.addGetterSetter(a.Node, "contrast", 0, (0, i.getNumberValidator)(), r.Factory.afterSetFilter), Yi;
}
var Xi = {}, Sd;
function F6() {
  if (Sd) return Xi;
  Sd = 1, Object.defineProperty(Xi, "__esModule", { value: !0 }), Xi.Emboss = void 0;
  const r = Tt(), a = $t(), i = Kt(), s = Ot(), h = function(o) {
    let l = this.embossStrength() * 10, u = this.embossWhiteLevel() * 255, g = this.embossDirection(), p = this.embossBlend(), b = 0, S = 0, x = o.data, v = o.width, _ = o.height, w = v * 4, C = _;
    switch (g) {
      case "top-left":
        b = -1, S = -1;
        break;
      case "top":
        b = -1, S = 0;
        break;
      case "top-right":
        b = -1, S = 1;
        break;
      case "right":
        b = 0, S = 1;
        break;
      case "bottom-right":
        b = 1, S = 1;
        break;
      case "bottom":
        b = 1, S = 0;
        break;
      case "bottom-left":
        b = 1, S = -1;
        break;
      case "left":
        b = 0, S = -1;
        break;
      default:
        i.Util.error("Unknown emboss direction: " + g);
    }
    do {
      const F = (C - 1) * w;
      let c = b;
      C + c < 1 && (c = 0), C + c > _ && (c = 0);
      const f = (C - 1 + c) * v * 4;
      let m = v;
      do {
        const E = F + (m - 1) * 4;
        let T = S;
        m + T < 1 && (T = 0), m + T > v && (T = 0);
        const D = f + (m - 1 + T) * 4, k = x[E] - x[D], M = x[E + 1] - x[D + 1], O = x[E + 2] - x[D + 2];
        let N = k;
        const z = N > 0 ? N : -N, y = M > 0 ? M : -M, P = O > 0 ? O : -O;
        if (y > z && (N = M), P > z && (N = O), N *= l, p) {
          const A = x[E] + N, G = x[E + 1] + N, U = x[E + 2] + N;
          x[E] = A > 255 ? 255 : A < 0 ? 0 : A, x[E + 1] = G > 255 ? 255 : G < 0 ? 0 : G, x[E + 2] = U > 255 ? 255 : U < 0 ? 0 : U;
        } else {
          let A = u - N;
          A < 0 ? A = 0 : A > 255 && (A = 255), x[E] = x[E + 1] = x[E + 2] = A;
        }
      } while (--m);
    } while (--C);
  };
  return Xi.Emboss = h, r.Factory.addGetterSetter(a.Node, "embossStrength", 0.5, (0, s.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "embossWhiteLevel", 0.5, (0, s.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "embossDirection", "top-left", null, r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "embossBlend", !1, null, r.Factory.afterSetFilter), Xi;
}
var $i = {}, wd;
function O6() {
  if (wd) return $i;
  wd = 1, Object.defineProperty($i, "__esModule", { value: !0 }), $i.Enhance = void 0;
  const r = Tt(), a = $t(), i = Ot();
  function s(o, l, u, g, p) {
    let b = u - l, S = p - g, x;
    return b === 0 ? g + S / 2 : S === 0 ? g : (x = (o - l) / b, x = S * x + g, x);
  }
  const h = function(o) {
    let l = o.data, u = l.length, g = l[0], p = g, b, S = l[1], x = S, v, _ = l[2], w = _, C, F;
    const c = this.enhance();
    if (c === 0)
      return;
    for (F = 0; F < u; F += 4)
      b = l[F + 0], b < g ? g = b : b > p && (p = b), v = l[F + 1], v < S ? S = v : v > x && (x = v), C = l[F + 2], C < _ ? _ = C : C > w && (w = C);
    p === g && (p = 255, g = 0), x === S && (x = 255, S = 0), w === _ && (w = 255, _ = 0);
    let f, m, E, T, D, k, M, O, N;
    for (c > 0 ? (m = p + c * (255 - p), E = g - c * (g - 0), D = x + c * (255 - x), k = S - c * (S - 0), O = w + c * (255 - w), N = _ - c * (_ - 0)) : (f = (p + g) * 0.5, m = p + c * (p - f), E = g + c * (g - f), T = (x + S) * 0.5, D = x + c * (x - T), k = S + c * (S - T), M = (w + _) * 0.5, O = w + c * (w - M), N = _ + c * (_ - M)), F = 0; F < u; F += 4)
      l[F + 0] = s(l[F + 0], g, p, E, m), l[F + 1] = s(l[F + 1], S, x, k, D), l[F + 2] = s(l[F + 2], _, w, N, O);
  };
  return $i.Enhance = h, r.Factory.addGetterSetter(a.Node, "enhance", 0, (0, i.getNumberValidator)(), r.Factory.afterSetFilter), $i;
}
var Zi = {}, Cd;
function I6() {
  if (Cd) return Zi;
  Cd = 1, Object.defineProperty(Zi, "__esModule", { value: !0 }), Zi.Grayscale = void 0;
  const r = function(a) {
    let i = a.data, s = i.length, h, o;
    for (h = 0; h < s; h += 4)
      o = 0.34 * i[h] + 0.5 * i[h + 1] + 0.16 * i[h + 2], i[h] = o, i[h + 1] = o, i[h + 2] = o;
  };
  return Zi.Grayscale = r, Zi;
}
var Ji = {}, xd;
function k6() {
  if (xd) return Ji;
  xd = 1, Object.defineProperty(Ji, "__esModule", { value: !0 }), Ji.HSL = void 0;
  const r = Tt(), a = $t(), i = Ot();
  r.Factory.addGetterSetter(a.Node, "hue", 0, (0, i.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "saturation", 0, (0, i.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "luminance", 0, (0, i.getNumberValidator)(), r.Factory.afterSetFilter);
  const s = function(h) {
    let o = h.data, l = o.length, u = 1, g = Math.pow(2, this.saturation()), p = Math.abs(this.hue() + 360) % 360, b = this.luminance() * 127, S;
    const x = u * g * Math.cos(p * Math.PI / 180), v = u * g * Math.sin(p * Math.PI / 180), _ = 0.299 * u + 0.701 * x + 0.167 * v, w = 0.587 * u - 0.587 * x + 0.33 * v, C = 0.114 * u - 0.114 * x - 0.497 * v, F = 0.299 * u - 0.299 * x - 0.328 * v, c = 0.587 * u + 0.413 * x + 0.035 * v, f = 0.114 * u - 0.114 * x + 0.293 * v, m = 0.299 * u - 0.3 * x + 1.25 * v, E = 0.587 * u - 0.586 * x - 1.05 * v, T = 0.114 * u + 0.886 * x - 0.2 * v;
    let D, k, M, O;
    for (S = 0; S < l; S += 4)
      D = o[S + 0], k = o[S + 1], M = o[S + 2], O = o[S + 3], o[S + 0] = _ * D + w * k + C * M + b, o[S + 1] = F * D + c * k + f * M + b, o[S + 2] = m * D + E * k + T * M + b, o[S + 3] = O;
  };
  return Ji.HSL = s, Ji;
}
var Qi = {}, Ed;
function M6() {
  if (Ed) return Qi;
  Ed = 1, Object.defineProperty(Qi, "__esModule", { value: !0 }), Qi.HSV = void 0;
  const r = Tt(), a = $t(), i = Ot(), s = function(h) {
    const o = h.data, l = o.length, u = Math.pow(2, this.value()), g = Math.pow(2, this.saturation()), p = Math.abs(this.hue() + 360) % 360, b = u * g * Math.cos(p * Math.PI / 180), S = u * g * Math.sin(p * Math.PI / 180), x = 0.299 * u + 0.701 * b + 0.167 * S, v = 0.587 * u - 0.587 * b + 0.33 * S, _ = 0.114 * u - 0.114 * b - 0.497 * S, w = 0.299 * u - 0.299 * b - 0.328 * S, C = 0.587 * u + 0.413 * b + 0.035 * S, F = 0.114 * u - 0.114 * b + 0.293 * S, c = 0.299 * u - 0.3 * b + 1.25 * S, f = 0.587 * u - 0.586 * b - 1.05 * S, m = 0.114 * u + 0.886 * b - 0.2 * S;
    let E, T, D, k;
    for (let M = 0; M < l; M += 4)
      E = o[M + 0], T = o[M + 1], D = o[M + 2], k = o[M + 3], o[M + 0] = x * E + v * T + _ * D, o[M + 1] = w * E + C * T + F * D, o[M + 2] = c * E + f * T + m * D, o[M + 3] = k;
  };
  return Qi.HSV = s, r.Factory.addGetterSetter(a.Node, "hue", 0, (0, i.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "saturation", 0, (0, i.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "value", 0, (0, i.getNumberValidator)(), r.Factory.afterSetFilter), Qi;
}
var tn = {}, Ad;
function L6() {
  if (Ad) return tn;
  Ad = 1, Object.defineProperty(tn, "__esModule", { value: !0 }), tn.Invert = void 0;
  const r = function(a) {
    let i = a.data, s = i.length, h;
    for (h = 0; h < s; h += 4)
      i[h] = 255 - i[h], i[h + 1] = 255 - i[h + 1], i[h + 2] = 255 - i[h + 2];
  };
  return tn.Invert = r, tn;
}
var en = {}, Rd;
function N6() {
  if (Rd) return en;
  Rd = 1, Object.defineProperty(en, "__esModule", { value: !0 }), en.Kaleidoscope = void 0;
  const r = Tt(), a = $t(), i = Kt(), s = Ot(), h = function(u, g, p) {
    let b = u.data, S = g.data, x = u.width, v = u.height, _ = p.polarCenterX || x / 2, w = p.polarCenterY || v / 2, C, F, c, f = 0, m = 0, E = 0, T = 0, D, k = Math.sqrt(_ * _ + w * w);
    F = x - _, c = v - w, D = Math.sqrt(F * F + c * c), k = D > k ? D : k;
    let M = v, O = x, N, z, y = 360 / O * Math.PI / 180, P, A;
    for (z = 0; z < O; z += 1)
      for (P = Math.sin(z * y), A = Math.cos(z * y), N = 0; N < M; N += 1)
        F = Math.floor(_ + k * N / M * A), c = Math.floor(w + k * N / M * P), C = (c * x + F) * 4, f = b[C + 0], m = b[C + 1], E = b[C + 2], T = b[C + 3], C = (z + N * x) * 4, S[C + 0] = f, S[C + 1] = m, S[C + 2] = E, S[C + 3] = T;
  }, o = function(u, g, p) {
    let b = u.data, S = g.data, x = u.width, v = u.height, _ = p.polarCenterX || x / 2, w = p.polarCenterY || v / 2, C, F, c, f, m, E = 0, T = 0, D = 0, k = 0, M, O = Math.sqrt(_ * _ + w * w);
    F = x - _, c = v - w, M = Math.sqrt(F * F + c * c), O = M > O ? M : O;
    let N = v, z = x, y, P, A = 0, G, U;
    for (F = 0; F < x; F += 1)
      for (c = 0; c < v; c += 1)
        f = F - _, m = c - w, y = Math.sqrt(f * f + m * m) * N / O, P = (Math.atan2(m, f) * 180 / Math.PI + 360 + A) % 360, P = P * z / 360, G = Math.floor(P), U = Math.floor(y), C = (U * x + G) * 4, E = b[C + 0], T = b[C + 1], D = b[C + 2], k = b[C + 3], C = (c * x + F) * 4, S[C + 0] = E, S[C + 1] = T, S[C + 2] = D, S[C + 3] = k;
  }, l = function(u) {
    const g = u.width, p = u.height;
    let b, S, x, v, _, w, C, F, c, f, m = Math.round(this.kaleidoscopePower());
    const E = Math.round(this.kaleidoscopeAngle()), T = Math.floor(g * (E % 360) / 360);
    if (m < 1)
      return;
    const D = i.Util.createCanvasElement();
    D.width = g, D.height = p;
    const k = D.getContext("2d").getImageData(0, 0, g, p);
    i.Util.releaseCanvas(D), h(u, k, {
      polarCenterX: g / 2,
      polarCenterY: p / 2
    });
    let M = g / Math.pow(2, m);
    for (; M <= 8; )
      M = M * 2, m -= 1;
    M = Math.ceil(M);
    let O = M, N = 0, z = O, y = 1;
    for (T + M > g && (N = O, z = 0, y = -1), S = 0; S < p; S += 1)
      for (b = N; b !== z; b += y)
        x = Math.round(b + T) % g, c = (g * S + x) * 4, _ = k.data[c + 0], w = k.data[c + 1], C = k.data[c + 2], F = k.data[c + 3], f = (g * S + b) * 4, k.data[f + 0] = _, k.data[f + 1] = w, k.data[f + 2] = C, k.data[f + 3] = F;
    for (S = 0; S < p; S += 1)
      for (O = Math.floor(M), v = 0; v < m; v += 1) {
        for (b = 0; b < O + 1; b += 1)
          c = (g * S + b) * 4, _ = k.data[c + 0], w = k.data[c + 1], C = k.data[c + 2], F = k.data[c + 3], f = (g * S + O * 2 - b - 1) * 4, k.data[f + 0] = _, k.data[f + 1] = w, k.data[f + 2] = C, k.data[f + 3] = F;
        O *= 2;
      }
    o(k, u, {});
  };
  return en.Kaleidoscope = l, r.Factory.addGetterSetter(a.Node, "kaleidoscopePower", 2, (0, s.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "kaleidoscopeAngle", 0, (0, s.getNumberValidator)(), r.Factory.afterSetFilter), en;
}
var rn = {}, Td;
function G6() {
  if (Td) return rn;
  Td = 1, Object.defineProperty(rn, "__esModule", { value: !0 }), rn.Mask = void 0;
  const r = Tt(), a = $t(), i = Ot();
  function s(x, v, _) {
    let w = (_ * x.width + v) * 4;
    const C = [];
    return C.push(x.data[w++], x.data[w++], x.data[w++], x.data[w++]), C;
  }
  function h(x, v) {
    return Math.sqrt(Math.pow(x[0] - v[0], 2) + Math.pow(x[1] - v[1], 2) + Math.pow(x[2] - v[2], 2));
  }
  function o(x) {
    const v = [0, 0, 0];
    for (let _ = 0; _ < x.length; _++)
      v[0] += x[_][0], v[1] += x[_][1], v[2] += x[_][2];
    return v[0] /= x.length, v[1] /= x.length, v[2] /= x.length, v;
  }
  function l(x, v) {
    const _ = s(x, 0, 0), w = s(x, x.width - 1, 0), C = s(x, 0, x.height - 1), F = s(x, x.width - 1, x.height - 1), c = v || 10;
    if (h(_, w) < c && h(w, F) < c && h(F, C) < c && h(C, _) < c) {
      const f = o([w, _, F, C]), m = [];
      for (let E = 0; E < x.width * x.height; E++) {
        const T = h(f, [
          x.data[E * 4],
          x.data[E * 4 + 1],
          x.data[E * 4 + 2]
        ]);
        m[E] = T < c ? 0 : 255;
      }
      return m;
    }
  }
  function u(x, v) {
    for (let _ = 0; _ < x.width * x.height; _++)
      x.data[4 * _ + 3] = v[_];
  }
  function g(x, v, _) {
    const w = [1, 1, 1, 1, 0, 1, 1, 1, 1], C = Math.round(Math.sqrt(w.length)), F = Math.floor(C / 2), c = [];
    for (let f = 0; f < _; f++)
      for (let m = 0; m < v; m++) {
        const E = f * v + m;
        let T = 0;
        for (let D = 0; D < C; D++)
          for (let k = 0; k < C; k++) {
            const M = f + D - F, O = m + k - F;
            if (M >= 0 && M < _ && O >= 0 && O < v) {
              const N = M * v + O, z = w[D * C + k];
              T += x[N] * z;
            }
          }
        c[E] = T === 255 * 8 ? 255 : 0;
      }
    return c;
  }
  function p(x, v, _) {
    const w = [1, 1, 1, 1, 1, 1, 1, 1, 1], C = Math.round(Math.sqrt(w.length)), F = Math.floor(C / 2), c = [];
    for (let f = 0; f < _; f++)
      for (let m = 0; m < v; m++) {
        const E = f * v + m;
        let T = 0;
        for (let D = 0; D < C; D++)
          for (let k = 0; k < C; k++) {
            const M = f + D - F, O = m + k - F;
            if (M >= 0 && M < _ && O >= 0 && O < v) {
              const N = M * v + O, z = w[D * C + k];
              T += x[N] * z;
            }
          }
        c[E] = T >= 255 * 4 ? 255 : 0;
      }
    return c;
  }
  function b(x, v, _) {
    const w = [0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111], C = Math.round(Math.sqrt(w.length)), F = Math.floor(C / 2), c = [];
    for (let f = 0; f < _; f++)
      for (let m = 0; m < v; m++) {
        const E = f * v + m;
        let T = 0;
        for (let D = 0; D < C; D++)
          for (let k = 0; k < C; k++) {
            const M = f + D - F, O = m + k - F;
            if (M >= 0 && M < _ && O >= 0 && O < v) {
              const N = M * v + O, z = w[D * C + k];
              T += x[N] * z;
            }
          }
        c[E] = T;
      }
    return c;
  }
  const S = function(x) {
    let v = this.threshold(), _ = l(x, v);
    return _ && (_ = g(_, x.width, x.height), _ = p(_, x.width, x.height), _ = b(_, x.width, x.height), u(x, _)), x;
  };
  return rn.Mask = S, r.Factory.addGetterSetter(a.Node, "threshold", 0, (0, i.getNumberValidator)(), r.Factory.afterSetFilter), rn;
}
var nn = {}, Pd;
function D6() {
  if (Pd) return nn;
  Pd = 1, Object.defineProperty(nn, "__esModule", { value: !0 }), nn.Noise = void 0;
  const r = Tt(), a = $t(), i = Ot(), s = function(h) {
    const o = this.noise() * 255, l = h.data, u = l.length, g = o / 2;
    for (let p = 0; p < u; p += 4)
      l[p + 0] += g - 2 * g * Math.random(), l[p + 1] += g - 2 * g * Math.random(), l[p + 2] += g - 2 * g * Math.random();
  };
  return nn.Noise = s, r.Factory.addGetterSetter(a.Node, "noise", 0.2, (0, i.getNumberValidator)(), r.Factory.afterSetFilter), nn;
}
var an = {}, Fd;
function B6() {
  if (Fd) return an;
  Fd = 1, Object.defineProperty(an, "__esModule", { value: !0 }), an.Pixelate = void 0;
  const r = Tt(), a = Kt(), i = $t(), s = Ot(), h = function(o) {
    let l = Math.ceil(this.pixelSize()), u = o.width, g = o.height, p, b, S, x, v, _, w, C = Math.ceil(u / l), F = Math.ceil(g / l), c, f, m, E, T, D, k, M = o.data;
    if (l <= 0) {
      a.Util.error("pixelSize value can not be <= 0");
      return;
    }
    for (T = 0; T < C; T += 1)
      for (D = 0; D < F; D += 1) {
        for (x = 0, v = 0, _ = 0, w = 0, c = T * l, f = c + l, m = D * l, E = m + l, k = 0, p = c; p < f; p += 1)
          if (!(p >= u))
            for (b = m; b < E; b += 1)
              b >= g || (S = (u * b + p) * 4, x += M[S + 0], v += M[S + 1], _ += M[S + 2], w += M[S + 3], k += 1);
        for (x = x / k, v = v / k, _ = _ / k, w = w / k, p = c; p < f; p += 1)
          if (!(p >= u))
            for (b = m; b < E; b += 1)
              b >= g || (S = (u * b + p) * 4, M[S + 0] = x, M[S + 1] = v, M[S + 2] = _, M[S + 3] = w);
      }
  };
  return an.Pixelate = h, r.Factory.addGetterSetter(i.Node, "pixelSize", 8, (0, s.getNumberValidator)(), r.Factory.afterSetFilter), an;
}
var sn = {}, Od;
function U6() {
  if (Od) return sn;
  Od = 1, Object.defineProperty(sn, "__esModule", { value: !0 }), sn.Posterize = void 0;
  const r = Tt(), a = $t(), i = Ot(), s = function(h) {
    let o = Math.round(this.levels() * 254) + 1, l = h.data, u = l.length, g = 255 / o, p;
    for (p = 0; p < u; p += 1)
      l[p] = Math.floor(l[p] / g) * g;
  };
  return sn.Posterize = s, r.Factory.addGetterSetter(a.Node, "levels", 0.5, (0, i.getNumberValidator)(), r.Factory.afterSetFilter), sn;
}
var on = {}, Id;
function q6() {
  if (Id) return on;
  Id = 1, Object.defineProperty(on, "__esModule", { value: !0 }), on.RGB = void 0;
  const r = Tt(), a = $t(), i = Ot(), s = function(h) {
    let o = h.data, l = o.length, u = this.red(), g = this.green(), p = this.blue(), b, S;
    for (b = 0; b < l; b += 4)
      S = (0.34 * o[b] + 0.5 * o[b + 1] + 0.16 * o[b + 2]) / 255, o[b] = S * u, o[b + 1] = S * g, o[b + 2] = S * p, o[b + 3] = o[b + 3];
  };
  return on.RGB = s, r.Factory.addGetterSetter(a.Node, "red", 0, function(h) {
    return this._filterUpToDate = !1, h > 255 ? 255 : h < 0 ? 0 : Math.round(h);
  }), r.Factory.addGetterSetter(a.Node, "green", 0, function(h) {
    return this._filterUpToDate = !1, h > 255 ? 255 : h < 0 ? 0 : Math.round(h);
  }), r.Factory.addGetterSetter(a.Node, "blue", 0, i.RGBComponent, r.Factory.afterSetFilter), on;
}
var hn = {}, kd;
function z6() {
  if (kd) return hn;
  kd = 1, Object.defineProperty(hn, "__esModule", { value: !0 }), hn.RGBA = void 0;
  const r = Tt(), a = $t(), i = Ot(), s = function(h) {
    const o = h.data, l = o.length, u = this.red(), g = this.green(), p = this.blue(), b = this.alpha();
    for (let S = 0; S < l; S += 4) {
      const x = 1 - b;
      o[S] = u * b + o[S] * x, o[S + 1] = g * b + o[S + 1] * x, o[S + 2] = p * b + o[S + 2] * x;
    }
  };
  return hn.RGBA = s, r.Factory.addGetterSetter(a.Node, "red", 0, function(h) {
    return this._filterUpToDate = !1, h > 255 ? 255 : h < 0 ? 0 : Math.round(h);
  }), r.Factory.addGetterSetter(a.Node, "green", 0, function(h) {
    return this._filterUpToDate = !1, h > 255 ? 255 : h < 0 ? 0 : Math.round(h);
  }), r.Factory.addGetterSetter(a.Node, "blue", 0, i.RGBComponent, r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "alpha", 1, function(h) {
    return this._filterUpToDate = !1, h > 1 ? 1 : h < 0 ? 0 : h;
  }), hn;
}
var ln = {}, Md;
function H6() {
  if (Md) return ln;
  Md = 1, Object.defineProperty(ln, "__esModule", { value: !0 }), ln.Sepia = void 0;
  const r = function(a) {
    let i = a.data, s = i.length, h, o, l, u;
    for (h = 0; h < s; h += 4)
      o = i[h + 0], l = i[h + 1], u = i[h + 2], i[h + 0] = Math.min(255, o * 0.393 + l * 0.769 + u * 0.189), i[h + 1] = Math.min(255, o * 0.349 + l * 0.686 + u * 0.168), i[h + 2] = Math.min(255, o * 0.272 + l * 0.534 + u * 0.131);
  };
  return ln.Sepia = r, ln;
}
var un = {}, Ld;
function W6() {
  if (Ld) return un;
  Ld = 1, Object.defineProperty(un, "__esModule", { value: !0 }), un.Solarize = void 0;
  const r = function(a) {
    const i = a.data, s = a.width, h = a.height, o = s * 4;
    let l = h;
    do {
      const u = (l - 1) * o;
      let g = s;
      do {
        const p = u + (g - 1) * 4;
        let b = i[p], S = i[p + 1], x = i[p + 2];
        b > 127 && (b = 255 - b), S > 127 && (S = 255 - S), x > 127 && (x = 255 - x), i[p] = b, i[p + 1] = S, i[p + 2] = x;
      } while (--g);
    } while (--l);
  };
  return un.Solarize = r, un;
}
var cn = {}, Nd;
function V6() {
  if (Nd) return cn;
  Nd = 1, Object.defineProperty(cn, "__esModule", { value: !0 }), cn.Threshold = void 0;
  const r = Tt(), a = $t(), i = Ot(), s = function(h) {
    const o = this.threshold() * 255, l = h.data, u = l.length;
    for (let g = 0; g < u; g += 1)
      l[g] = l[g] < o ? 0 : 255;
  };
  return cn.Threshold = s, r.Factory.addGetterSetter(a.Node, "threshold", 0.5, (0, i.getNumberValidator)(), r.Factory.afterSetFilter), cn;
}
var Gd;
function j6() {
  if (Gd) return xi;
  Gd = 1, Object.defineProperty(xi, "__esModule", { value: !0 }), xi.Konva = void 0;
  const r = d6(), a = f6(), i = p6(), s = _6(), h = v6(), o = y6(), l = m6(), u = ng(), g = il(), p = sg(), b = b6(), S = S6(), x = w6(), v = C6(), _ = og(), w = x6(), C = E6(), F = A6(), c = R6(), f = T6(), m = P6(), E = F6(), T = O6(), D = I6(), k = k6(), M = M6(), O = L6(), N = N6(), z = G6(), y = D6(), P = B6(), A = U6(), G = q6(), U = z6(), K = H6(), $ = W6(), X = V6();
  return xi.Konva = r.Konva.Util._assign(r.Konva, {
    Arc: a.Arc,
    Arrow: i.Arrow,
    Circle: s.Circle,
    Ellipse: h.Ellipse,
    Image: o.Image,
    Label: l.Label,
    Tag: l.Tag,
    Line: u.Line,
    Path: g.Path,
    Rect: p.Rect,
    RegularPolygon: b.RegularPolygon,
    Ring: S.Ring,
    Sprite: x.Sprite,
    Star: v.Star,
    Text: _.Text,
    TextPath: w.TextPath,
    Transformer: C.Transformer,
    Wedge: F.Wedge,
    Filters: {
      Blur: c.Blur,
      Brighten: f.Brighten,
      Contrast: m.Contrast,
      Emboss: E.Emboss,
      Enhance: T.Enhance,
      Grayscale: D.Grayscale,
      HSL: k.HSL,
      HSV: M.HSV,
      Invert: O.Invert,
      Kaleidoscope: N.Kaleidoscope,
      Mask: z.Mask,
      Noise: y.Noise,
      Pixelate: P.Pixelate,
      Posterize: A.Posterize,
      RGB: G.RGB,
      RGBA: U.RGBA,
      Sepia: K.Sepia,
      Solarize: $.Solarize,
      Threshold: X.Threshold
    }
  }), xi;
}
var K6 = ga.exports, Dd;
function Y6() {
  if (Dd) return ga.exports;
  Dd = 1, Object.defineProperty(K6, "__esModule", { value: !0 });
  const r = j6();
  return ga.exports = r.Konva, ga.exports;
}
var X6 = Y6();
const ft = /* @__PURE__ */ ai(X6);
var eo, Bd;
function mn() {
  if (Bd) return eo;
  Bd = 1;
  function r(a) {
    var i = typeof a;
    return a != null && (i == "object" || i == "function");
  }
  return eo = r, eo;
}
var ro, Ud;
function hg() {
  if (Ud) return ro;
  Ud = 1;
  var r = typeof ii == "object" && ii && ii.Object === Object && ii;
  return ro = r, ro;
}
var io, qd;
function $e() {
  if (qd) return io;
  qd = 1;
  var r = hg(), a = typeof self == "object" && self && self.Object === Object && self, i = r || a || Function("return this")();
  return io = i, io;
}
var no, zd;
function $6() {
  if (zd) return no;
  zd = 1;
  var r = $e(), a = function() {
    return r.Date.now();
  };
  return no = a, no;
}
var ao, Hd;
function Z6() {
  if (Hd) return ao;
  Hd = 1;
  var r = /\s/;
  function a(i) {
    for (var s = i.length; s-- && r.test(i.charAt(s)); )
      ;
    return s;
  }
  return ao = a, ao;
}
var so, Wd;
function J6() {
  if (Wd) return so;
  Wd = 1;
  var r = Z6(), a = /^\s+/;
  function i(s) {
    return s && s.slice(0, r(s) + 1).replace(a, "");
  }
  return so = i, so;
}
var oo, Vd;
function wa() {
  if (Vd) return oo;
  Vd = 1;
  var r = $e(), a = r.Symbol;
  return oo = a, oo;
}
var ho, jd;
function Q6() {
  if (jd) return ho;
  jd = 1;
  var r = wa(), a = Object.prototype, i = a.hasOwnProperty, s = a.toString, h = r ? r.toStringTag : void 0;
  function o(l) {
    var u = i.call(l, h), g = l[h];
    try {
      l[h] = void 0;
      var p = !0;
    } catch {
    }
    var b = s.call(l);
    return p && (u ? l[h] = g : delete l[h]), b;
  }
  return ho = o, ho;
}
var lo, Kd;
function tv() {
  if (Kd) return lo;
  Kd = 1;
  var r = Object.prototype, a = r.toString;
  function i(s) {
    return a.call(s);
  }
  return lo = i, lo;
}
var uo, Yd;
function bn() {
  if (Yd) return uo;
  Yd = 1;
  var r = wa(), a = Q6(), i = tv(), s = "[object Null]", h = "[object Undefined]", o = r ? r.toStringTag : void 0;
  function l(u) {
    return u == null ? u === void 0 ? h : s : o && o in Object(u) ? a(u) : i(u);
  }
  return uo = l, uo;
}
var co, Xd;
function Sn() {
  if (Xd) return co;
  Xd = 1;
  function r(a) {
    return a != null && typeof a == "object";
  }
  return co = r, co;
}
var fo, $d;
function lg() {
  if ($d) return fo;
  $d = 1;
  var r = bn(), a = Sn(), i = "[object Symbol]";
  function s(h) {
    return typeof h == "symbol" || a(h) && r(h) == i;
  }
  return fo = s, fo;
}
var go, Zd;
function nl() {
  if (Zd) return go;
  Zd = 1;
  var r = J6(), a = mn(), i = lg(), s = NaN, h = /^[-+]0x[0-9a-f]+$/i, o = /^0b[01]+$/i, l = /^0o[0-7]+$/i, u = parseInt;
  function g(p) {
    if (typeof p == "number")
      return p;
    if (i(p))
      return s;
    if (a(p)) {
      var b = typeof p.valueOf == "function" ? p.valueOf() : p;
      p = a(b) ? b + "" : b;
    }
    if (typeof p != "string")
      return p === 0 ? p : +p;
    p = r(p);
    var S = o.test(p);
    return S || l.test(p) ? u(p.slice(2), S ? 2 : 8) : h.test(p) ? s : +p;
  }
  return go = g, go;
}
var po, Jd;
function ug() {
  if (Jd) return po;
  Jd = 1;
  var r = mn(), a = $6(), i = nl(), s = "Expected a function", h = Math.max, o = Math.min;
  function l(u, g, p) {
    var b, S, x, v, _, w, C = 0, F = !1, c = !1, f = !0;
    if (typeof u != "function")
      throw new TypeError(s);
    g = i(g) || 0, r(p) && (F = !!p.leading, c = "maxWait" in p, x = c ? h(i(p.maxWait) || 0, g) : x, f = "trailing" in p ? !!p.trailing : f);
    function m(y) {
      var P = b, A = S;
      return b = S = void 0, C = y, v = u.apply(A, P), v;
    }
    function E(y) {
      return C = y, _ = setTimeout(k, g), F ? m(y) : v;
    }
    function T(y) {
      var P = y - w, A = y - C, G = g - P;
      return c ? o(G, x - A) : G;
    }
    function D(y) {
      var P = y - w, A = y - C;
      return w === void 0 || P >= g || P < 0 || c && A >= x;
    }
    function k() {
      var y = a();
      if (D(y))
        return M(y);
      _ = setTimeout(k, T(y));
    }
    function M(y) {
      return _ = void 0, f && b ? m(y) : (b = S = void 0, v);
    }
    function O() {
      _ !== void 0 && clearTimeout(_), C = 0, b = w = S = _ = void 0;
    }
    function N() {
      return _ === void 0 ? v : M(a());
    }
    function z() {
      var y = a(), P = D(y);
      if (b = arguments, S = this, w = y, P) {
        if (_ === void 0)
          return E(w);
        if (c)
          return clearTimeout(_), _ = setTimeout(k, g), m(w);
      }
      return _ === void 0 && (_ = setTimeout(k, g)), v;
    }
    return z.cancel = O, z.flush = N, z;
  }
  return po = l, po;
}
var ev = ug();
const rv = /* @__PURE__ */ ai(ev);
var _o, Qd;
function iv() {
  if (Qd) return _o;
  Qd = 1;
  function r() {
    this.__data__ = [], this.size = 0;
  }
  return _o = r, _o;
}
var vo, tf;
function cg() {
  if (tf) return vo;
  tf = 1;
  function r(a, i) {
    return a === i || a !== a && i !== i;
  }
  return vo = r, vo;
}
var yo, ef;
function Ca() {
  if (ef) return yo;
  ef = 1;
  var r = cg();
  function a(i, s) {
    for (var h = i.length; h--; )
      if (r(i[h][0], s))
        return h;
    return -1;
  }
  return yo = a, yo;
}
var mo, rf;
function nv() {
  if (rf) return mo;
  rf = 1;
  var r = Ca(), a = Array.prototype, i = a.splice;
  function s(h) {
    var o = this.__data__, l = r(o, h);
    if (l < 0)
      return !1;
    var u = o.length - 1;
    return l == u ? o.pop() : i.call(o, l, 1), --this.size, !0;
  }
  return mo = s, mo;
}
var bo, nf;
function av() {
  if (nf) return bo;
  nf = 1;
  var r = Ca();
  function a(i) {
    var s = this.__data__, h = r(s, i);
    return h < 0 ? void 0 : s[h][1];
  }
  return bo = a, bo;
}
var So, af;
function sv() {
  if (af) return So;
  af = 1;
  var r = Ca();
  function a(i) {
    return r(this.__data__, i) > -1;
  }
  return So = a, So;
}
var wo, sf;
function ov() {
  if (sf) return wo;
  sf = 1;
  var r = Ca();
  function a(i, s) {
    var h = this.__data__, o = r(h, i);
    return o < 0 ? (++this.size, h.push([i, s])) : h[o][1] = s, this;
  }
  return wo = a, wo;
}
var Co, of;
function xa() {
  if (of) return Co;
  of = 1;
  var r = iv(), a = nv(), i = av(), s = sv(), h = ov();
  function o(l) {
    var u = -1, g = l == null ? 0 : l.length;
    for (this.clear(); ++u < g; ) {
      var p = l[u];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = r, o.prototype.delete = a, o.prototype.get = i, o.prototype.has = s, o.prototype.set = h, Co = o, Co;
}
var xo, hf;
function hv() {
  if (hf) return xo;
  hf = 1;
  var r = xa();
  function a() {
    this.__data__ = new r(), this.size = 0;
  }
  return xo = a, xo;
}
var Eo, lf;
function lv() {
  if (lf) return Eo;
  lf = 1;
  function r(a) {
    var i = this.__data__, s = i.delete(a);
    return this.size = i.size, s;
  }
  return Eo = r, Eo;
}
var Ao, uf;
function uv() {
  if (uf) return Ao;
  uf = 1;
  function r(a) {
    return this.__data__.get(a);
  }
  return Ao = r, Ao;
}
var Ro, cf;
function cv() {
  if (cf) return Ro;
  cf = 1;
  function r(a) {
    return this.__data__.has(a);
  }
  return Ro = r, Ro;
}
var To, df;
function dg() {
  if (df) return To;
  df = 1;
  var r = bn(), a = mn(), i = "[object AsyncFunction]", s = "[object Function]", h = "[object GeneratorFunction]", o = "[object Proxy]";
  function l(u) {
    if (!a(u))
      return !1;
    var g = r(u);
    return g == s || g == h || g == i || g == o;
  }
  return To = l, To;
}
var Po, ff;
function dv() {
  if (ff) return Po;
  ff = 1;
  var r = $e(), a = r["__core-js_shared__"];
  return Po = a, Po;
}
var Fo, gf;
function fv() {
  if (gf) return Fo;
  gf = 1;
  var r = dv(), a = function() {
    var s = /[^.]+$/.exec(r && r.keys && r.keys.IE_PROTO || "");
    return s ? "Symbol(src)_1." + s : "";
  }();
  function i(s) {
    return !!a && a in s;
  }
  return Fo = i, Fo;
}
var Oo, pf;
function fg() {
  if (pf) return Oo;
  pf = 1;
  var r = Function.prototype, a = r.toString;
  function i(s) {
    if (s != null) {
      try {
        return a.call(s);
      } catch {
      }
      try {
        return s + "";
      } catch {
      }
    }
    return "";
  }
  return Oo = i, Oo;
}
var Io, _f;
function gv() {
  if (_f) return Io;
  _f = 1;
  var r = dg(), a = fv(), i = mn(), s = fg(), h = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, l = Function.prototype, u = Object.prototype, g = l.toString, p = u.hasOwnProperty, b = RegExp(
    "^" + g.call(p).replace(h, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function S(x) {
    if (!i(x) || a(x))
      return !1;
    var v = r(x) ? b : o;
    return v.test(s(x));
  }
  return Io = S, Io;
}
var ko, vf;
function pv() {
  if (vf) return ko;
  vf = 1;
  function r(a, i) {
    return a == null ? void 0 : a[i];
  }
  return ko = r, ko;
}
var Mo, yf;
function si() {
  if (yf) return Mo;
  yf = 1;
  var r = gv(), a = pv();
  function i(s, h) {
    var o = a(s, h);
    return r(o) ? o : void 0;
  }
  return Mo = i, Mo;
}
var Lo, mf;
function al() {
  if (mf) return Lo;
  mf = 1;
  var r = si(), a = $e(), i = r(a, "Map");
  return Lo = i, Lo;
}
var No, bf;
function Ea() {
  if (bf) return No;
  bf = 1;
  var r = si(), a = r(Object, "create");
  return No = a, No;
}
var Go, Sf;
function _v() {
  if (Sf) return Go;
  Sf = 1;
  var r = Ea();
  function a() {
    this.__data__ = r ? r(null) : {}, this.size = 0;
  }
  return Go = a, Go;
}
var Do, wf;
function vv() {
  if (wf) return Do;
  wf = 1;
  function r(a) {
    var i = this.has(a) && delete this.__data__[a];
    return this.size -= i ? 1 : 0, i;
  }
  return Do = r, Do;
}
var Bo, Cf;
function yv() {
  if (Cf) return Bo;
  Cf = 1;
  var r = Ea(), a = "__lodash_hash_undefined__", i = Object.prototype, s = i.hasOwnProperty;
  function h(o) {
    var l = this.__data__;
    if (r) {
      var u = l[o];
      return u === a ? void 0 : u;
    }
    return s.call(l, o) ? l[o] : void 0;
  }
  return Bo = h, Bo;
}
var Uo, xf;
function mv() {
  if (xf) return Uo;
  xf = 1;
  var r = Ea(), a = Object.prototype, i = a.hasOwnProperty;
  function s(h) {
    var o = this.__data__;
    return r ? o[h] !== void 0 : i.call(o, h);
  }
  return Uo = s, Uo;
}
var qo, Ef;
function bv() {
  if (Ef) return qo;
  Ef = 1;
  var r = Ea(), a = "__lodash_hash_undefined__";
  function i(s, h) {
    var o = this.__data__;
    return this.size += this.has(s) ? 0 : 1, o[s] = r && h === void 0 ? a : h, this;
  }
  return qo = i, qo;
}
var zo, Af;
function Sv() {
  if (Af) return zo;
  Af = 1;
  var r = _v(), a = vv(), i = yv(), s = mv(), h = bv();
  function o(l) {
    var u = -1, g = l == null ? 0 : l.length;
    for (this.clear(); ++u < g; ) {
      var p = l[u];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = r, o.prototype.delete = a, o.prototype.get = i, o.prototype.has = s, o.prototype.set = h, zo = o, zo;
}
var Ho, Rf;
function wv() {
  if (Rf) return Ho;
  Rf = 1;
  var r = Sv(), a = xa(), i = al();
  function s() {
    this.size = 0, this.__data__ = {
      hash: new r(),
      map: new (i || a)(),
      string: new r()
    };
  }
  return Ho = s, Ho;
}
var Wo, Tf;
function Cv() {
  if (Tf) return Wo;
  Tf = 1;
  function r(a) {
    var i = typeof a;
    return i == "string" || i == "number" || i == "symbol" || i == "boolean" ? a !== "__proto__" : a === null;
  }
  return Wo = r, Wo;
}
var Vo, Pf;
function Aa() {
  if (Pf) return Vo;
  Pf = 1;
  var r = Cv();
  function a(i, s) {
    var h = i.__data__;
    return r(s) ? h[typeof s == "string" ? "string" : "hash"] : h.map;
  }
  return Vo = a, Vo;
}
var jo, Ff;
function xv() {
  if (Ff) return jo;
  Ff = 1;
  var r = Aa();
  function a(i) {
    var s = r(this, i).delete(i);
    return this.size -= s ? 1 : 0, s;
  }
  return jo = a, jo;
}
var Ko, Of;
function Ev() {
  if (Of) return Ko;
  Of = 1;
  var r = Aa();
  function a(i) {
    return r(this, i).get(i);
  }
  return Ko = a, Ko;
}
var Yo, If;
function Av() {
  if (If) return Yo;
  If = 1;
  var r = Aa();
  function a(i) {
    return r(this, i).has(i);
  }
  return Yo = a, Yo;
}
var Xo, kf;
function Rv() {
  if (kf) return Xo;
  kf = 1;
  var r = Aa();
  function a(i, s) {
    var h = r(this, i), o = h.size;
    return h.set(i, s), this.size += h.size == o ? 0 : 1, this;
  }
  return Xo = a, Xo;
}
var $o, Mf;
function gg() {
  if (Mf) return $o;
  Mf = 1;
  var r = wv(), a = xv(), i = Ev(), s = Av(), h = Rv();
  function o(l) {
    var u = -1, g = l == null ? 0 : l.length;
    for (this.clear(); ++u < g; ) {
      var p = l[u];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = r, o.prototype.delete = a, o.prototype.get = i, o.prototype.has = s, o.prototype.set = h, $o = o, $o;
}
var Zo, Lf;
function Tv() {
  if (Lf) return Zo;
  Lf = 1;
  var r = xa(), a = al(), i = gg(), s = 200;
  function h(o, l) {
    var u = this.__data__;
    if (u instanceof r) {
      var g = u.__data__;
      if (!a || g.length < s - 1)
        return g.push([o, l]), this.size = ++u.size, this;
      u = this.__data__ = new i(g);
    }
    return u.set(o, l), this.size = u.size, this;
  }
  return Zo = h, Zo;
}
var Jo, Nf;
function Pv() {
  if (Nf) return Jo;
  Nf = 1;
  var r = xa(), a = hv(), i = lv(), s = uv(), h = cv(), o = Tv();
  function l(u) {
    var g = this.__data__ = new r(u);
    this.size = g.size;
  }
  return l.prototype.clear = a, l.prototype.delete = i, l.prototype.get = s, l.prototype.has = h, l.prototype.set = o, Jo = l, Jo;
}
var Qo, Gf;
function Fv() {
  if (Gf) return Qo;
  Gf = 1;
  var r = "__lodash_hash_undefined__";
  function a(i) {
    return this.__data__.set(i, r), this;
  }
  return Qo = a, Qo;
}
var th, Df;
function Ov() {
  if (Df) return th;
  Df = 1;
  function r(a) {
    return this.__data__.has(a);
  }
  return th = r, th;
}
var eh, Bf;
function Iv() {
  if (Bf) return eh;
  Bf = 1;
  var r = gg(), a = Fv(), i = Ov();
  function s(h) {
    var o = -1, l = h == null ? 0 : h.length;
    for (this.__data__ = new r(); ++o < l; )
      this.add(h[o]);
  }
  return s.prototype.add = s.prototype.push = a, s.prototype.has = i, eh = s, eh;
}
var rh, Uf;
function kv() {
  if (Uf) return rh;
  Uf = 1;
  function r(a, i) {
    for (var s = -1, h = a == null ? 0 : a.length; ++s < h; )
      if (i(a[s], s, a))
        return !0;
    return !1;
  }
  return rh = r, rh;
}
var ih, qf;
function Mv() {
  if (qf) return ih;
  qf = 1;
  function r(a, i) {
    return a.has(i);
  }
  return ih = r, ih;
}
var nh, zf;
function pg() {
  if (zf) return nh;
  zf = 1;
  var r = Iv(), a = kv(), i = Mv(), s = 1, h = 2;
  function o(l, u, g, p, b, S) {
    var x = g & s, v = l.length, _ = u.length;
    if (v != _ && !(x && _ > v))
      return !1;
    var w = S.get(l), C = S.get(u);
    if (w && C)
      return w == u && C == l;
    var F = -1, c = !0, f = g & h ? new r() : void 0;
    for (S.set(l, u), S.set(u, l); ++F < v; ) {
      var m = l[F], E = u[F];
      if (p)
        var T = x ? p(E, m, F, u, l, S) : p(m, E, F, l, u, S);
      if (T !== void 0) {
        if (T)
          continue;
        c = !1;
        break;
      }
      if (f) {
        if (!a(u, function(D, k) {
          if (!i(f, k) && (m === D || b(m, D, g, p, S)))
            return f.push(k);
        })) {
          c = !1;
          break;
        }
      } else if (!(m === E || b(m, E, g, p, S))) {
        c = !1;
        break;
      }
    }
    return S.delete(l), S.delete(u), c;
  }
  return nh = o, nh;
}
var ah, Hf;
function Lv() {
  if (Hf) return ah;
  Hf = 1;
  var r = $e(), a = r.Uint8Array;
  return ah = a, ah;
}
var sh, Wf;
function Nv() {
  if (Wf) return sh;
  Wf = 1;
  function r(a) {
    var i = -1, s = Array(a.size);
    return a.forEach(function(h, o) {
      s[++i] = [o, h];
    }), s;
  }
  return sh = r, sh;
}
var oh, Vf;
function Gv() {
  if (Vf) return oh;
  Vf = 1;
  function r(a) {
    var i = -1, s = Array(a.size);
    return a.forEach(function(h) {
      s[++i] = h;
    }), s;
  }
  return oh = r, oh;
}
var hh, jf;
function Dv() {
  if (jf) return hh;
  jf = 1;
  var r = wa(), a = Lv(), i = cg(), s = pg(), h = Nv(), o = Gv(), l = 1, u = 2, g = "[object Boolean]", p = "[object Date]", b = "[object Error]", S = "[object Map]", x = "[object Number]", v = "[object RegExp]", _ = "[object Set]", w = "[object String]", C = "[object Symbol]", F = "[object ArrayBuffer]", c = "[object DataView]", f = r ? r.prototype : void 0, m = f ? f.valueOf : void 0;
  function E(T, D, k, M, O, N, z) {
    switch (k) {
      case c:
        if (T.byteLength != D.byteLength || T.byteOffset != D.byteOffset)
          return !1;
        T = T.buffer, D = D.buffer;
      case F:
        return !(T.byteLength != D.byteLength || !N(new a(T), new a(D)));
      case g:
      case p:
      case x:
        return i(+T, +D);
      case b:
        return T.name == D.name && T.message == D.message;
      case v:
      case w:
        return T == D + "";
      case S:
        var y = h;
      case _:
        var P = M & l;
        if (y || (y = o), T.size != D.size && !P)
          return !1;
        var A = z.get(T);
        if (A)
          return A == D;
        M |= u, z.set(T, D);
        var G = s(y(T), y(D), M, O, N, z);
        return z.delete(T), G;
      case C:
        if (m)
          return m.call(T) == m.call(D);
    }
    return !1;
  }
  return hh = E, hh;
}
var lh, Kf;
function Bv() {
  if (Kf) return lh;
  Kf = 1;
  function r(a, i) {
    for (var s = -1, h = i.length, o = a.length; ++s < h; )
      a[o + s] = i[s];
    return a;
  }
  return lh = r, lh;
}
var uh, Yf;
function Ra() {
  if (Yf) return uh;
  Yf = 1;
  var r = Array.isArray;
  return uh = r, uh;
}
var ch, Xf;
function Uv() {
  if (Xf) return ch;
  Xf = 1;
  var r = Bv(), a = Ra();
  function i(s, h, o) {
    var l = h(s);
    return a(s) ? l : r(l, o(s));
  }
  return ch = i, ch;
}
var dh, $f;
function qv() {
  if ($f) return dh;
  $f = 1;
  function r(a, i) {
    for (var s = -1, h = a == null ? 0 : a.length, o = 0, l = []; ++s < h; ) {
      var u = a[s];
      i(u, s, a) && (l[o++] = u);
    }
    return l;
  }
  return dh = r, dh;
}
var fh, Zf;
function zv() {
  if (Zf) return fh;
  Zf = 1;
  function r() {
    return [];
  }
  return fh = r, fh;
}
var gh, Jf;
function Hv() {
  if (Jf) return gh;
  Jf = 1;
  var r = qv(), a = zv(), i = Object.prototype, s = i.propertyIsEnumerable, h = Object.getOwnPropertySymbols, o = h ? function(l) {
    return l == null ? [] : (l = Object(l), r(h(l), function(u) {
      return s.call(l, u);
    }));
  } : a;
  return gh = o, gh;
}
var ph, Qf;
function Wv() {
  if (Qf) return ph;
  Qf = 1;
  function r(a, i) {
    for (var s = -1, h = Array(a); ++s < a; )
      h[s] = i(s);
    return h;
  }
  return ph = r, ph;
}
var _h, t0;
function Vv() {
  if (t0) return _h;
  t0 = 1;
  var r = bn(), a = Sn(), i = "[object Arguments]";
  function s(h) {
    return a(h) && r(h) == i;
  }
  return _h = s, _h;
}
var vh, e0;
function jv() {
  if (e0) return vh;
  e0 = 1;
  var r = Vv(), a = Sn(), i = Object.prototype, s = i.hasOwnProperty, h = i.propertyIsEnumerable, o = r(/* @__PURE__ */ function() {
    return arguments;
  }()) ? r : function(l) {
    return a(l) && s.call(l, "callee") && !h.call(l, "callee");
  };
  return vh = o, vh;
}
var fn = { exports: {} }, yh, r0;
function Kv() {
  if (r0) return yh;
  r0 = 1;
  function r() {
    return !1;
  }
  return yh = r, yh;
}
fn.exports;
var i0;
function _g() {
  return i0 || (i0 = 1, function(r, a) {
    var i = $e(), s = Kv(), h = a && !a.nodeType && a, o = h && !0 && r && !r.nodeType && r, l = o && o.exports === h, u = l ? i.Buffer : void 0, g = u ? u.isBuffer : void 0, p = g || s;
    r.exports = p;
  }(fn, fn.exports)), fn.exports;
}
var mh, n0;
function vg() {
  if (n0) return mh;
  n0 = 1;
  var r = 9007199254740991, a = /^(?:0|[1-9]\d*)$/;
  function i(s, h) {
    var o = typeof s;
    return h = h == null ? r : h, !!h && (o == "number" || o != "symbol" && a.test(s)) && s > -1 && s % 1 == 0 && s < h;
  }
  return mh = i, mh;
}
var bh, a0;
function yg() {
  if (a0) return bh;
  a0 = 1;
  var r = 9007199254740991;
  function a(i) {
    return typeof i == "number" && i > -1 && i % 1 == 0 && i <= r;
  }
  return bh = a, bh;
}
var Sh, s0;
function Yv() {
  if (s0) return Sh;
  s0 = 1;
  var r = bn(), a = yg(), i = Sn(), s = "[object Arguments]", h = "[object Array]", o = "[object Boolean]", l = "[object Date]", u = "[object Error]", g = "[object Function]", p = "[object Map]", b = "[object Number]", S = "[object Object]", x = "[object RegExp]", v = "[object Set]", _ = "[object String]", w = "[object WeakMap]", C = "[object ArrayBuffer]", F = "[object DataView]", c = "[object Float32Array]", f = "[object Float64Array]", m = "[object Int8Array]", E = "[object Int16Array]", T = "[object Int32Array]", D = "[object Uint8Array]", k = "[object Uint8ClampedArray]", M = "[object Uint16Array]", O = "[object Uint32Array]", N = {};
  N[c] = N[f] = N[m] = N[E] = N[T] = N[D] = N[k] = N[M] = N[O] = !0, N[s] = N[h] = N[C] = N[o] = N[F] = N[l] = N[u] = N[g] = N[p] = N[b] = N[S] = N[x] = N[v] = N[_] = N[w] = !1;
  function z(y) {
    return i(y) && a(y.length) && !!N[r(y)];
  }
  return Sh = z, Sh;
}
var wh, o0;
function Xv() {
  if (o0) return wh;
  o0 = 1;
  function r(a) {
    return function(i) {
      return a(i);
    };
  }
  return wh = r, wh;
}
var gn = { exports: {} };
gn.exports;
var h0;
function $v() {
  return h0 || (h0 = 1, function(r, a) {
    var i = hg(), s = a && !a.nodeType && a, h = s && !0 && r && !r.nodeType && r, o = h && h.exports === s, l = o && i.process, u = function() {
      try {
        var g = h && h.require && h.require("util").types;
        return g || l && l.binding && l.binding("util");
      } catch {
      }
    }();
    r.exports = u;
  }(gn, gn.exports)), gn.exports;
}
var Ch, l0;
function mg() {
  if (l0) return Ch;
  l0 = 1;
  var r = Yv(), a = Xv(), i = $v(), s = i && i.isTypedArray, h = s ? a(s) : r;
  return Ch = h, Ch;
}
var xh, u0;
function Zv() {
  if (u0) return xh;
  u0 = 1;
  var r = Wv(), a = jv(), i = Ra(), s = _g(), h = vg(), o = mg(), l = Object.prototype, u = l.hasOwnProperty;
  function g(p, b) {
    var S = i(p), x = !S && a(p), v = !S && !x && s(p), _ = !S && !x && !v && o(p), w = S || x || v || _, C = w ? r(p.length, String) : [], F = C.length;
    for (var c in p)
      (b || u.call(p, c)) && !(w && // Safari 9 has enumerable `arguments.length` in strict mode.
      (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      v && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      _ && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
      h(c, F))) && C.push(c);
    return C;
  }
  return xh = g, xh;
}
var Eh, c0;
function Jv() {
  if (c0) return Eh;
  c0 = 1;
  var r = Object.prototype;
  function a(i) {
    var s = i && i.constructor, h = typeof s == "function" && s.prototype || r;
    return i === h;
  }
  return Eh = a, Eh;
}
var Ah, d0;
function Qv() {
  if (d0) return Ah;
  d0 = 1;
  function r(a, i) {
    return function(s) {
      return a(i(s));
    };
  }
  return Ah = r, Ah;
}
var Rh, f0;
function ty() {
  if (f0) return Rh;
  f0 = 1;
  var r = Qv(), a = r(Object.keys, Object);
  return Rh = a, Rh;
}
var Th, g0;
function ey() {
  if (g0) return Th;
  g0 = 1;
  var r = Jv(), a = ty(), i = Object.prototype, s = i.hasOwnProperty;
  function h(o) {
    if (!r(o))
      return a(o);
    var l = [];
    for (var u in Object(o))
      s.call(o, u) && u != "constructor" && l.push(u);
    return l;
  }
  return Th = h, Th;
}
var Ph, p0;
function ry() {
  if (p0) return Ph;
  p0 = 1;
  var r = dg(), a = yg();
  function i(s) {
    return s != null && a(s.length) && !r(s);
  }
  return Ph = i, Ph;
}
var Fh, _0;
function iy() {
  if (_0) return Fh;
  _0 = 1;
  var r = Zv(), a = ey(), i = ry();
  function s(h) {
    return i(h) ? r(h) : a(h);
  }
  return Fh = s, Fh;
}
var Oh, v0;
function ny() {
  if (v0) return Oh;
  v0 = 1;
  var r = Uv(), a = Hv(), i = iy();
  function s(h) {
    return r(h, i, a);
  }
  return Oh = s, Oh;
}
var Ih, y0;
function ay() {
  if (y0) return Ih;
  y0 = 1;
  var r = ny(), a = 1, i = Object.prototype, s = i.hasOwnProperty;
  function h(o, l, u, g, p, b) {
    var S = u & a, x = r(o), v = x.length, _ = r(l), w = _.length;
    if (v != w && !S)
      return !1;
    for (var C = v; C--; ) {
      var F = x[C];
      if (!(S ? F in l : s.call(l, F)))
        return !1;
    }
    var c = b.get(o), f = b.get(l);
    if (c && f)
      return c == l && f == o;
    var m = !0;
    b.set(o, l), b.set(l, o);
    for (var E = S; ++C < v; ) {
      F = x[C];
      var T = o[F], D = l[F];
      if (g)
        var k = S ? g(D, T, F, l, o, b) : g(T, D, F, o, l, b);
      if (!(k === void 0 ? T === D || p(T, D, u, g, b) : k)) {
        m = !1;
        break;
      }
      E || (E = F == "constructor");
    }
    if (m && !E) {
      var M = o.constructor, O = l.constructor;
      M != O && "constructor" in o && "constructor" in l && !(typeof M == "function" && M instanceof M && typeof O == "function" && O instanceof O) && (m = !1);
    }
    return b.delete(o), b.delete(l), m;
  }
  return Ih = h, Ih;
}
var kh, m0;
function sy() {
  if (m0) return kh;
  m0 = 1;
  var r = si(), a = $e(), i = r(a, "DataView");
  return kh = i, kh;
}
var Mh, b0;
function oy() {
  if (b0) return Mh;
  b0 = 1;
  var r = si(), a = $e(), i = r(a, "Promise");
  return Mh = i, Mh;
}
var Lh, S0;
function hy() {
  if (S0) return Lh;
  S0 = 1;
  var r = si(), a = $e(), i = r(a, "Set");
  return Lh = i, Lh;
}
var Nh, w0;
function ly() {
  if (w0) return Nh;
  w0 = 1;
  var r = si(), a = $e(), i = r(a, "WeakMap");
  return Nh = i, Nh;
}
var Gh, C0;
function uy() {
  if (C0) return Gh;
  C0 = 1;
  var r = sy(), a = al(), i = oy(), s = hy(), h = ly(), o = bn(), l = fg(), u = "[object Map]", g = "[object Object]", p = "[object Promise]", b = "[object Set]", S = "[object WeakMap]", x = "[object DataView]", v = l(r), _ = l(a), w = l(i), C = l(s), F = l(h), c = o;
  return (r && c(new r(new ArrayBuffer(1))) != x || a && c(new a()) != u || i && c(i.resolve()) != p || s && c(new s()) != b || h && c(new h()) != S) && (c = function(f) {
    var m = o(f), E = m == g ? f.constructor : void 0, T = E ? l(E) : "";
    if (T)
      switch (T) {
        case v:
          return x;
        case _:
          return u;
        case w:
          return p;
        case C:
          return b;
        case F:
          return S;
      }
    return m;
  }), Gh = c, Gh;
}
var Dh, x0;
function cy() {
  if (x0) return Dh;
  x0 = 1;
  var r = Pv(), a = pg(), i = Dv(), s = ay(), h = uy(), o = Ra(), l = _g(), u = mg(), g = 1, p = "[object Arguments]", b = "[object Array]", S = "[object Object]", x = Object.prototype, v = x.hasOwnProperty;
  function _(w, C, F, c, f, m) {
    var E = o(w), T = o(C), D = E ? b : h(w), k = T ? b : h(C);
    D = D == p ? S : D, k = k == p ? S : k;
    var M = D == S, O = k == S, N = D == k;
    if (N && l(w)) {
      if (!l(C))
        return !1;
      E = !0, M = !1;
    }
    if (N && !M)
      return m || (m = new r()), E || u(w) ? a(w, C, F, c, f, m) : i(w, C, D, F, c, f, m);
    if (!(F & g)) {
      var z = M && v.call(w, "__wrapped__"), y = O && v.call(C, "__wrapped__");
      if (z || y) {
        var P = z ? w.value() : w, A = y ? C.value() : C;
        return m || (m = new r()), f(P, A, F, c, m);
      }
    }
    return N ? (m || (m = new r()), s(w, C, F, c, f, m)) : !1;
  }
  return Dh = _, Dh;
}
var Bh, E0;
function dy() {
  if (E0) return Bh;
  E0 = 1;
  var r = cy(), a = Sn();
  function i(s, h, o, l, u) {
    return s === h ? !0 : s == null || h == null || !a(s) && !a(h) ? s !== s && h !== h : r(s, h, o, l, i, u);
  }
  return Bh = i, Bh;
}
var Uh, A0;
function fy() {
  if (A0) return Uh;
  A0 = 1;
  var r = dy();
  function a(i, s) {
    return r(i, s);
  }
  return Uh = a, Uh;
}
var gy = fy();
const R0 = /* @__PURE__ */ ai(gy);
var qh, T0;
function py() {
  if (T0) return qh;
  T0 = 1;
  var r = nl(), a = 1 / 0, i = 17976931348623157e292;
  function s(h) {
    if (!h)
      return h === 0 ? h : 0;
    if (h = r(h), h === a || h === -1 / 0) {
      var o = h < 0 ? -1 : 1;
      return o * i;
    }
    return h === h ? h : 0;
  }
  return qh = s, qh;
}
var zh, P0;
function bg() {
  if (P0) return zh;
  P0 = 1;
  var r = py();
  function a(i) {
    var s = r(i), h = s % 1;
    return s === s ? h ? s - h : s : 0;
  }
  return zh = a, zh;
}
var Hh, F0;
function _y() {
  if (F0) return Hh;
  F0 = 1;
  function r(a, i) {
    for (var s = -1, h = a == null ? 0 : a.length, o = Array(h); ++s < h; )
      o[s] = i(a[s], s, a);
    return o;
  }
  return Hh = r, Hh;
}
var Wh, O0;
function vy() {
  if (O0) return Wh;
  O0 = 1;
  var r = wa(), a = _y(), i = Ra(), s = lg(), h = r ? r.prototype : void 0, o = h ? h.toString : void 0;
  function l(u) {
    if (typeof u == "string")
      return u;
    if (i(u))
      return a(u, l) + "";
    if (s(u))
      return o ? o.call(u) : "";
    var g = u + "";
    return g == "0" && 1 / u == -1 / 0 ? "-0" : g;
  }
  return Wh = l, Wh;
}
var Vh, I0;
function yy() {
  if (I0) return Vh;
  I0 = 1;
  var r = vy();
  function a(i) {
    return i == null ? "" : r(i);
  }
  return Vh = a, Vh;
}
var jh, k0;
function my() {
  if (k0) return jh;
  k0 = 1;
  var r = $e(), a = bg(), i = nl(), s = yy(), h = r.isFinite, o = Math.min;
  function l(u) {
    var g = Math[u];
    return function(p, b) {
      if (p = i(p), b = b == null ? 0 : o(a(b), 292), b && h(p)) {
        var S = (s(p) + "e").split("e"), x = g(S[0] + "e" + (+S[1] + b));
        return S = (s(x) + "e").split("e"), +(S[0] + "e" + (+S[1] - b));
      }
      return g(p);
    };
  }
  return jh = l, jh;
}
var Kh, M0;
function by() {
  if (M0) return Kh;
  M0 = 1;
  var r = my(), a = r("round");
  return Kh = a, Kh;
}
var Sy = by();
const pn = /* @__PURE__ */ ai(Sy);
var Yh, L0;
function wy() {
  if (L0) return Yh;
  L0 = 1;
  var r = ug(), a = mn(), i = "Expected a function";
  function s(h, o, l) {
    var u = !0, g = !0;
    if (typeof h != "function")
      throw new TypeError(i);
    return a(l) && (u = "leading" in l ? !!l.leading : u, g = "trailing" in l ? !!l.trailing : g), r(h, o, {
      leading: u,
      maxWait: o,
      trailing: g
    });
  }
  return Yh = s, Yh;
}
var Cy = wy();
const Sg = /* @__PURE__ */ ai(Cy), N0 = (r) => {
  let a;
  const i = /* @__PURE__ */ new Set(), s = (p, b) => {
    const S = typeof p == "function" ? p(a) : p;
    if (!Object.is(S, a)) {
      const x = a;
      a = (b != null ? b : typeof S != "object" || S === null) ? S : Object.assign({}, a, S), i.forEach((v) => v(a, x));
    }
  }, h = () => a, u = { setState: s, getState: h, getInitialState: () => g, subscribe: (p) => (i.add(p), () => i.delete(p)) }, g = a = r(s, h, u);
  return u;
}, wg = (r) => r ? N0(r) : N0, wt = wg(() => ({
  assetsBaseUrl: "",
  backgroundUrl: null,
  debug: !1,
  draggable: !0,
  elementsLayerOffsetX: 0,
  fit: yn.COVER,
  isPrintEnabled: !1,
  mapSize: {
    height: 0,
    width: 0
  },
  originalMapSize: {
    height: 0,
    width: 0
  },
  containerSize: {
    height: 0,
    width: 0
  },
  minScale: 0
})), _a = {
  getBackgroundColor(r) {
    switch (r) {
      case tt.GREY:
        return "rgb(103, 103, 103, 0.4)";
      case tt.BLUE:
        return "rgba(0, 176, 255, 0.4)";
      default:
        gr(r);
    }
  },
  getBorderColor(r) {
    switch (r) {
      case tt.GREY:
        return "rgb(103, 103, 103)";
      case tt.BLUE:
        return "rgb(0, 176, 255)";
      default:
        gr(r);
    }
  }
}, xe = {
  loadImageFromUrl(r, a) {
    const { isPrintEnabled: i } = wt.getState();
    return new Promise((s, h) => {
      const o = document.createElement("img");
      i && (o.crossOrigin = "anonymous"), o.onload = function() {
        const l = new ft.Image({
          image: o,
          listening: !1,
          ...a
        });
        s(l);
      }, o.onerror = h, o.src = r;
    });
  }
};
function G0(r) {
  return typeof r == "string";
}
class Xe extends ft.Group {
  constructor(i, s) {
    var h;
    super(i);
    qe(this, "HIGHLIGHT_GROUP_NAME", "highlight");
    qe(this, "IMAGE_NAME", "image");
    qe(this, "SPOT_NAME", "spot");
    qe(this, "GAP", 2);
    qe(this, "ATTRIBUTE_ICON_WIDTH", 8);
    qe(this, "highligthColor", null);
    this.spot = s, this.highligthColor = (h = s.highlightColor) != null ? h : null;
  }
  get backgroundBorderColor() {
    var i, s, h;
    return (h = (s = (i = this.spot.style) == null ? void 0 : i.css) == null ? void 0 : s.borderColor) != null ? h : "rgb(135, 135, 135)";
  }
  get hasAttributeIcon() {
    var i;
    return G0((i = this.spot.style) == null ? void 0 : i.attributeIcon);
  }
  get isPlayfield() {
    return this.spot.subType === Ar.PLAYFIELD;
  }
  get strokeWidth() {
    var i, s, h;
    return (h = (s = (i = this.spot.style) == null ? void 0 : i.css) == null ? void 0 : s.borderWidth) != null ? h : 1;
  }
  get bgWidth() {
    return this.spot.width - this.strokeWidth;
  }
  addBackground() {
    var s, h, o, l, u;
    const i = new ft.Rect({
      width: this.bgWidth,
      height: this.spot.height - this.strokeWidth,
      fill: (o = (h = (s = this.spot.style) == null ? void 0 : s.css) == null ? void 0 : h.backgroundColor) != null ? o : "#FFF",
      cornerRadius: 4,
      stroke: this.backgroundBorderColor,
      strokeWidth: this.strokeWidth,
      ...((u = (l = this.spot.style) == null ? void 0 : l.css) == null ? void 0 : u.borderStyle) === "dashed" ? { dash: [5, 5] } : {}
    });
    this.add(i);
  }
  async clearHighlight() {
    this.highligthColor = null, this.find(`.${this.HIGHLIGHT_GROUP_NAME}`).forEach((i) => i.destroy());
  }
  async highlight(i, s = !1) {
    try {
      if (this.highligthColor !== null && !s)
        return;
      this.highligthColor = i;
      const h = _a.getBackgroundColor(i), o = _a.getBorderColor(i), l = new ft.Rect({
        name: this.HIGHLIGHT_GROUP_NAME,
        width: this.width(),
        height: this.height(),
        fill: h,
        stroke: o,
        cornerRadius: 4,
        listening: !1
      });
      this.add(l), l.zIndex(1);
      const u = await xe.loadImageFromUrl(
        `${wt.getState().assetsBaseUrl}/iconset/check.svg`
      ), g = new ft.Circle({
        name: this.HIGHLIGHT_GROUP_NAME,
        width: 16,
        height: 16,
        fill: o,
        x: this.width() / 2,
        y: this.height() / 2,
        listening: !1
      }), p = 10;
      u.name(this.HIGHLIGHT_GROUP_NAME), u.width(p), u.height(p), u.x(this.width() / 2 - p / 2), u.y(this.height() / 2 - p / 2), this.add(g, u);
    } catch (h) {
      console.error(h);
    }
  }
  getYFromImageSize() {
    const i = this.GAP, s = this.findOne(`.${this.IMAGE_NAME}`);
    return s ? s.y() + 1 + s.height() : i;
  }
  async addAttributeIcon(i = 1) {
    var s;
    try {
      const h = (s = this.spot.style) == null ? void 0 : s.attributeIcon;
      if (!G0(h))
        return;
      const { assetsBaseUrl: o } = wt.getState(), l = await xe.loadImageFromUrl(
        `${o}/iconset/${h}`
      ), u = this.ATTRIBUTE_ICON_WIDTH * i, g = new ft.Rect({
        width: u + this.GAP * 2,
        height: u + this.GAP * 2,
        fill: this.backgroundBorderColor,
        listening: !1
      });
      g.x(this.bgWidth - g.width()), l.width(u), l.height(u), l.x(this.bgWidth - u - this.GAP), l.y(this.GAP), l.listening(!1), this.add(g, l);
    } catch (h) {
      console.error(h);
    }
  }
}
const xy = "background-sea", Ey = "background-sand", Ay = 100;
class Ry extends ft.Layer {
  constructor(i) {
    super({
      draggable: !1,
      listening: !1
    });
    qe(this, "bgImage", null);
    qe(this, "seaImage", null);
    qe(this, "sandRect", null);
    typeof (i == null ? void 0 : i.visible) == "boolean" && this.visible(i.visible), this.init();
  }
  setVisibility(i) {
    this.visible(i);
  }
  toggleVisibility() {
    this.visible(!this.visible());
  }
  updateBgSize() {
    const i = wt.getState();
    this.sandRect !== null && (this.sandRect.width(i.mapSize.width), this.sandRect.height(i.mapSize.height)), this.seaImage !== null && this.seaImage.width(i.mapSize.width), this.bgImage !== null && (this.bgImage.width(i.mapSize.width), this.bgImage.height(i.mapSize.height));
  }
  init() {
    this.renderSand(), this.renderSea(() => this.renderCustomBackground());
  }
  renderSand() {
    const i = wt.getState();
    this.sandRect = new ft.Rect({
      x: 0,
      y: 0,
      width: i.mapSize.width,
      height: i.mapSize.height,
      fill: "wheat",
      id: Ey,
      listening: !1,
      draggable: !1
    }), this.add(this.sandRect);
  }
  renderSea(i) {
    const { assetsBaseUrl: s } = wt.getState();
    xe.loadImageFromUrl(`${s}/images/sea.svg`).then((h) => {
      this.seaImage = h;
      const o = wt.getState();
      h.setAttrs({
        x: 0,
        y: 0,
        fillPatternRepeat: "repeat-x",
        width: o.mapSize.width,
        height: Ay,
        id: xy
      }), h.listening(!1), h.draggable(!1), this.add(h), i();
    }).catch((h) => {
      console.error(h);
    });
  }
  renderCustomBackground() {
    const i = wt.getState();
    i.backgroundUrl && xe.loadImageFromUrl(i.backgroundUrl).then((s) => {
      this.bgImage = s, s.width(i.mapSize.width), s.height(i.mapSize.height), this.add(s);
    }).catch((s) => {
      console.error(s);
    });
  }
}
var Xh, D0;
function Ty() {
  if (D0) return Xh;
  D0 = 1;
  var r = vg();
  function a(i, s) {
    var h = i.length;
    if (h)
      return s += s < 0 ? h : 0, r(s, h) ? i[s] : void 0;
  }
  return Xh = a, Xh;
}
var $h, B0;
function Py() {
  if (B0) return $h;
  B0 = 1;
  var r = Ty(), a = bg();
  function i(s, h) {
    return s && s.length ? r(s, a(h)) : void 0;
  }
  return $h = i, $h;
}
var Fy = Py();
const Oy = /* @__PURE__ */ ai(Fy);
class Br extends ft.Group {
  constructor(a, i, s) {
    super({
      x: i.x,
      y: i.y,
      ...s
    }), this.decoration = i, this.add(a), this.init(a);
  }
  getSubType() {
    return this.decoration.subType;
  }
  get isSquareCell() {
    return this.decoration.width === this.decoration.cellSize.width;
  }
  get isDebugEnabled() {
    return wt.getState().debug;
  }
  addDebugInfo() {
    if (!this.isDebugEnabled)
      return;
    const a = new ft.Rect({
      dash: [5, 5],
      height: this.height(),
      listening: !1,
      stroke: "rebeccapurple",
      strokeWidth: 1,
      width: this.width(),
      x: 0,
      y: 0
    });
    this.add(a);
  }
}
const ee = '"Roboto", system-ui, -apple-system, "Segoe UI", "Helvetica Neue", Arial, sans-serif', dn = 4;
class Iy extends Br {
  constructor(a, i) {
    super(a, i, {
      height: i.cellSize.height,
      width: i.cellSize.width
    }), this.add(a);
  }
  init(a) {
    var h;
    const i = new ft.Text({
      fill: "black",
      fontFamily: ee,
      fontSize: 14,
      padding: dn,
      text: this.decoration.name,
      x: dn / 2,
      y: dn / 2
    }), s = new ft.Rect({
      cornerRadius: 8,
      fill: "white",
      height: i.height() + dn,
      width: i.width() + dn
    });
    if (a instanceof ft.Group) {
      a.add(s, i);
      const o = this.createTriangle({
        balloonHeight: s.height(),
        balloonWidth: s.width(),
        triangleSize: 8,
        direction: (h = this.decoration.direction) != null ? h : "left"
      });
      o && a.add(o), a.scale({
        x: this.decoration.cellSize.width,
        y: this.decoration.cellSize.height
      }), this.decoration.rotation > 0 && a.rotation(this.decoration.rotation);
    }
  }
  createTriangle(a) {
    const {
      balloonHeight: i,
      balloonWidth: s,
      direction: h = "left",
      triangleSize: o
    } = a;
    let l = [];
    switch (h) {
      case "left":
        l = [
          -o,
          i / 2,
          0,
          i / 2 - o / 2,
          0,
          i / 2 + o / 2,
          -o,
          i / 2
        ];
        break;
      case "right":
        l = [
          s + o,
          i / 2,
          s,
          i / 2 - o / 2,
          s,
          i / 2 + o / 2,
          s + o,
          i / 2
        ];
        break;
      case "top":
        l = [
          s / 2,
          -o,
          s / 2 - o / 2,
          0,
          s / 2 + o / 2,
          0,
          s / 2,
          -o
        ];
        break;
      case "bottom":
        l = [
          s / 2,
          i + o,
          s / 2 - o / 2,
          i,
          s / 2 + o / 2,
          i,
          s / 2,
          i + o
        ];
        break;
      case "none":
        return null;
      default:
        gr(h);
    }
    return new ft.Line({
      points: l,
      fill: "white",
      stroke: "white",
      strokeWidth: 1,
      closed: !0
    });
  }
}
const _n = (r) => r * (Math.PI / 180), ky = (r) => r * (180 / Math.PI);
function U0(r, a) {
  const i = Math.cos(a), s = Math.sin(a);
  return {
    x: r.x * i - r.y * s,
    y: r.y * i + r.x * s
  };
}
function Gr(r, a) {
  const i = { x: -r.width() / 2, y: -r.height() / 2 }, s = U0(i, 0), h = U0(i, _n(a)), o = h.x - s.x, l = h.y - s.y;
  r.rotation(a), r.x(r.x() + o), r.y(r.y() + l);
}
class Cg extends Br {
  constructor(a, i) {
    const s = i.cellSize.width / i.width;
    super(a, i, {
      height: a.height(),
      width: a.width() * s
    }), this.add(a);
  }
  init(a) {
    this.addDebugInfo(), a.x(this.width() / 2 - a.width() / 2), this.decoration.rotation > 0 && Gr(a, this.decoration.rotation);
  }
  addDebugInfo() {
    if (!this.isDebugEnabled)
      return;
    const a = new ft.Rect({
      dash: [5, 5],
      height: this.height(),
      listening: !1,
      stroke: "yellow",
      strokeWidth: 1,
      width: this.width(),
      x: 0,
      y: 0
    });
    this.add(a);
  }
}
class My extends Br {
  constructor(a, i) {
    super(a, i, {
      height: i.cellSize.height,
      width: i.cellSize.width
    }), this.add(a);
  }
  init(a) {
    this.adjustImageSize(a), this.adjustImagePosition(a), this.addDebugInfo();
  }
  getCustomDecorationImageSize(a, i, s) {
    const h = a.width / i, o = a.height / s;
    return h < o ? {
      width: a.width,
      height: Math.floor(s * h)
    } : {
      width: Math.floor(i * o),
      height: a.height
    };
  }
  adjustImageSize(a) {
    a.setAttrs({
      ...this.getCustomDecorationImageSize(
        this.decoration,
        a.width(),
        a.height()
      )
    });
  }
  adjustImagePosition(a) {
    a.x(this.width() / 2 - a.width() / 2), a.y(this.height() / 2 - a.height() / 2), this.decoration.rotation > 0 && Gr(a, this.decoration.rotation);
  }
}
class Ly extends Br {
  constructor(a, i) {
    super(a, i, {
      height: i.cellSize.height,
      width: i.cellSize.width
    }), this.add(a);
  }
  init() {
  }
}
class Ny extends Br {
  constructor(a, i) {
    super(a, i, {
      height: i.height,
      width: i.width
    }), this.add(a);
  }
  init(a) {
    this.adjustLineWidth(a), this.adjustRotation(a), this.addDebugInfo();
  }
  addDebugInfo() {
    if (!this.isDebugEnabled)
      return;
    const a = _n(this.decoration.rotation), i = Math.cos(a), s = Math.sin(a);
    if (Math.abs(i) === 1 || Math.abs(s) === 1)
      return;
    const h = i < 0, o = s < 0, l = Math.abs(this.decoration.width * i), u = Math.abs(this.decoration.width * s), g = new ft.Rect({
      x: h ? -l : 0,
      y: o ? -u : 0,
      width: l,
      height: u,
      stroke: "goldenrod",
      strokeWidth: 1,
      dash: [5, 5],
      listening: !1
    }), p = this.decoration.cellSize.width / this.decoration.width;
    if (p !== 1) {
      const b = l * p, S = new ft.Rect({
        x: h ? -b : 0,
        y: o ? -u : 0,
        width: b,
        height: u,
        stroke: "deepskyblue",
        strokeWidth: 1,
        dash: [5, 5],
        listening: !1
      });
      this.add(S);
    }
    this.add(g);
  }
  adjustLineWidth(a) {
    if (this.isSquareCell || !(a instanceof ft.Group) || a.children.length < 1)
      return;
    const i = a.children[0], s = _n(this.decoration.rotation), h = Math.cos(s), o = Math.sin(s);
    if (Math.abs(o) === 1)
      return;
    if (Math.abs(h) === 1) {
      i.width(this.decoration.cellSize.width);
      return;
    }
    const l = this.decoration.width * h, u = this.decoration.width * o, g = this.decoration.cellSize.width / this.decoration.width, p = l * g, b = Math.sqrt(Math.pow(p, 2) + Math.pow(u, 2));
    i.width(b);
  }
  adjustRotation(a) {
    if (this.decoration.rotation <= 0)
      return;
    const i = _n(this.decoration.rotation), s = Math.cos(i), h = Math.sin(i);
    if (this.isSquareCell || Math.abs(s) === 1 || Math.abs(h) === 1) {
      Gr(a, this.decoration.rotation);
      return;
    }
    const o = s < 0, l = h < 0, u = Math.abs(this.decoration.width * s), g = Math.abs(this.decoration.width * h), p = this.decoration.cellSize.width / this.decoration.width, b = u * p, S = Math.atan(g / b), x = ky(S);
    o && l ? Gr(a, x + 180) : o ? Gr(a, 180 - x) : Gr(a, x);
  }
}
function Gy(r) {
  const a = _n(r), i = Math.cos(a), s = Math.sin(a);
  switch (!0) {
    case i === 1:
      return "horizontal";
    case i === -1:
      return "horizontal-flip";
    case s === 1:
      return "vertical";
    case s === -1:
      return "vertical-flip";
    default:
      return "diagonal";
  }
}
class Dy extends Cg {
  constructor(a, i) {
    super(a, i);
  }
  init(a) {
    const i = Gy(this.decoration.rotation);
    if (this.isSquareCell || i === "diagonal") {
      super.init(a);
      return;
    }
    this.decoration.rotation > 0 && Gr(a, this.decoration.rotation), this.handleStretch(a, i), this.addDebugInfo();
  }
  addDebugInfo() {
    if (!this.isDebugEnabled)
      return;
    const a = this.children[0];
    if (!a)
      return;
    const i = new ft.Rect({
      dash: [5, 5],
      height: a.height(),
      listening: !1,
      stroke: "hotpink",
      strokeWidth: 1,
      width: a.width(),
      x: 0,
      y: 0
    });
    this.add(i);
  }
  handleStretch(a, i) {
    const s = this.decoration.cellSize.width / this.decoration.width;
    switch (i) {
      case "vertical": {
        const h = a.height() * s, o = h - a.height();
        a.height(h), a.offsetY(o);
        break;
      }
      case "vertical-flip": {
        a.height(a.height() * s);
        break;
      }
      case "horizontal": {
        a.width(a.width() * s), a.x(0);
        break;
      }
      case "horizontal-flip": {
        a.width(a.width() * s), a.x(this.width());
        break;
      }
      default:
        gr(i);
    }
  }
}
const By = "black";
class Uy {
  async createDecoration(a) {
    switch (a.subType) {
      case Ce.BALLOON:
        return zy(a);
      case Ce.CUSTOM:
        return qy(a);
      case Ce.LABEL:
        return Hy(a);
      case Ce.LINE:
        return Vy(a);
      case Ce.BASKET_FIELD:
      case Ce.BEACH_VOLLEY:
      case Ce.FOOTBOARD:
      case Ce.POOL:
      case Ce.POOL_ROUNDED:
      case Ce.SOCCER_FIELD:
      case Ce.TENT:
      case Ce.TENT_BIG:
        return q0(a, !0);
      default:
        return q0(a);
    }
  }
}
async function qy(r) {
  if (!r.url)
    throw new Error("Decoration URL is required");
  try {
    const a = await xe.loadImageFromUrl(r.url);
    return a.setAttrs({
      x: 0,
      y: 0
    }), new My(a, r);
  } catch (a) {
    console.error(a);
  }
  return null;
}
async function q0(r, a = !1) {
  const i = `${wt.getState().assetsBaseUrl}/decorations/${r.subType}.svg`;
  try {
    const s = await xe.loadImageFromUrl(i), h = jy(r), o = s.width(), l = s.height();
    if (o > l) {
      const u = h.width, g = l / o * h.height;
      s.setAttrs({
        height: g,
        width: u
      });
    } else if (o < l) {
      const u = h.height, g = o / l * h.width;
      s.setAttrs({
        height: u,
        width: g
      });
    } else {
      const u = h.height, g = h.width;
      s.setAttrs({
        height: u,
        width: g
      });
    }
    return a ? new Dy(s, r) : new Cg(s, r);
  } catch (s) {
    console.error(s);
  }
  return null;
}
function zy(r) {
  const a = new ft.Group({
    x: 0,
    y: 0
  });
  return new Iy(a, r);
}
function Hy(r) {
  const a = new ft.Text({
    fill: "black",
    fontFamily: ee,
    fontSize: 14,
    listening: !1,
    padding: 4,
    text: r.name,
    x: 0,
    y: 0
  });
  return new Ly(a, r);
}
const Wy = (r) => r.trim().length === 0 ? By : r;
function Vy(r) {
  const a = new ft.Group({
    listening: !1,
    x: 0,
    y: 0
  }), i = new ft.Rect({
    fill: Wy(r.name),
    height: r.height,
    listening: !1,
    strokeEnabled: !1,
    width: r.width,
    x: 0,
    y: 0
  });
  return a.add(i), new Ny(a, r);
}
function jy(r) {
  return r.width > r.height ? {
    width: r.height,
    height: r.height
  } : r.width < r.height ? {
    width: r.width,
    height: r.width
  } : {
    width: r.width,
    height: r.height
  };
}
function Ky(r) {
  const a = r.split(" ");
  return {
    timeSlot: a[a.length - 1],
    name: a.slice(0, a.length - 1).join(" ")
  };
}
function Ta(r) {
  return r.subType === Ar.PLAYFIELD ? Ky(r.name).name : r.name;
}
const ei = 1, z0 = "image";
class xg extends Xe {
  constructor(a, i) {
    super(a, i);
  }
  get isAvailable() {
    var a;
    return ((a = this.spot.style) == null ? void 0 : a.iconColor) === tt.GREEN;
  }
  async init() {
    this.addBackground(), await this.addImage(), this.addSpotName();
  }
  async clearHighlight() {
    if (this.highligthColor !== null)
      return this.highligthColor = null, this.redrawImage();
  }
  async highlight() {
    this.highligthColor === null && (this.highligthColor = tt.BLUE, await this.redrawImage());
  }
  async redrawImage() {
    var i;
    (i = this.findOne(`.${z0}`)) == null || i.destroy();
    const a = await this.addImage();
    a !== null && a.zIndex(1);
  }
  addBackground() {
    const a = new ft.Rect({
      width: this.spot.width,
      height: this.spot.height,
      fill: "#FFF",
      cornerRadius: 4
    });
    this.add(a);
  }
  getImageName() {
    return this.highligthColor ? "checked" : this.isAvailable ? "available" : "not-available";
  }
  getImageWidth() {
    return this.spot.subType === Ar.CABIN ? 24 : this.spot.subType === Ar.UMBRELLA && this.highligthColor ? 35 : 30;
  }
  async addImage() {
    try {
      const a = `${this.spot.subType}-${this.getImageName()}`, i = `${wt.getState().assetsBaseUrl}/spots/${a}.svg`, s = await xe.loadImageFromUrl(i), h = this.getImageWidth(), o = h * s.height() / s.width();
      return s.width(h), s.height(o), s.x(this.width() / 2 - s.width() / 2), s.y(this.height() / 2 - s.height() / 2), s.name(z0), this.add(s), s;
    } catch (a) {
      console.error(a);
    }
    return null;
  }
  addSpotName() {
    if (!this.isAvailable)
      return;
    if (this.spot.subType === Ar.PLAYFIELD)
      return this.addPlayfieldName();
    const a = new ft.Text({
      text: Ta(this.spot),
      fontSize: 12,
      fontFamily: ee,
      fontStyle: "bold",
      fill: "black",
      wrap: "none",
      listening: !1,
      x: 0,
      y: 0
    });
    a.width() > this.width() ? (a.width(this.width() - ei * 2), a.x(this.width() - a.width() - ei)) : a.x(this.width() - a.width() - ei * 2), a.y(this.height() - a.height());
    const i = new ft.Rect({
      cornerRadius: 4,
      fill: "white",
      height: a.height(),
      listening: !1,
      width: a.width(),
      x: a.x(),
      y: a.y()
    });
    this.add(i, a);
  }
  addPlayfieldName() {
    const [a, i] = this.spot.name.split(" "), s = new ft.Text({
      text: a,
      fontFamily: ee,
      fontSize: 10,
      fontStyle: "bold",
      fill: "black",
      wrap: "none",
      listening: !1,
      x: 0,
      y: 0
    });
    s.x(this.width() - s.width() - ei * 2), s.y(this.height() - s.height());
    const h = new ft.Rect({
      cornerRadius: 4,
      fill: "white",
      height: s.height() * 2,
      listening: !1,
      width: this.width(),
      x: 0,
      y: s.y()
    }), o = i.indexOf("-"), l = i.substring(0, o + 1), u = i.substring(o + 1), g = new ft.Text({
      text: l,
      fontFamily: ee,
      fontSize: 10,
      fontStyle: "bold",
      fill: "black",
      wrap: "none",
      listening: !1,
      x: 0,
      y: 0
    });
    g.x(this.width() - g.width() - ei * 2), g.y(h.y() + 10);
    const p = new ft.Text({
      text: u,
      fontFamily: ee,
      fontSize: 10,
      fontStyle: "bold",
      fill: "black",
      wrap: "none",
      listening: !1,
      x: 0,
      y: 0
    });
    p.x(this.width() - p.width() - ei * 2), p.y(g.y() + 10), this.add(h, s, g, p);
  }
}
const Pa = {
  getSpotIconByColor(r, a) {
    const i = `spots/${r}`;
    switch (a) {
      case tt.RED:
      case tt.BLUE:
      case tt.GREEN:
      case tt.YELLOW:
      case tt.ORANGE:
      case tt.WHITE:
      case tt.BLACK:
      case tt.PURPLE:
      case tt.BLACK_WHITE:
      case tt.BLACK_BLUE:
      case tt.BLACK_YELLOW:
      case tt.BLACK_GREY:
      case tt.BLACK_RED:
      case tt.BLACK_GREEN:
      case tt.BLACK_PURPLE:
      case tt.GREY:
      case tt.CYAN:
      case tt.BROWN:
      case tt.LIME:
      case tt.PINK:
        return `${i}/${a.toLowerCase()}.svg`;
      case tt.PINK_FLUO:
        return `${i}/pinkfluo.svg`;
      case tt.RED_FLUO:
        return `${i}/redfluo.svg`;
      case tt.BLUE_FLUO:
        return `${i}/bluefluo.svg`;
      case tt.GREEN_FLUO:
        return `${i}/greenfluo.svg`;
      case tt.YELLOW_FLUO:
        return `${i}/yellowfluo.svg`;
      case tt.WHITE_FLUO:
        return `${i}/whitefluo.svg`;
      case tt.PURPLE_FLUO:
        return `${i}/purplefluo.svg`;
    }
  }
};
class Yy extends Xe {
  constructor(a, i) {
    super(a, i);
  }
  async init() {
    this.addBackground(), await this.addImage(), this.addSpotName(), this.addCustomLabel();
  }
  async clearHighlight() {
  }
  async highlight() {
  }
  addBackground() {
    var i, s, h, o, l, u, g, p;
    const a = new ft.Circle({
      radius: this.width() / 2,
      fill: (h = (s = (i = this.spot.style) == null ? void 0 : i.css) == null ? void 0 : s.backgroundColor) != null ? h : "#FFF",
      stroke: "rgb(135, 135, 135)",
      strokeWidth: (u = (l = (o = this.spot.style) == null ? void 0 : o.css) == null ? void 0 : l.borderWidth) != null ? u : 1,
      x: this.width() / 2,
      y: this.height() / 2,
      ...((p = (g = this.spot.style) == null ? void 0 : g.css) == null ? void 0 : p.borderStyle) === "dashed" ? { dash: [5, 5] } : {}
    });
    this.add(a);
  }
  async addImage() {
    var a, i;
    try {
      const s = `${wt.getState().assetsBaseUrl}/${Pa.getSpotIconByColor(this.spot.subType, (i = (a = this.spot.style) == null ? void 0 : a.iconColor) != null ? i : tt.GREEN)}`, h = await xe.loadImageFromUrl(s), o = 32, l = o * h.height() / h.width();
      h.width(o), h.height(l), h.x(this.width() / 2 - h.width() / 2), h.y(this.height() / 2 - h.height() / 2), this.add(h);
    } catch (s) {
      console.error(s);
    }
  }
  addSpotName() {
    const a = new ft.Text({
      text: this.spot.name,
      fontFamily: ee,
      fontSize: 10,
      fontStyle: "bold",
      fill: "#242424",
      align: "center",
      wrap: "none",
      width: this.width(),
      y: 38,
      listening: !1
    });
    this.add(a);
  }
  addCustomLabel() {
    if (typeof this.spot.customLabel != "string")
      return;
    const a = new ft.Text({
      text: this.spot.customLabel,
      fontFamily: ee,
      fontSize: 8,
      fill: "#242424",
      align: "center",
      width: this.width(),
      y: 8,
      listening: !1
    });
    this.add(a);
  }
}
const H0 = "SPOT_DATE", ua = 10, Xy = 6.6, W0 = 13;
class $y extends Xe {
  constructor(a, i) {
    super(a, i);
  }
  async init() {
    this.addBackground(), this.addCustomerName(), this.addServiceIcons(), await this.addImage(), this.addDate(), this.addSpotName(), this.addStaging(), this.highligthColor && await this.highlight(this.highligthColor, !0), await this.addAttributeIcon();
  }
  async addImage() {
    var a, i;
    try {
      const s = `${wt.getState().assetsBaseUrl}/${Pa.getSpotIconByColor(this.spot.subType, (i = (a = this.spot.style) == null ? void 0 : a.iconColor) != null ? i : tt.GREEN)}`, h = await xe.loadImageFromUrl(s, {
        name: this.IMAGE_NAME,
        y: 14
      }), o = 1 / (h.height() / W0);
      h.width(h.width() * o), h.height(W0), h.x(this.GAP), this.add(h);
    } catch (s) {
      console.error(s);
    }
  }
  getSpotNameWidth() {
    const a = this.findOne(`.${H0}`);
    return a ? this.bgWidth - a.width() + this.strokeWidth : this.bgWidth;
  }
  addSpotName() {
    const a = this.getSpotNameWidth(), i = new ft.Text({
      fill: "black",
      fontSize: ua,
      fontFamily: ee,
      fontStyle: "bold",
      letterSpacing: -0.4,
      listening: !1,
      name: this.SPOT_NAME,
      text: Ta(this.spot),
      width: a,
      wrap: "none",
      x: this.GAP / 2,
      y: 30 - this.strokeWidth
    });
    this.add(i);
  }
  addStaging() {
    if (this.spot.staging === null)
      return;
    const a = new ft.Text({
      text: this.spot.staging,
      fontFamily: ee,
      fontSize: this.isPlayfield ? Xy : ua,
      fill: "black",
      y: 20 - this.strokeWidth,
      listening: !1
    });
    a.x(
      this.width() - a.width() * 2 / this.GAP - this.strokeWidth
    ), this.add(a);
  }
  addDate() {
    var s, h, o;
    const a = (o = (s = this.spot.reservation) == null ? void 0 : s.endDate) != null ? o : (h = this.spot.reservation) == null ? void 0 : h.startDate;
    if (a === null)
      return;
    const i = new ft.Text({
      text: a,
      name: H0,
      fontFamily: ee,
      fontSize: ua,
      letterSpacing: -0.6,
      fill: "black",
      y: 30 - this.strokeWidth,
      listening: !1,
      wrap: "none"
    });
    i.x(this.width() - i.width() - this.strokeWidth), this.add(i);
  }
  addCustomerName() {
    var s;
    const a = (s = this.spot.reservation) == null ? void 0 : s.customerName;
    if (typeof a != "string")
      return;
    const i = new ft.Text({
      ellipsis: !0,
      fill: "black",
      fontFamily: ee,
      fontSize: ua,
      listening: !1,
      text: a,
      width: this.width() - 2 * this.GAP - (this.hasAttributeIcon ? this.ATTRIBUTE_ICON_WIDTH : 0),
      wrap: "none",
      x: this.GAP,
      y: this.GAP
    });
    this.add(i);
  }
  async addServiceIcons() {
    if (!Array.isArray(this.spot.serviceIcons) || this.spot.serviceIcons.length === 0)
      return;
    const { assetsBaseUrl: a } = wt.getState(), i = 7;
    let s = 0;
    for await (const h of this.spot.serviceIcons)
      try {
        const o = await xe.loadImageFromUrl(
          `${a}/services/${h}`
        ), l = o.width() * i / o.height();
        o.width(l), o.height(i), o.y(12), o.x(this.width() - o.width() - s - this.strokeWidth), o.listening(!1), s += o.width(), this.add(o);
      } catch (o) {
        console.error(o);
      }
  }
}
const Fa = 0.7, V0 = "SPOT_DATE", ca = 10 * Fa, Zy = 6.6 * Fa, j0 = 13 * Fa;
class Jy extends Xe {
  constructor(a, i) {
    super(a, i);
  }
  async init() {
    this.addBackground(), this.addCustomerName(), this.addServiceIcons(), await this.addImage(), this.addDate(), this.addSpotName(), this.addStaging(), this.highligthColor && await this.highlight(this.highligthColor, !0), await this.addAttributeIcon(Fa);
  }
  async addImage() {
    var a, i;
    try {
      const s = `${wt.getState().assetsBaseUrl}/${Pa.getSpotIconByColor(this.spot.subType, (i = (a = this.spot.style) == null ? void 0 : a.iconColor) != null ? i : tt.GREEN)}`, h = await xe.loadImageFromUrl(s, {
        name: this.IMAGE_NAME,
        y: 14
      }), o = 1 / (h.height() / j0);
      h.width(h.width() * o), h.height(j0), h.x(this.GAP), this.add(h);
    } catch (s) {
      console.error(s);
    }
  }
  getSpotNameWidth() {
    const a = this.findOne(`.${V0}`);
    return a ? this.bgWidth - a.width() + this.strokeWidth : this.bgWidth;
  }
  addSpotName() {
    const a = this.getSpotNameWidth(), i = new ft.Text({
      fill: "black",
      fontSize: ca,
      fontFamily: ee,
      fontStyle: "bold",
      letterSpacing: -0.4,
      listening: !1,
      name: this.SPOT_NAME,
      text: Ta(this.spot),
      width: a,
      wrap: "none",
      x: this.GAP / 2,
      y: 32 - this.strokeWidth
    });
    this.add(i);
  }
  addStaging() {
    if (this.spot.staging === null)
      return;
    const a = new ft.Text({
      text: this.spot.staging,
      fontFamily: ee,
      fontSize: this.isPlayfield ? Zy : ca,
      fill: "black",
      y: 20 - this.strokeWidth,
      listening: !1
    });
    a.x(
      this.width() - a.width() * 2 / this.GAP - this.strokeWidth
    ), this.add(a);
  }
  addDate() {
    var s, h, o;
    const a = (o = (s = this.spot.reservation) == null ? void 0 : s.endDate) != null ? o : (h = this.spot.reservation) == null ? void 0 : h.startDate;
    if (a === null)
      return;
    const i = new ft.Text({
      text: a,
      name: V0,
      fontFamily: ee,
      fontSize: ca,
      letterSpacing: -0.6,
      fill: "black",
      y: 32 - this.strokeWidth,
      listening: !1,
      wrap: "none"
    });
    i.x(this.width() - i.width() - this.strokeWidth), this.add(i);
  }
  addCustomerName() {
    var s;
    const a = (s = this.spot.reservation) == null ? void 0 : s.customerName;
    if (typeof a != "string")
      return;
    const i = new ft.Text({
      ellipsis: !0,
      fill: "black",
      fontFamily: ee,
      fontSize: ca,
      listening: !1,
      text: a,
      width: this.width() - 2 * this.GAP - (this.hasAttributeIcon ? this.ATTRIBUTE_ICON_WIDTH : 0),
      wrap: "none",
      x: this.GAP,
      y: this.GAP
    });
    this.add(i);
  }
  async addServiceIcons() {
    if (!Array.isArray(this.spot.serviceIcons) || this.spot.serviceIcons.length === 0)
      return;
    const { assetsBaseUrl: a } = wt.getState(), i = 7;
    let s = 0;
    for await (const h of this.spot.serviceIcons)
      try {
        const o = await xe.loadImageFromUrl(
          `${a}/services/${h}`
        ), l = o.width() * i / o.height();
        o.width(l), o.height(i), o.y(10), o.x(this.width() - o.width() - s - this.strokeWidth), o.listening(!1), s += o.width(), this.add(o);
      } catch (o) {
        console.error(o);
      }
  }
}
const Qy = "SPOT_DATE", Zh = 10, t8 = 6.6, K0 = 13;
class e8 extends Xe {
  constructor(a, i) {
    super(a, i);
  }
  async init() {
    this.addBackground(), await this.addImage(), this.addSpotName(), this.addDate(), this.addStaging(), this.highligthColor && await this.highlight(this.highligthColor, !0), await this.addAttributeIcon();
  }
  async clearHighlight() {
    this.highligthColor = null, this.find(`.${this.HIGHLIGHT_GROUP_NAME}`).forEach((a) => a.destroy());
  }
  async highlight(a, i = !1) {
    try {
      if (this.highligthColor !== null && !i)
        return;
      this.highligthColor = a;
      const s = _a.getBackgroundColor(a), h = _a.getBorderColor(a), o = new ft.Rect({
        name: this.HIGHLIGHT_GROUP_NAME,
        width: this.width(),
        height: this.height(),
        fill: s,
        stroke: h,
        cornerRadius: 4,
        listening: !1
      });
      this.add(o), o.zIndex(1);
      const l = await xe.loadImageFromUrl(
        `${wt.getState().assetsBaseUrl}/iconset/check.svg`
      ), u = new ft.Circle({
        name: this.HIGHLIGHT_GROUP_NAME,
        width: 16,
        height: 16,
        fill: h,
        x: this.width() / 2,
        y: this.height() / 2,
        listening: !1
      }), g = 10;
      l.name(this.HIGHLIGHT_GROUP_NAME), l.width(g), l.height(g), l.x(this.width() / 2 - g / 2), l.y(this.height() / 2 - g / 2), this.add(u, l);
    } catch (s) {
      console.error(s);
    }
  }
  getYFromSpotName() {
    const a = this.GAP, i = this.findOne(`.${this.SPOT_NAME}`);
    return i ? a + i.y() + i.height() : a;
  }
  async addImage() {
    var a, i;
    try {
      const s = `${wt.getState().assetsBaseUrl}/${Pa.getSpotIconByColor(this.spot.subType, (i = (a = this.spot.style) == null ? void 0 : a.iconColor) != null ? i : tt.GREEN)}`, h = await xe.loadImageFromUrl(s, {
        name: this.IMAGE_NAME,
        y: this.GAP
      }), o = 1 / (h.height() / K0);
      h.width(h.width() * o), h.height(K0), h.x(this.spot.width / 2 - h.width() / 2), this.add(h);
    } catch (s) {
      console.error(s);
    }
  }
  getSpotNameWidth() {
    return this.spot.width;
  }
  addSpotName() {
    const a = this.getSpotNameWidth(), i = new ft.Text({
      align: "center",
      ellipsis: !0,
      fill: "black",
      fontFamily: ee,
      fontSize: Zh,
      fontStyle: "bold",
      listening: !1,
      name: this.SPOT_NAME,
      text: Ta(this.spot),
      width: a,
      wrap: "none",
      y: this.getYFromImageSize()
    });
    this.add(i);
  }
  addStaging() {
    if (this.spot.layout !== pe.VIEWER_STAGING || this.spot.staging === null)
      return;
    const a = new ft.Text({
      align: "center",
      ellipsis: !0,
      fill: "black",
      fontFamily: ee,
      fontSize: this.isPlayfield ? t8 : Zh,
      listening: !1,
      text: this.spot.staging,
      width: this.spot.width,
      wrap: "none",
      y: this.getYFromSpotName()
    });
    this.add(a);
  }
  addDate() {
    var s, h, o;
    const a = (o = (s = this.spot.reservation) == null ? void 0 : s.endDate) != null ? o : (h = this.spot.reservation) == null ? void 0 : h.startDate;
    if (this.spot.layout !== pe.VIEWER_DATE || a === null)
      return;
    const i = new ft.Text({
      align: "center",
      ellipsis: !0,
      fill: "black",
      fontFamily: ee,
      fontSize: Zh,
      listening: !1,
      name: Qy,
      text: a,
      width: this.spot.width,
      wrap: "none",
      y: this.getYFromSpotName()
    });
    this.add(i);
  }
}
class r8 {
  async createSpot(a) {
    const i = {
      id: a.id,
      x: a.x,
      y: a.y,
      width: a.width,
      height: a.height
    };
    let s;
    switch (a.layout) {
      case pe.BOOKING_NAME:
        s = new xg(i, a);
        break;
      case pe.VIEWER_DATE:
      case pe.VIEWER_FULL:
      case pe.VIEWER_FULL_SQUARE:
      case pe.VIEWER_NAME:
      case pe.VIEWER_STAGING:
        s = i8(i, a);
        break;
      default:
        gr(a.layout);
    }
    return await s.init(), s;
  }
}
function i8(r, a) {
  if (a.subType === Ar.BEDS)
    return new Yy(
      {
        ...r,
        height: 52,
        width: 52
      },
      a
    );
  switch (a.layout) {
    case pe.BOOKING_NAME:
      throw new Error(`Invalid layout: ${a.layout}`);
    case pe.VIEWER_FULL:
      return new $y(r, a);
    case pe.VIEWER_FULL_SQUARE:
      return new Jy(r, a);
    case pe.VIEWER_DATE:
    case pe.VIEWER_NAME:
    case pe.VIEWER_STAGING:
      return new e8(r, a);
    default:
      gr(a.layout);
  }
}
const Oa = wg(() => ({
  cachePixelRation: 3,
  clusterSize: 500,
  dragMoveThrottle: 500,
  lazyLoadEnabled: !1
})), Y0 = 8, X0 = "spot-group";
function $0() {
  return {
    imageSmoothingEnabled: !0,
    pixelRatio: Math.max(3, Oa.getState().cachePixelRation)
  };
}
class n8 extends ft.Layer {
  constructor() {
    super(...arguments);
    qe(this, "spotClusterMap", /* @__PURE__ */ new Map());
  }
  async renderElements({
    elements: i,
    layerConfig: s
  }) {
    var _, w, C, F;
    this.destroyChildren();
    const h = new r8(), o = new Uy(), l = (w = (_ = s == null ? void 0 : s.spots) == null ? void 0 : _.visible) != null ? w : !0, u = (F = (C = s == null ? void 0 : s.decorations) == null ? void 0 : C.visible) != null ? F : !0, g = i.map(
      async (c) => {
        if (h6(c)) {
          const m = await h.createSpot(c);
          return l || m.visible(!1), m;
        }
        const f = await o.createDecoration(c);
        if (f === null)
          throw new Error(
            `Cannot create decoration element from: ${JSON.stringify(c)}`
          );
        return u || f.visible(!1), f;
      }
    ), p = await Promise.allSettled(g), { decorations: b, spots: S } = p.reduce(
      (c, f) => {
        const { status: m } = f;
        switch (m) {
          case "rejected":
            console.error(f.reason);
            break;
          case "fulfilled": {
            f.value instanceof Xe ? c.spots.push(f.value) : c.decorations.push(f.value);
            break;
          }
          default:
            gr(m);
        }
        return c;
      },
      { spots: [], decorations: [] }
    ), x = this.sortDecorations(b), v = this.getSpotClusters(S);
    this.add(...x, ...v), this.adjustLayerPosition(), v.forEach((c) => {
      c.cache($0());
    });
  }
  setVisibility(i, s) {
    switch (i) {
      case fr.SPOT: {
        this.setSpotsVisibility(s);
        break;
      }
      case fr.DECORATION: {
        this.setDecorationsVisibility(s);
        break;
      }
      default:
        gr(i);
    }
  }
  toggleVisibility(i) {
    switch (i) {
      case fr.SPOT: {
        this.setSpotsVisibility();
        break;
      }
      case fr.DECORATION: {
        this.setDecorationsVisibility();
        break;
      }
      default:
        gr(i);
    }
  }
  onElementHighligh(i) {
    const s = this.spotClusterMap.get(i);
    s && (s.isCached() && s.clearCache(), s.cache($0()));
  }
  updateClusterVisibility() {
    if (!Oa.getState().lazyLoadEnabled)
      return;
    const i = this.getStage(), s = {
      x: -i.x() / i.scaleX(),
      y: -i.y() / i.scaleY(),
      width: i.width() / i.scaleX(),
      height: i.height() / i.scaleY()
    };
    this.find(`.${X0}`).forEach((h) => {
      if (!(h instanceof ft.Group))
        return;
      const o = h.getClientRect({ relativeTo: i }), l = ft.Util.haveIntersection(o, s);
      l !== h.visible() && h.visible(l);
    });
  }
  updateOffset(i) {
    this.x(i), wt.setState({
      elementsLayerOffsetX: i
    });
  }
  adjustLayerPosition() {
    if (this.children.length === 0) {
      this.updateOffset(0);
      return;
    }
    const i = wt.getState();
    if (!i.backgroundUrl && i.originalMapSize.width < i.mapSize.width) {
      const s = (i.mapSize.width - i.originalMapSize.width) / 2;
      this.updateOffset(s);
    } else
      this.updateOffset(0);
  }
  setSpotsVisibility(i) {
    this.children.forEach((s) => {
      s instanceof Xe && s.visible(i != null ? i : !s.visible());
    });
  }
  setDecorationsVisibility(i) {
    this.children.forEach((s) => {
      s instanceof Br && s.visible(i != null ? i : !s.visible());
    });
  }
  clusterize(i, s) {
    const h = Y0, o = [];
    for (let l = 0; l < h; l++) {
      const u = new ft.Group({
        name: s.groupName
      }), g = [];
      for (let p = 0; p < s.clusterSize; p++) {
        const b = l * s.clusterSize + p;
        if (b >= i.length)
          break;
        const S = Oy(i, b);
        S && (g.push(S), this.spotClusterMap.set(S.id(), u));
      }
      u.add(...g), o.push(u);
    }
    return o;
  }
  sortDecorations(i) {
    return i.sort(
      (s, h) => s.decoration.zIndex - h.decoration.zIndex
    );
  }
  getSpotClusters(i) {
    this.spotClusterMap.clear();
    const s = i.sort((h, o) => h.x() - o.x());
    return this.clusterize(s, {
      clusterSize: Math.ceil(s.length / Y0),
      groupName: X0
    });
  }
}
const Z0 = 1754, da = "black", fa = 0.5, vn = class vn extends ft.Layer {
  constructor(a) {
    super(), this.init(a);
  }
  init(a) {
    this.buildPrintPreview(a);
  }
  getPrintPreview() {
    return this.findOne(`#${vn.PRINT_PREVIEW_ID}`);
  }
  buildPrintPreview(a) {
    var v, _, w, C, F, c, f, m;
    const i = wt.getState(), s = new ft.Rect({
      id: vn.PRINT_PREVIEW_ID,
      x: (_ = (v = a.initialPreview) == null ? void 0 : v.x) != null ? _ : 0,
      y: (C = (w = a.initialPreview) == null ? void 0 : w.y) != null ? C : 0,
      width: (c = (F = a.initialPreview) == null ? void 0 : F.width) != null ? c : 100,
      height: (m = (f = a.initialPreview) == null ? void 0 : f.height) != null ? m : 100,
      draggable: !0
    }), h = s.x(), o = s.y(), l = s.x() + s.width(), u = s.y() + s.height(), g = new ft.Rect({
      x: 0,
      y: 0,
      width: h,
      height: i.mapSize.height,
      fill: da,
      opacity: fa,
      listening: !1
    }), p = new ft.Rect({
      x: l - 0.5,
      y: 0,
      width: i.mapSize.width - l,
      height: i.mapSize.height,
      fill: da,
      opacity: fa,
      listening: !1
    }), b = new ft.Rect({
      x: h,
      y: 0,
      width: s.width(),
      height: o,
      fill: da,
      opacity: fa,
      listening: !1
    }), S = new ft.Rect({
      x: h,
      y: u,
      width: s.width(),
      height: i.mapSize.height - u,
      fill: da,
      opacity: fa,
      listening: !1
    }), x = new ft.Transformer({
      enabledAnchors: [
        "top-left",
        "top-right",
        "bottom-left",
        "bottom-right",
        "top-center",
        "middle-right",
        "middle-left",
        "bottom-center"
      ],
      rotateEnabled: !1,
      keepRatio: !1,
      anchorFill: "white",
      anchorStroke: "black",
      borderStroke: "black",
      borderStrokeWidth: 1,
      flipEnabled: !1
    });
    this.add(
      g,
      p,
      b,
      S,
      s,
      x
    ), x.nodes([s]), s.on("transform dragmove", () => {
      const E = this.getPrintPreview();
      if (!E) {
        console.error("printPreview is not initialized");
        return;
      }
      const T = E.width() * E.scaleX(), D = E.height() * E.scaleY(), k = E.x(), M = E.y(), O = E.x() + T, N = E.y() + D;
      g.width(k), p.setAttrs({
        x: O - 0.5,
        width: i.mapSize.width - O
      }), b.setAttrs({
        x: k,
        y: 0,
        width: T,
        height: M
      }), S.setAttrs({
        x: k,
        y: N,
        width: T,
        height: i.mapSize.height - N
      });
    }), s.on("transformend dragend", () => {
      a.cb && this.print(this.parent).then(a.cb);
    });
  }
  print(a) {
    return new Promise((i, s) => {
      const h = this.getPrintPreview();
      if (!h) {
        s("printPreview is not initialized");
        return;
      }
      const o = a.scaleX(), l = h.width() * h.scaleX(), u = h.height() * h.scaleY(), g = h.x(), p = h.y(), b = u > l ? Z0 / (u * o) : Z0 / (l * o);
      this.hide();
      try {
        a.toDataURL({
          x: g * o,
          y: p * o,
          // keep at least a 5x on the image
          pixelRatio: Math.max(b, 5),
          width: l * o,
          height: u * o,
          callback: (S) => {
            this.show(), i({
              data: S,
              x: g,
              y: p,
              width: l,
              height: u,
              pixelRatio: b
            });
          }
        });
      } catch (S) {
        this.show(), s(S);
      }
    });
  }
};
qe(vn, "PRINT_PREVIEW_ID", "print-preview");
let va = vn;
const J0 = {
  fit(r, a) {
    const i = r.width / r.height, s = a.width / a.height;
    return i > s ? {
      width: a.width,
      height: a.width / i
    } : {
      width: a.height * i,
      height: a.height
    };
  },
  cover(r, a) {
    const i = r.width / r.height, s = a.width / a.height;
    return i < s ? {
      width: a.width,
      height: a.width / i
    } : {
      width: a.height * i,
      height: a.height
    };
  }
};
function ya(r, a) {
  const { draggable: i, fit: s } = wt.getState();
  return s === yn.CONTAIN ? J0.fit(a, {
    width: r.clientWidth,
    height: r.clientHeight
  }) : i ? {
    width: r.clientWidth,
    height: r.clientHeight
  } : J0.cover(a, {
    width: r.clientWidth,
    height: r.clientHeight
  });
}
function a8(r) {
  const a = ya(r.container, r.mapSize), i = new ft.Stage({
    container: r.container.id,
    width: a.width,
    height: a.height,
    draggable: r.draggable
  });
  i.on("click tap", function(h) {
    var l, u;
    const o = h.target.getParent();
    o instanceof Xe && ((u = (l = r.events) == null ? void 0 : l.onMapElementClick) == null || u.call(l, o.id()));
  });
  const s = Sg(
    () => {
      var h, o;
      if ((h = r.events) != null && h.onMapPanZoom) {
        const { x: l, y: u } = i.position(), g = i.scaleX();
        (o = r.events) == null || o.onMapPanZoom({
          position: {
            x: l / g,
            y: u / g
          },
          zoom: g
        });
      }
    },
    Oa.getState().dragMoveThrottle,
    {
      leading: !0,
      trailing: !0
    }
  );
  return i.on("dragmove", s), i.on("mouseover", () => {
    var u, g, p, b;
    const h = i.getPointerPosition(), { isPrintEnabled: o } = wt.getState();
    if (h === null)
      return;
    let l = i.getIntersection(h);
    if (o) {
      if ((l == null ? void 0 : l.id()) === va.PRINT_PREVIEW_ID) {
        i.container().style.cursor = "move";
        return;
      }
    } else {
      for (; l !== null; ) {
        if (l instanceof xg) {
          i.container().style.cursor = l.isAvailable ? "pointer" : "not-allowed";
          return;
        }
        if (l instanceof Xe) {
          (g = (u = r.events) == null ? void 0 : u.onMapElementHover) == null || g.call(u, l.id()), i.container().style.cursor = "pointer";
          return;
        }
        if (l instanceof Br) {
          (b = (p = r.events) == null ? void 0 : p.onMapElementHover) == null || b.call(p, l.id());
          return;
        }
        l = l.parent;
      }
      i.container().style.cursor = "move";
    }
  }), i.on("mouseout", () => {
    i.container().style.cursor = "default";
  }), i;
}
function Dr(r) {
  const a = wt.getState(), i = a.mapSize.width * r.scale, s = a.mapSize.height * r.scale;
  return {
    x: Math.min(
      0,
      Math.max(r.stageSize.width - i, r.pos.x)
    ),
    y: Math.min(
      0,
      Math.max(r.stageSize.height - s, r.pos.y)
    )
  };
}
function Qh(r) {
  const { minScale: a } = wt.getState();
  r.scale({ x: a, y: a }), r.position(
    Dr({
      scale: r.scaleX(),
      pos: r.position(),
      stageSize: { width: r.width(), height: r.height() }
    })
  );
}
function ma(r, a) {
  const i = sl();
  return Math.min(Math.max(r, a), i);
}
function Q0(r) {
  const { minScale: a } = wt.getState();
  let i = r.scale;
  i < a && (i = a);
  const s = sl();
  i > s && (i = s);
  const h = {
    x: pn((r.point.x - r.stage.x()) / r.stage.scaleX(), 2),
    y: pn((r.point.y - r.stage.y()) / r.stage.scaleX(), 2)
  };
  r.stage.scale({
    x: i,
    y: i
  });
  const o = Dr({
    scale: i,
    pos: {
      x: pn(r.point.x - h.x * i, 2),
      y: pn(r.point.y - h.y * i, 2)
    },
    stageSize: { width: r.stage.width(), height: r.stage.height() }
  });
  return r.stage.position(o), {
    position: {
      x: h.x,
      y: h.y
    },
    scale: i
  };
}
function sl() {
  const { minScale: r } = wt.getState();
  return Math.max(r, 3);
}
function s8(r, a) {
  return Math.sqrt(Math.pow(a.x - r.x, 2) + Math.pow(a.y - r.y, 2));
}
function o8(r, a) {
  return {
    x: (r.x + a.x) / 2,
    y: (r.y + a.y) / 2
  };
}
const tg = 0.2;
ft.hitOnDragEnabled = !0;
function ni(r, a) {
  const { fit: i } = wt.getState();
  return (i === yn.CONTAIN ? Math.min : Math.max)(a.width / r.width, a.height / r.height);
}
async function I8(r) {
  var S, x, v, _, w, C, F, c, f;
  const a = document.getElementById(r.opts.containerId);
  if (!a)
    throw new Error("Canvas container not found");
  const i = (x = (S = r.opts.print) == null ? void 0 : S.enabled) != null ? x : !1, s = (v = r.opts.draggable) != null ? v : !0;
  wt.setState({
    assetsBaseUrl: r.opts.assetsBaseUrl,
    backgroundUrl: r.opts.backgroundUrl,
    debug: !!r.opts.debug,
    fit: (_ = r.opts.fit) != null ? _ : yn.COVER,
    draggable: s,
    containerSize: {
      height: a.clientHeight,
      width: a.clientWidth
    },
    mapSize: {
      height: r.opts.size.height,
      width: r.opts.size.width
    },
    originalMapSize: {
      height: r.opts.originalSize.height,
      width: r.opts.originalSize.width
    },
    isPrintEnabled: i
  }), r.config && Oa.setState(r.config);
  const h = a8({
    container: a,
    draggable: s,
    events: r.events,
    mapSize: {
      height: a.clientHeight,
      width: a.clientWidth
    }
  }), o = ni(
    {
      height: r.opts.size.height,
      width: r.opts.size.width
    },
    {
      width: h.width(),
      height: h.height()
    }
  );
  wt.setState({
    minScale: o
  });
  const l = new Ry(
    (w = r.opts.layersConfig) == null ? void 0 : w.background
  );
  h.add(l);
  const u = new n8();
  h.add(u), await u.renderElements({
    elements: r.opts.elements,
    layerConfig: (C = r.opts.layersConfig) == null ? void 0 : C.elements
  });
  let g;
  if (i && (g = new va({
    initialPreview: (F = r.opts.print) == null ? void 0 : F.initialPreview,
    cb: (c = r.events) == null ? void 0 : c.onPrintPreview
  }), h.add(g)), i)
    h.scale({ x: o, y: o });
  else {
    if (h8(h, (f = r.events) == null ? void 0 : f.onMapPanZoom), r.opts.initialZoom) {
      const m = ma(o, r.opts.initialZoom);
      h.scale({ x: m, y: m });
    }
    r.opts.initialPosition && h.position(
      Dr({
        scale: h.scaleX(),
        pos: {
          x: r.opts.initialPosition.x * h.scaleX(),
          y: r.opts.initialPosition.y * h.scaleY()
        },
        stageSize: {
          height: h.height(),
          width: h.width()
        }
      })
    );
  }
  const p = rv(l8(h, a), 250);
  window.addEventListener("resize", p);
  function b() {
    const { fit: m } = wt.getState(), E = h.scaleX();
    return {
      fit: m,
      rect: {
        height: h.height() / E,
        width: h.width() / E,
        x: Math.abs(h.x()) / E,
        y: Math.abs(h.y()) / E
      },
      zoom: E
    };
  }
  return {
    destroy() {
      h.destroy();
    },
    getStageInfo: b,
    renderElements(m, E) {
      return u.renderElements({
        elements: m,
        layerConfig: E
      });
    },
    setBackgroundVisibility(m) {
      l.setVisibility(m);
    },
    setDecorationsVisibility(m) {
      u.setVisibility(fr.DECORATION, m);
    },
    setSpotsVisibility(m) {
      u.setVisibility(fr.SPOT, m);
    },
    toggleBackgroundVisibility() {
      l.toggleVisibility();
    },
    toggleDecorationsVisibility() {
      u.toggleVisibility(fr.DECORATION);
    },
    toggleSpotsVisibility() {
      u.toggleVisibility(fr.SPOT);
    },
    updateFit(m) {
      const E = wt.getState();
      wt.setState({ fit: m });
      const T = ya(a, E.mapSize);
      wt.setState({
        minScale: ni(E.mapSize, T)
      }), h.size(T), Qh(h);
    },
    zoomIn() {
      var k, M;
      const m = h.scaleX(), E = sl(), T = pn(Math.min(m + tg, E), 2), D = Q0({
        scale: T,
        point: {
          x: h.width() / 2,
          y: h.height() / 2
        },
        stage: h
      });
      (M = (k = r.events) == null ? void 0 : k.onMapPanZoom) == null || M.call(k, {
        position: D.position,
        zoom: D.scale
      });
    },
    zoomOut() {
      var k, M;
      const { minScale: m } = wt.getState(), E = h.scaleX(), T = Math.max(m, E - tg), D = Q0({
        stage: h,
        scale: T,
        point: {
          x: h.width() / 2,
          y: h.height() / 2
        }
      });
      (M = (k = r.events) == null ? void 0 : k.onMapPanZoom) == null || M.call(k, {
        position: D.position,
        zoom: D.scale
      });
    },
    updateBgSize(m, E) {
      const T = wt.getState();
      if (R0(m, T.mapSize) && R0(E, T.originalMapSize))
        return;
      const D = ya(a, m);
      h.width(D.width), h.height(D.height), wt.setState((k) => ({
        ...k,
        mapSize: m,
        minScale: ni(m, {
          width: D.width,
          height: D.height
        }),
        originalMapSize: E
      })), l.updateBgSize(), Qh(h);
    },
    async highlightElement(m, E) {
      const T = h.findOne(`#${m}`);
      if (T instanceof Xe)
        return T.highlight(E).then(() => {
          u.onElementHighligh(m);
        });
    },
    async clearHighlight(m) {
      if (m.length === 0)
        return;
      const E = m.map(async (T) => {
        const D = h.findOne(`#${T}`);
        if (D instanceof Xe)
          return D.clearHighlight();
      });
      await Promise.allSettled(E), m.forEach((T) => {
        u.onElementHighligh(T);
      });
    },
    goToPosition(m, E) {
      if (E) {
        const { minScale: T } = wt.getState(), D = ma(T, E);
        h.scale({ x: D, y: D });
      }
      h.position(
        Dr({
          scale: h.scaleX(),
          pos: {
            x: m.x * h.scaleX(),
            y: m.y * h.scaleY()
          },
          stageSize: {
            height: h.height(),
            width: h.width()
          }
        })
      );
    },
    print() {
      if (!g)
        throw new Error("Print mode is not enabled");
      return g.print(h);
    },
    updatePrintPreview(m) {
      var E;
      if (!g)
        throw new Error("Print mode is not enabled");
      g.destroyChildren(), g.buildPrintPreview({
        initialPreview: m,
        cb: (E = r.events) == null ? void 0 : E.onPrintPreview
      });
    },
    handleResize() {
      p();
    },
    updateClusterVisibility() {
      u.updateClusterVisibility();
    }
  };
}
function h8(r, a) {
  const i = wt.getState(), s = 1.05;
  r.scale({ x: i.minScale, y: i.minScale });
  const h = a ? Sg(a, 250, {
    trailing: !0
  }) : null;
  r.on("wheel", (g) => {
    g.evt.preventDefault();
    const p = r.scaleX(), b = r.getPointerPosition();
    if (!b) return;
    const S = {
      x: (b.x - r.x()) / p,
      y: (b.y - r.y()) / p
    }, x = g.evt.deltaY > 0 ? -1 : 1, v = wt.getState(), _ = x > 0 ? p * s : p / s, w = ni(v.mapSize, {
      width: r.width(),
      height: r.height()
    }), C = ma(w, _);
    if (_ > C || _ < w) return;
    r.scale({
      x: C,
      y: C
    });
    const F = b.x - S.x * _, c = b.y - S.y * _, f = {
      x: Math.min(0, F),
      // bound to the left of the bg
      y: Math.min(0, c)
      // bound to the top of the bg
    };
    r.position(
      Dr({
        scale: C,
        pos: f,
        stageSize: {
          height: r.height(),
          width: r.width()
        }
      })
    ), h && h({
      position: {
        x: f.x / C,
        y: f.y / C
      },
      zoom: C
    });
  }), r.dragBoundFunc(
    (g) => Dr({
      stageSize: { width: r.width(), height: r.height() },
      pos: g,
      scale: r.scaleX()
    })
  );
  let o = null, l = 0, u = !1;
  r.on("touchmove", function(g) {
    g.evt.preventDefault();
    const p = g.evt.touches[0], b = g.evt.touches[1];
    if (p && !b && !r.isDragging() && u && (r.startDrag(), u = !1), p && b) {
      r.isDragging() && (u = !0, r.stopDrag());
      const S = {
        x: p.clientX,
        y: p.clientY
      }, x = {
        x: b.clientX,
        y: b.clientY
      }, v = o8(S, x), _ = s8(S, x);
      if (!o || !l) {
        o = v, l = _;
        return;
      }
      const w = r.scaleX(), C = {
        x: (v.x - r.x()) / w,
        y: (v.y - r.y()) / w
      }, F = _ / l, c = w * F, f = ni(i.mapSize, {
        width: r.width(),
        height: r.height()
      }), m = ma(f, c);
      r.scale({
        x: m,
        y: m
      });
      const E = v.x - o.x, T = v.y - o.y, D = {
        x: v.x - C.x * m + E,
        y: v.y - C.y * m + T
      };
      r.position(
        Dr({
          scale: m,
          pos: D,
          stageSize: {
            height: r.height(),
            width: r.width()
          }
        })
      ), h && h({
        position: {
          x: r.x() / m,
          y: r.y() / m
        },
        zoom: m
      }), l = _, o = v;
    }
  }), r.on("touchend", function() {
    l = 0, o = null;
  });
}
const l8 = (r, a) => () => {
  const i = a.clientWidth, s = a.clientHeight, h = ya(a, wt.getState().mapSize);
  r.width(h.width), r.height(h.height), wt.setState((o) => ({
    ...o,
    minScale: ni(o.mapSize, {
      width: i,
      height: s
    })
  })), Qh(r);
};
export {
  yn as Fit,
  pe as SpotLayout,
  I8 as init
};
